/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AbpApiDefinitionListParams,
  AbpApplicationConfigurationListParams,
  AbpApplicationLocalizationListParams,
  AbpMultiTenancyTenantsByIdDetailParams,
  AbpMultiTenancyTenantsByNameDetailParams,
  AccountConfirmationStateListParams,
  AccountExternalProviderByNameListParams,
  AccountMyProfileSetTwoFactorEnabledCreateParams,
  AccountProfilePictureCreateParams,
  AccountProfilePictureDetailParams,
  AccountProfilePictureFileDetailParams,
  AccountRecaptchaValidateListParams,
  AccountSecurityLogsListParams,
  AccountTwoFactorProvidersListParams,
  AccountUserDelegationDeleteDelegationCreateParams,
  AccountUserDelegationUserLookupListParams,
  AppAiActivityReportJobActivityDetailParams,
  AppAiChatConversationsDeleteParams,
  AppAiChatConversationsListParams,
  AppAiChatConversationsMessagesCreateParams,
  AppAiChatConversationsMessagesListParams,
  AppAiChatConversationsMessagesStreamCreateParams,
  AppAiChatSkillAuthoringConversationsDetailParams,
  AppAiChatSkillAuthoringSkillsPatchesApplyCreateParams,
  AppAiExtnGetChatMessagesListParams,
  AppAiExtnSendMessageCreateParams,
  AppAiModelsAiProviderLookupListParams,
  AppAiModelsAllDeleteParams,
  AppAiModelsAsExcelFileListParams,
  AppAiModelsDelete2Params,
  AppAiModelsDeleteParams,
  AppAiModelsDetailParams,
  AppAiModelsIdentityUserLookupListParams,
  AppAiModelsListParams,
  AppAiModelsUpdateParams,
  AppAiModelsWithNavigationPropertiesDetailParams,
  AppAiProvidersAllDeleteParams,
  AppAiProvidersAsExcelFileListParams,
  AppAiProvidersDelete2Params,
  AppAiProvidersDeleteParams,
  AppAiProvidersDetailParams,
  AppAiProvidersListParams,
  AppAiProvidersUpdateParams,
  AppAiTaskExecutionsAiModelLookupListParams,
  AppAiTaskExecutionsAiTaskLookupListParams,
  AppAiTaskExecutionsAllDeleteParams,
  AppAiTaskExecutionsAsExcelFileListParams,
  AppAiTaskExecutionsDelete2Params,
  AppAiTaskExecutionsDeleteParams,
  AppAiTaskExecutionsDetailParams,
  AppAiTaskExecutionsJobStepLookupListParams,
  AppAiTaskExecutionsListParams,
  AppAiTaskExecutionsUpdateParams,
  AppAiTaskExecutionsWithNavigationPropertiesDetailParams,
  AppAiTaskOutputsAiTaskExecutionLookupListParams,
  AppAiTaskOutputsAiTaskLookupListParams,
  AppAiTaskOutputsAiTaskStepLookupListParams,
  AppAiTaskOutputsAllDeleteParams,
  AppAiTaskOutputsAsExcelFileListParams,
  AppAiTaskOutputsDelete2Params,
  AppAiTaskOutputsDeleteParams,
  AppAiTaskOutputsDetailParams,
  AppAiTaskOutputsListParams,
  AppAiTaskOutputsUpdateParams,
  AppAiTaskOutputsWithNavigationPropertiesDetailParams,
  AppAiTaskStepSkillsAiTaskStepLookupListParams,
  AppAiTaskStepSkillsDeleteParams,
  AppAiTaskStepSkillsDetailParams,
  AppAiTaskStepSkillsListParams,
  AppAiTaskStepSkillsSkillLookupListParams,
  AppAiTaskStepSkillsSkillVersionLookupListParams,
  AppAiTaskStepSkillsUpdateParams,
  AppAiTaskStepSkillsWithNavigationPropertiesDetailParams,
  AppAiTaskStepsByAiTaskListParams,
  AppAiTaskStepsDeleteParams,
  AppAiTaskStepsDetailParams,
  AppAiTaskStepsListParams,
  AppAiTaskStepsUpdateParams,
  AppAiTasksAiModelLookupListParams,
  AppAiTasksAllDeleteParams,
  AppAiTasksAsExcelFileListParams,
  AppAiTasksDelete2Params,
  AppAiTasksDeleteParams,
  AppAiTasksDetailParams,
  AppAiTasksListParams,
  AppAiTasksUpdateParams,
  AppAiTasksWithNavigationPropertiesDetailParams,
  AppAiUsageReportAiHealthListParams,
  AppAiUsageReportAiUsageDetailsListParams,
  AppAiUsageReportAiUsageSummaryListParams,
  AppAiUsageReportAiUsageTrendListParams,
  AppApiKeyActivateCreateParams,
  AppApiKeyDeactivateCreateParams,
  AppApiKeyDeleteParams,
  AppApiKeyDetailParams,
  AppApiKeyListParams,
  AppApiKeyUpdateParams,
  AppApprovalActionListParams,
  AppApprovalPageListParams,
  AppBrandingLogoDeleteParams,
  AppCabinetsAsExcelFileListParams,
  AppCabinetsDeleteParams,
  AppCabinetsDetailParams,
  AppCabinetsExtnAsExcelFileListParams,
  AppCabinetsExtnDeleteParams,
  AppCabinetsExtnDetailParams,
  AppCabinetsExtnListParams,
  AppCabinetsExtnMetadataSchemaListParams,
  AppCabinetsExtnMetadataSchemaUpdateParams,
  AppCabinetsExtnSyncHistoryListParams,
  AppCabinetsExtnSyncedDataByKeyListParams,
  AppCabinetsExtnSyncedDataChildrenListParams,
  AppCabinetsExtnSyncedDataCreateParams,
  AppCabinetsExtnSyncedDataDeleteParams,
  AppCabinetsExtnSyncedDataDetailParams,
  AppCabinetsExtnSyncedDataDirtyPreviewListParams,
  AppCabinetsExtnSyncedDataKeysListParams,
  AppCabinetsExtnSyncedDataListParams,
  AppCabinetsExtnSyncedDataLocalOnlyCreateParams,
  AppCabinetsExtnSyncedDataMetadataUpdateParams,
  AppCabinetsExtnSyncedDataPushCreateParams,
  AppCabinetsExtnSyncedDataResolveConflictCreateParams,
  AppCabinetsExtnSyncedDataUpdateParams,
  AppCabinetsExtnUpdateParams,
  AppCabinetsListParams,
  AppCabinetsUpdateParams,
  AppClientDashboardRequestTimelineDetailParams,
  AppClientFeedbackApiStatusDetailParams,
  AppClientFeedbackFormListParams,
  AppClientFeedbackHasPendingFeedbackCreateParams,
  AppClientFeedbackPeekTokenStatusCreateParams,
  AppClientMattersAsExcelFileListParams,
  AppClientMattersDeleteParams,
  AppClientMattersDetailParams,
  AppClientMattersExtnAsExcelFileListParams,
  AppClientMattersExtnDeleteParams,
  AppClientMattersExtnDetailParams,
  AppClientMattersExtnListParams,
  AppClientMattersExtnUpdateParams,
  AppClientMattersListParams,
  AppClientMattersUpdateParams,
  AppCustomAccountConfirmationStateListParams,
  AppCustomAccountProfilePictureFileListParams,
  AppCustomAccountProfilePictureListParams,
  AppCustomAccountSecurityLogListListParams,
  AppCustomAccountSetProfilePictureCreateParams,
  AppCustomAccountTwoFactorProvidersListParams,
  AppDataFormsAsExcelFileListParams,
  AppDataFormsDeleteParams,
  AppDataFormsDetailParams,
  AppDataFormsExtnAsExcelFileListParams,
  AppDataFormsExtnDeleteParams,
  AppDataFormsExtnDetailParams,
  AppDataFormsExtnListParams,
  AppDataFormsExtnUpdateParams,
  AppDataFormsListParams,
  AppDataFormsUpdateParams,
  AppDocumentLinksDeleteParams,
  AppDocumentLinksDetailParams,
  AppDocumentLinksExtnDeleteParams,
  AppDocumentLinksExtnDetailParams,
  AppDocumentLinksExtnListParams,
  AppDocumentLinksExtnUpdateParams,
  AppDocumentLinksListParams,
  AppDocumentLinksUpdateParams,
  AppDocumentPlaceHoldersAllDeleteParams,
  AppDocumentPlaceHoldersAsExcelFileListParams,
  AppDocumentPlaceHoldersDelete2Params,
  AppDocumentPlaceHoldersDeleteParams,
  AppDocumentPlaceHoldersDetailParams,
  AppDocumentPlaceHoldersDocumentLookupListParams,
  AppDocumentPlaceHoldersExtnAllDeleteParams,
  AppDocumentPlaceHoldersExtnAsExcelFileListParams,
  AppDocumentPlaceHoldersExtnDelete2Params,
  AppDocumentPlaceHoldersExtnDeleteParams,
  AppDocumentPlaceHoldersExtnDetailParams,
  AppDocumentPlaceHoldersExtnDocumentLookupListParams,
  AppDocumentPlaceHoldersExtnJobLookupListParams,
  AppDocumentPlaceHoldersExtnJobStepLookupListParams,
  AppDocumentPlaceHoldersExtnListParams,
  AppDocumentPlaceHoldersExtnTemplateLookupListParams,
  AppDocumentPlaceHoldersExtnUpdateParams,
  AppDocumentPlaceHoldersExtnWithNavigationPropertiesDetailParams,
  AppDocumentPlaceHoldersJobLookupListParams,
  AppDocumentPlaceHoldersJobStepLookupListParams,
  AppDocumentPlaceHoldersListParams,
  AppDocumentPlaceHoldersTemplateLookupListParams,
  AppDocumentPlaceHoldersUpdateParams,
  AppDocumentPlaceHoldersWithNavigationPropertiesDetailParams,
  AppDocumentTemplatesDeleteParams,
  AppDocumentTemplatesDetailParams,
  AppDocumentTemplatesListParams,
  AppDocumentTemplatesUpdateDocumentAndPlaceholderAsyncCreateParams,
  AppDocumentTemplatesUpdateParams,
  AppDocumentsDeleteParams,
  AppDocumentsDetailParams,
  AppDocumentsExtDeleteParams,
  AppDocumentsExtDetailParams,
  AppDocumentsExtGetDocumentsListParams,
  AppDocumentsExtGetListListParams,
  AppDocumentsExtJobLookupListParams,
  AppDocumentsExtJobStepLookupListParams,
  AppDocumentsExtTemplateLookupListParams,
  AppDocumentsExtTemplateStepLookupListParams,
  AppDocumentsExtUpdateParams,
  AppDocumentsExtWithNavigationPropertiesDetailParams,
  AppDocumentsJobLookupListParams,
  AppDocumentsJobStepLookupListParams,
  AppDocumentsListParams,
  AppDocumentsProviderDownloadDocumentListParams,
  AppDocumentsProviderDownloadTokenizedDocumentListParams,
  AppDocumentsProviderGetCabinetsListParams,
  AppDocumentsProviderGetClientsListParams,
  AppDocumentsProviderGetDocumentLinkForRegisteredUsersListParams,
  AppDocumentsProviderGetDocumentLinkListParams,
  AppDocumentsProviderGetFolderContentListParams,
  AppDocumentsProviderGetFoldersListParams,
  AppDocumentsProviderGetDocumentTypesListParams,
  AppDocumentsProviderGetLocationsListParams,
  AppDocumentsProviderGetMattersListParams,
  AppDocumentsProviderGetProfileAttributesListParams,
  AppDocumentsProviderGetProviderConfigListParams,
  AppDocumentsProviderGetUserDetailsListParams,
  AppDocumentsProviderGetWorkspaceDataListParams,
  AppDocumentsProviderGetWorkspaceListParams,
  AppDocumentsProviderUploadDocumentCreateParams,
  AppDocumentsProviderViewDocumentListParams,
  AppDocumentsTemplateLookupListParams,
  AppDocumentsTemplateStepLookupListParams,
  AppDocumentsUpdateParams,
  AppDocumentsWithNavigationPropertiesDetailParams,
  AppEmailConversationsAllDeleteParams,
  AppEmailConversationsAsExcelFileListParams,
  AppEmailConversationsDelete2Params,
  AppEmailConversationsDeleteParams,
  AppEmailConversationsDetailParams,
  AppEmailConversationsJobLookupListParams,
  AppEmailConversationsListParams,
  AppEmailConversationsUpdateParams,
  AppEmailConversationsWithNavigationPropertiesDetailParams,
  AppEmailTemplateExtDeleteParams,
  AppEmailTemplateExtDetailParams,
  AppEmailTemplateExtListParams,
  AppEmailTemplateExtSnippetLookupListParams,
  AppEmailTemplateExtUpdateParams,
  AppEmailTemplateExtWithNavigationPropertiesDetailParams,
  AppEmailTemplatesDeleteParams,
  AppEmailTemplatesDetailParams,
  AppEmailTemplatesListParams,
  AppEmailTemplatesSnippetLookupListParams,
  AppEmailTemplatesUpdateParams,
  AppEmailTemplatesWithNavigationPropertiesDetailParams,
  AppEntityRecordsBulkUploadSampleListParams,
  AppEntityRecordsDeleteParams,
  AppEntityRecordsDetailParams,
  AppEntityRecordsEnabledUpdateParams,
  AppEntityRecordsListParams,
  AppEntityRecordsLookupDetailParams,
  AppEntityRecordsUpdateParams,
  AppEntityTypesDeleteParams,
  AppEntityTypesDetailParams,
  AppEntityTypesListParams,
  AppEntityTypesUpdateParams,
  AppEnvelopeExtnDeleteParams,
  AppEnvelopeExtnDetailParams,
  AppEnvelopeExtnDocumentLookupListParams,
  AppEnvelopeExtnJobLookupListParams,
  AppEnvelopeExtnListParams,
  AppEnvelopeExtnUpdateParams,
  AppEnvelopeExtnWithNavigationPropertiesDetailParams,
  AppEnvelopesDeleteParams,
  AppEnvelopesDetailParams,
  AppEnvelopesDocumentLookupListParams,
  AppEnvelopesJobLookupListParams,
  AppEnvelopesListParams,
  AppEnvelopesUpdateParams,
  AppEnvelopesWithNavigationPropertiesDetailParams,
  AppFiltersAllDeleteParams,
  AppFiltersAsExcelFileListParams,
  AppFiltersDelete2Params,
  AppFiltersDeleteParams,
  AppFiltersDetailParams,
  AppFiltersExtnAllDeleteParams,
  AppFiltersExtnAsExcelFileListParams,
  AppFiltersExtnDelete2Params,
  AppFiltersExtnDeleteParams,
  AppFiltersExtnDetailParams,
  AppFiltersExtnGetListForUserListParams,
  AppFiltersExtnGetListListParams,
  AppFiltersExtnUpdateParams,
  AppFiltersListParams,
  AppFiltersUpdateParams,
  AppJobActionExtnDeleteParams,
  AppJobActionExtnDetailParams,
  AppJobActionExtnJobLookupListParams,
  AppJobActionExtnJobStepLookupListParams,
  AppJobActionExtnListParams,
  AppJobActionExtnTaskExecutionCreateParams,
  AppJobActionExtnUpdateParams,
  AppJobActionExtnWithNavigationPropertiesListParams,
  AppJobActionsDeleteParams,
  AppJobActionsDetailParams,
  AppJobActionsExtnDeleteParams,
  AppJobActionsExtnDetailParams,
  AppJobActionsExtnJobLookupListParams,
  AppJobActionsExtnJobStepLookupListParams,
  AppJobActionsExtnListParams,
  AppJobActionsExtnUpdateParams,
  AppJobActionsExtnWithNavigationPropertiesDetailParams,
  AppJobActionsJobLookupListParams,
  AppJobActionsJobStepLookupListParams,
  AppJobActionsListParams,
  AppJobActionsUpdateParams,
  AppJobActionsWithNavigationPropertiesDetailParams,
  AppJobDataFormsAsExcelFileListParams,
  AppJobDataFormsDataFormLookupListParams,
  AppJobDataFormsDeleteParams,
  AppJobDataFormsDetailParams,
  AppJobDataFormsExtnAsExcelFileListParams,
  AppJobDataFormsExtnDeleteParams,
  AppJobDataFormsExtnDetailParams,
  AppJobDataFormsExtnJobLookupListParams,
  AppJobDataFormsExtnJobStepLookupListParams,
  AppJobDataFormsExtnListParams,
  AppJobDataFormsExtnUpdateParams,
  AppJobDataFormsExtnWithNavigationPropertiesDetailParams,
  AppJobDataFormsJobLookupListParams,
  AppJobDataFormsJobStepLookupListParams,
  AppJobDataFormsListParams,
  AppJobDataFormsTemplateStepLookupListParams,
  AppJobDataFormsUpdateParams,
  AppJobDataFormsWithNavigationPropertiesDetailParams,
  AppJobHoldsDeleteParams,
  AppJobHoldsDetailParams,
  AppJobHoldsJobLookupListParams,
  AppJobHoldsJobStepLookupListParams,
  AppJobHoldsListParams,
  AppJobHoldsUpdateParams,
  AppJobHoldsWithNavigationPropertiesDetailParams,
  AppJobImprovementByJobStepListParams,
  AppJobImprovementDeleteParams,
  AppJobImprovementForExportListParams,
  AppJobImprovementListParams,
  AppJobImprovementWithHistoryDetailParams,
  AppJobImprovementsByJobStepListParams,
  AppJobImprovementsDeleteParams,
  AppJobImprovementsExportListParams,
  AppJobImprovementsListParams,
  AppJobImprovementsWithHistoryListParams,
  AppJobLinksDeleteParams,
  AppJobLinksDetailParams,
  AppJobLinksJobLookupListParams,
  AppJobLinksJobStepLookupListParams,
  AppJobLinksListParams,
  AppJobLinksUpdateParams,
  AppJobLinksWithNavigationPropertiesDetailParams,
  AppJobNotesDeleteParams,
  AppJobNotesDetailParams,
  AppJobNotesExtnDeleteParams,
  AppJobNotesExtnDetailParams,
  AppJobNotesExtnJobLookupListParams,
  AppJobNotesExtnJobStepLookupListParams,
  AppJobNotesExtnListParams,
  AppJobNotesExtnUpdateParams,
  AppJobNotesExtnWithNavigationPropertiesDetailParams,
  AppJobNotesJobLookupListParams,
  AppJobNotesJobStepLookupListParams,
  AppJobNotesListParams,
  AppJobNotesUpdateParams,
  AppJobNotesWithNavigationPropertiesDetailParams,
  AppJobOutcomesDeleteParams,
  AppJobOutcomesDetailParams,
  AppJobOutcomesExtnDeleteParams,
  AppJobOutcomesExtnDetailParams,
  AppJobOutcomesExtnListParams,
  AppJobOutcomesExtnUpdateParams,
  AppJobOutcomesListParams,
  AppJobOutcomesUpdateParams,
  AppJobRiskByJobStepListParams,
  AppJobRiskDeleteParams,
  AppJobRiskForExportListParams,
  AppJobRiskListParams,
  AppJobRiskWithHistoryDetailParams,
  AppJobRisksByJobStepListParams,
  AppJobRisksDeleteParams,
  AppJobRisksExportListParams,
  AppJobRisksListParams,
  AppJobRisksWithHistoryListParams,
  AppJobStepApprovalApprovalsByJobDetailParams,
  AppJobStepApprovalApprovalsByJobStepDetailParams,
  AppJobStepApprovalMyPendingApprovalsListParams,
  AppJobStepApprovalRemoveApproverDeleteParams,
  AppJobStepApprovalsReportDetailsListParams,
  AppJobStepBasedApprovalReportReportListParams,
  AppJobStepChecklistGroupsDeleteParams,
  AppJobStepChecklistGroupsDetailParams,
  AppJobStepChecklistGroupsExtnDeleteParams,
  AppJobStepChecklistGroupsExtnDetailParams,
  AppJobStepChecklistGroupsExtnJobStepLookupListParams,
  AppJobStepChecklistGroupsExtnListParams,
  AppJobStepChecklistGroupsExtnUpdateParams,
  AppJobStepChecklistGroupsExtnWithNavigationPropertiesDetailParams,
  AppJobStepChecklistGroupsJobStepLookupListParams,
  AppJobStepChecklistGroupsListParams,
  AppJobStepChecklistGroupsUpdateParams,
  AppJobStepChecklistGroupsWithNavigationPropertiesDetailParams,
  AppJobStepChecklistsDeleteParams,
  AppJobStepChecklistsDetailParams,
  AppJobStepChecklistsExtnChecklistGroupAndItemDetailParams,
  AppJobStepChecklistsExtnDeleteParams,
  AppJobStepChecklistsExtnDetailParams,
  AppJobStepChecklistsExtnJobStepChecklistGroupLookupListParams,
  AppJobStepChecklistsExtnListParams,
  AppJobStepChecklistsExtnUpdateParams,
  AppJobStepChecklistsExtnWithNavigationPropertiesDetailParams,
  AppJobStepChecklistsJobStepChecklistGroupLookupListParams,
  AppJobStepChecklistsListParams,
  AppJobStepChecklistsUpdateParams,
  AppJobStepChecklistsWithNavigationPropertiesDetailParams,
  AppJobStepUsersDeleteParams,
  AppJobStepUsersDetailParams,
  AppJobStepUsersExtnDeleteParams,
  AppJobStepUsersExtnDetailParams,
  AppJobStepUsersExtnIdentityUserLookupListParams,
  AppJobStepUsersExtnJobStepLookupListParams,
  AppJobStepUsersExtnListParams,
  AppJobStepUsersExtnUpdateParams,
  AppJobStepUsersExtnWithNavigationPropertiesDetailParams,
  AppJobStepUsersIdentityUserLookupListParams,
  AppJobStepUsersJobStepLookupListParams,
  AppJobStepUsersListParams,
  AppJobStepUsersUpdateParams,
  AppJobStepUsersWithNavigationPropertiesDetailParams,
  AppJobStepsDeleteParams,
  AppJobStepsDetailParams,
  AppJobStepsExtnDeleteParams,
  AppJobStepsExtnDetailParams,
  AppJobStepsExtnJobLookupListParams,
  AppJobStepsExtnListParams,
  AppJobStepsExtnUpdateParams,
  AppJobStepsExtnWithNavigationPropertiesDetailParams,
  AppJobStepsJobLookupListParams,
  AppJobStepsListParams,
  AppJobStepsUpdateParams,
  AppJobStepsWithNavigationPropertiesDetailParams,
  AppJobTimeLogsAllDeleteParams,
  AppJobTimeLogsAsExcelFileListParams,
  AppJobTimeLogsDelete2Params,
  AppJobTimeLogsDeleteParams,
  AppJobTimeLogsDetailParams,
  AppJobTimeLogsExtnAllDeleteParams,
  AppJobTimeLogsExtnAsExcelFileListParams,
  AppJobTimeLogsExtnDelete2Params,
  AppJobTimeLogsExtnDeleteParams,
  AppJobTimeLogsExtnDetailParams,
  AppJobTimeLogsExtnIdentityUserLookupListParams,
  AppJobTimeLogsExtnListParams,
  AppJobTimeLogsExtnUpdateParams,
  AppJobTimeLogsExtnWithNavigationPropertiesDetailParams,
  AppJobTimeLogsIdentityUserLookupListParams,
  AppJobTimeLogsListParams,
  AppJobTimeLogsUpdateParams,
  AppJobTimeLogsWithNavigationPropertiesDetailParams,
  AppJobsDeleteParams,
  AppJobsDetailParams,
  AppJobsExtAddJobWorkingDocumentsCreateParams,
  AppJobsExtClearCacheListParams,
  AppJobsExtDeleteParams,
  AppJobsExtDetailParams,
  AppJobsExtGetCacheItemListParams,
  AppJobsExtGetJobLinksCountListParams,
  AppJobsExtGetJobLinksListParams,
  AppJobsExtGetJobParametersListParams,
  AppJobsExtGetJobWorkingDocumentsListParams,
  AppJobsExtGetStepListListParams,
  AppJobsExtGetStepUsersListParams,
  AppJobsExtGetUserAllJobsListParams,
  AppJobsExtJobOutcomeLookupListParams,
  AppJobsExtListParams,
  AppJobsExtOrganizationUnitLookupListParams,
  AppJobsExtRegenerateWorkingDocumentCreateParams,
  AppJobsExtRetryTaskExecutionCreateParams,
  AppJobsExtStepActionsListParams,
  AppJobsExtTemplateLookupListParams,
  AppJobsExtToggleStepNotificationsListParams,
  AppJobsExtUpdateJobChecklistItemsCreateParams,
  AppJobsExtUpdateParams,
  AppJobsExtWithNavigationPropertiesDetailParams,
  AppJobsExtWorkgroupWorkloadByUserListParams,
  AppJobsExtWorkgroupWorkloadListParams,
  AppJobsJobOutcomeLookupListParams,
  AppJobsListParams,
  AppJobsOrganizationUnitLookupListParams,
  AppJobsTemplateLookupListParams,
  AppJobsUpdateParams,
  AppJobsWithNavigationPropertiesDetailParams,
  AppKeyMapsDeleteParams,
  AppKeyMapsDetailParams,
  AppKeyMapsExtnDeleteParams,
  AppKeyMapsExtnDetailParams,
  AppKeyMapsExtnListParams,
  AppKeyMapsExtnUpdateParams,
  AppKeyMapsListParams,
  AppKeyMapsUpdateParams,
  AppKnowledgeBaseDocumentsDeleteParams,
  AppKnowledgeBaseDocumentsListParams,
  AppKnowledgeBaseDocumentsReprocessCreateParams,
  AppKnowledgeBaseSearchListParams,
  AppMcpServerAuditLogsDeleteParams,
  AppMcpServerAuditLogsDetailParams,
  AppMcpServerAuditLogsListParams,
  AppMcpServerAuditLogsMcpServerLookupListParams,
  AppMcpServerAuditLogsUpdateParams,
  AppMcpServerAuditLogsWithNavigationPropertiesDetailParams,
  AppMcpServerToolsByMcpServerListParams,
  AppMcpServerToolsDeleteParams,
  AppMcpServerToolsDetailParams,
  AppMcpServerToolsDetailedByMcpServerListParams,
  AppMcpServerToolsListParams,
  AppMcpServerToolsMcpServerLookupListParams,
  AppMcpServerToolsUpdateParams,
  AppMcpServerToolsWithNavigationPropertiesDetailParams,
  AppMcpServersAllDeleteParams,
  AppMcpServersDelete2Params,
  AppMcpServersDeleteParams,
  AppMcpServersDetailParams,
  AppMcpServersListParams,
  AppMcpServersRefreshToolsCreateParams,
  AppMcpServersTestCallCreateParams,
  AppMcpServersUpdateParams,
  AppMessageExtnCountListParams,
  AppMessageExtnDeleteParams,
  AppMessageExtnDetailParams,
  AppMessageExtnIdentityUserLookupListParams,
  AppMessageExtnJobLookupListParams,
  AppMessageExtnJobStepLookupListParams,
  AppMessageExtnListParams,
  AppMessageExtnMarkMessagesReadCreateParams,
  AppMessageExtnMessagesDeleteParams,
  AppMessageExtnPagedListListParams,
  AppMessageExtnUpdateParams,
  AppMessageExtnWithNavigationPropertiesListParams,
  AppMessagesDeleteParams,
  AppMessagesDetailParams,
  AppMessagesExtnDeleteParams,
  AppMessagesExtnDetailParams,
  AppMessagesExtnGetCommunicationsListParams,
  AppMessagesExtnGetCountsListParams,
  AppMessagesExtnGetMessagesListParams,
  AppMessagesExtnIdentityUserLookupListParams,
  AppMessagesExtnJobLookupListParams,
  AppMessagesExtnJobStepLookupListParams,
  AppMessagesExtnMessageMarkAsReadListParams,
  AppMessagesExtnMessagesDeleteDeleteParams,
  AppMessagesExtnUpdateParams,
  AppMessagesExtnWithNavigationPropertiesDetailParams,
  AppMessagesIdentityUserLookupListParams,
  AppMessagesJobLookupListParams,
  AppMessagesJobStepLookupListParams,
  AppMessagesListParams,
  AppMessagesUpdateParams,
  AppMessagesWithNavigationPropertiesDetailParams,
  AppMotrQDocumentPlaceholdersByTemplateIdDetailParams,
  AppMotrQServiceRequestClientsDetailParams,
  AppMotrQServiceRequestMattersDetailParams,
  AppMotrQServiceRequestParametersDetailParams,
  AppMotrQServiceRequestPrefillDetailParams,
  AppNdAuditLogsDeleteParams,
  AppNdAuditLogsDetailParams,
  AppNdAuditLogsExtnDeleteParams,
  AppNdAuditLogsExtnDetailParams,
  AppNdAuditLogsExtnListParams,
  AppNdAuditLogsExtnUpdateParams,
  AppNdAuditLogsListParams,
  AppNdAuditLogsUpdateParams,
  AppNotificationsDeleteParams,
  AppNotificationsDetailParams,
  AppNotificationsExtnDeleteParams,
  AppNotificationsExtnDetailParams,
  AppNotificationsExtnListParams,
  AppNotificationsExtnTemplateLookupListParams,
  AppNotificationsExtnUpdateParams,
  AppNotificationsExtnWithNavigationPropertiesDetailParams,
  AppNotificationsListParams,
  AppNotificationsTemplateLookupListParams,
  AppNotificationsUpdateParams,
  AppNotificationsWithNavigationPropertiesDetailParams,
  AppOrganizationUnitExtnAddMemberCreateParams,
  AppOrganizationUnitExtnAddRoleCreateParams,
  AppOrganizationUnitExtnBulkDeleteDeleteParams,
  AppOrganizationUnitExtnDeleteDeleteParams,
  AppOrganizationUnitExtnGetAvailableRolesListParams,
  AppOrganizationUnitExtnGetAvailableUsersListParams,
  AppOrganizationUnitExtnGetByIdListParams,
  AppOrganizationUnitExtnGetListAsyncListParams,
  AppOrganizationUnitExtnGetMembersAsyncListParams,
  AppOrganizationUnitExtnGetRolesAsyncListParams,
  AppOrganizationUnitExtnMoveAllUsersAsyncUpdateParams,
  AppOrganizationUnitExtnMoveAsyncUpdateParams,
  AppOrganizationUnitExtnRemoveMemberAsyncDeleteParams,
  AppOrganizationUnitExtnRemoveRoleAsyncDeleteParams,
  AppOrganizationUnitExtnUpdateAsyncUpdateParams,
  AppOutcomesDeleteParams,
  AppOutcomesDetailParams,
  AppOutcomesExtnDeleteParams,
  AppOutcomesExtnDetailParams,
  AppOutcomesExtnListParams,
  AppOutcomesExtnUpdateParams,
  AppOutcomesListParams,
  AppOutcomesUpdateParams,
  AppPackMcpServersByPackListParams,
  AppPackMcpServersDeleteParams,
  AppPackMcpServersDetailParams,
  AppPackMcpServersDetailedByPackListParams,
  AppPackMcpServersListParams,
  AppPackMcpServersMcpServerLookupListParams,
  AppPackMcpServersPackLookupListParams,
  AppPackMcpServersUpdateParams,
  AppPackMcpServersWithNavigationPropertiesDetailParams,
  AppPackSkillsByPackListParams,
  AppPackSkillsDeleteParams,
  AppPackSkillsDetailParams,
  AppPackSkillsDetailedByPackListParams,
  AppPackSkillsListParams,
  AppPackSkillsPackLookupListParams,
  AppPackSkillsSkillLookupListParams,
  AppPackSkillsUpdateParams,
  AppPackSkillsWithNavigationPropertiesDetailParams,
  AppPackVersionsAiModelLookupListParams,
  AppPackVersionsDeleteParams,
  AppPackVersionsDetailParams,
  AppPackVersionsListParams,
  AppPackVersionsPackLookupListParams,
  AppPackVersionsUpdateParams,
  AppPackVersionsWithNavigationPropertiesDetailParams,
  AppPacksAiModelLookupListParams,
  AppPacksAllDeleteParams,
  AppPacksDelete2Params,
  AppPacksDeleteParams,
  AppPacksDetailParams,
  AppPacksListParams,
  AppPacksPublishCreateParams,
  AppPacksRollbackCreateParams,
  AppPacksSetListedCreateParams,
  AppPacksUpdateParams,
  AppPacksWithNavigationPropertiesDetailParams,
  AppPasswordRequirementsValidatePasswordCreateParams,
  AppPowerReportsAsExcelFileListParams,
  AppPowerReportsDeleteParams,
  AppPowerReportsDetailParams,
  AppPowerReportsExtnAsExcelFileListParams,
  AppPowerReportsExtnDeleteParams,
  AppPowerReportsExtnDetailParams,
  AppPowerReportsExtnGetEmbedInfoListParams,
  AppPowerReportsExtnListParams,
  AppPowerReportsExtnUpdateParams,
  AppPowerReportsListParams,
  AppPowerReportsUpdateParams,
  AppRepoSyncHistoryDetailParams,
  AppRepoSyncHistoryListParams,
  AppReportExtDurationReportForStepsListParams,
  AppReportExtDurationReportListParams,
  AppReportExtGetJobHistoryListParams,
  AppReportExtGetJobTimelogsListParams,
  AppReportExtGetUserHistoryListParams,
  AppReportExtJobOutcomeReportListParams,
  AppReportExtNdAuditLogDetailsListParams,
  AppReportExtNdAuditLogsListParams,
  AppReportExtPerformanceDetailsListParams,
  AppReportExtSystemPerformanceDetailsListParams,
  AppReportExtSystemTagsPerformanceDetailsListParams,
  AppReportExtTagsReportListParams,
  AppReportExtUserDashboardDetailsListParams,
  AppSettingsClearCacheCreateParams,
  AppSettingsResetRolePermissionsCreateParams,
  AppSettingsSettingsListParams,
  AppSettingsSyncLanguageTextsCreateParams,
  AppSettingsUserSettingsListParams,
  AppSkillAuditLogsDeleteParams,
  AppSkillAuditLogsDetailParams,
  AppSkillAuditLogsListParams,
  AppSkillAuditLogsSkillLookupListParams,
  AppSkillAuditLogsUpdateParams,
  AppSkillAuditLogsWithNavigationPropertiesDetailParams,
  AppSkillResourcesBySkillListParams,
  AppSkillResourcesDeleteParams,
  AppSkillResourcesDetailParams,
  AppSkillResourcesDetailedBySkillListParams,
  AppSkillResourcesListParams,
  AppSkillResourcesSkillLookupListParams,
  AppSkillResourcesUpdateParams,
  AppSkillResourcesWithNavigationPropertiesDetailParams,
  AppSkillToolBindingsBySkillListParams,
  AppSkillToolBindingsDeleteParams,
  AppSkillToolBindingsDetailParams,
  AppSkillToolBindingsDetailedBySkillListParams,
  AppSkillToolBindingsListParams,
  AppSkillToolBindingsMcpServerLookupListParams,
  AppSkillToolBindingsSkillLookupListParams,
  AppSkillToolBindingsUpdateParams,
  AppSkillToolBindingsWithNavigationPropertiesDetailParams,
  AppSkillVersionsDeleteParams,
  AppSkillVersionsDetailParams,
  AppSkillVersionsListParams,
  AppSkillVersionsSkillLookupListParams,
  AppSkillVersionsUpdateParams,
  AppSkillVersionsWithNavigationPropertiesDetailParams,
  AppSkillsAllDeleteParams,
  AppSkillsDelete2Params,
  AppSkillsDeleteParams,
  AppSkillsDeprecateCreateParams,
  AppSkillsDetailParams,
  AppSkillsListParams,
  AppSkillsPublishCreateParams,
  AppSkillsRestoreCreateParams,
  AppSkillsRollbackCreateParams,
  AppSkillsUpdateParams,
  AppSnippetsDeleteParams,
  AppSnippetsDetailParams,
  AppSnippetsExtnDeleteParams,
  AppSnippetsExtnDetailParams,
  AppSnippetsExtnListParams,
  AppSnippetsExtnUpdateParams,
  AppSnippetsListParams,
  AppSnippetsUpdateParams,
  AppStepResponsibilityJobDetailParams,
  AppStepResponsibilityStepDetailParams,
  AppStepResponsibilityTimeBreakdownReportListParams,
  AppSyncHistoryDetailParams,
  AppTagCategoriesAsExcelFileListParams,
  AppTagCategoriesDeleteParams,
  AppTagCategoriesDetailParams,
  AppTagCategoriesExtnAsExcelFileListParams,
  AppTagCategoriesExtnDeleteParams,
  AppTagCategoriesExtnDetailParams,
  AppTagCategoriesExtnListParams,
  AppTagCategoriesExtnUpdateParams,
  AppTagCategoriesListParams,
  AppTagCategoriesUpdateParams,
  AppTagsAsExcelFileListParams,
  AppTagsDeleteParams,
  AppTagsDetailParams,
  AppTagsExtnAsExcelFileListParams,
  AppTagsExtnDeleteParams,
  AppTagsExtnDetailParams,
  AppTagsExtnListParams,
  AppTagsExtnTagCategoryLookupListParams,
  AppTagsExtnUpdateParams,
  AppTagsExtnWithNavigationPropertiesDetailParams,
  AppTagsListParams,
  AppTagsTagCategoryLookupListParams,
  AppTagsUpdateParams,
  AppTagsWithNavigationPropertiesDetailParams,
  AppTemplateAuditLogsDeleteParams,
  AppTemplateAuditLogsDetailParams,
  AppTemplateAuditLogsExtnDeleteParams,
  AppTemplateAuditLogsExtnDetailParams,
  AppTemplateAuditLogsExtnListParams,
  AppTemplateAuditLogsExtnUpdateParams,
  AppTemplateAuditLogsListParams,
  AppTemplateAuditLogsUpdateParams,
  AppTemplateDraftsDeleteParams,
  AppTemplateDraftsDetailParams,
  AppTemplateDraftsExtnCreateDraftDocumentPlaceholderCreateParams,
  AppTemplateDraftsExtnDeleteDraftDocumentPlaceholderDeleteParams,
  AppTemplateDraftsExtnDeleteDraftStepDeleteParams,
  AppTemplateDraftsExtnDeleteDraftTemplateChecklistGroupDeleteParams,
  AppTemplateDraftsExtnDeleteDraftTemplateChecklistItemsDeleteParams,
  AppTemplateDraftsExtnDeleteDraftTemplateCreateParams,
  AppTemplateDraftsExtnDeleteParams,
  AppTemplateDraftsExtnDetailParams,
  AppTemplateDraftsExtnGetDraftDocumentPlaceholdersListParams,
  AppTemplateDraftsExtnGetDraftStepDocumentsListParams,
  AppTemplateDraftsExtnGetDraftTemplateChecklistItemsListParams,
  AppTemplateDraftsExtnGetDraftTemplateCreateParams,
  AppTemplateDraftsExtnGetDraftTemplateStepsListParams,
  AppTemplateDraftsExtnListParams,
  AppTemplateDraftsExtnUpdateChecklistItemsCreateParams,
  AppTemplateDraftsExtnUpdateDraftDocumentPlaceholderUpdateParams,
  AppTemplateDraftsExtnUpdateDraftStepAiStepActionCreateParams,
  AppTemplateDraftsExtnUpdateDraftStepDocumentsCreateParams,
  AppTemplateDraftsExtnUpdateDraftTemplateCreateParams,
  AppTemplateDraftsExtnUpdateDraftTemplateStepCreateParams,
  AppTemplateDraftsExtnUpdateDraftTemplateStepPositionsCreateParams,
  AppTemplateDraftsExtnUpdateParams,
  AppTemplateDraftsListParams,
  AppTemplateDraftsUpdateParams,
  AppTemplateStepAiTasksAiTaskLookupListParams,
  AppTemplateStepAiTasksAllDeleteParams,
  AppTemplateStepAiTasksAsExcelFileListParams,
  AppTemplateStepAiTasksDelete2Params,
  AppTemplateStepAiTasksDeleteParams,
  AppTemplateStepAiTasksDetailParams,
  AppTemplateStepAiTasksListParams,
  AppTemplateStepAiTasksTemplateStepLookupListParams,
  AppTemplateStepAiTasksUpdateParams,
  AppTemplateStepAiTasksWithNavigationPropertiesDetailParams,
  AppTemplateStepChecklistGroupsDeleteParams,
  AppTemplateStepChecklistGroupsDetailParams,
  AppTemplateStepChecklistGroupsExtnDeleteChecklistGroupDeleteParams,
  AppTemplateStepChecklistGroupsExtnDeleteParams,
  AppTemplateStepChecklistGroupsExtnDetailParams,
  AppTemplateStepChecklistGroupsExtnListParams,
  AppTemplateStepChecklistGroupsExtnTemplateStepLookupListParams,
  AppTemplateStepChecklistGroupsExtnUpdateParams,
  AppTemplateStepChecklistGroupsExtnWithNavigationPropertiesDetailParams,
  AppTemplateStepChecklistGroupsListParams,
  AppTemplateStepChecklistGroupsTemplateStepLookupListParams,
  AppTemplateStepChecklistGroupsUpdateParams,
  AppTemplateStepChecklistGroupsWithNavigationPropertiesDetailParams,
  AppTemplateStepChecklistsDeleteParams,
  AppTemplateStepChecklistsDetailParams,
  AppTemplateStepChecklistsExtnDeleteChecklistItemDeleteParams,
  AppTemplateStepChecklistsExtnDeleteParams,
  AppTemplateStepChecklistsExtnDetailParams,
  AppTemplateStepChecklistsExtnGetTemplateStepGroupAndItemsDetailParams,
  AppTemplateStepChecklistsExtnListParams,
  AppTemplateStepChecklistsExtnTemplateStepChecklistGroupLookupListParams,
  AppTemplateStepChecklistsExtnUpdateParams,
  AppTemplateStepChecklistsExtnWithNavigationPropertiesDetailParams,
  AppTemplateStepChecklistsListParams,
  AppTemplateStepChecklistsTemplateStepChecklistGroupLookupListParams,
  AppTemplateStepChecklistsUpdateParams,
  AppTemplateStepChecklistsWithNavigationPropertiesDetailParams,
  AppTemplateStepExtnAiTaskLookupListParams,
  AppTemplateStepExtnDeleteParams,
  AppTemplateStepExtnDetailParams,
  AppTemplateStepExtnListParams,
  AppTemplateStepExtnOrgUnitAndMembersListParams,
  AppTemplateStepExtnSetStepApproversCreateParams,
  AppTemplateStepExtnStepApprovalSettingsUpdateParams,
  AppTemplateStepExtnStepApproversDetailParams,
  AppTemplateStepExtnStepsListParams,
  AppTemplateStepExtnTemplateLookupListParams,
  AppTemplateStepExtnTemplateStepListParams,
  AppTemplateStepExtnUpdateParams,
  AppTemplateStepExtnWithNavigationPropertiesListParams,
  AppTemplateStepsDeleteParams,
  AppTemplateStepsDetailParams,
  AppTemplateStepsExtnAiTaskLookupListParams,
  AppTemplateStepsExtnDeleteParams,
  AppTemplateStepsExtnDetailParams,
  AppTemplateStepsExtnGetAllStepsListParams,
  AppTemplateStepsExtnGetOrgMemebersListParams,
  AppTemplateStepsExtnGetTemplateListListParams,
  AppTemplateStepsExtnGetTemplateStepListParams,
  AppTemplateStepsExtnStepApprovalSettingsUpdateParams,
  AppTemplateStepsExtnStepApproversCreateParams,
  AppTemplateStepsExtnStepApproversDetailParams,
  AppTemplateStepsExtnTemplateLookupListParams,
  AppTemplateStepsExtnUpdateParams,
  AppTemplateStepsExtnWithNavigationPropertiesDetailParams,
  AppTemplateStepsListParams,
  AppTemplateStepsTemplateLookupListParams,
  AppTemplateStepsUpdateParams,
  AppTemplateStepsWithNavigationPropertiesDetailParams,
  AppTemplateTypesDeleteParams,
  AppTemplateTypesDetailParams,
  AppTemplateTypesExtnDeleteParams,
  AppTemplateTypesExtnDetailParams,
  AppTemplateTypesExtnListParams,
  AppTemplateTypesExtnUpdateParams,
  AppTemplateTypesListParams,
  AppTemplateTypesUpdateParams,
  AppTemplatesDeleteParams,
  AppTemplatesDetailParams,
  AppTemplatesExtnCloneCreateParams,
  AppTemplatesExtnDeleteParams,
  AppTemplatesExtnDetailParams,
  AppTemplatesExtnGetAllTemplateWithStepsListParams,
  AppTemplatesExtnGetAllTemplatesListParams,
  AppTemplatesExtnGetServiceRequestTemplatesListParams,
  AppTemplatesExtnGetTemplateDetailsDetailParams,
  AppTemplatesExtnGetTemplateWithStepsListParams,
  AppTemplatesExtnListParams,
  AppTemplatesExtnPublishTemplateCreateParams,
  AppTemplatesExtnRemoveServiceRequestDetailParams,
  AppTemplatesExtnServiceRequestFieldsDetailParams,
  AppTemplatesExtnServiceRequestFieldsUpdateParams,
  AppTemplatesExtnServiceRequestWorkgroupsDetailParams,
  AppTemplatesExtnSetAsServiceRequestDetailParams,
  AppTemplatesExtnSetAsServiceRequestV2CreateParams,
  AppTemplatesExtnTemplateTypeLookupListParams,
  AppTemplatesExtnUpdateDraftCreateParams,
  AppTemplatesExtnUpdateParams,
  AppTemplatesExtnWithNavigationPropertiesDetailParams,
  AppTemplatesGetServiceRequestTemplatesListParams,
  AppTemplatesListParams,
  AppTemplatesTemplateTypeLookupListParams,
  AppTemplatesUpdateParams,
  AppTemplatesWithNavigationPropertiesDetailParams,
  AppTenantPackEnablementsAvailableHostPacksListParams,
  AppTenantPackEnablementsByPackListParams,
  AppTenantPackEnablementsDeleteParams,
  AppTenantPackEnablementsDetailParams,
  AppTenantPackEnablementsDetailedByPackListParams,
  AppTenantPackEnablementsDisableCreateParams,
  AppTenantPackEnablementsEnableCreateParams,
  AppTenantPackEnablementsListParams,
  AppTenantPackEnablementsPackLookupListParams,
  AppTenantPackEnablementsPackVersionLookupListParams,
  AppTenantPackEnablementsUpdateParams,
  AppTenantPackEnablementsUpdateToLatestCreateParams,
  AppTenantPackEnablementsWithNavigationPropertiesDetailParams,
  AppUserAccountExtVerifyUserAccountListParams,
  AppUserEnrollmentLogsDeleteParams,
  AppUserEnrollmentLogsDetailParams,
  AppUserEnrollmentLogsExtnDeleteParams,
  AppUserEnrollmentLogsExtnDetailParams,
  AppUserEnrollmentLogsExtnListParams,
  AppUserEnrollmentLogsExtnUpdateParams,
  AppUserEnrollmentLogsListParams,
  AppUserEnrollmentLogsUpdateParams,
  AppUserExtGetListAsyncListParams,
  AppUserExtGetOrgunitUsersListParams,
  AppUserExtGetOrgunitsListParams,
  AppUserExtGetProfilePicsListParams,
  AppUserExtGetUserListParams,
  AppUserExtGetUserOrgunitsListParams,
  AppUserExtGetUsernamesListParams,
  AppUserExtGetUsersBasicDetailsAsyncCreateParams,
  AppUserExtGetUsersByEmailsAsyncListParams,
  AppUserExtGetUsersByRoleListParams,
  AppUserExtGetWorkgroupChildUsersListParams,
  AppUserExtGetWorkgroupUsersListParams,
  AppUserExtUsersListListParams,
  AppWebRequestBase64EncodeCreateParams,
  AppWebRequestExecuteRequestCreateParams,
  AppWebRequestFormRequestCreateParams,
  AppWebRequestHeaderCreateParams,
  AppWebRequestParameterCreateParams,
  AppWebRequestSetupCreateParams,
  AuditLoggingAuditLogsDetailParams,
  AuditLoggingAuditLogsEntityChangeWithUsernameDetailParams,
  AuditLoggingAuditLogsEntityChangesDetailParams,
  AuditLoggingAuditLogsEntityChangesListParams,
  AuditLoggingAuditLogsEntityChangesWithUsernameListParams,
  AuditLoggingAuditLogsListParams,
  AuditLoggingAuditLogsStatisticsAverageExecutionDurationPerDayListParams,
  AuditLoggingAuditLogsStatisticsErrorRateListParams,
  FeatureManagementFeaturesDeleteParams,
  FeatureManagementFeaturesListParams,
  FeatureManagementFeaturesUpdateParams,
  IdentityClaimTypesDeleteParams,
  IdentityClaimTypesDetailParams,
  IdentityClaimTypesListParams,
  IdentityClaimTypesUpdateParams,
  IdentityOrganizationUnitsAvailableRolesListParams,
  IdentityOrganizationUnitsAvailableUsersListParams,
  IdentityOrganizationUnitsDeleteParams,
  IdentityOrganizationUnitsDetailParams,
  IdentityOrganizationUnitsListParams,
  IdentityOrganizationUnitsMembersDeleteParams,
  IdentityOrganizationUnitsMembersListParams,
  IdentityOrganizationUnitsMembersUpdateParams,
  IdentityOrganizationUnitsMoveAllUsersUpdateParams,
  IdentityOrganizationUnitsMoveUpdateParams,
  IdentityOrganizationUnitsRolesDeleteParams,
  IdentityOrganizationUnitsRolesListParams,
  IdentityOrganizationUnitsRolesUpdateParams,
  IdentityOrganizationUnitsUpdateParams,
  IdentityRolesClaimsListParams,
  IdentityRolesClaimsUpdateParams,
  IdentityRolesDeleteParams,
  IdentityRolesDetailParams,
  IdentityRolesListParams,
  IdentityRolesMoveAllUsersUpdateParams,
  IdentityRolesUpdateParams,
  IdentitySecurityLogsDetailParams,
  IdentitySecurityLogsListParams,
  IdentitySecurityLogsMyDetailParams,
  IdentitySecurityLogsMyListParams,
  IdentityUsersByEmailDetailParams,
  IdentityUsersByIdDetailParams,
  IdentityUsersByUsernameDetailParams,
  IdentityUsersChangePasswordUpdateParams,
  IdentityUsersClaimsListParams,
  IdentityUsersClaimsUpdateParams,
  IdentityUsersDeleteParams,
  IdentityUsersDetailParams,
  IdentityUsersDownloadImportInvalidUsersFileListParams,
  IdentityUsersExportAsCsvListParams,
  IdentityUsersExportAsExcelListParams,
  IdentityUsersImportUsersFromFileCreateParams,
  IdentityUsersImportUsersSampleFileListParams,
  IdentityUsersListParams,
  IdentityUsersLockUpdateParams,
  IdentityUsersLookupByUsernameDetailParams,
  IdentityUsersLookupCountListParams,
  IdentityUsersLookupDetailParams,
  IdentityUsersLookupSearchListParams,
  IdentityUsersOrganizationUnitsListParams,
  IdentityUsersRolesListParams,
  IdentityUsersRolesUpdateParams,
  IdentityUsersTwoFactorEnabledListParams,
  IdentityUsersTwoFactorUpdateParams,
  IdentityUsersUnlockUpdateParams,
  IdentityUsersUpdateParams,
  LanguageManagementLanguageTextsDetailParams,
  LanguageManagementLanguageTextsListParams,
  LanguageManagementLanguageTextsRestoreUpdateParams,
  LanguageManagementLanguageTextsUpdateParams,
  LanguageManagementLanguagesDeleteParams,
  LanguageManagementLanguagesDetailParams,
  LanguageManagementLanguagesListParams,
  LanguageManagementLanguagesSetAsDefaultUpdateParams,
  LanguageManagementLanguagesUpdateParams,
  MotrAISkillsAiToolCatalogDto,
  MotrAISkillsAiToolOptionDto,
  MotrAiChatAiCapabilityDto,
  MotrAiChatAiChatResponseDto,
  MotrAiChatAiConversationDto,
  MotrAiChatAiConversationMessageDto,
  MotrAiChatCreateConversationInput,
  MotrAiChatSendMessageInput,
  MotrAiChatSkillAuthoringMessageInputDto,
  MotrAiChatSkillPatchDto,
  MotrAiModelsAiModelCreateDto,
  MotrAiModelsAiModelDto,
  MotrAiModelsAiModelUpdateDto,
  MotrAiModelsAiModelWithNavigationPropertiesDto,
  MotrAiProvidersAiProviderCreateDto,
  MotrAiProvidersAiProviderDto,
  MotrAiProvidersAiProviderUpdateDto,
  MotrAiServicesAiAnalyzeRequest,
  MotrAiServicesAiAnalyzeResponse,
  MotrAiServicesAiMessageDetail,
  MotrAiServicesAiTaskExecutionDto,
  MotrAiServicesJobsData,
  MotrAiServicesSkillsSkillTestRunInputDto,
  MotrAiTaskExecutionsAiTaskExecutionCreateDto,
  MotrAiTaskExecutionsAiTaskExecutionDto,
  MotrAiTaskExecutionsAiTaskExecutionUpdateDto,
  MotrAiTaskExecutionsAiTaskExecutionWithNavigationPropertiesDto,
  MotrAiTaskOutputsAiTaskOutputCreateDto,
  MotrAiTaskOutputsAiTaskOutputDto,
  MotrAiTaskOutputsAiTaskOutputUpdateDto,
  MotrAiTaskOutputsAiTaskOutputWithNavigationPropertiesDto,
  MotrAiTaskStepsAiTaskStepCreateDto,
  MotrAiTaskStepsAiTaskStepDto,
  MotrAiTaskStepsAiTaskStepUpdateDto,
  MotrAiTasksAiTaskCreateDto,
  MotrAiTasksAiTaskDto,
  MotrAiTasksAiTaskUpdateDto,
  MotrAiTasksAiTaskWithNavigationPropertiesDto,
  MotrApiKeysApiKeyDto,
  MotrApiKeysCreateApiKeyDto,
  MotrApiKeysUpdateApiKeyDto,
  MotrBrandingLogoUploadResultDto,
  MotrBrandingLogoUrlsDto,
  MotrCabinetMetadataSchemasCabinetMetadataSchemaDto,
  MotrCabinetMetadataSchemasUpdateMetadataSchemaInput,
  MotrCabinetsCabinetCreateDto,
  MotrCabinetsCabinetDto,
  MotrCabinetsCabinetUpdateDto,
  MotrClientDashboardClientDocumentDto,
  MotrClientDashboardClientRequestDto,
  MotrClientDashboardClientRequestTimelineDto,
  MotrClientFeedbackFeedbackTokenStatusDto,
  MotrClientFeedbackSubmitFeedbackByTokenDto,
  MotrClientMattersClientMatterCreateDto,
  MotrClientMattersClientMatterDto,
  MotrClientMattersClientMatterUpdateDto,
  MotrClosingBinderDocumentInputDto,
  MotrDataFormsDataFormCreateDto,
  MotrDataFormsDataFormDto,
  MotrDataFormsDataFormUpdateDto,
  MotrDataSyncExecuteWorkgroupCloneInput,
  MotrDataSyncJobMatterTypeSyncQueuedDto,
  MotrDataSyncStartJobMatterTypeSyncDto,
  MotrDataSyncWorkgroupClonePreviewDto,
  MotrDataSyncWorkgroupClonePreviewInput,
  MotrDataSyncWorkgroupCloneResultDto,
  MotrDocumentLinksDocumentLinkCreateDto,
  MotrDocumentLinksDocumentLinkDto,
  MotrDocumentLinksDocumentLinkUpdateDto,
  MotrDocumentPlaceHoldersDocumentPlaceHolderBulkCreateOrUpdateDto,
  MotrDocumentPlaceHoldersDocumentPlaceHolderCreateDto,
  MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
  MotrDocumentPlaceHoldersDocumentPlaceHolderUpdateDto,
  MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDto,
  MotrDocumentTemplatesDocumentPlaceholderDetailsVm,
  MotrDocumentTemplatesDocumentTemplateCreateDto,
  MotrDocumentTemplatesDocumentTemplateDto,
  MotrDocumentTemplatesDocumentTemplateUpdateDto,
  MotrDocumentsDocumentCreateDto,
  MotrDocumentsDocumentDto,
  MotrDocumentsDocumentEnvelopeViewModel,
  MotrDocumentsDocumentUpdateDto,
  MotrDocumentsDocumentWithNavigationPropertiesDto,
  MotrDocumentsGetProviderSecureLinkVm,
  MotrDocumentsModelsCabinetSyncVm,
  MotrDocumentsModelsCreateDocRepoRecord,
  MotrDocumentsModelsDocumentRepoCabinetInfoVm,
  MotrDocumentsModelsDocumentRepoClientInfoVm,
  MotrDocumentsModelsDocumentRepoMatterInfoVm,
  MotrDocumentsModelsFollowDocumentsVm,
  MotrDocumentsModelsUploadWorkingDocumentVm,
  MotrEmailConversationsEmailConversationCreateDto,
  MotrEmailConversationsEmailConversationDto,
  MotrEmailConversationsEmailConversationUpdateDto,
  MotrEmailConversationsEmailConversationWithNavigationPropertiesDto,
  MotrEmailMonitoringDtosEmailJobCreationRequestDto,
  MotrEmailMonitoringDtosWorkflowDefinitionsForAiDto,
  MotrEmailTemplatesEmailTemplateCreateDto,
  MotrEmailTemplatesEmailTemplateDto,
  MotrEmailTemplatesEmailTemplateUpdateDto,
  MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDto,
  MotrEntityRecordsEntityRecordBulkUploadInspectResultDto,
  MotrEntityRecordsEntityRecordBulkUploadResultDto,
  MotrEntityRecordsEntityRecordCreateDto,
  MotrEntityRecordsEntityRecordDto,
  MotrEntityRecordsEntityRecordUpdateDto,
  MotrEntityTypesEntityTypeCreateDto,
  MotrEntityTypesEntityTypeDto,
  MotrEntityTypesEntityTypeUpdateDto,
  MotrEnvelopesEnvelopeCreateDto,
  MotrEnvelopesEnvelopeDto,
  MotrEnvelopesEnvelopeUpdateDto,
  MotrEnvelopesEnvelopeWithNavigationPropertiesDto,
  MotrFiltersFilterCreateDto,
  MotrFiltersFilterDto,
  MotrFiltersFilterUpdateDto,
  MotrIdentityPasswordRequirementsDto,
  MotrJobActionsJobActionCreateDto,
  MotrJobActionsJobActionDto,
  MotrJobActionsJobActionLogDto,
  MotrJobActionsJobActionUpdateDto,
  MotrJobActionsJobActionWithNavigationPropertiesDto,
  MotrJobDataFormsJobDataFormCreateDto,
  MotrJobDataFormsJobDataFormDto,
  MotrJobDataFormsJobDataFormUpdateDto,
  MotrJobDataFormsJobDataFormWithNavigationPropertiesDto,
  MotrJobHoldsJobHoldCreateDto,
  MotrJobHoldsJobHoldDto,
  MotrJobHoldsJobHoldUpdateDto,
  MotrJobHoldsJobHoldWithNavigationPropertiesDto,
  MotrJobImprovementsCreateJobImprovementDto,
  MotrJobImprovementsImprovementStatusHistoryDto,
  MotrJobImprovementsImprovementWithHistoryDto,
  MotrJobImprovementsJobImprovementReportDto,
  MotrJobImprovementsUpdateImprovementStatusDto,
  MotrJobLinksJobLinkCreateDto,
  MotrJobLinksJobLinkDto,
  MotrJobLinksJobLinkDtoVm,
  MotrJobLinksJobLinkUpdateDto,
  MotrJobLinksJobLinkWithNavigationPropertiesDto,
  MotrJobLinksJobLinksVM,
  MotrJobNotesJobNoteCreateDto,
  MotrJobNotesJobNoteDto,
  MotrJobNotesJobNoteUpdateDto,
  MotrJobNotesJobNoteWithNavigationPropertiesDto,
  MotrJobOutcomesJobOutcomeCreateDto,
  MotrJobOutcomesJobOutcomeDto,
  MotrJobOutcomesJobOutcomeUpdateDto,
  MotrJobRisksCreateJobRiskDto,
  MotrJobRisksJobRiskDto,
  MotrJobRisksJobRiskReportDto,
  MotrJobRisksRiskControlMaturityHistoryDto,
  MotrJobRisksRiskWithHistoryDto,
  MotrJobRisksUpdateControlMaturityDto,
  MotrJobStepApprovalsAddJobStepApproverDto,
  MotrJobStepApprovalsAddJobStepApproversDto,
  MotrJobStepApprovalsCreateTemplateStepApproverDto,
  MotrJobStepApprovalsDelegateApprovalDto,
  MotrJobStepApprovalsJobStepApprovalDto,
  MotrJobStepApprovalsSendApprovalEmailsDto,
  MotrJobStepApprovalsSubmitApprovalDto,
  MotrJobStepApprovalsTemplateStepApproverDto,
  MotrJobStepApprovalsUpdateStepApprovalSettingsDto,
  MotrJobStepChecklistGroupsJobStepChecklistGroupCreateDto,
  MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
  MotrJobStepChecklistGroupsJobStepChecklistGroupUpdateDto,
  MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDto,
  MotrJobStepChecklistsAssignChecklistItemsInput,
  MotrJobStepChecklistsJobStepCheckListGroupAndItems,
  MotrJobStepChecklistsJobStepChecklistCreateAndLogDto,
  MotrJobStepChecklistsJobStepChecklistCreateDto,
  MotrJobStepChecklistsJobStepChecklistDto,
  MotrJobStepChecklistsJobStepChecklistUpdateDto,
  MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDto,
  MotrJobStepChecklistsMyAssignedChecklistItemDto,
  MotrJobStepChecklistsTransferChecklistItemsInput,
  MotrJobStepChecklistsUpdateChecklistDueDateInput,
  MotrJobStepUsersJobStepUserCreateDto,
  MotrJobStepUsersJobStepUserDto,
  MotrJobStepUsersJobStepUserUpdateDto,
  MotrJobStepUsersJobStepUserWithNavigationPropertiesDto,
  MotrJobStepsJobStepCreateDto,
  MotrJobStepsJobStepDto,
  MotrJobStepsJobStepUpdateDto,
  MotrJobStepsJobStepWithNavigationPropertiesDto,
  MotrJobTimeLogsJobTimeLogCreateDto,
  MotrJobTimeLogsJobTimeLogDto,
  MotrJobTimeLogsJobTimeLogUpdateDto,
  MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDto,
  MotrJobsAddJobCheckListItemRequest,
  MotrJobsAddJobStepViewModel,
  MotrJobsAddRemoveStepUsers,
  MotrJobsAddUpdateCheckListGroupAndItemRequest,
  MotrJobsAddUpdateWorkingDocumentsVm,
  MotrJobsBulkImportRequest,
  MotrJobsDocumentExceptionDecisionResponseVM,
  MotrJobsDocumentExceptionDecisionVM,
  MotrJobsDurationReportDataModel,
  MotrJobsEmailTemplateFilters,
  MotrJobsEnrollUserRequestVm,
  MotrJobsGenericEntity,
  MotrJobsGetJobHistoryResponse,
  MotrJobsGetJobStepEmailTemplate,
  MotrJobsGetJobTimeLogReportResponse,
  MotrJobsGetJobsRequest,
  MotrJobsGetJobsWithNavigationPropertiesRequest,
  MotrJobsJobActionResponse,
  MotrJobsJobCreateDto,
  MotrJobsJobDashboardVM,
  MotrJobsJobDocumentAccessDto,
  MotrJobsJobDocumentReadyForSigningDto,
  MotrJobsJobDto,
  MotrJobsJobExtnDto,
  MotrJobsJobHistoryFilters,
  MotrJobsJobOutputEntity,
  MotrJobsJobStepAdhocEmailTemplateRespose,
  MotrJobsJobStepChecklistGroupDtoVm,
  MotrJobsJobStepDetailResponse1MotrJobsJobStepVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrJobsJobStepOrderUpdate,
  MotrJobsJobUpdateDto,
  MotrJobsJobVm,
  MotrJobsJobWithNavigationPropertiesDto,
  MotrJobsJobWithNavigationPropertiesVm,
  MotrJobsKeyValueParentVM,
  MotrJobsKeyValueSequenceVm,
  MotrJobsKeyValueVM,
  MotrJobsLinkJobRequestVm,
  MotrJobsMyJobDto,
  MotrJobsOwnerDetailVm,
  MotrJobsPipelineRepotRequest,
  MotrJobsPipelineRepotResponse,
  MotrJobsUpdateJboStepActionRequest,
  MotrJobsUpdateJobAllowClient,
  MotrJobsUpdateJobDataFormVm,
  MotrJobsUpdateJobGuidlineRequest,
  MotrJobsUpdateJobStepDueDateRequest,
  MotrJobsWorkGroupUserDto,
  MotrJobsWorkGroupUserResponseVm,
  MotrJobsWorkgroupPipelineRepotRequest,
  MotrJobsWorkgroupPipelineRepotResponse,
  MotrJobsWorkgroupWorkloadVm,
  MotrJobsWorkingDocument,
  MotrKeyMapsKeyMapCreateDto,
  MotrKeyMapsKeyMapDto,
  MotrKeyMapsKeyMapUpdateDto,
  MotrKnowledgeBaseKnowledgeDocumentDto,
  MotrKnowledgeBaseKnowledgeSearchResultDto,
  MotrLanguageTextsBulkUpdateLanguageTextDto,
  MotrLanguageTextsBulkUpdateLanguageTextResultDto,
  MotrMessagesDeliverSecureLink,
  MotrMessagesMessageCreateDto,
  MotrMessagesMessageDto,
  MotrMessagesMessageUpdateDto,
  MotrMessagesMessageWithNavigationPropertiesDto,
  MotrMessagesSendBroadcastMessageViewModel,
  MotrMotrQMotrQDocumentPlaceholderDto,
  MotrMotrQMotrQQuestionnaireDto,
  MotrMotrQMotrQTemplateDto,
  MotrMotrQQuestionnaireResponseDto,
  MotrMotrQServiceRequestParameterDto,
  MotrMotrQServiceRequestPrefillItemDto,
  MotrNdAuditLogsNdAuditLogCreateDto,
  MotrNdAuditLogsNdAuditLogDto,
  MotrNdAuditLogsNdAuditLogUpdateDto,
  MotrNotificationsNotificationCreateDto,
  MotrNotificationsNotificationDto,
  MotrNotificationsNotificationUpdateDto,
  MotrNotificationsNotificationWithNavigationPropertiesDto,
  MotrOrganizationsAddClientWorkGroupWithUsers,
  MotrOrganizationsResolveOrganizationUnitsInput,
  MotrOutcomesOutcomeCreateDto,
  MotrOutcomesOutcomeDto,
  MotrOutcomesOutcomeUpdateDto,
  MotrPowerReportsPowerReportCreateDto,
  MotrPowerReportsPowerReportDto,
  MotrPowerReportsPowerReportUpdateDto,
  MotrReportsAiActivityJobActivityResponseDto,
  MotrReportsAiUsageAiHealthDto,
  MotrReportsAiUsageAiUsageSummaryDto,
  MotrReportsAiUsageAiUsageTrendDto,
  MotrReportsDashboardSummaryRequest,
  MotrReportsDashboardSummaryResponse,
  MotrReportsJobStepApprovalsJobStepApprovalsFilterOptionsDto,
  MotrReportsJobStepBasedApprovalJobStepBasedApprovalPersonDto,
  MotrReportsMatterTypeFilterOptionDto,
  MotrReportsNdAuditLogResponseModel,
  MotrReportsPerformaceReportResponseViewModel,
  MotrReportsTagsPerformaceReportResponseViewModel,
  MotrReportsUserDashboardGraphResponseModel,
  MotrResponseMessage,
  MotrSettingsLanguageListViewModel,
  MotrSettingsLanguageSyncViewModel,
  MotrSharedDownloadTokenResultDto,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsDocumentRepositoryFoldersMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsCreateDocRepoRecordResponseMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsDocumentRepoUserDetailVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsDownloadDocumentResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsGetDocumentResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsUploadedDocsListResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrJobsWorkingDocumentVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrPowerReportsPowerBIReportResponseVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrSyncedDataBulkPushResultDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1MotrTemplatesTemplateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  MotrSharedModelsGenericResponseDataVM1SystemCollectionsGenericList1MotrDocumentTemplatesDocumentPlaceholderDetailsVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNullSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E,
  MotrSharedModelsGenericResponseVM,
  MotrSharedOrganizationUnitAndUserDto,
  MotrSharedUserBasicInfoDto,
  MotrSharedUserDto,
  MotrSharedUserExtDto,
  MotrSkillsAiTaskStepSkillCreateDto,
  MotrSkillsAiTaskStepSkillDto,
  MotrSkillsAiTaskStepSkillUpdateDto,
  MotrSkillsAiTaskStepSkillWithNavigationPropertiesDto,
  MotrSkillsEnablePackInputDto,
  MotrSkillsMcpServerAuditLogCreateDto,
  MotrSkillsMcpServerAuditLogDto,
  MotrSkillsMcpServerAuditLogUpdateDto,
  MotrSkillsMcpServerAuditLogWithNavigationPropertiesDto,
  MotrSkillsMcpServerCreateDto,
  MotrSkillsMcpServerDto,
  MotrSkillsMcpServerToolCreateDto,
  MotrSkillsMcpServerToolDto,
  MotrSkillsMcpServerToolUpdateDto,
  MotrSkillsMcpServerToolWithNavigationPropertiesDto,
  MotrSkillsMcpServerUpdateDto,
  MotrSkillsMcpToolCallResultDto,
  MotrSkillsPackCreateDto,
  MotrSkillsPackDto,
  MotrSkillsPackMcpServerCreateDto,
  MotrSkillsPackMcpServerDto,
  MotrSkillsPackMcpServerUpdateDto,
  MotrSkillsPackMcpServerWithNavigationPropertiesDto,
  MotrSkillsPackSkillCreateDto,
  MotrSkillsPackSkillDto,
  MotrSkillsPackSkillUpdateDto,
  MotrSkillsPackSkillWithNavigationPropertiesDto,
  MotrSkillsPackUpdateDto,
  MotrSkillsPackVersionCreateDto,
  MotrSkillsPackVersionDto,
  MotrSkillsPackVersionUpdateDto,
  MotrSkillsPackVersionWithNavigationPropertiesDto,
  MotrSkillsPackWithNavigationPropertiesDto,
  MotrSkillsPublishPackInputDto,
  MotrSkillsPublishSkillInputDto,
  MotrSkillsRefreshMcpToolsResultDto,
  MotrSkillsRollbackPackInputDto,
  MotrSkillsRollbackSkillInputDto,
  MotrSkillsSkillAuditLogCreateDto,
  MotrSkillsSkillAuditLogDto,
  MotrSkillsSkillAuditLogUpdateDto,
  MotrSkillsSkillAuditLogWithNavigationPropertiesDto,
  MotrSkillsSkillCreateDto,
  MotrSkillsSkillDto,
  MotrSkillsSkillResourceCreateDto,
  MotrSkillsSkillResourceDto,
  MotrSkillsSkillResourceUpdateDto,
  MotrSkillsSkillResourceWithNavigationPropertiesDto,
  MotrSkillsSkillToolBindingCreateDto,
  MotrSkillsSkillToolBindingDto,
  MotrSkillsSkillToolBindingUpdateDto,
  MotrSkillsSkillToolBindingWithNavigationPropertiesDto,
  MotrSkillsSkillUpdateDto,
  MotrSkillsSkillVersionCreateDto,
  MotrSkillsSkillVersionDto,
  MotrSkillsSkillVersionUpdateDto,
  MotrSkillsSkillVersionWithNavigationPropertiesDto,
  MotrSkillsTenantPackEnablementCreateDto,
  MotrSkillsTenantPackEnablementDto,
  MotrSkillsTenantPackEnablementUpdateDto,
  MotrSkillsTenantPackEnablementWithNavigationPropertiesDto,
  MotrSkillsTestMcpToolCallInputDto,
  MotrSnippetsSnippetCreateDto,
  MotrSnippetsSnippetDto,
  MotrSnippetsSnippetUpdateDto,
  MotrStepResponsibilitySegmentsJobResponsibilitySummaryDto,
  MotrStepResponsibilitySegmentsStepResponsibilitySummaryDto,
  MotrStepResponsibilitySegmentsTimeBreakdownReportResponseDto,
  MotrStepResponsibilitySegmentsToggleResponsibilityInput,
  MotrSyncHistoryRepoSyncHistoryDetailDto,
  MotrSyncedDataCreateSyncedEntityInput,
  MotrSyncedDataDirtyPreviewDto,
  MotrSyncedDataKeyIdPairDto,
  MotrSyncedDataResolveConflictInput,
  MotrSyncedDataSyncedDataTreeDto,
  MotrSyncedDataSyncedEntityNodeDto,
  MotrSyncedDataUpdateMetadataOnlyInput,
  MotrSyncedDataUpdateSyncedEntityInput,
  MotrTagCategoriesTagCategoryCreateDto,
  MotrTagCategoriesTagCategoryDto,
  MotrTagCategoriesTagCategoryUpdateDto,
  MotrTagsTagAndCategoriesDto,
  MotrTagsTagCreateDto,
  MotrTagsTagDto,
  MotrTagsTagUpdateDto,
  MotrTagsTagWithNavigationPropertiesDto,
  MotrTemplateAuditLogsTemplateAuditLogCreateDto,
  MotrTemplateAuditLogsTemplateAuditLogDto,
  MotrTemplateAuditLogsTemplateAuditLogUpdateDto,
  MotrTemplateDraftsTemplateDraftCreateDto,
  MotrTemplateDraftsTemplateDraftCreateVm,
  MotrTemplateDraftsTemplateDraftDto,
  MotrTemplateDraftsTemplateDraftUpdateDto,
  MotrTemplateStepAiTasksTemplateStepAiTaskCreateDto,
  MotrTemplateStepAiTasksTemplateStepAiTaskDto,
  MotrTemplateStepAiTasksTemplateStepAiTaskUpdateDto,
  MotrTemplateStepAiTasksTemplateStepAiTaskWithNavigationPropertiesDto,
  MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupCreateDto,
  MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
  MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupUpdateDto,
  MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDto,
  MotrTemplateStepChecklistsTemplateStepCheckListGroupAndItems,
  MotrTemplateStepChecklistsTemplateStepChecklistCreateDto,
  MotrTemplateStepChecklistsTemplateStepChecklistDto,
  MotrTemplateStepChecklistsTemplateStepChecklistUpdateDto,
  MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDto,
  MotrTemplateStepsTemplateStepCreateDto,
  MotrTemplateStepsTemplateStepDto,
  MotrTemplateStepsTemplateStepOrgUnitDto,
  MotrTemplateStepsTemplateStepPositionDto,
  MotrTemplateStepsTemplateStepUpdateDto,
  MotrTemplateStepsTemplateStepWithNavigationPropertiesDto,
  MotrTemplateTypesTemplateTypeCreateDto,
  MotrTemplateTypesTemplateTypeDto,
  MotrTemplateTypesTemplateTypeUpdateDto,
  MotrTemplatesOrganizationTemplatesRequestModel,
  MotrTemplatesServiceRequestFieldDto,
  MotrTemplatesTemplateCreateDto,
  MotrTemplatesTemplateDto,
  MotrTemplatesTemplateImportTemplateImportValidationResultDto,
  MotrTemplatesTemplateInfoDto,
  MotrTemplatesTemplateServiceDto,
  MotrTemplatesTemplateServiceRequestWorkgroupDto,
  MotrTemplatesTemplateStepChecklistGroupDtoVM,
  MotrTemplatesTemplateUpdateDto,
  MotrTemplatesTemplateVm,
  MotrTemplatesTemplateWithNavigationPropertiesDto,
  MotrTemplatesTemplateWithNavigationPropertiesDtoVm,
  MotrTemplatesUpdateServiceRequestFieldsDto,
  MotrUserEnrollmentLogsUserEnrollmentLogCreateDto,
  MotrUserEnrollmentLogsUserEnrollmentLogDto,
  MotrUserEnrollmentLogsUserEnrollmentLogUpdateDto,
  MotrUserEnrollmentLogsV2ExecutePeopleChangeInput,
  MotrUserEnrollmentLogsV2GetWizardScopeInput,
  MotrUserEnrollmentLogsV2PeopleChangeHistoryDetailDto,
  MotrUserEnrollmentLogsV2PeopleChangeResultDto,
  MotrUserEnrollmentLogsV2WizardScopeDataDto,
  MotrUsersExecuteUserImportInput,
  MotrUsersUserImportResultDto,
  MotrUsersUserImportValidationResultDto,
  MotrUsersUserLoginResponseVm,
  MotrUsersUserLoginVm,
  MotrUsersUserToken,
  MotrUsersValidateUserImportInput,
  MotrqGetServiceRequestParametersDetailParams,
  MotrqServiceRequestClientsDetailParams,
  MotrqServiceRequestMattersDetailParams,
  MotrqServiceRequestPrefillDetailParams,
  MotrqTemplatesPlaceholdersListParams,
  OpeniddictApplicationsDeleteParams,
  OpeniddictApplicationsDetailParams,
  OpeniddictApplicationsListParams,
  OpeniddictApplicationsTokenLifetimeListParams,
  OpeniddictApplicationsTokenLifetimeUpdateParams,
  OpeniddictApplicationsUpdateParams,
  OpeniddictScopesDeleteParams,
  OpeniddictScopesDetailParams,
  OpeniddictScopesListParams,
  OpeniddictScopesUpdateParams,
  PermissionManagementPermissionsListParams,
  PermissionManagementPermissionsUpdateParams,
  RestSharpRestRequest,
  RestSharpRestResponse,
  SaasEditionsDeleteParams,
  SaasEditionsDetailParams,
  SaasEditionsListParams,
  SaasEditionsMoveAllTenantsUpdateParams,
  SaasEditionsUpdateParams,
  SaasSubscriptionCreateParams,
  SaasTenantsApplyDatabaseMigrationsCreateParams,
  SaasTenantsCheckConnectionStringListParams,
  SaasTenantsConnectionStringsListParams,
  SaasTenantsConnectionStringsUpdateParams,
  SaasTenantsDeleteParams,
  SaasTenantsDetailParams,
  SaasTenantsListParams,
  SaasTenantsSetPasswordUpdateParams,
  SaasTenantsUpdateParams,
  SettingManagementTimezoneCreateParams,
  SystemCollectionsGenericKeyValuePair2SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrClientMattersClientMatterUpdateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  TextTemplateManagementTemplateContentsListParams,
  TextTemplateManagementTemplateDefinitionsDetailParams,
  TextTemplateManagementTemplateDefinitionsListParams,
  V2AppPeopleChangesHistoryDetailParams,
  V2AppPeopleChangesHistoryListParams,
  VoloAbpAccountAccountExternalProviderSettingsDto,
  VoloAbpAccountAccountRecaptchaSettingsDto,
  VoloAbpAccountAccountSettingsDto,
  VoloAbpAccountAccountTwoFactorSettingsDto,
  VoloAbpAccountAuthenticatorInfoDto,
  VoloAbpAccountChangePasswordInput,
  VoloAbpAccountConfirmEmailInput,
  VoloAbpAccountConfirmPhoneNumberInput,
  VoloAbpAccountDelegateNewUserInput,
  VoloAbpAccountExternalProvidersExternalProviderDto,
  VoloAbpAccountExternalProvidersExternalProviderItemWithSecretDto,
  VoloAbpAccountIdentityUserConfirmationStateDto,
  VoloAbpAccountIsLinkedInput,
  VoloAbpAccountLinkUserInput,
  VoloAbpAccountProfileDto,
  VoloAbpAccountProfilePictureSourceDto,
  VoloAbpAccountPublicWebAreasAccountControllersModelsAbpLoginResult,
  VoloAbpAccountPublicWebAreasAccountControllersModelsLinkUserLoginInfo,
  VoloAbpAccountPublicWebAreasAccountControllersModelsUserLoginInfo,
  VoloAbpAccountRegisterDto,
  VoloAbpAccountResetPasswordDto,
  VoloAbpAccountSendEmailConfirmationTokenDto,
  VoloAbpAccountSendPasswordResetCodeDto,
  VoloAbpAccountSendPhoneNumberConfirmationTokenDto,
  VoloAbpAccountSendTwoFactorCodeInput,
  VoloAbpAccountUnLinkUserInput,
  VoloAbpAccountUpdateExternalProviderDto,
  VoloAbpAccountUpdateProfileDto,
  VoloAbpAccountVerifyAuthenticatorCodeDto,
  VoloAbpAccountVerifyAuthenticatorCodeInput,
  VoloAbpAccountVerifyEmailConfirmationTokenInput,
  VoloAbpAccountVerifyLinkLoginTokenInput,
  VoloAbpAccountVerifyLinkTokenInput,
  VoloAbpAccountVerifyPasswordResetTokenInput,
  VoloAbpApplicationDtosListResultDto1MotrOrganizationsResolvedOrganizationUnitDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpAccountLinkUserDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserDelegationDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserLookupDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpLanguageManagementDtoLanguageDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosListResultDto1VoloAbpUsersUserDataVoloAbpUsersAbstractionsVersion8200CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiChatAiConversationDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiModelsAiModelWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiProvidersAiProviderDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiTaskExecutionsAiTaskExecutionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiTaskOutputsAiTaskOutputWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiTaskStepsAiTaskStepDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrAiTasksAiTaskWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrApiKeysApiKeyDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrCabinetsCabinetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrClientMattersClientMatterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrDataFormsDataFormDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrDocumentLinksDocumentLinkDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrDocumentTemplatesDocumentTemplateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrDocumentsDocumentWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrEmailConversationsEmailConversationWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrEntityRecordsEntityRecordDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrEntityTypesEntityTypeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrEnvelopesEnvelopeWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrFiltersFilterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobActionsJobActionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobDataFormsJobDataFormWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobHoldsJobHoldWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobImprovementsJobImprovementReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobLinksJobLinkWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobNotesJobNoteWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobOutcomesJobOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobRisksJobRiskReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobStepApprovalsMyPendingApprovalDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobStepUsersJobStepUserWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobStepsJobStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrJobsJobWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrKeyMapsKeyMapDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrKnowledgeBaseKnowledgeDocumentDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrMotrQLookupItemDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrNdAuditLogsNdAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrNotificationsNotificationWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrOutcomesOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrPowerReportsPowerReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrReportsAiUsageAiUsageDetailDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrReportsJobStepApprovalsJobStepApprovalsStepDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrReportsJobStepBasedApprovalJobStepBasedApprovalRowDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSharedUserExtDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsAiTaskStepSkillWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsHostPackSummaryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerAuditLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerToolDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerToolWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackMcpServerDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackMcpServerWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackSkillDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackSkillWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackVersionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillAuditLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillResourceDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillResourceWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillToolBindingDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillToolBindingWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillVersionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsTenantPackEnablementDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSkillsTenantPackEnablementWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSnippetsSnippetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrSyncHistoryRepoSyncHistorySummaryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTagCategoriesTagCategoryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTagsTagWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateAuditLogsTemplateAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateDraftsTemplateDraftDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepAiTasksTemplateStepAiTaskWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplateTypesTemplateTypeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavPropVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrUserEnrollmentLogsUserEnrollmentLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1MotrUserEnrollmentLogsV2PeopleChangeHistoryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpAuditLoggingAuditLogDtoVoloAbpAuditLoggingApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpAuditLoggingEntityChangeDtoVoloAbpAuditLoggingApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityClaimTypeDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentitySecurityLogDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpLanguageManagementDtoLanguageDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpLanguageManagementDtoLanguageTextDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpOpenIddictApplicationsDtosApplicationDtoVoloAbpOpenIddictProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpOpenIddictScopesDtosScopeDtoVoloAbpOpenIddictProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloAbpTextTemplateManagementTextTemplatesTemplateDefinitionDtoVoloAbpTextTemplateManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloSaasHostDtosEditionDtoVoloSaasHostApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpApplicationDtosPagedResultDto1VoloSaasHostDtosSaasTenantDtoVoloSaasHostApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
  VoloAbpAspNetCoreMvcApplicationConfigurationsApplicationConfigurationDto,
  VoloAbpAspNetCoreMvcApplicationConfigurationsApplicationLocalizationDto,
  VoloAbpAspNetCoreMvcMultiTenancyFindTenantResultDto,
  VoloAbpAuditLoggingAuditLogDto,
  VoloAbpAuditLoggingEntityChangeDto,
  VoloAbpAuditLoggingEntityChangeWithUsernameDto,
  VoloAbpAuditLoggingGetAverageExecutionDurationPerDayOutput,
  VoloAbpAuditLoggingGetErrorRateOutput,
  VoloAbpFeatureManagementGetFeatureListResultDto,
  VoloAbpFeatureManagementUpdateFeaturesDto,
  VoloAbpHttpModelingApplicationApiDescriptionModel,
  VoloAbpHttpRemoteServiceErrorResponse,
  VoloAbpIdentityClaimTypeDto,
  VoloAbpIdentityCreateClaimTypeDto,
  VoloAbpIdentityDownloadTokenResultDto,
  VoloAbpIdentityExternalLoginProviderDto,
  VoloAbpIdentityIdentityLdapSettingsDto,
  VoloAbpIdentityIdentityOAuthSettingsDto,
  VoloAbpIdentityIdentityRoleClaimDto,
  VoloAbpIdentityIdentityRoleCreateDto,
  VoloAbpIdentityIdentityRoleDto,
  VoloAbpIdentityIdentityRoleLookupDto,
  VoloAbpIdentityIdentityRoleUpdateDto,
  VoloAbpIdentityIdentitySecurityLogDto,
  VoloAbpIdentityIdentitySettingsDto,
  VoloAbpIdentityIdentityUserClaimDto,
  VoloAbpIdentityIdentityUserCreateDto,
  VoloAbpIdentityIdentityUserDto,
  VoloAbpIdentityIdentityUserUpdateDto,
  VoloAbpIdentityIdentityUserUpdatePasswordInput,
  VoloAbpIdentityIdentityUserUpdateRolesDto,
  VoloAbpIdentityImportExternalUserInput,
  VoloAbpIdentityImportUsersFromFileOutput,
  VoloAbpIdentityOrganizationUnitCreateDto,
  VoloAbpIdentityOrganizationUnitDto,
  VoloAbpIdentityOrganizationUnitLookupDto,
  VoloAbpIdentityOrganizationUnitMoveInput,
  VoloAbpIdentityOrganizationUnitRoleInput,
  VoloAbpIdentityOrganizationUnitUpdateDto,
  VoloAbpIdentityOrganizationUnitUserInput,
  VoloAbpIdentityOrganizationUnitWithDetailsDto,
  VoloAbpIdentityUpdateClaimTypeDto,
  VoloAbpLanguageManagementDtoCreateLanguageDto,
  VoloAbpLanguageManagementDtoCultureInfoDto,
  VoloAbpLanguageManagementDtoLanguageDto,
  VoloAbpLanguageManagementDtoLanguageResourceDto,
  VoloAbpLanguageManagementDtoLanguageTextDto,
  VoloAbpLanguageManagementDtoUpdateLanguageDto,
  VoloAbpNameValue,
  VoloAbpOpenIddictApplicationsDtosApplicationDto,
  VoloAbpOpenIddictApplicationsDtosApplicationTokenLifetimeDto,
  VoloAbpOpenIddictApplicationsDtosCreateApplicationInput,
  VoloAbpOpenIddictApplicationsDtosUpdateApplicationInput,
  VoloAbpOpenIddictScopesDtosCreateScopeInput,
  VoloAbpOpenIddictScopesDtosScopeDto,
  VoloAbpOpenIddictScopesDtosUpdateScopeInput,
  VoloAbpPermissionManagementGetPermissionListResultDto,
  VoloAbpPermissionManagementUpdatePermissionsDto,
  VoloAbpSettingManagementEmailSettingsDto,
  VoloAbpSettingManagementSendTestEmailInput,
  VoloAbpSettingManagementUpdateEmailSettingsDto,
  VoloAbpSettingsSettingValue,
  VoloAbpTextTemplateManagementTextTemplatesRestoreTemplateContentInput,
  VoloAbpTextTemplateManagementTextTemplatesTemplateDefinitionDto,
  VoloAbpTextTemplateManagementTextTemplatesTextTemplateContentDto,
  VoloAbpTextTemplateManagementTextTemplatesUpdateTemplateContentInput,
  VoloAbpUsersUserData,
  VoloPaymentPlansPlanDto,
  VoloPaymentRequestsPaymentRequestWithDetailsDto,
  VoloSaasHostDtosEditionCreateDto,
  VoloSaasHostDtosEditionDto,
  VoloSaasHostDtosEditionLookupDto,
  VoloSaasHostDtosEditionUpdateDto,
  VoloSaasHostDtosSaasTenantConnectionStringsDto,
  VoloSaasHostDtosSaasTenantCreateDto,
  VoloSaasHostDtosSaasTenantDatabasesDto,
  VoloSaasHostDtosSaasTenantDto,
  VoloSaasHostDtosSaasTenantSetPasswordDto,
  VoloSaasHostDtosSaasTenantUpdateDto,
  VoloSaasHostGetEditionUsageStatisticsResultDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags AbpApiDefinition
   * @name AbpApiDefinitionList
   * @request GET:/api/abp/api-definition
   * @secure
   */
  abpApiDefinitionList = (
    query: AbpApiDefinitionListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpHttpModelingApplicationApiDescriptionModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/abp/api-definition`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AbpApplicationConfiguration
   * @name AbpApplicationConfigurationList
   * @request GET:/api/abp/application-configuration
   * @secure
   */
  abpApplicationConfigurationList = (
    query: AbpApplicationConfigurationListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAspNetCoreMvcApplicationConfigurationsApplicationConfigurationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/abp/application-configuration`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AbpApplicationLocalization
   * @name AbpApplicationLocalizationList
   * @request GET:/api/abp/application-localization
   * @secure
   */
  abpApplicationLocalizationList = (
    query: AbpApplicationLocalizationListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAspNetCoreMvcApplicationConfigurationsApplicationLocalizationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/abp/application-localization`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AbpTenant
   * @name AbpMultiTenancyTenantsByNameDetail
   * @request GET:/api/abp/multi-tenancy/tenants/by-name/{name}
   * @secure
   */
  abpMultiTenancyTenantsByNameDetail = (
    { name }: AbpMultiTenancyTenantsByNameDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAspNetCoreMvcMultiTenancyFindTenantResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/abp/multi-tenancy/tenants/by-name/${name}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AbpTenant
   * @name AbpMultiTenancyTenantsByIdDetail
   * @request GET:/api/abp/multi-tenancy/tenants/by-id/{id}
   * @secure
   */
  abpMultiTenancyTenantsByIdDetail = (
    { id }: AbpMultiTenancyTenantsByIdDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAspNetCoreMvcMultiTenancyFindTenantResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/abp/multi-tenancy/tenants/by-id/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRegisterCreate
   * @request POST:/api/account/register
   * @secure
   */
  accountRegisterCreate = (
    data: VoloAbpAccountRegisterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSendPasswordResetCodeCreate
   * @request POST:/api/account/send-password-reset-code
   * @secure
   */
  accountSendPasswordResetCodeCreate = (
    data: VoloAbpAccountSendPasswordResetCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/send-password-reset-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifyPasswordResetTokenCreate
   * @request POST:/api/account/verify-password-reset-token
   * @secure
   */
  accountVerifyPasswordResetTokenCreate = (
    data: VoloAbpAccountVerifyPasswordResetTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/verify-password-reset-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountResetPasswordCreate
   * @request POST:/api/account/reset-password
   * @secure
   */
  accountResetPasswordCreate = (
    data: VoloAbpAccountResetPasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountConfirmationStateList
   * @request GET:/api/account/confirmation-state
   * @secure
   */
  accountConfirmationStateList = (
    query: AccountConfirmationStateListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountIdentityUserConfirmationStateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/confirmation-state`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSendPhoneNumberConfirmationTokenCreate
   * @request POST:/api/account/send-phone-number-confirmation-token
   * @secure
   */
  accountSendPhoneNumberConfirmationTokenCreate = (
    data: VoloAbpAccountSendPhoneNumberConfirmationTokenDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/send-phone-number-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSendEmailConfirmationTokenCreate
   * @request POST:/api/account/send-email-confirmation-token
   * @secure
   */
  accountSendEmailConfirmationTokenCreate = (
    data: VoloAbpAccountSendEmailConfirmationTokenDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/send-email-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifyEmailConfirmationTokenCreate
   * @request POST:/api/account/verify-email-confirmation-token
   * @secure
   */
  accountVerifyEmailConfirmationTokenCreate = (
    data: VoloAbpAccountVerifyEmailConfirmationTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/verify-email-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountConfirmPhoneNumberCreate
   * @request POST:/api/account/confirm-phone-number
   * @secure
   */
  accountConfirmPhoneNumberCreate = (
    data: VoloAbpAccountConfirmPhoneNumberInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/confirm-phone-number`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountConfirmEmailCreate
   * @request POST:/api/account/confirm-email
   * @secure
   */
  accountConfirmEmailCreate = (
    data: VoloAbpAccountConfirmEmailInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/confirm-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountProfilePictureCreate
   * @request POST:/api/account/profile-picture
   * @secure
   */
  accountProfilePictureCreate = (
    data: {
      /** @format binary */
      ImageContent?: File;
    },
    query: AccountProfilePictureCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/profile-picture`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountProfilePictureDetail
   * @request GET:/api/account/profile-picture/{id}
   * @secure
   */
  accountProfilePictureDetail = (
    { id }: AccountProfilePictureDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountProfilePictureSourceDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/profile-picture/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountTwoFactorProvidersList
   * @request GET:/api/account/two-factor-providers
   * @secure
   */
  accountTwoFactorProvidersList = (
    query: AccountTwoFactorProvidersListParams,
    params: RequestParams = {},
  ) =>
    this.request<string[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/two-factor-providers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSendTwoFactorCodeCreate
   * @request POST:/api/account/send-two-factor-code
   * @secure
   */
  accountSendTwoFactorCodeCreate = (
    data: VoloAbpAccountSendTwoFactorCodeInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/send-two-factor-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountSecurityLogsList
   * @request GET:/api/account/security-logs
   * @secure
   */
  accountSecurityLogsList = (
    query: AccountSecurityLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentitySecurityLogDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/security-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountVerifyAuthenticatorCodeCreate
   * @request POST:/api/account/verify-authenticator-code
   * @secure
   */
  accountVerifyAuthenticatorCodeCreate = (
    data: VoloAbpAccountVerifyAuthenticatorCodeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountVerifyAuthenticatorCodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/verify-authenticator-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountResetAuthenticatorCreate
   * @request POST:/api/account/reset-authenticator
   * @secure
   */
  accountResetAuthenticatorCreate = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/reset-authenticator`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountHasAuthenticatorKeyList
   * @request GET:/api/account/has-authenticator-key
   * @secure
   */
  accountHasAuthenticatorKeyList = (params: RequestParams = {}) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/has-authenticator-key`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountAuthenticatorInfoList
   * @request GET:/api/account/authenticator-info
   * @secure
   */
  accountAuthenticatorInfoList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAuthenticatorInfoDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/authenticator-info`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountProfilePictureFileDetail
   * @request GET:/api/account/profile-picture-file/{id}
   * @secure
   */
  accountProfilePictureFileDetail = (
    { id }: AccountProfilePictureFileDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/profile-picture-file/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRecaptchaValidateList
   * @request GET:/api/account/recaptcha-validate
   * @secure
   */
  accountRecaptchaValidateList = (
    query: AccountRecaptchaValidateListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/recaptcha-validate`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountExternalProvider
   * @name AccountExternalProviderList
   * @request GET:/api/account/external-provider
   * @secure
   */
  accountExternalProviderList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountExternalProvidersExternalProviderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/external-provider`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountExternalProvider
   * @name AccountExternalProviderByNameList
   * @request GET:/api/account/external-provider/by-name
   * @secure
   */
  accountExternalProviderByNameList = (
    query: AccountExternalProviderByNameListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountExternalProvidersExternalProviderItemWithSecretDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/external-provider/by-name`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsList
   * @request GET:/api/account-admin/settings
   * @secure
   */
  accountAdminSettingsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAccountSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account-admin/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsUpdate
   * @request PUT:/api/account-admin/settings
   * @secure
   */
  accountAdminSettingsUpdate = (
    data: VoloAbpAccountAccountSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account-admin/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsTwoFactorList
   * @request GET:/api/account-admin/settings/two-factor
   * @secure
   */
  accountAdminSettingsTwoFactorList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAccountTwoFactorSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account-admin/settings/two-factor`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsTwoFactorUpdate
   * @request PUT:/api/account-admin/settings/two-factor
   * @secure
   */
  accountAdminSettingsTwoFactorUpdate = (
    data: VoloAbpAccountAccountTwoFactorSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account-admin/settings/two-factor`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsRecaptchaList
   * @request GET:/api/account-admin/settings/recaptcha
   * @secure
   */
  accountAdminSettingsRecaptchaList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAccountRecaptchaSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account-admin/settings/recaptcha`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsRecaptchaUpdate
   * @request PUT:/api/account-admin/settings/recaptcha
   * @secure
   */
  accountAdminSettingsRecaptchaUpdate = (
    data: VoloAbpAccountAccountRecaptchaSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account-admin/settings/recaptcha`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsExternalProviderList
   * @request GET:/api/account-admin/settings/external-provider
   * @secure
   */
  accountAdminSettingsExternalProviderList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAccountExternalProviderSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account-admin/settings/external-provider`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccountSettings
   * @name AccountAdminSettingsExternalProviderUpdate
   * @request PUT:/api/account-admin/settings/external-provider
   * @secure
   */
  accountAdminSettingsExternalProviderUpdate = (
    data: VoloAbpAccountUpdateExternalProviderDto[],
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account-admin/settings/external-provider`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiActivityReport
   * @name AppAiActivityReportJobActivityDetail
   * @request GET:/api/app/ai-activity-report/job-activity/{jobId}
   * @secure
   */
  appAiActivityReportJobActivityDetail = (
    { jobId }: AppAiActivityReportJobActivityDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsAiActivityJobActivityResponseDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-activity-report/job-activity/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsCreate
   * @request POST:/api/app/ai-chat/conversations
   * @secure
   */
  appAiChatConversationsCreate = (
    data: MotrAiChatCreateConversationInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiChatAiConversationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/conversations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsList
   * @request GET:/api/app/ai-chat/conversations
   * @secure
   */
  appAiChatConversationsList = (
    query: AppAiChatConversationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiChatAiConversationDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/conversations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsMessagesList
   * @request GET:/api/app/ai-chat/conversations/{conversationId}/messages
   * @secure
   */
  appAiChatConversationsMessagesList = (
    { conversationId }: AppAiChatConversationsMessagesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiChatAiConversationMessageDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/conversations/${conversationId}/messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsMessagesCreate
   * @request POST:/api/app/ai-chat/conversations/{conversationId}/messages
   * @secure
   */
  appAiChatConversationsMessagesCreate = (
    { conversationId }: AppAiChatConversationsMessagesCreateParams,
    data: MotrAiChatSendMessageInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiChatAiChatResponseDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/conversations/${conversationId}/messages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsDelete
   * @request DELETE:/api/app/ai-chat/conversations/{conversationId}
   * @secure
   */
  appAiChatConversationsDelete = (
    { conversationId }: AppAiChatConversationsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-chat/conversations/${conversationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatCapabilitiesList
   * @request GET:/api/app/ai-chat/capabilities
   * @secure
   */
  appAiChatCapabilitiesList = (params: RequestParams = {}) =>
    this.request<
      MotrAiChatAiCapabilityDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/capabilities`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatConversationsMessagesStreamCreate
   * @request POST:/api/app/ai-chat/conversations/{conversationId}/messages/stream
   * @secure
   */
  appAiChatConversationsMessagesStreamCreate = (
    { conversationId }: AppAiChatConversationsMessagesStreamCreateParams,
    data: MotrAiChatSendMessageInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-chat/conversations/${conversationId}/messages/stream`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatSkillAuthoringMessagesStreamCreate
   * @request POST:/api/app/ai-chat/skill-authoring/messages/stream
   * @secure
   */
  appAiChatSkillAuthoringMessagesStreamCreate = (
    data: MotrAiChatSkillAuthoringMessageInputDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-chat/skill-authoring/messages/stream`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatSkillAuthoringConversationsDetail
   * @request GET:/api/app/ai-chat/skill-authoring/conversations/{skillId}
   * @secure
   */
  appAiChatSkillAuthoringConversationsDetail = (
    { skillId }: AppAiChatSkillAuthoringConversationsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiChatAiConversationMessageDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-chat/skill-authoring/conversations/${skillId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiChat
   * @name AppAiChatSkillAuthoringSkillsPatchesApplyCreate
   * @request POST:/api/app/ai-chat/skill-authoring/skills/{skillId}/patches/apply
   * @secure
   */
  appAiChatSkillAuthoringSkillsPatchesApplyCreate = (
    { skillId }: AppAiChatSkillAuthoringSkillsPatchesApplyCreateParams,
    data: MotrAiChatSkillPatchDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-chat/skill-authoring/skills/${skillId}/patches/apply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiExtn
   * @name AppAiExtnGetChatMessagesList
   * @request GET:/api/app/ai-extn/get-chat-messages
   * @secure
   */
  appAiExtnGetChatMessagesList = (
    query: AppAiExtnGetChatMessagesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiServicesAiMessageDetail[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-extn/get-chat-messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiExtn
   * @name AppAiExtnSendMessageCreate
   * @request POST:/api/app/ai-extn/send-message
   * @secure
   */
  appAiExtnSendMessageCreate = (
    query: AppAiExtnSendMessageCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-extn/send-message`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiExtn
   * @name AppAiExtnAnalyzeDataCreate
   * @request POST:/api/app/ai-extn/analyze-data
   * @secure
   */
  appAiExtnAnalyzeDataCreate = (
    data: MotrAiServicesAiAnalyzeRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiServicesAiAnalyzeResponse,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-extn/analyze-data`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsList
   * @request GET:/api/app/ai-models
   * @secure
   */
  appAiModelsList = (
    query: AppAiModelsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiModelsAiModelWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-models`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsCreate
   * @request POST:/api/app/ai-models
   * @secure
   */
  appAiModelsCreate = (
    data: MotrAiModelsAiModelCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiModelsAiModelDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/ai-models`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsDelete
   * @request DELETE:/api/app/ai-models
   * @secure
   */
  appAiModelsDelete = (
    query: AppAiModelsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-models`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsWithNavigationPropertiesDetail
   * @request GET:/api/app/ai-models/with-navigation-properties/{id}
   * @secure
   */
  appAiModelsWithNavigationPropertiesDetail = (
    { id }: AppAiModelsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiModelsAiModelWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-models/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsDetail
   * @request GET:/api/app/ai-models/{id}
   * @secure
   */
  appAiModelsDetail = (
    { id }: AppAiModelsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiModelsAiModelDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/ai-models/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsUpdate
   * @request PUT:/api/app/ai-models/{id}
   * @secure
   */
  appAiModelsUpdate = (
    { id }: AppAiModelsUpdateParams,
    data: MotrAiModelsAiModelUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiModelsAiModelDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/ai-models/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsDelete2
   * @request DELETE:/api/app/ai-models/{id}
   * @originalName appAiModelsDelete
   * @duplicate
   * @secure
   */
  appAiModelsDelete2 = (
    { id }: AppAiModelsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-models/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsAiProviderLookupList
   * @request GET:/api/app/ai-models/ai-provider-lookup
   * @secure
   */
  appAiModelsAiProviderLookupList = (
    query: AppAiModelsAiProviderLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-models/ai-provider-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsIdentityUserLookupList
   * @request GET:/api/app/ai-models/identity-user-lookup
   * @secure
   */
  appAiModelsIdentityUserLookupList = (
    query: AppAiModelsIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-models/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsAsExcelFileList
   * @request GET:/api/app/ai-models/as-excel-file
   * @secure
   */
  appAiModelsAsExcelFileList = (
    query: AppAiModelsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-models/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsDownloadTokenList
   * @request GET:/api/app/ai-models/download-token
   * @secure
   */
  appAiModelsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-models/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiModel
   * @name AppAiModelsAllDelete
   * @request DELETE:/api/app/ai-models/all
   * @secure
   */
  appAiModelsAllDelete = (
    query: AppAiModelsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-models/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersList
   * @request GET:/api/app/ai-providers
   * @secure
   */
  appAiProvidersList = (
    query: AppAiProvidersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiProvidersAiProviderDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-providers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersCreate
   * @request POST:/api/app/ai-providers
   * @secure
   */
  appAiProvidersCreate = (
    data: MotrAiProvidersAiProviderCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiProvidersAiProviderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-providers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersDelete
   * @request DELETE:/api/app/ai-providers
   * @secure
   */
  appAiProvidersDelete = (
    query: AppAiProvidersDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-providers`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersDetail
   * @request GET:/api/app/ai-providers/{id}
   * @secure
   */
  appAiProvidersDetail = (
    { id }: AppAiProvidersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiProvidersAiProviderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-providers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersUpdate
   * @request PUT:/api/app/ai-providers/{id}
   * @secure
   */
  appAiProvidersUpdate = (
    { id }: AppAiProvidersUpdateParams,
    data: MotrAiProvidersAiProviderUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiProvidersAiProviderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-providers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersDelete2
   * @request DELETE:/api/app/ai-providers/{id}
   * @originalName appAiProvidersDelete
   * @duplicate
   * @secure
   */
  appAiProvidersDelete2 = (
    { id }: AppAiProvidersDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-providers/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersAsExcelFileList
   * @request GET:/api/app/ai-providers/as-excel-file
   * @secure
   */
  appAiProvidersAsExcelFileList = (
    query: AppAiProvidersAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-providers/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersDownloadTokenList
   * @request GET:/api/app/ai-providers/download-token
   * @secure
   */
  appAiProvidersDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-providers/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiProvider
   * @name AppAiProvidersAllDelete
   * @request DELETE:/api/app/ai-providers/all
   * @secure
   */
  appAiProvidersAllDelete = (
    query: AppAiProvidersAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-providers/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksList
   * @request GET:/api/app/ai-tasks
   * @secure
   */
  appAiTasksList = (
    query: AppAiTasksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiTasksAiTaskWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksCreate
   * @request POST:/api/app/ai-tasks
   * @secure
   */
  appAiTasksCreate = (
    data: MotrAiTasksAiTaskCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiTasksAiTaskDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksDelete
   * @request DELETE:/api/app/ai-tasks
   * @secure
   */
  appAiTasksDelete = (
    query: AppAiTasksDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksWithNavigationPropertiesDetail
   * @request GET:/api/app/ai-tasks/with-navigation-properties/{id}
   * @secure
   */
  appAiTasksWithNavigationPropertiesDetail = (
    { id }: AppAiTasksWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTasksAiTaskWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tasks/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksDetail
   * @request GET:/api/app/ai-tasks/{id}
   * @secure
   */
  appAiTasksDetail = (
    { id }: AppAiTasksDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiTasksAiTaskDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksUpdate
   * @request PUT:/api/app/ai-tasks/{id}
   * @secure
   */
  appAiTasksUpdate = (
    { id }: AppAiTasksUpdateParams,
    data: MotrAiTasksAiTaskUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiTasksAiTaskDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksDelete2
   * @request DELETE:/api/app/ai-tasks/{id}
   * @originalName appAiTasksDelete
   * @duplicate
   * @secure
   */
  appAiTasksDelete2 = (
    { id }: AppAiTasksDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksAiModelLookupList
   * @request GET:/api/app/ai-tasks/ai-model-lookup
   * @secure
   */
  appAiTasksAiModelLookupList = (
    query: AppAiTasksAiModelLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tasks/ai-model-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksAsExcelFileList
   * @request GET:/api/app/ai-tasks/as-excel-file
   * @secure
   */
  appAiTasksAsExcelFileList = (
    query: AppAiTasksAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksDownloadTokenList
   * @request GET:/api/app/ai-tasks/download-token
   * @secure
   */
  appAiTasksDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tasks/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTask
   * @name AppAiTasksAllDelete
   * @request DELETE:/api/app/ai-tasks/all
   * @secure
   */
  appAiTasksAllDelete = (
    query: AppAiTasksAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-tasks/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsList
   * @request GET:/api/app/ai-task-executions
   * @secure
   */
  appAiTaskExecutionsList = (
    query: AppAiTaskExecutionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiTaskExecutionsAiTaskExecutionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsCreate
   * @request POST:/api/app/ai-task-executions
   * @secure
   */
  appAiTaskExecutionsCreate = (
    data: MotrAiTaskExecutionsAiTaskExecutionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskExecutionsAiTaskExecutionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsDelete
   * @request DELETE:/api/app/ai-task-executions
   * @secure
   */
  appAiTaskExecutionsDelete = (
    query: AppAiTaskExecutionsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-executions`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsWithNavigationPropertiesDetail
   * @request GET:/api/app/ai-task-executions/with-navigation-properties/{id}
   * @secure
   */
  appAiTaskExecutionsWithNavigationPropertiesDetail = (
    { id }: AppAiTaskExecutionsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskExecutionsAiTaskExecutionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsDetail
   * @request GET:/api/app/ai-task-executions/{id}
   * @secure
   */
  appAiTaskExecutionsDetail = (
    { id }: AppAiTaskExecutionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskExecutionsAiTaskExecutionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsUpdate
   * @request PUT:/api/app/ai-task-executions/{id}
   * @secure
   */
  appAiTaskExecutionsUpdate = (
    { id }: AppAiTaskExecutionsUpdateParams,
    data: MotrAiTaskExecutionsAiTaskExecutionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskExecutionsAiTaskExecutionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsDelete2
   * @request DELETE:/api/app/ai-task-executions/{id}
   * @originalName appAiTaskExecutionsDelete
   * @duplicate
   * @secure
   */
  appAiTaskExecutionsDelete2 = (
    { id }: AppAiTaskExecutionsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-executions/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsAiTaskLookupList
   * @request GET:/api/app/ai-task-executions/ai-task-lookup
   * @secure
   */
  appAiTaskExecutionsAiTaskLookupList = (
    query: AppAiTaskExecutionsAiTaskLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/ai-task-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsAiModelLookupList
   * @request GET:/api/app/ai-task-executions/ai-model-lookup
   * @secure
   */
  appAiTaskExecutionsAiModelLookupList = (
    query: AppAiTaskExecutionsAiModelLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/ai-model-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsJobStepLookupList
   * @request GET:/api/app/ai-task-executions/job-step-lookup
   * @secure
   */
  appAiTaskExecutionsJobStepLookupList = (
    query: AppAiTaskExecutionsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsAsExcelFileList
   * @request GET:/api/app/ai-task-executions/as-excel-file
   * @secure
   */
  appAiTaskExecutionsAsExcelFileList = (
    query: AppAiTaskExecutionsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-executions/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsDownloadTokenList
   * @request GET:/api/app/ai-task-executions/download-token
   * @secure
   */
  appAiTaskExecutionsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-executions/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskExecution
   * @name AppAiTaskExecutionsAllDelete
   * @request DELETE:/api/app/ai-task-executions/all
   * @secure
   */
  appAiTaskExecutionsAllDelete = (
    query: AppAiTaskExecutionsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-executions/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsList
   * @request GET:/api/app/ai-task-outputs
   * @secure
   */
  appAiTaskOutputsList = (
    query: AppAiTaskOutputsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiTaskOutputsAiTaskOutputWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsCreate
   * @request POST:/api/app/ai-task-outputs
   * @secure
   */
  appAiTaskOutputsCreate = (
    data: MotrAiTaskOutputsAiTaskOutputCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskOutputsAiTaskOutputDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsDelete
   * @request DELETE:/api/app/ai-task-outputs
   * @secure
   */
  appAiTaskOutputsDelete = (
    query: AppAiTaskOutputsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-outputs`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsWithNavigationPropertiesDetail
   * @request GET:/api/app/ai-task-outputs/with-navigation-properties/{id}
   * @secure
   */
  appAiTaskOutputsWithNavigationPropertiesDetail = (
    { id }: AppAiTaskOutputsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskOutputsAiTaskOutputWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsDetail
   * @request GET:/api/app/ai-task-outputs/{id}
   * @secure
   */
  appAiTaskOutputsDetail = (
    { id }: AppAiTaskOutputsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskOutputsAiTaskOutputDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsUpdate
   * @request PUT:/api/app/ai-task-outputs/{id}
   * @secure
   */
  appAiTaskOutputsUpdate = (
    { id }: AppAiTaskOutputsUpdateParams,
    data: MotrAiTaskOutputsAiTaskOutputUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskOutputsAiTaskOutputDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsDelete2
   * @request DELETE:/api/app/ai-task-outputs/{id}
   * @originalName appAiTaskOutputsDelete
   * @duplicate
   * @secure
   */
  appAiTaskOutputsDelete2 = (
    { id }: AppAiTaskOutputsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-outputs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsAiTaskExecutionLookupList
   * @request GET:/api/app/ai-task-outputs/ai-task-execution-lookup
   * @secure
   */
  appAiTaskOutputsAiTaskExecutionLookupList = (
    query: AppAiTaskOutputsAiTaskExecutionLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/ai-task-execution-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsAiTaskStepLookupList
   * @request GET:/api/app/ai-task-outputs/ai-task-step-lookup
   * @secure
   */
  appAiTaskOutputsAiTaskStepLookupList = (
    query: AppAiTaskOutputsAiTaskStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/ai-task-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsAiTaskLookupList
   * @request GET:/api/app/ai-task-outputs/ai-task-lookup
   * @secure
   */
  appAiTaskOutputsAiTaskLookupList = (
    query: AppAiTaskOutputsAiTaskLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/ai-task-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsAsExcelFileList
   * @request GET:/api/app/ai-task-outputs/as-excel-file
   * @secure
   */
  appAiTaskOutputsAsExcelFileList = (
    query: AppAiTaskOutputsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-outputs/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsDownloadTokenList
   * @request GET:/api/app/ai-task-outputs/download-token
   * @secure
   */
  appAiTaskOutputsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-outputs/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskOutput
   * @name AppAiTaskOutputsAllDelete
   * @request DELETE:/api/app/ai-task-outputs/all
   * @secure
   */
  appAiTaskOutputsAllDelete = (
    query: AppAiTaskOutputsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-outputs/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsByAiTaskList
   * @request GET:/api/app/ai-task-steps/by-ai-task
   * @secure
   */
  appAiTaskStepsByAiTaskList = (
    query: AppAiTaskStepsByAiTaskListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiTaskStepsAiTaskStepDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-steps/by-ai-task`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsList
   * @request GET:/api/app/ai-task-steps
   * @secure
   */
  appAiTaskStepsList = (
    query: AppAiTaskStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrAiTaskStepsAiTaskStepDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsCreate
   * @request POST:/api/app/ai-task-steps
   * @secure
   */
  appAiTaskStepsCreate = (
    data: MotrAiTaskStepsAiTaskStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskStepsAiTaskStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-steps`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsDetail
   * @request GET:/api/app/ai-task-steps/{id}
   * @secure
   */
  appAiTaskStepsDetail = (
    { id }: AppAiTaskStepsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskStepsAiTaskStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-steps/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsUpdate
   * @request PUT:/api/app/ai-task-steps/{id}
   * @secure
   */
  appAiTaskStepsUpdate = (
    { id }: AppAiTaskStepsUpdateParams,
    data: MotrAiTaskStepsAiTaskStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiTaskStepsAiTaskStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-steps/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStep
   * @name AppAiTaskStepsDelete
   * @request DELETE:/api/app/ai-task-steps/{id}
   * @secure
   */
  appAiTaskStepsDelete = (
    { id }: AppAiTaskStepsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-steps/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsList
   * @request GET:/api/app/ai-task-step-skills
   * @secure
   */
  appAiTaskStepSkillsList = (
    query: AppAiTaskStepSkillsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsAiTaskStepSkillWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsCreate
   * @request POST:/api/app/ai-task-step-skills
   * @secure
   */
  appAiTaskStepSkillsCreate = (
    data: MotrSkillsAiTaskStepSkillCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsAiTaskStepSkillDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsWithNavigationPropertiesDetail
   * @request GET:/api/app/ai-task-step-skills/with-navigation-properties/{id}
   * @secure
   */
  appAiTaskStepSkillsWithNavigationPropertiesDetail = (
    { id }: AppAiTaskStepSkillsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsAiTaskStepSkillWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsDetail
   * @request GET:/api/app/ai-task-step-skills/{id}
   * @secure
   */
  appAiTaskStepSkillsDetail = (
    { id }: AppAiTaskStepSkillsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsAiTaskStepSkillDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsUpdate
   * @request PUT:/api/app/ai-task-step-skills/{id}
   * @secure
   */
  appAiTaskStepSkillsUpdate = (
    { id }: AppAiTaskStepSkillsUpdateParams,
    data: MotrSkillsAiTaskStepSkillUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsAiTaskStepSkillDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsDelete
   * @request DELETE:/api/app/ai-task-step-skills/{id}
   * @secure
   */
  appAiTaskStepSkillsDelete = (
    { id }: AppAiTaskStepSkillsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-task-step-skills/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsAiTaskStepLookupList
   * @request GET:/api/app/ai-task-step-skills/ai-task-step-lookup
   * @secure
   */
  appAiTaskStepSkillsAiTaskStepLookupList = (
    query: AppAiTaskStepSkillsAiTaskStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/ai-task-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsSkillLookupList
   * @request GET:/api/app/ai-task-step-skills/skill-lookup
   * @secure
   */
  appAiTaskStepSkillsSkillLookupList = (
    query: AppAiTaskStepSkillsSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiTaskStepSkill
   * @name AppAiTaskStepSkillsSkillVersionLookupList
   * @request GET:/api/app/ai-task-step-skills/skill-version-lookup
   * @secure
   */
  appAiTaskStepSkillsSkillVersionLookupList = (
    query: AppAiTaskStepSkillsSkillVersionLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-task-step-skills/skill-version-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiToolCatalog
   * @name AppAiToolCatalogList
   * @request GET:/api/app/ai-tool-catalog
   * @secure
   */
  appAiToolCatalogList = (params: RequestParams = {}) =>
    this.request<
      MotrAISkillsAiToolCatalogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tool-catalog`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiToolRegistry
   * @name AppAiToolRegistryList
   * @request GET:/api/app/ai-tool-registry
   * @secure
   */
  appAiToolRegistryList = (params: RequestParams = {}) =>
    this.request<
      MotrAISkillsAiToolOptionDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-tool-registry`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiUsageReport
   * @name AppAiUsageReportAvailableSinceList
   * @request GET:/api/app/ai-usage-report/available-since
   * @secure
   */
  appAiUsageReportAvailableSinceList = (params: RequestParams = {}) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/ai-usage-report/available-since`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiUsageReport
   * @name AppAiUsageReportAiUsageSummaryList
   * @request GET:/api/app/ai-usage-report/ai-usage-summary
   * @secure
   */
  appAiUsageReportAiUsageSummaryList = (
    query: AppAiUsageReportAiUsageSummaryListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsAiUsageAiUsageSummaryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-usage-report/ai-usage-summary`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiUsageReport
   * @name AppAiUsageReportAiUsageTrendList
   * @request GET:/api/app/ai-usage-report/ai-usage-trend
   * @secure
   */
  appAiUsageReportAiUsageTrendList = (
    query: AppAiUsageReportAiUsageTrendListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsAiUsageAiUsageTrendDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-usage-report/ai-usage-trend`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiUsageReport
   * @name AppAiUsageReportAiHealthList
   * @request GET:/api/app/ai-usage-report/ai-health
   * @secure
   */
  appAiUsageReportAiHealthList = (
    query: AppAiUsageReportAiHealthListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsAiUsageAiHealthDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-usage-report/ai-health`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AiUsageReport
   * @name AppAiUsageReportAiUsageDetailsList
   * @request GET:/api/app/ai-usage-report/ai-usage-details
   * @secure
   */
  appAiUsageReportAiUsageDetailsList = (
    query: AppAiUsageReportAiUsageDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrReportsAiUsageAiUsageDetailDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/ai-usage-report/ai-usage-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyList
   * @request GET:/api/app/api-key
   * @secure
   */
  appApiKeyList = (
    query: AppApiKeyListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrApiKeysApiKeyDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/api-key`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyCreate
   * @request POST:/api/app/api-key
   * @secure
   */
  appApiKeyCreate = (
    data: MotrApiKeysCreateApiKeyDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrApiKeysApiKeyDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyDetail
   * @request GET:/api/app/api-key/{id}
   * @secure
   */
  appApiKeyDetail = (
    { id }: AppApiKeyDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrApiKeysApiKeyDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyUpdate
   * @request PUT:/api/app/api-key/{id}
   * @secure
   */
  appApiKeyUpdate = (
    { id }: AppApiKeyUpdateParams,
    data: MotrApiKeysUpdateApiKeyDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrApiKeysApiKeyDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyDelete
   * @request DELETE:/api/app/api-key/{id}
   * @secure
   */
  appApiKeyDelete = (
    { id }: AppApiKeyDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyActivateCreate
   * @request POST:/api/app/api-key/{id}/activate
   * @secure
   */
  appApiKeyActivateCreate = (
    { id }: AppApiKeyActivateCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrApiKeysApiKeyDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKey
   * @name AppApiKeyDeactivateCreate
   * @request POST:/api/app/api-key/{id}/deactivate
   * @secure
   */
  appApiKeyDeactivateCreate = (
    { id }: AppApiKeyDeactivateCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrApiKeysApiKeyDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/api-key/${id}/deactivate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKeyTest
   * @name TestApiKeyValidateList
   * @request GET:/api/test/api-key/validate
   * @secure
   */
  testApiKeyValidateList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/test/api-key/validate`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ApiKeyTest
   * @name TestApiKeySecureList
   * @request GET:/api/test/api-key/secure
   * @secure
   */
  testApiKeySecureList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/test/api-key/secure`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsDetail
   * @request GET:/api/openiddict/applications/{id}
   * @secure
   */
  openiddictApplicationsDetail = (
    { id }: OpeniddictApplicationsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictApplicationsDtosApplicationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/applications/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsUpdate
   * @request PUT:/api/openiddict/applications/{id}
   * @secure
   */
  openiddictApplicationsUpdate = (
    { id }: OpeniddictApplicationsUpdateParams,
    data: VoloAbpOpenIddictApplicationsDtosUpdateApplicationInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictApplicationsDtosApplicationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/applications/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsList
   * @request GET:/api/openiddict/applications
   * @secure
   */
  openiddictApplicationsList = (
    query: OpeniddictApplicationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpOpenIddictApplicationsDtosApplicationDtoVoloAbpOpenIddictProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/applications`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsCreate
   * @request POST:/api/openiddict/applications
   * @secure
   */
  openiddictApplicationsCreate = (
    data: VoloAbpOpenIddictApplicationsDtosCreateApplicationInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictApplicationsDtosApplicationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/applications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsDelete
   * @request DELETE:/api/openiddict/applications
   * @secure
   */
  openiddictApplicationsDelete = (
    query: OpeniddictApplicationsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/openiddict/applications`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsTokenLifetimeList
   * @request GET:/api/openiddict/applications/{id}/token-lifetime
   * @secure
   */
  openiddictApplicationsTokenLifetimeList = (
    { id }: OpeniddictApplicationsTokenLifetimeListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictApplicationsDtosApplicationTokenLifetimeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/applications/${id}/token-lifetime`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Applications
   * @name OpeniddictApplicationsTokenLifetimeUpdate
   * @request PUT:/api/openiddict/applications/{id}/token-lifetime
   * @secure
   */
  openiddictApplicationsTokenLifetimeUpdate = (
    { id }: OpeniddictApplicationsTokenLifetimeUpdateParams,
    data: VoloAbpOpenIddictApplicationsDtosApplicationTokenLifetimeDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/openiddict/applications/${id}/token-lifetime`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ApprovalAction
   * @name AppApprovalActionList
   * @request GET:/api/app/approval/action
   * @secure
   */
  appApprovalActionList = (
    query: AppApprovalActionListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/approval/action`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ApprovalAction
   * @name AppApprovalActionCreate
   * @request POST:/api/app/approval/action
   * @secure
   */
  appApprovalActionCreate = (
    data: {
      token?: string;
      action?: string;
      comment?: string;
      /** @format uuid */
      jobId?: string;
      /** @format uuid */
      stepId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/approval/action`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags ApprovalAction
   * @name AppApprovalPageList
   * @request GET:/api/app/approval/page
   * @secure
   */
  appApprovalPageList = (
    query: AppApprovalPageListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/approval/page`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsList
   * @request GET:/api/audit-logging/audit-logs
   * @secure
   */
  auditLoggingAuditLogsList = (
    query: AuditLoggingAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpAuditLoggingAuditLogDtoVoloAbpAuditLoggingApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsDetail
   * @request GET:/api/audit-logging/audit-logs/{id}
   * @secure
   */
  auditLoggingAuditLogsDetail = (
    { id }: AuditLoggingAuditLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsStatisticsErrorRateList
   * @request GET:/api/audit-logging/audit-logs/statistics/error-rate
   * @secure
   */
  auditLoggingAuditLogsStatisticsErrorRateList = (
    query: AuditLoggingAuditLogsStatisticsErrorRateListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingGetErrorRateOutput,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/statistics/error-rate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsStatisticsAverageExecutionDurationPerDayList
   * @request GET:/api/audit-logging/audit-logs/statistics/average-execution-duration-per-day
   * @secure
   */
  auditLoggingAuditLogsStatisticsAverageExecutionDurationPerDayList = (
    query: AuditLoggingAuditLogsStatisticsAverageExecutionDurationPerDayListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingGetAverageExecutionDurationPerDayOutput,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/statistics/average-execution-duration-per-day`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsEntityChangesList
   * @request GET:/api/audit-logging/audit-logs/entity-changes
   * @secure
   */
  auditLoggingAuditLogsEntityChangesList = (
    query: AuditLoggingAuditLogsEntityChangesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpAuditLoggingEntityChangeDtoVoloAbpAuditLoggingApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/entity-changes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsEntityChangesWithUsernameList
   * @request GET:/api/audit-logging/audit-logs/entity-changes-with-username
   * @secure
   */
  auditLoggingAuditLogsEntityChangesWithUsernameList = (
    query: AuditLoggingAuditLogsEntityChangesWithUsernameListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingEntityChangeWithUsernameDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/entity-changes-with-username`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsEntityChangeWithUsernameDetail
   * @request GET:/api/audit-logging/audit-logs/entity-change-with-username/{entityChangeId}
   * @secure
   */
  auditLoggingAuditLogsEntityChangeWithUsernameDetail = (
    {
      entityChangeId,
    }: AuditLoggingAuditLogsEntityChangeWithUsernameDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingEntityChangeWithUsernameDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/entity-change-with-username/${entityChangeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuditLogs
   * @name AuditLoggingAuditLogsEntityChangesDetail
   * @request GET:/api/audit-logging/audit-logs/entity-changes/{entityChangeId}
   * @secure
   */
  auditLoggingAuditLogsEntityChangesDetail = (
    { entityChangeId }: AuditLoggingAuditLogsEntityChangesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAuditLoggingEntityChangeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/audit-logging/audit-logs/entity-changes/${entityChangeId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugTestAuthList
   * @request GET:/api/AuthDebug/test-auth
   * @secure
   */
  authDebugTestAuthList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/test-auth`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugTestAuthWithTenantList
   * @request GET:/api/AuthDebug/test-auth-with-tenant
   * @secure
   */
  authDebugTestAuthWithTenantList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/test-auth-with-tenant`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugTestAuthSecuredList
   * @request GET:/api/AuthDebug/test-auth-secured
   * @secure
   */
  authDebugTestAuthSecuredList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/test-auth-secured`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugCheckOpenidConfigList
   * @request GET:/api/AuthDebug/check-openid-config
   * @secure
   */
  authDebugCheckOpenidConfigList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/check-openid-config`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugTestTenantList
   * @request GET:/api/AuthDebug/test-tenant
   * @secure
   */
  authDebugTestTenantList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/test-tenant`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthDebug
   * @name AuthDebugDecodeTokenList
   * @request GET:/api/AuthDebug/decode-token
   * @secure
   */
  authDebugDecodeTokenList = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/AuthDebug/decode-token`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsList
   * @request GET:/api/app/cabinets
   * @secure
   */
  appCabinetsList = (
    query: AppCabinetsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrCabinetsCabinetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsCreate
   * @request POST:/api/app/cabinets
   * @secure
   */
  appCabinetsCreate = (
    data: MotrCabinetsCabinetCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsDetail
   * @request GET:/api/app/cabinets/{id}
   * @secure
   */
  appCabinetsDetail = (
    { id }: AppCabinetsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsUpdate
   * @request PUT:/api/app/cabinets/{id}
   * @secure
   */
  appCabinetsUpdate = (
    { id }: AppCabinetsUpdateParams,
    data: MotrCabinetsCabinetUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsDelete
   * @request DELETE:/api/app/cabinets/{id}
   * @secure
   */
  appCabinetsDelete = (
    { id }: AppCabinetsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsAsExcelFileList
   * @request GET:/api/app/cabinets/as-excel-file
   * @secure
   */
  appCabinetsAsExcelFileList = (
    query: AppCabinetsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Cabinet
   * @name AppCabinetsDownloadTokenList
   * @request GET:/api/app/cabinets/download-token
   * @secure
   */
  appCabinetsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnList
   * @request GET:/api/app/cabinets-extn
   * @secure
   */
  appCabinetsExtnList = (
    query: AppCabinetsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrCabinetsCabinetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnCreate
   * @request POST:/api/app/cabinets-extn
   * @secure
   */
  appCabinetsExtnCreate = (
    data: MotrCabinetsCabinetCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnDetail
   * @request GET:/api/app/cabinets-extn/{id}
   * @secure
   */
  appCabinetsExtnDetail = (
    { id }: AppCabinetsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnUpdate
   * @request PUT:/api/app/cabinets-extn/{id}
   * @secure
   */
  appCabinetsExtnUpdate = (
    { id }: AppCabinetsExtnUpdateParams,
    data: MotrCabinetsCabinetUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrCabinetsCabinetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/cabinets-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnDelete
   * @request DELETE:/api/app/cabinets-extn/{id}
   * @secure
   */
  appCabinetsExtnDelete = (
    { id }: AppCabinetsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnAsExcelFileList
   * @request GET:/api/app/cabinets-extn/as-excel-file
   * @secure
   */
  appCabinetsExtnAsExcelFileList = (
    query: AppCabinetsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CabinetExtn
   * @name AppCabinetsExtnDownloadTokenList
   * @request GET:/api/app/cabinets-extn/download-token
   * @secure
   */
  appCabinetsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClaimType
   * @name IdentityClaimTypesList
   * @request GET:/api/identity/claim-types
   * @secure
   */
  identityClaimTypesList = (
    query: IdentityClaimTypesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityClaimTypeDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/claim-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClaimType
   * @name IdentityClaimTypesCreate
   * @request POST:/api/identity/claim-types
   * @secure
   */
  identityClaimTypesCreate = (
    data: VoloAbpIdentityCreateClaimTypeDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityClaimTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/claim-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClaimType
   * @name IdentityClaimTypesDetail
   * @request GET:/api/identity/claim-types/{id}
   * @secure
   */
  identityClaimTypesDetail = (
    { id }: IdentityClaimTypesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityClaimTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/claim-types/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClaimType
   * @name IdentityClaimTypesUpdate
   * @request PUT:/api/identity/claim-types/{id}
   * @secure
   */
  identityClaimTypesUpdate = (
    { id }: IdentityClaimTypesUpdateParams,
    data: VoloAbpIdentityUpdateClaimTypeDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityClaimTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/claim-types/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClaimType
   * @name IdentityClaimTypesDelete
   * @request DELETE:/api/identity/claim-types/{id}
   * @secure
   */
  identityClaimTypesDelete = (
    { id }: IdentityClaimTypesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/claim-types/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientDashboard
   * @name AppClientDashboardMyRequestsList
   * @request GET:/api/app/client-dashboard/my-requests
   * @secure
   */
  appClientDashboardMyRequestsList = (params: RequestParams = {}) =>
    this.request<
      MotrClientDashboardClientRequestDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-dashboard/my-requests`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientDashboard
   * @name AppClientDashboardRequestTimelineDetail
   * @request GET:/api/app/client-dashboard/request-timeline/{jobId}
   * @secure
   */
  appClientDashboardRequestTimelineDetail = (
    { jobId }: AppClientDashboardRequestTimelineDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientDashboardClientRequestTimelineDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-dashboard/request-timeline/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientDashboard
   * @name AppClientDashboardMyDocumentsList
   * @request GET:/api/app/client-dashboard/my-documents
   * @secure
   */
  appClientDashboardMyDocumentsList = (params: RequestParams = {}) =>
    this.request<
      MotrClientDashboardClientDocumentDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-dashboard/my-documents`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientFeedback
   * @name AppClientFeedbackSubmitFeedbackByTokenCreate
   * @request POST:/api/app/client-feedback/submit-feedback-by-token
   * @secure
   */
  appClientFeedbackSubmitFeedbackByTokenCreate = (
    data: MotrClientFeedbackSubmitFeedbackByTokenDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-feedback/submit-feedback-by-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientFeedback
   * @name AppClientFeedbackHasPendingFeedbackCreate
   * @request POST:/api/app/client-feedback/has-pending-feedback/{jobId}
   * @secure
   */
  appClientFeedbackHasPendingFeedbackCreate = (
    { jobId }: AppClientFeedbackHasPendingFeedbackCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-feedback/has-pending-feedback/${jobId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientFeedback
   * @name AppClientFeedbackPeekTokenStatusCreate
   * @request POST:/api/app/client-feedback/peek-token-status
   * @secure
   */
  appClientFeedbackPeekTokenStatusCreate = (
    query: AppClientFeedbackPeekTokenStatusCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientFeedbackFeedbackTokenStatusDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-feedback/peek-token-status`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientFeedbackApi
   * @name AppClientFeedbackApiStatusDetail
   * @request GET:/api/app/client-feedback-api/status/{jobId}
   * @secure
   */
  appClientFeedbackApiStatusDetail = (
    { jobId }: AppClientFeedbackApiStatusDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-feedback-api/status/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersList
   * @request GET:/api/app/client-matters
   * @secure
   */
  appClientMattersList = (
    query: AppClientMattersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrClientMattersClientMatterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersCreate
   * @request POST:/api/app/client-matters
   * @secure
   */
  appClientMattersCreate = (
    data: MotrClientMattersClientMatterCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersDetail
   * @request GET:/api/app/client-matters/{id}
   * @secure
   */
  appClientMattersDetail = (
    { id }: AppClientMattersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersUpdate
   * @request PUT:/api/app/client-matters/{id}
   * @secure
   */
  appClientMattersUpdate = (
    { id }: AppClientMattersUpdateParams,
    data: MotrClientMattersClientMatterUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersDelete
   * @request DELETE:/api/app/client-matters/{id}
   * @secure
   */
  appClientMattersDelete = (
    { id }: AppClientMattersDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-matters/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersAsExcelFileList
   * @request GET:/api/app/client-matters/as-excel-file
   * @secure
   */
  appClientMattersAsExcelFileList = (
    query: AppClientMattersAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-matters/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatter
   * @name AppClientMattersDownloadTokenList
   * @request GET:/api/app/client-matters/download-token
   * @secure
   */
  appClientMattersDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnList
   * @request GET:/api/app/client-matters-extn
   * @secure
   */
  appClientMattersExtnList = (
    query: AppClientMattersExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrClientMattersClientMatterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnCreate
   * @request POST:/api/app/client-matters-extn
   * @secure
   */
  appClientMattersExtnCreate = (
    data: MotrClientMattersClientMatterCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnDetail
   * @request GET:/api/app/client-matters-extn/{id}
   * @secure
   */
  appClientMattersExtnDetail = (
    { id }: AppClientMattersExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnUpdate
   * @request PUT:/api/app/client-matters-extn/{id}
   * @secure
   */
  appClientMattersExtnUpdate = (
    { id }: AppClientMattersExtnUpdateParams,
    data: MotrClientMattersClientMatterUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnDelete
   * @request DELETE:/api/app/client-matters-extn/{id}
   * @secure
   */
  appClientMattersExtnDelete = (
    { id }: AppClientMattersExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-matters-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnAsExcelFileList
   * @request GET:/api/app/client-matters-extn/as-excel-file
   * @secure
   */
  appClientMattersExtnAsExcelFileList = (
    query: AppClientMattersExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-matters-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnDownloadTokenList
   * @request GET:/api/app/client-matters-extn/download-token
   * @secure
   */
  appClientMattersExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnBulkCreateCreate
   * @request POST:/api/app/client-matters-extn/bulk-create
   * @secure
   */
  appClientMattersExtnBulkCreateCreate = (
    data: MotrClientMattersClientMatterCreateDto[],
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn/bulk-create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClientMatterExtn
   * @name AppClientMattersExtnBulkUpdateCreate
   * @request POST:/api/app/client-matters-extn/bulk-update
   * @secure
   */
  appClientMattersExtnBulkUpdateCreate = (
    data: SystemCollectionsGenericKeyValuePair2SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrClientMattersClientMatterUpdateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull[],
    params: RequestParams = {},
  ) =>
    this.request<
      MotrClientMattersClientMatterDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/client-matters-extn/bulk-update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ClosingBinder
   * @name AppClosingBinderMergeDocumentsCreate
   * @request POST:/api/app/closing-binder/merge-documents
   * @secure
   */
  appClosingBinderMergeDocumentsCreate = (
    data: MotrClosingBinderDocumentInputDto[],
    params: RequestParams = {},
  ) =>
    this.request<Blob, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/closing-binder/merge-documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountVerifyEmailConfirmationTokenCreate
   * @request POST:/api/app/custom-account/verify-email-confirmation-token
   * @secure
   */
  appCustomAccountVerifyEmailConfirmationTokenCreate = (
    data: VoloAbpAccountVerifyEmailConfirmationTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/verify-email-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSendEmailConfirmationTokenCreate
   * @request POST:/api/app/custom-account/send-email-confirmation-token
   * @secure
   */
  appCustomAccountSendEmailConfirmationTokenCreate = (
    data: VoloAbpAccountSendEmailConfirmationTokenDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/send-email-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountRegisterCreate
   * @request POST:/api/app/custom-account/register
   * @secure
   */
  appCustomAccountRegisterCreate = (
    data: VoloAbpAccountRegisterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSendPasswordResetCodeCreate
   * @request POST:/api/app/custom-account/send-password-reset-code
   * @secure
   */
  appCustomAccountSendPasswordResetCodeCreate = (
    data: VoloAbpAccountSendPasswordResetCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/send-password-reset-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountVerifyPasswordResetTokenCreate
   * @request POST:/api/app/custom-account/verify-password-reset-token
   * @secure
   */
  appCustomAccountVerifyPasswordResetTokenCreate = (
    data: VoloAbpAccountVerifyPasswordResetTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/verify-password-reset-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountResetPasswordCreate
   * @request POST:/api/app/custom-account/reset-password
   * @secure
   */
  appCustomAccountResetPasswordCreate = (
    data: VoloAbpAccountResetPasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountConfirmationStateList
   * @request GET:/api/app/custom-account/{id}/confirmation-state
   * @secure
   */
  appCustomAccountConfirmationStateList = (
    { id }: AppCustomAccountConfirmationStateListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountIdentityUserConfirmationStateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/${id}/confirmation-state`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSendPhoneNumberConfirmationTokenCreate
   * @request POST:/api/app/custom-account/send-phone-number-confirmation-token
   * @secure
   */
  appCustomAccountSendPhoneNumberConfirmationTokenCreate = (
    data: VoloAbpAccountSendPhoneNumberConfirmationTokenDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/send-phone-number-confirmation-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountConfirmPhoneNumberCreate
   * @request POST:/api/app/custom-account/confirm-phone-number
   * @secure
   */
  appCustomAccountConfirmPhoneNumberCreate = (
    data: VoloAbpAccountConfirmPhoneNumberInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/confirm-phone-number`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountConfirmEmailCreate
   * @request POST:/api/app/custom-account/confirm-email
   * @secure
   */
  appCustomAccountConfirmEmailCreate = (
    data: VoloAbpAccountConfirmEmailInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/confirm-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSetProfilePictureCreate
   * @request POST:/api/app/custom-account/set-profile-picture
   * @secure
   */
  appCustomAccountSetProfilePictureCreate = (
    data: {
      /** @format binary */
      ImageContent?: File;
    },
    query: AppCustomAccountSetProfilePictureCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/set-profile-picture`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountProfilePictureList
   * @request GET:/api/app/custom-account/{id}/profile-picture
   * @secure
   */
  appCustomAccountProfilePictureList = (
    { id }: AppCustomAccountProfilePictureListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountProfilePictureSourceDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/${id}/profile-picture`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountProfilePictureFileList
   * @request GET:/api/app/custom-account/{id}/profile-picture-file
   * @secure
   */
  appCustomAccountProfilePictureFileList = (
    { id }: AppCustomAccountProfilePictureFileListParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/${id}/profile-picture-file`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountTwoFactorProvidersList
   * @request GET:/api/app/custom-account/two-factor-providers
   * @secure
   */
  appCustomAccountTwoFactorProvidersList = (
    query: AppCustomAccountTwoFactorProvidersListParams,
    params: RequestParams = {},
  ) =>
    this.request<string[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/two-factor-providers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSendTwoFactorCodeCreate
   * @request POST:/api/app/custom-account/send-two-factor-code
   * @secure
   */
  appCustomAccountSendTwoFactorCodeCreate = (
    data: VoloAbpAccountSendTwoFactorCodeInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/send-two-factor-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountSecurityLogListList
   * @request GET:/api/app/custom-account/security-log-list
   * @secure
   */
  appCustomAccountSecurityLogListList = (
    query: AppCustomAccountSecurityLogListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentitySecurityLogDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/security-log-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountVerifyAuthenticatorCodeCreate
   * @request POST:/api/app/custom-account/verify-authenticator-code
   * @secure
   */
  appCustomAccountVerifyAuthenticatorCodeCreate = (
    data: VoloAbpAccountVerifyAuthenticatorCodeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountVerifyAuthenticatorCodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/verify-authenticator-code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountResetAuthenticatorCreate
   * @request POST:/api/app/custom-account/reset-authenticator
   * @secure
   */
  appCustomAccountResetAuthenticatorCreate = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/reset-authenticator`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountHasAuthenticatorCreate
   * @request POST:/api/app/custom-account/has-authenticator
   * @secure
   */
  appCustomAccountHasAuthenticatorCreate = (params: RequestParams = {}) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/custom-account/has-authenticator`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomAccount
   * @name AppCustomAccountAuthenticatorInfoList
   * @request GET:/api/app/custom-account/authenticator-info
   * @secure
   */
  appCustomAccountAuthenticatorInfoList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountAuthenticatorInfoDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/custom-account/authenticator-info`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsList
   * @request GET:/api/app/data-forms
   * @secure
   */
  appDataFormsList = (
    query: AppDataFormsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDataFormsDataFormDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsCreate
   * @request POST:/api/app/data-forms
   * @secure
   */
  appDataFormsCreate = (
    data: MotrDataFormsDataFormCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsDetail
   * @request GET:/api/app/data-forms/{id}
   * @secure
   */
  appDataFormsDetail = (
    { id }: AppDataFormsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsUpdate
   * @request PUT:/api/app/data-forms/{id}
   * @secure
   */
  appDataFormsUpdate = (
    { id }: AppDataFormsUpdateParams,
    data: MotrDataFormsDataFormUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsDelete
   * @request DELETE:/api/app/data-forms/{id}
   * @secure
   */
  appDataFormsDelete = (
    { id }: AppDataFormsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/data-forms/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsAsExcelFileList
   * @request GET:/api/app/data-forms/as-excel-file
   * @secure
   */
  appDataFormsAsExcelFileList = (
    query: AppDataFormsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/data-forms/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataForm
   * @name AppDataFormsDownloadTokenList
   * @request GET:/api/app/data-forms/download-token
   * @secure
   */
  appDataFormsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnList
   * @request GET:/api/app/data-forms-extn
   * @secure
   */
  appDataFormsExtnList = (
    query: AppDataFormsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDataFormsDataFormDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnCreate
   * @request POST:/api/app/data-forms-extn
   * @secure
   */
  appDataFormsExtnCreate = (
    data: MotrDataFormsDataFormCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnDetail
   * @request GET:/api/app/data-forms-extn/{id}
   * @secure
   */
  appDataFormsExtnDetail = (
    { id }: AppDataFormsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnUpdate
   * @request PUT:/api/app/data-forms-extn/{id}
   * @secure
   */
  appDataFormsExtnUpdate = (
    { id }: AppDataFormsExtnUpdateParams,
    data: MotrDataFormsDataFormUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDataFormsDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnDelete
   * @request DELETE:/api/app/data-forms-extn/{id}
   * @secure
   */
  appDataFormsExtnDelete = (
    { id }: AppDataFormsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/data-forms-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnAsExcelFileList
   * @request GET:/api/app/data-forms-extn/as-excel-file
   * @secure
   */
  appDataFormsExtnAsExcelFileList = (
    query: AppDataFormsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/data-forms-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataFormExtn
   * @name AppDataFormsExtnDownloadTokenList
   * @request GET:/api/app/data-forms-extn/download-token
   * @secure
   */
  appDataFormsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/data-forms-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataSync
   * @name AppSuperadminDataSyncJobMatterTypesCreate
   * @request POST:/api/app/superadmin/data-sync/job-matter-types
   * @secure
   */
  appSuperadminDataSyncJobMatterTypesCreate = (
    data: MotrDataSyncStartJobMatterTypeSyncDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrDataSyncJobMatterTypeSyncQueuedDto, any>({
      path: `/api/app/superadmin/data-sync/job-matter-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataSync
   * @name AppSuperadminDataSyncWorkgroupClonePreviewCreate
   * @request POST:/api/app/superadmin/data-sync/workgroup-clone/preview
   * @secure
   */
  appSuperadminDataSyncWorkgroupClonePreviewCreate = (
    data: MotrDataSyncWorkgroupClonePreviewInput,
    params: RequestParams = {},
  ) =>
    this.request<MotrDataSyncWorkgroupClonePreviewDto, any>({
      path: `/api/app/superadmin/data-sync/workgroup-clone/preview`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DataSync
   * @name AppSuperadminDataSyncWorkgroupCloneExecuteCreate
   * @request POST:/api/app/superadmin/data-sync/workgroup-clone/execute
   * @secure
   */
  appSuperadminDataSyncWorkgroupCloneExecuteCreate = (
    data: MotrDataSyncExecuteWorkgroupCloneInput,
    params: RequestParams = {},
  ) =>
    this.request<MotrDataSyncWorkgroupCloneResultDto, any>({
      path: `/api/app/superadmin/data-sync/workgroup-clone/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsList
   * @request GET:/api/app/documents
   * @secure
   */
  appDocumentsList = (
    query: AppDocumentsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentsDocumentWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsCreate
   * @request POST:/api/app/documents
   * @secure
   */
  appDocumentsCreate = (
    data: MotrDocumentsDocumentCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsWithNavigationPropertiesDetail
   * @request GET:/api/app/documents/with-navigation-properties/{id}
   * @secure
   */
  appDocumentsWithNavigationPropertiesDetail = (
    { id }: AppDocumentsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsDetail
   * @request GET:/api/app/documents/{id}
   * @secure
   */
  appDocumentsDetail = (
    { id }: AppDocumentsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsUpdate
   * @request PUT:/api/app/documents/{id}
   * @secure
   */
  appDocumentsUpdate = (
    { id }: AppDocumentsUpdateParams,
    data: MotrDocumentsDocumentUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsDelete
   * @request DELETE:/api/app/documents/{id}
   * @secure
   */
  appDocumentsDelete = (
    { id }: AppDocumentsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/documents/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsJobLookupList
   * @request GET:/api/app/documents/job-lookup
   * @secure
   */
  appDocumentsJobLookupList = (
    query: AppDocumentsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsTemplateLookupList
   * @request GET:/api/app/documents/template-lookup
   * @secure
   */
  appDocumentsTemplateLookupList = (
    query: AppDocumentsTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsTemplateStepLookupList
   * @request GET:/api/app/documents/template-step-lookup
   * @secure
   */
  appDocumentsTemplateStepLookupList = (
    query: AppDocumentsTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Document
   * @name AppDocumentsJobStepLookupList
   * @request GET:/api/app/documents/job-step-lookup
   * @secure
   */
  appDocumentsJobStepLookupList = (
    query: AppDocumentsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtGetListList
   * @request GET:/api/app/documents-ext/get-list
   * @secure
   */
  appDocumentsExtGetListList = (
    query: AppDocumentsExtGetListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentsDocumentWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/get-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtWithNavigationPropertiesDetail
   * @request GET:/api/app/documents-ext/with-navigation-properties/{id}
   * @secure
   */
  appDocumentsExtWithNavigationPropertiesDetail = (
    { id }: AppDocumentsExtWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtDetail
   * @request GET:/api/app/documents-ext/{id}
   * @secure
   */
  appDocumentsExtDetail = (
    { id }: AppDocumentsExtDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtUpdate
   * @request PUT:/api/app/documents-ext/{id}
   * @secure
   */
  appDocumentsExtUpdate = (
    { id }: AppDocumentsExtUpdateParams,
    data: MotrDocumentsDocumentUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtDelete
   * @request DELETE:/api/app/documents-ext/{id}
   * @secure
   */
  appDocumentsExtDelete = (
    { id }: AppDocumentsExtDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/documents-ext/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtJobLookupList
   * @request GET:/api/app/documents-ext/job-lookup
   * @secure
   */
  appDocumentsExtJobLookupList = (
    query: AppDocumentsExtJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtTemplateLookupList
   * @request GET:/api/app/documents-ext/template-lookup
   * @secure
   */
  appDocumentsExtTemplateLookupList = (
    query: AppDocumentsExtTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtTemplateStepLookupList
   * @request GET:/api/app/documents-ext/template-step-lookup
   * @secure
   */
  appDocumentsExtTemplateStepLookupList = (
    query: AppDocumentsExtTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtJobStepLookupList
   * @request GET:/api/app/documents-ext/job-step-lookup
   * @secure
   */
  appDocumentsExtJobStepLookupList = (
    query: AppDocumentsExtJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtCreateCreate
   * @request POST:/api/app/documents-ext/create
   * @secure
   */
  appDocumentsExtCreateCreate = (
    data: MotrDocumentsDocumentCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentExt
   * @name AppDocumentsExtGetDocumentsList
   * @request GET:/api/app/documents-ext/get-documents
   * @secure
   */
  appDocumentsExtGetDocumentsList = (
    query: AppDocumentsExtGetDocumentsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-ext/get-documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLink
   * @name AppDocumentLinksList
   * @request GET:/api/app/document-links
   * @secure
   */
  appDocumentLinksList = (
    query: AppDocumentLinksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentLinksDocumentLinkDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLink
   * @name AppDocumentLinksCreate
   * @request POST:/api/app/document-links
   * @secure
   */
  appDocumentLinksCreate = (
    data: MotrDocumentLinksDocumentLinkCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLink
   * @name AppDocumentLinksDetail
   * @request GET:/api/app/document-links/{id}
   * @secure
   */
  appDocumentLinksDetail = (
    { id }: AppDocumentLinksDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLink
   * @name AppDocumentLinksUpdate
   * @request PUT:/api/app/document-links/{id}
   * @secure
   */
  appDocumentLinksUpdate = (
    { id }: AppDocumentLinksUpdateParams,
    data: MotrDocumentLinksDocumentLinkUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLink
   * @name AppDocumentLinksDelete
   * @request DELETE:/api/app/document-links/{id}
   * @secure
   */
  appDocumentLinksDelete = (
    { id }: AppDocumentLinksDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-links/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLinkExtn
   * @name AppDocumentLinksExtnList
   * @request GET:/api/app/document-links-extn
   * @secure
   */
  appDocumentLinksExtnList = (
    query: AppDocumentLinksExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentLinksDocumentLinkDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLinkExtn
   * @name AppDocumentLinksExtnCreate
   * @request POST:/api/app/document-links-extn
   * @secure
   */
  appDocumentLinksExtnCreate = (
    data: MotrDocumentLinksDocumentLinkCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLinkExtn
   * @name AppDocumentLinksExtnDetail
   * @request GET:/api/app/document-links-extn/{id}
   * @secure
   */
  appDocumentLinksExtnDetail = (
    { id }: AppDocumentLinksExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLinkExtn
   * @name AppDocumentLinksExtnUpdate
   * @request PUT:/api/app/document-links-extn/{id}
   * @secure
   */
  appDocumentLinksExtnUpdate = (
    { id }: AppDocumentLinksExtnUpdateParams,
    data: MotrDocumentLinksDocumentLinkUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentLinksDocumentLinkDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-links-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentLinkExtn
   * @name AppDocumentLinksExtnDelete
   * @request DELETE:/api/app/document-links-extn/{id}
   * @secure
   */
  appDocumentLinksExtnDelete = (
    { id }: AppDocumentLinksExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-links-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersList
   * @request GET:/api/app/document-place-holders
   * @secure
   */
  appDocumentPlaceHoldersList = (
    query: AppDocumentPlaceHoldersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersCreate
   * @request POST:/api/app/document-place-holders
   * @secure
   */
  appDocumentPlaceHoldersCreate = (
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersDelete
   * @request DELETE:/api/app/document-place-holders
   * @secure
   */
  appDocumentPlaceHoldersDelete = (
    query: AppDocumentPlaceHoldersDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersWithNavigationPropertiesDetail
   * @request GET:/api/app/document-place-holders/with-navigation-properties/{id}
   * @secure
   */
  appDocumentPlaceHoldersWithNavigationPropertiesDetail = (
    { id }: AppDocumentPlaceHoldersWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersDetail
   * @request GET:/api/app/document-place-holders/{id}
   * @secure
   */
  appDocumentPlaceHoldersDetail = (
    { id }: AppDocumentPlaceHoldersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersUpdate
   * @request PUT:/api/app/document-place-holders/{id}
   * @secure
   */
  appDocumentPlaceHoldersUpdate = (
    { id }: AppDocumentPlaceHoldersUpdateParams,
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersDelete2
   * @request DELETE:/api/app/document-place-holders/{id}
   * @originalName appDocumentPlaceHoldersDelete
   * @duplicate
   * @secure
   */
  appDocumentPlaceHoldersDelete2 = (
    { id }: AppDocumentPlaceHoldersDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersTemplateLookupList
   * @request GET:/api/app/document-place-holders/template-lookup
   * @secure
   */
  appDocumentPlaceHoldersTemplateLookupList = (
    query: AppDocumentPlaceHoldersTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersJobLookupList
   * @request GET:/api/app/document-place-holders/job-lookup
   * @secure
   */
  appDocumentPlaceHoldersJobLookupList = (
    query: AppDocumentPlaceHoldersJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersJobStepLookupList
   * @request GET:/api/app/document-place-holders/job-step-lookup
   * @secure
   */
  appDocumentPlaceHoldersJobStepLookupList = (
    query: AppDocumentPlaceHoldersJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersDocumentLookupList
   * @request GET:/api/app/document-place-holders/document-lookup
   * @secure
   */
  appDocumentPlaceHoldersDocumentLookupList = (
    query: AppDocumentPlaceHoldersDocumentLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/document-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersAsExcelFileList
   * @request GET:/api/app/document-place-holders/as-excel-file
   * @secure
   */
  appDocumentPlaceHoldersAsExcelFileList = (
    query: AppDocumentPlaceHoldersAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersDownloadTokenList
   * @request GET:/api/app/document-place-holders/download-token
   * @secure
   */
  appDocumentPlaceHoldersDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolder
   * @name AppDocumentPlaceHoldersAllDelete
   * @request DELETE:/api/app/document-place-holders/all
   * @secure
   */
  appDocumentPlaceHoldersAllDelete = (
    query: AppDocumentPlaceHoldersAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnList
   * @request GET:/api/app/document-place-holders-extn
   * @secure
   */
  appDocumentPlaceHoldersExtnList = (
    query: AppDocumentPlaceHoldersExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDelete
   * @request DELETE:/api/app/document-place-holders-extn
   * @secure
   */
  appDocumentPlaceHoldersExtnDelete = (
    query: AppDocumentPlaceHoldersExtnDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders-extn`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/document-place-holders-extn/with-navigation-properties/{id}
   * @secure
   */
  appDocumentPlaceHoldersExtnWithNavigationPropertiesDetail = (
    { id }: AppDocumentPlaceHoldersExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDetail
   * @request GET:/api/app/document-place-holders-extn/{id}
   * @secure
   */
  appDocumentPlaceHoldersExtnDetail = (
    { id }: AppDocumentPlaceHoldersExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnUpdate
   * @request PUT:/api/app/document-place-holders-extn/{id}
   * @secure
   */
  appDocumentPlaceHoldersExtnUpdate = (
    { id }: AppDocumentPlaceHoldersExtnUpdateParams,
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDelete2
   * @request DELETE:/api/app/document-place-holders-extn/{id}
   * @originalName appDocumentPlaceHoldersExtnDelete
   * @duplicate
   * @secure
   */
  appDocumentPlaceHoldersExtnDelete2 = (
    { id }: AppDocumentPlaceHoldersExtnDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnTemplateLookupList
   * @request GET:/api/app/document-place-holders-extn/template-lookup
   * @secure
   */
  appDocumentPlaceHoldersExtnTemplateLookupList = (
    query: AppDocumentPlaceHoldersExtnTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnJobLookupList
   * @request GET:/api/app/document-place-holders-extn/job-lookup
   * @secure
   */
  appDocumentPlaceHoldersExtnJobLookupList = (
    query: AppDocumentPlaceHoldersExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnJobStepLookupList
   * @request GET:/api/app/document-place-holders-extn/job-step-lookup
   * @secure
   */
  appDocumentPlaceHoldersExtnJobStepLookupList = (
    query: AppDocumentPlaceHoldersExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDocumentLookupList
   * @request GET:/api/app/document-place-holders-extn/document-lookup
   * @secure
   */
  appDocumentPlaceHoldersExtnDocumentLookupList = (
    query: AppDocumentPlaceHoldersExtnDocumentLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/document-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDocumentCreateCreate
   * @request POST:/api/app/document-place-holders-extn/document-create
   * @secure
   */
  appDocumentPlaceHoldersExtnDocumentCreateCreate = (
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/document-create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnAsExcelFileList
   * @request GET:/api/app/document-place-holders-extn/as-excel-file
   * @secure
   */
  appDocumentPlaceHoldersExtnAsExcelFileList = (
    query: AppDocumentPlaceHoldersExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnDownloadTokenList
   * @request GET:/api/app/document-place-holders-extn/download-token
   * @secure
   */
  appDocumentPlaceHoldersExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnAllDelete
   * @request DELETE:/api/app/document-place-holders-extn/all
   * @secure
   */
  appDocumentPlaceHoldersExtnAllDelete = (
    query: AppDocumentPlaceHoldersExtnAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-place-holders-extn/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentPlaceHolderEtn
   * @name AppDocumentPlaceHoldersExtnBulkDocumentCreateOrUpdateCreate
   * @request POST:/api/app/document-place-holders-extn/bulk-document-create-or-update
   * @secure
   */
  appDocumentPlaceHoldersExtnBulkDocumentCreateOrUpdateCreate = (
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderBulkCreateOrUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-place-holders-extn/bulk-document-create-or-update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderDownloadDocumentList
   * @request GET:/api/app/documents-provider/download-document
   * @secure
   */
  appDocumentsProviderDownloadDocumentList = (
    query: AppDocumentsProviderDownloadDocumentListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsDownloadDocumentResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/download-document`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetUserDetailsList
   * @request GET:/api/app/documents-provider/get-user-details
   * @secure
   */
  appDocumentsProviderGetUserDetailsList = (
    query: AppDocumentsProviderGetUserDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsDocumentRepoUserDetailVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-user-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetDocumentLinkForRegisteredUsersList
   * @request GET:/api/app/documents-provider/get-document-link-for-registered-users
   * @secure
   */
  appDocumentsProviderGetDocumentLinkForRegisteredUsersList = (
    query: AppDocumentsProviderGetDocumentLinkForRegisteredUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-document-link-for-registered-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetDocumentLinkList
   * @request GET:/api/app/documents-provider/get-document-link
   * @secure
   */
  appDocumentsProviderGetDocumentLinkList = (
    query: AppDocumentsProviderGetDocumentLinkListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-document-link`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderViewDocumentList
   * @request GET:/api/app/documents-provider/view-document
   * @secure
   */
  appDocumentsProviderViewDocumentList = (
    query: AppDocumentsProviderViewDocumentListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsGetDocumentResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/view-document`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderDownloadTokenizedDocumentList
   * @request GET:/api/app/documents-provider/download-tokenized-document
   * @secure
   */
  appDocumentsProviderDownloadTokenizedDocumentList = (
    query: AppDocumentsProviderDownloadTokenizedDocumentListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsGetDocumentResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/download-tokenized-document`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderUploadDocumentCreate
   * @request POST:/api/app/documents-provider/upload-document
   * @secure
   */
  appDocumentsProviderUploadDocumentCreate = (
    data: {
      Files?: File[];
    },
    query: AppDocumentsProviderUploadDocumentCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsUploadedDocsListResponseVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/upload-document`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderMoveDocumentToServiceAccountCreate
   * @request POST:/api/app/documents-provider/move-document-to-service-account
   * @secure
   */
  appDocumentsProviderMoveDocumentToServiceAccountCreate = (
    data: MotrDocumentsModelsUploadWorkingDocumentVm,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrJobsWorkingDocumentVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/move-document-to-service-account`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetCabinetsList
   * @request GET:/api/app/documents-provider/get-cabinets
   * @secure
   */
  appDocumentsProviderGetCabinetsList = (
    query: AppDocumentsProviderGetCabinetsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsModelsDocumentRepoCabinetInfoVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-cabinets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetClientsList
   * @request GET:/api/app/documents-provider/get-clients
   * @secure
   */
  appDocumentsProviderGetClientsList = (
    query: AppDocumentsProviderGetClientsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsModelsDocumentRepoClientInfoVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-clients`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetMattersList
   * @request GET:/api/app/documents-provider/get-matters
   * @secure
   */
  appDocumentsProviderGetMattersList = (
    query: AppDocumentsProviderGetMattersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsModelsDocumentRepoMatterInfoVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-matters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderCreateDocRepoRecordCreate
   * @request POST:/api/app/documents-provider/create-doc-repo-record
   * @secure
   */
  appDocumentsProviderCreateDocRepoRecordCreate = (
    data: MotrDocumentsModelsCreateDocRepoRecord,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsModelsCreateDocRepoRecordResponseMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/create-doc-repo-record`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetWorkspaceList
   * @request GET:/api/app/documents-provider/get-workspace
   * @secure
   */
  appDocumentsProviderGetWorkspaceList = (
    query: AppDocumentsProviderGetWorkspaceListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-workspace`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetProfileAttributesList
   * @request GET:/api/app/documents-provider/get-profile-attributes
   * @secure
   */
  appDocumentsProviderGetProfileAttributesList = (
    query: AppDocumentsProviderGetProfileAttributesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-profile-attributes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetWorkspaceDataList
   * @request GET:/api/app/documents-provider/get-workspace-data
   * @secure
   */
  appDocumentsProviderGetWorkspaceDataList = (
    query: AppDocumentsProviderGetWorkspaceDataListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-workspace-data`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetProviderConfigList
   * @request GET:/api/app/documents-provider/get-provider-config
   * @secure
   */
  appDocumentsProviderGetProviderConfigList = (
    query: AppDocumentsProviderGetProviderConfigListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsKeyValueParentVM[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-provider-config`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetLocationsList
   * @request GET:/api/app/documents-provider/get-locations
   * @secure
   */
  appDocumentsProviderGetLocationsList = (
    query: AppDocumentsProviderGetLocationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-locations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetDocumentTypesList
   * @request GET:/api/app/documents-provider/get-document-types
   * @secure
   */
  appDocumentsProviderGetDocumentTypesList = (
    query: AppDocumentsProviderGetDocumentTypesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      { isSuccess?: boolean; message?: string | null; result?: { key?: string | null; value?: string | null }[] | null },
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-document-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetFoldersList
   * @request GET:/api/app/documents-provider/get-folders
   * @secure
   */
  appDocumentsProviderGetFoldersList = (
    query: AppDocumentsProviderGetFoldersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrDocumentsDocumentRepositoryFoldersMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-folders`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetFolderContentList
   * @request GET:/api/app/documents-provider/get-folder-content
   * @secure
   */
  appDocumentsProviderGetFolderContentList = (
    query: AppDocumentsProviderGetFolderContentListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/get-folder-content`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderFollowDocumentsCreate
   * @request POST:/api/app/documents-provider/follow-documents
   * @secure
   */
  appDocumentsProviderFollowDocumentsCreate = (
    data: MotrDocumentsModelsFollowDocumentsVm,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/follow-documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderSyncCabinetsCreate
   * @request POST:/api/app/documents-provider/sync-cabinets
   * @secure
   */
  appDocumentsProviderSyncCabinetsCreate = (
    data: MotrDocumentsModelsCabinetSyncVm,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrSyncedDataBulkPushResultDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/sync-cabinets`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetSecureLinkCreate
   * @request POST:/api/app/documents-provider/GetSecureLink
   * @secure
   */
  appDocumentsProviderGetSecureLinkCreate = (
    data: MotrDocumentsGetProviderSecureLinkVm,
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/documents-provider/GetSecureLink`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetSecureLinkForUserCreate
   * @request POST:/api/app/documents-provider/GetSecureLink-forUser
   * @secure
   */
  appDocumentsProviderGetSecureLinkForUserCreate = (
    data: MotrDocumentsGetProviderSecureLinkVm,
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/documents-provider/GetSecureLink-forUser`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderAuthenticateUserCreate
   * @request POST:/api/app/documents-provider/Authenticate-user
   * @secure
   */
  appDocumentsProviderAuthenticateUserCreate = (
    data: MotrUsersUserLoginVm,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUsersUserLoginResponseVm,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/Authenticate-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentProvider
   * @name AppDocumentsProviderGetDocumentTokensCreate
   * @request POST:/api/app/documents-provider/GetDocumentTokens
   * @secure
   */
  appDocumentsProviderGetDocumentTokensCreate = (
    data: Blob,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1SystemCollectionsGenericList1MotrDocumentTemplatesDocumentPlaceholderDetailsVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNullSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/documents-provider/GetDocumentTokens`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesGetDocumentTokensAsyncCreate
   * @request POST:/api/app/document-templates/GetDocumentTokensAsync
   * @secure
   */
  appDocumentTemplatesGetDocumentTokensAsyncCreate = (
    data: MotrDocumentTemplatesDocumentTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentTemplatesDocumentPlaceholderDetailsVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates/GetDocumentTokensAsync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesUpdateDocumentAndPlaceholderAsyncCreate
   * @request POST:/api/app/document-templates/UpdateDocumentAndPlaceholderAsync
   * @secure
   */
  appDocumentTemplatesUpdateDocumentAndPlaceholderAsyncCreate = (
    data: MotrDocumentTemplatesDocumentTemplateUpdateDto,
    query: AppDocumentTemplatesUpdateDocumentAndPlaceholderAsyncCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentTemplatesDocumentTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates/UpdateDocumentAndPlaceholderAsync`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesList
   * @request GET:/api/app/document-templates
   * @secure
   */
  appDocumentTemplatesList = (
    query: AppDocumentTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrDocumentTemplatesDocumentTemplateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesCreate
   * @request POST:/api/app/document-templates
   * @secure
   */
  appDocumentTemplatesCreate = (
    data: MotrDocumentTemplatesDocumentTemplateCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentTemplatesDocumentTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesDetail
   * @request GET:/api/app/document-templates/{id}
   * @secure
   */
  appDocumentTemplatesDetail = (
    { id }: AppDocumentTemplatesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentTemplatesDocumentTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesUpdate
   * @request PUT:/api/app/document-templates/{id}
   * @secure
   */
  appDocumentTemplatesUpdate = (
    { id }: AppDocumentTemplatesUpdateParams,
    data: MotrDocumentTemplatesDocumentTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentTemplatesDocumentTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/document-templates/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DocumentTemplate
   * @name AppDocumentTemplatesDelete
   * @request DELETE:/api/app/document-templates/{id}
   * @secure
   */
  appDocumentTemplatesDelete = (
    { id }: AppDocumentTemplatesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/document-templates/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags DynamicClaims
   * @name AccountDynamicClaimsRefreshCreate
   * @request POST:/api/account/dynamic-claims/refresh
   * @secure
   */
  accountDynamicClaimsRefreshCreate = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/dynamic-claims/refresh`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsDetail
   * @request GET:/api/saas/editions/{id}
   * @secure
   */
  saasEditionsDetail = (
    { id }: SaasEditionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosEditionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsUpdate
   * @request PUT:/api/saas/editions/{id}
   * @secure
   */
  saasEditionsUpdate = (
    { id }: SaasEditionsUpdateParams,
    data: VoloSaasHostDtosEditionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosEditionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsDelete
   * @request DELETE:/api/saas/editions/{id}
   * @secure
   */
  saasEditionsDelete = (
    { id }: SaasEditionsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/editions/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsList
   * @request GET:/api/saas/editions
   * @secure
   */
  saasEditionsList = (
    query: SaasEditionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloSaasHostDtosEditionDtoVoloSaasHostApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsCreate
   * @request POST:/api/saas/editions
   * @secure
   */
  saasEditionsCreate = (
    data: VoloSaasHostDtosEditionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosEditionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsMoveAllTenantsUpdate
   * @request PUT:/api/saas/editions/{id}/move-all-tenants
   * @secure
   */
  saasEditionsMoveAllTenantsUpdate = (
    { id, ...query }: SaasEditionsMoveAllTenantsUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/editions/${id}/move-all-tenants`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsAllList
   * @request GET:/api/saas/editions/all
   * @secure
   */
  saasEditionsAllList = (params: RequestParams = {}) =>
    this.request<
      VoloSaasHostDtosEditionDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsStatisticsUsageStatisticList
   * @request GET:/api/saas/editions/statistics/usage-statistic
   * @secure
   */
  saasEditionsStatisticsUsageStatisticList = (params: RequestParams = {}) =>
    this.request<
      VoloSaasHostGetEditionUsageStatisticsResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions/statistics/usage-statistic`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasEditionsPlanLookupList
   * @request GET:/api/saas/editions/plan-lookup
   * @secure
   */
  saasEditionsPlanLookupList = (params: RequestParams = {}) =>
    this.request<
      VoloPaymentPlansPlanDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/editions/plan-lookup`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Edition
   * @name SaasSubscriptionCreate
   * @request POST:/api/saas/subscription
   * @secure
   */
  saasSubscriptionCreate = (
    query: SaasSubscriptionCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloPaymentRequestsPaymentRequestWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/subscription`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsList
   * @request GET:/api/app/email-conversations
   * @secure
   */
  appEmailConversationsList = (
    query: AppEmailConversationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEmailConversationsEmailConversationWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsCreate
   * @request POST:/api/app/email-conversations
   * @secure
   */
  appEmailConversationsCreate = (
    data: MotrEmailConversationsEmailConversationCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailConversationsEmailConversationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsDelete
   * @request DELETE:/api/app/email-conversations
   * @secure
   */
  appEmailConversationsDelete = (
    query: AppEmailConversationsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-conversations`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsWithNavigationPropertiesDetail
   * @request GET:/api/app/email-conversations/with-navigation-properties/{id}
   * @secure
   */
  appEmailConversationsWithNavigationPropertiesDetail = (
    { id }: AppEmailConversationsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailConversationsEmailConversationWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsDetail
   * @request GET:/api/app/email-conversations/{id}
   * @secure
   */
  appEmailConversationsDetail = (
    { id }: AppEmailConversationsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailConversationsEmailConversationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsUpdate
   * @request PUT:/api/app/email-conversations/{id}
   * @secure
   */
  appEmailConversationsUpdate = (
    { id }: AppEmailConversationsUpdateParams,
    data: MotrEmailConversationsEmailConversationUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailConversationsEmailConversationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsDelete2
   * @request DELETE:/api/app/email-conversations/{id}
   * @originalName appEmailConversationsDelete
   * @duplicate
   * @secure
   */
  appEmailConversationsDelete2 = (
    { id }: AppEmailConversationsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-conversations/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsJobLookupList
   * @request GET:/api/app/email-conversations/job-lookup
   * @secure
   */
  appEmailConversationsJobLookupList = (
    query: AppEmailConversationsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsAsExcelFileList
   * @request GET:/api/app/email-conversations/as-excel-file
   * @secure
   */
  appEmailConversationsAsExcelFileList = (
    query: AppEmailConversationsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-conversations/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsDownloadTokenList
   * @request GET:/api/app/email-conversations/download-token
   * @secure
   */
  appEmailConversationsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-conversations/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailConversation
   * @name AppEmailConversationsAllDelete
   * @request DELETE:/api/app/email-conversations/all
   * @secure
   */
  appEmailConversationsAllDelete = (
    query: AppEmailConversationsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-conversations/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailProcessing
   * @name AppEmailProcessingProcessEmailCreate
   * @request POST:/api/app/email-processing/process-email
   * @secure
   */
  appEmailProcessingProcessEmailCreate = (
    data: MotrEmailMonitoringDtosEmailJobCreationRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-processing/process-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailProcessing
   * @name AppEmailProcessingWorkflowDefinitionsForAiList
   * @request GET:/api/app/email-processing/workflow-definitions-for-ai
   * @secure
   */
  appEmailProcessingWorkflowDefinitionsForAiList = (
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailMonitoringDtosWorkflowDefinitionsForAiDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-processing/workflow-definitions-for-ai`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailSettings
   * @name SettingManagementEmailingList
   * @request GET:/api/setting-management/emailing
   * @secure
   */
  settingManagementEmailingList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpSettingManagementEmailSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/setting-management/emailing`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailSettings
   * @name SettingManagementEmailingCreate
   * @request POST:/api/setting-management/emailing
   * @secure
   */
  settingManagementEmailingCreate = (
    data: VoloAbpSettingManagementUpdateEmailSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/setting-management/emailing`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailSettings
   * @name SettingManagementEmailingSendTestEmailCreate
   * @request POST:/api/setting-management/emailing/send-test-email
   * @secure
   */
  settingManagementEmailingSendTestEmailCreate = (
    data: VoloAbpSettingManagementSendTestEmailInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/setting-management/emailing/send-test-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesList
   * @request GET:/api/app/email-templates
   * @secure
   */
  appEmailTemplatesList = (
    query: AppEmailTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesCreate
   * @request POST:/api/app/email-templates
   * @secure
   */
  appEmailTemplatesCreate = (
    data: MotrEmailTemplatesEmailTemplateCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesWithNavigationPropertiesDetail
   * @request GET:/api/app/email-templates/with-navigation-properties/{id}
   * @secure
   */
  appEmailTemplatesWithNavigationPropertiesDetail = (
    { id }: AppEmailTemplatesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesDetail
   * @request GET:/api/app/email-templates/{id}
   * @secure
   */
  appEmailTemplatesDetail = (
    { id }: AppEmailTemplatesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesUpdate
   * @request PUT:/api/app/email-templates/{id}
   * @secure
   */
  appEmailTemplatesUpdate = (
    { id }: AppEmailTemplatesUpdateParams,
    data: MotrEmailTemplatesEmailTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesDelete
   * @request DELETE:/api/app/email-templates/{id}
   * @secure
   */
  appEmailTemplatesDelete = (
    { id }: AppEmailTemplatesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-templates/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplate
   * @name AppEmailTemplatesSnippetLookupList
   * @request GET:/api/app/email-templates/snippet-lookup
   * @secure
   */
  appEmailTemplatesSnippetLookupList = (
    query: AppEmailTemplatesSnippetLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-templates/snippet-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtGetEmailTemplateFiltersList
   * @request GET:/api/app/email-template-ext/get-email-template-filters
   * @secure
   */
  appEmailTemplateExtGetEmailTemplateFiltersList = (
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsEmailTemplateFilters,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext/get-email-template-filters`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtList
   * @request GET:/api/app/email-template-ext
   * @secure
   */
  appEmailTemplateExtList = (
    query: AppEmailTemplateExtListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtCreate
   * @request POST:/api/app/email-template-ext
   * @secure
   */
  appEmailTemplateExtCreate = (
    data: MotrEmailTemplatesEmailTemplateCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtWithNavigationPropertiesDetail
   * @request GET:/api/app/email-template-ext/with-navigation-properties/{id}
   * @secure
   */
  appEmailTemplateExtWithNavigationPropertiesDetail = (
    { id }: AppEmailTemplateExtWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtDetail
   * @request GET:/api/app/email-template-ext/{id}
   * @secure
   */
  appEmailTemplateExtDetail = (
    { id }: AppEmailTemplateExtDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtUpdate
   * @request PUT:/api/app/email-template-ext/{id}
   * @secure
   */
  appEmailTemplateExtUpdate = (
    { id }: AppEmailTemplateExtUpdateParams,
    data: MotrEmailTemplatesEmailTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEmailTemplatesEmailTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtDelete
   * @request DELETE:/api/app/email-template-ext/{id}
   * @secure
   */
  appEmailTemplateExtDelete = (
    { id }: AppEmailTemplateExtDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/email-template-ext/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmailTemplateExt
   * @name AppEmailTemplateExtSnippetLookupList
   * @request GET:/api/app/email-template-ext/snippet-lookup
   * @secure
   */
  appEmailTemplateExtSnippetLookupList = (
    query: AppEmailTemplateExtSnippetLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/email-template-ext/snippet-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsList
   * @request GET:/api/app/entity-records
   * @secure
   */
  appEntityRecordsList = (
    query: AppEntityRecordsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEntityRecordsEntityRecordDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsCreate
   * @request POST:/api/app/entity-records
   * @secure
   */
  appEntityRecordsCreate = (
    data: MotrEntityRecordsEntityRecordCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsLookupDetail
   * @request GET:/api/app/entity-records/lookup/{typeId}
   * @secure
   */
  appEntityRecordsLookupDetail = (
    { typeId, ...query }: AppEntityRecordsLookupDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/lookup/${typeId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsDetail
   * @request GET:/api/app/entity-records/{id}
   * @secure
   */
  appEntityRecordsDetail = (
    { id }: AppEntityRecordsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsUpdate
   * @request PUT:/api/app/entity-records/{id}
   * @secure
   */
  appEntityRecordsUpdate = (
    { id }: AppEntityRecordsUpdateParams,
    data: MotrEntityRecordsEntityRecordUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsDelete
   * @request DELETE:/api/app/entity-records/{id}
   * @secure
   */
  appEntityRecordsDelete = (
    { id }: AppEntityRecordsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/entity-records/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsEnabledUpdate
   * @request PUT:/api/app/entity-records/{id}/enabled
   * @secure
   */
  appEntityRecordsEnabledUpdate = (
    { id, ...query }: AppEntityRecordsEnabledUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/${id}/enabled`,
      method: "PUT",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsBulkUploadCreate
   * @request POST:/api/app/entity-records/bulk-upload
   * @secure
   */
  appEntityRecordsBulkUploadCreate = (
    data: {
      /** @format binary */
      file?: File;
      /** @format uuid */
      defaultEntityTypeId?: string;
      /** @default true */
      validateParentKeys?: boolean;
      columnMapping?: string;
      /** @default false */
      dryRun?: boolean;
      /** @default false */
      generateMissingKeys?: boolean;
      /** @format int32 */
      batchOffset?: number;
      /** @format int32 */
      batchSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordBulkUploadResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/bulk-upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsBulkUploadInspectCreate
   * @request POST:/api/app/entity-records/bulk-upload/inspect
   * @secure
   */
  appEntityRecordsBulkUploadInspectCreate = (
    data: {
      /** @format binary */
      file?: File;
      /** @format uuid */
      defaultEntityTypeId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityRecordsEntityRecordBulkUploadInspectResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-records/bulk-upload/inspect`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityRecord
   * @name AppEntityRecordsBulkUploadSampleList
   * @request GET:/api/app/entity-records/bulk-upload/sample
   * @secure
   */
  appEntityRecordsBulkUploadSampleList = (
    query: AppEntityRecordsBulkUploadSampleListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/entity-records/bulk-upload/sample`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityType
   * @name AppEntityTypesList
   * @request GET:/api/app/entity-types
   * @secure
   */
  appEntityTypesList = (
    query: AppEntityTypesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEntityTypesEntityTypeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityType
   * @name AppEntityTypesCreate
   * @request POST:/api/app/entity-types
   * @secure
   */
  appEntityTypesCreate = (
    data: MotrEntityTypesEntityTypeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityTypesEntityTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityType
   * @name AppEntityTypesDetail
   * @request GET:/api/app/entity-types/{id}
   * @secure
   */
  appEntityTypesDetail = (
    { id }: AppEntityTypesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityTypesEntityTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-types/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityType
   * @name AppEntityTypesUpdate
   * @request PUT:/api/app/entity-types/{id}
   * @secure
   */
  appEntityTypesUpdate = (
    { id }: AppEntityTypesUpdateParams,
    data: MotrEntityTypesEntityTypeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEntityTypesEntityTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/entity-types/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityType
   * @name AppEntityTypesDelete
   * @request DELETE:/api/app/entity-types/{id}
   * @secure
   */
  appEntityTypesDelete = (
    { id }: AppEntityTypesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/entity-types/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesList
   * @request GET:/api/app/envelopes
   * @secure
   */
  appEnvelopesList = (
    query: AppEnvelopesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEnvelopesEnvelopeWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesCreate
   * @request POST:/api/app/envelopes
   * @secure
   */
  appEnvelopesCreate = (
    data: MotrEnvelopesEnvelopeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesWithNavigationPropertiesDetail
   * @request GET:/api/app/envelopes/with-navigation-properties/{id}
   * @secure
   */
  appEnvelopesWithNavigationPropertiesDetail = (
    { id }: AppEnvelopesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesDetail
   * @request GET:/api/app/envelopes/{id}
   * @secure
   */
  appEnvelopesDetail = (
    { id }: AppEnvelopesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesUpdate
   * @request PUT:/api/app/envelopes/{id}
   * @secure
   */
  appEnvelopesUpdate = (
    { id }: AppEnvelopesUpdateParams,
    data: MotrEnvelopesEnvelopeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesDelete
   * @request DELETE:/api/app/envelopes/{id}
   * @secure
   */
  appEnvelopesDelete = (
    { id }: AppEnvelopesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/envelopes/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesDocumentLookupList
   * @request GET:/api/app/envelopes/document-lookup
   * @secure
   */
  appEnvelopesDocumentLookupList = (
    query: AppEnvelopesDocumentLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes/document-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Envelope
   * @name AppEnvelopesJobLookupList
   * @request GET:/api/app/envelopes/job-lookup
   * @secure
   */
  appEnvelopesJobLookupList = (
    query: AppEnvelopesJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelopes/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnList
   * @request GET:/api/app/envelope-extn
   * @secure
   */
  appEnvelopeExtnList = (
    query: AppEnvelopeExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrEnvelopesEnvelopeWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnUpdateManyCreate
   * @request POST:/api/app/envelope-extn/update-many
   * @secure
   */
  appEnvelopeExtnUpdateManyCreate = (
    data: MotrEnvelopesEnvelopeUpdateDto[],
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/envelope-extn/update-many`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/envelope-extn/with-navigation-properties/{id}
   * @secure
   */
  appEnvelopeExtnWithNavigationPropertiesDetail = (
    { id }: AppEnvelopeExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnDetail
   * @request GET:/api/app/envelope-extn/{id}
   * @secure
   */
  appEnvelopeExtnDetail = (
    { id }: AppEnvelopeExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnUpdate
   * @request PUT:/api/app/envelope-extn/{id}
   * @secure
   */
  appEnvelopeExtnUpdate = (
    { id }: AppEnvelopeExtnUpdateParams,
    data: MotrEnvelopesEnvelopeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnDelete
   * @request DELETE:/api/app/envelope-extn/{id}
   * @secure
   */
  appEnvelopeExtnDelete = (
    { id }: AppEnvelopeExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/envelope-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnDocumentLookupList
   * @request GET:/api/app/envelope-extn/document-lookup
   * @secure
   */
  appEnvelopeExtnDocumentLookupList = (
    query: AppEnvelopeExtnDocumentLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/document-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnJobLookupList
   * @request GET:/api/app/envelope-extn/job-lookup
   * @secure
   */
  appEnvelopeExtnJobLookupList = (
    query: AppEnvelopeExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EnvelopeExtn
   * @name AppEnvelopeExtnCreateCreate
   * @request POST:/api/app/envelope-extn/create
   * @secure
   */
  appEnvelopeExtnCreateCreate = (
    data: MotrEnvelopesEnvelopeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrEnvelopesEnvelopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/envelope-extn/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name IdentityExternalLoginCreate
   * @request POST:/api/identity/external-login
   * @secure
   */
  identityExternalLoginCreate = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/external-login`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Features
   * @name FeatureManagementFeaturesList
   * @request GET:/api/feature-management/features
   * @secure
   */
  featureManagementFeaturesList = (
    query: FeatureManagementFeaturesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpFeatureManagementGetFeatureListResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/feature-management/features`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Features
   * @name FeatureManagementFeaturesUpdate
   * @request PUT:/api/feature-management/features
   * @secure
   */
  featureManagementFeaturesUpdate = (
    data: VoloAbpFeatureManagementUpdateFeaturesDto,
    query: FeatureManagementFeaturesUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/feature-management/features`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Features
   * @name FeatureManagementFeaturesDelete
   * @request DELETE:/api/feature-management/features
   * @secure
   */
  featureManagementFeaturesDelete = (
    query: FeatureManagementFeaturesDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/feature-management/features`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags FeedbackAction
   * @name AppClientFeedbackFormList
   * @request GET:/api/app/client-feedback/form
   * @secure
   */
  appClientFeedbackFormList = (
    query: AppClientFeedbackFormListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-feedback/form`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags FeedbackAction
   * @name AppClientFeedbackSubmitCreate
   * @request POST:/api/app/client-feedback/submit
   * @secure
   */
  appClientFeedbackSubmitCreate = (
    data: {
      token?: string;
      /** @format int32 */
      rating?: number;
      comment?: string;
      /** @format uuid */
      jobId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/client-feedback/submit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersList
   * @request GET:/api/app/filters
   * @secure
   */
  appFiltersList = (
    query: AppFiltersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrFiltersFilterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/filters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersCreate
   * @request POST:/api/app/filters
   * @secure
   */
  appFiltersCreate = (
    data: MotrFiltersFilterCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersDelete
   * @request DELETE:/api/app/filters
   * @secure
   */
  appFiltersDelete = (
    query: AppFiltersDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersDetail
   * @request GET:/api/app/filters/{id}
   * @secure
   */
  appFiltersDetail = (
    { id }: AppFiltersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersUpdate
   * @request PUT:/api/app/filters/{id}
   * @secure
   */
  appFiltersUpdate = (
    { id }: AppFiltersUpdateParams,
    data: MotrFiltersFilterUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersDelete2
   * @request DELETE:/api/app/filters/{id}
   * @originalName appFiltersDelete
   * @duplicate
   * @secure
   */
  appFiltersDelete2 = (
    { id }: AppFiltersDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersAsExcelFileList
   * @request GET:/api/app/filters/as-excel-file
   * @secure
   */
  appFiltersAsExcelFileList = (
    query: AppFiltersAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersDownloadTokenList
   * @request GET:/api/app/filters/download-token
   * @secure
   */
  appFiltersDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/filters/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Filter
   * @name AppFiltersAllDelete
   * @request DELETE:/api/app/filters/all
   * @secure
   */
  appFiltersAllDelete = (
    query: AppFiltersAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnGetListList
   * @request GET:/api/app/filters-extn/get-list
   * @secure
   */
  appFiltersExtnGetListList = (
    query: AppFiltersExtnGetListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrFiltersFilterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/filters-extn/get-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnGetListForUserList
   * @request GET:/api/app/filters-extn/get-list-for-user
   * @secure
   */
  appFiltersExtnGetListForUserList = (
    query: AppFiltersExtnGetListForUserListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrFiltersFilterDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/filters-extn/get-list-for-user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnDetail
   * @request GET:/api/app/filters-extn/{id}
   * @secure
   */
  appFiltersExtnDetail = (
    { id }: AppFiltersExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnUpdate
   * @request PUT:/api/app/filters-extn/{id}
   * @secure
   */
  appFiltersExtnUpdate = (
    { id }: AppFiltersExtnUpdateParams,
    data: MotrFiltersFilterUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnDelete
   * @request DELETE:/api/app/filters-extn/{id}
   * @secure
   */
  appFiltersExtnDelete = (
    { id }: AppFiltersExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnCreate
   * @request POST:/api/app/filters-extn
   * @secure
   */
  appFiltersExtnCreate = (
    data: MotrFiltersFilterCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrFiltersFilterDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnDelete2
   * @request DELETE:/api/app/filters-extn
   * @originalName appFiltersExtnDelete
   * @duplicate
   * @secure
   */
  appFiltersExtnDelete2 = (
    query: AppFiltersExtnDelete2Params = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnAsExcelFileList
   * @request GET:/api/app/filters-extn/as-excel-file
   * @secure
   */
  appFiltersExtnAsExcelFileList = (
    query: AppFiltersExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnDownloadTokenList
   * @request GET:/api/app/filters-extn/download-token
   * @secure
   */
  appFiltersExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/filters-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags FilterExtn
   * @name AppFiltersExtnAllDelete
   * @request DELETE:/api/app/filters-extn/all
   * @secure
   */
  appFiltersExtnAllDelete = (
    query: AppFiltersExtnAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/filters-extn/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags GetAiOperationsOutput
   * @name AppGetAiOperationsOutputExecuteCreate
   * @request POST:/api/app/get-ai-operations-output/execute
   * @secure
   */
  appGetAiOperationsOutputExecuteCreate = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/get-ai-operations-output/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GetDocumentTemplateTool
   * @name AppGetDocumentTemplateToolExecuteCreate
   * @request POST:/api/app/get-document-template-tool/execute
   * @secure
   */
  appGetDocumentTemplateToolExecuteCreate = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/get-document-template-tool/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ImapEmailReceiver
   * @name AppImapEmailReceiverFetchAndProcessNewEmailsCreate
   * @request POST:/api/app/imap-email-receiver/fetch-and-process-new-emails
   * @secure
   */
  appImapEmailReceiverFetchAndProcessNewEmailsCreate = (
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/imap-email-receiver/fetch-and-process-new-emails`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsList
   * @request GET:/api/app/jobs
   * @secure
   */
  appJobsList = (query: AppJobsListParams = {}, params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobsJobWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsCreate
   * @request POST:/api/app/jobs
   * @secure
   */
  appJobsCreate = (data: MotrJobsJobCreateDto, params: RequestParams = {}) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsWithNavigationPropertiesDetail
   * @request GET:/api/app/jobs/with-navigation-properties/{id}
   * @secure
   */
  appJobsWithNavigationPropertiesDetail = (
    { id }: AppJobsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsDetail
   * @request GET:/api/app/jobs/{id}
   * @secure
   */
  appJobsDetail = ({ id }: AppJobsDetailParams, params: RequestParams = {}) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsUpdate
   * @request PUT:/api/app/jobs/{id}
   * @secure
   */
  appJobsUpdate = (
    { id }: AppJobsUpdateParams,
    data: MotrJobsJobUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsDelete
   * @request DELETE:/api/app/jobs/{id}
   * @secure
   */
  appJobsDelete = ({ id }: AppJobsDeleteParams, params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsTemplateLookupList
   * @request GET:/api/app/jobs/template-lookup
   * @secure
   */
  appJobsTemplateLookupList = (
    query: AppJobsTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsOrganizationUnitLookupList
   * @request GET:/api/app/jobs/organization-unit-lookup
   * @secure
   */
  appJobsOrganizationUnitLookupList = (
    query: AppJobsOrganizationUnitLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs/organization-unit-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Job
   * @name AppJobsJobOutcomeLookupList
   * @request GET:/api/app/jobs/job-outcome-lookup
   * @secure
   */
  appJobsJobOutcomeLookupList = (
    query: AppJobsJobOutcomeLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs/job-outcome-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsList
   * @request GET:/api/app/job-actions
   * @secure
   */
  appJobActionsList = (
    query: AppJobActionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobActionsJobActionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsCreate
   * @request POST:/api/app/job-actions
   * @secure
   */
  appJobActionsCreate = (
    data: MotrJobActionsJobActionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-actions/with-navigation-properties/{id}
   * @secure
   */
  appJobActionsWithNavigationPropertiesDetail = (
    { id }: AppJobActionsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsDetail
   * @request GET:/api/app/job-actions/{id}
   * @secure
   */
  appJobActionsDetail = (
    { id }: AppJobActionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsUpdate
   * @request PUT:/api/app/job-actions/{id}
   * @secure
   */
  appJobActionsUpdate = (
    { id }: AppJobActionsUpdateParams,
    data: MotrJobActionsJobActionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsDelete
   * @request DELETE:/api/app/job-actions/{id}
   * @secure
   */
  appJobActionsDelete = (
    { id }: AppJobActionsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-actions/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsJobLookupList
   * @request GET:/api/app/job-actions/job-lookup
   * @secure
   */
  appJobActionsJobLookupList = (
    query: AppJobActionsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobAction
   * @name AppJobActionsJobStepLookupList
   * @request GET:/api/app/job-actions/job-step-lookup
   * @secure
   */
  appJobActionsJobStepLookupList = (
    query: AppJobActionsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnList
   * @request GET:/api/app/job-actions-extn
   * @secure
   */
  appJobActionsExtnList = (
    query: AppJobActionsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobActionsJobActionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-actions-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobActionsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobActionsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnDetail
   * @request GET:/api/app/job-actions-extn/{id}
   * @secure
   */
  appJobActionsExtnDetail = (
    { id }: AppJobActionsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnUpdate
   * @request PUT:/api/app/job-actions-extn/{id}
   * @secure
   */
  appJobActionsExtnUpdate = (
    { id }: AppJobActionsExtnUpdateParams,
    data: MotrJobActionsJobActionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnDelete
   * @request DELETE:/api/app/job-actions-extn/{id}
   * @secure
   */
  appJobActionsExtnDelete = (
    { id }: AppJobActionsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-actions-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnJobLookupList
   * @request GET:/api/app/job-actions-extn/job-lookup
   * @secure
   */
  appJobActionsExtnJobLookupList = (
    query: AppJobActionsExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnJobStepLookupList
   * @request GET:/api/app/job-actions-extn/job-step-lookup
   * @secure
   */
  appJobActionsExtnJobStepLookupList = (
    query: AppJobActionsExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnCreateCreate
   * @request POST:/api/app/job-actions-extn/create
   * @secure
   */
  appJobActionsExtnCreateCreate = (
    data: MotrJobActionsJobActionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionsExtnCreateLogAndSendMailCreate
   * @request POST:/api/app/job-actions-extn/create-log-and-send-mail
   * @secure
   */
  appJobActionsExtnCreateLogAndSendMailCreate = (
    data: MotrJobActionsJobActionLogDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-actions-extn/create-log-and-send-mail`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnList
   * @request GET:/api/app/job-action-extn
   * @secure
   */
  appJobActionExtnList = (
    query: AppJobActionExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobActionsJobActionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnCreate
   * @request POST:/api/app/job-action-extn
   * @secure
   */
  appJobActionExtnCreate = (
    data: MotrJobActionsJobActionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnWithNavigationPropertiesList
   * @request GET:/api/app/job-action-extn/{id}/with-navigation-properties
   * @secure
   */
  appJobActionExtnWithNavigationPropertiesList = (
    { id }: AppJobActionExtnWithNavigationPropertiesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/${id}/with-navigation-properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnDetail
   * @request GET:/api/app/job-action-extn/{id}
   * @secure
   */
  appJobActionExtnDetail = (
    { id }: AppJobActionExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnDelete
   * @request DELETE:/api/app/job-action-extn/{id}
   * @secure
   */
  appJobActionExtnDelete = (
    { id }: AppJobActionExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-action-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnUpdate
   * @request PUT:/api/app/job-action-extn/{id}
   * @secure
   */
  appJobActionExtnUpdate = (
    { id }: AppJobActionExtnUpdateParams,
    data: MotrJobActionsJobActionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnJobLookupList
   * @request GET:/api/app/job-action-extn/job-lookup
   * @secure
   */
  appJobActionExtnJobLookupList = (
    query: AppJobActionExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnJobStepLookupList
   * @request GET:/api/app/job-action-extn/job-step-lookup
   * @secure
   */
  appJobActionExtnJobStepLookupList = (
    query: AppJobActionExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnAndSendMailCreate
   * @request POST:/api/app/job-action-extn/and-send-mail
   * @secure
   */
  appJobActionExtnAndSendMailCreate = (
    data: MotrJobActionsJobActionLogDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobActionsJobActionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/and-send-mail`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobActionExtn
   * @name AppJobActionExtnTaskExecutionCreate
   * @request POST:/api/app/job-action-extn/task-execution
   * @secure
   */
  appJobActionExtnTaskExecutionCreate = (
    data: Record<string, any>,
    query: AppJobActionExtnTaskExecutionCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrAiServicesAiTaskExecutionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-action-extn/task-execution`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsList
   * @request GET:/api/app/job-data-forms
   * @secure
   */
  appJobDataFormsList = (
    query: AppJobDataFormsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobDataFormsJobDataFormWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsCreate
   * @request POST:/api/app/job-data-forms
   * @secure
   */
  appJobDataFormsCreate = (
    data: MotrJobDataFormsJobDataFormCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-data-forms/with-navigation-properties/{id}
   * @secure
   */
  appJobDataFormsWithNavigationPropertiesDetail = (
    { id }: AppJobDataFormsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsDetail
   * @request GET:/api/app/job-data-forms/{id}
   * @secure
   */
  appJobDataFormsDetail = (
    { id }: AppJobDataFormsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsUpdate
   * @request PUT:/api/app/job-data-forms/{id}
   * @secure
   */
  appJobDataFormsUpdate = (
    { id }: AppJobDataFormsUpdateParams,
    data: MotrJobDataFormsJobDataFormUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsDelete
   * @request DELETE:/api/app/job-data-forms/{id}
   * @secure
   */
  appJobDataFormsDelete = (
    { id }: AppJobDataFormsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-data-forms/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsJobLookupList
   * @request GET:/api/app/job-data-forms/job-lookup
   * @secure
   */
  appJobDataFormsJobLookupList = (
    query: AppJobDataFormsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsJobStepLookupList
   * @request GET:/api/app/job-data-forms/job-step-lookup
   * @secure
   */
  appJobDataFormsJobStepLookupList = (
    query: AppJobDataFormsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsTemplateStepLookupList
   * @request GET:/api/app/job-data-forms/template-step-lookup
   * @secure
   */
  appJobDataFormsTemplateStepLookupList = (
    query: AppJobDataFormsTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsDataFormLookupList
   * @request GET:/api/app/job-data-forms/data-form-lookup
   * @secure
   */
  appJobDataFormsDataFormLookupList = (
    query: AppJobDataFormsDataFormLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/data-form-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsAsExcelFileList
   * @request GET:/api/app/job-data-forms/as-excel-file
   * @secure
   */
  appJobDataFormsAsExcelFileList = (
    query: AppJobDataFormsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-data-forms/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataForm
   * @name AppJobDataFormsDownloadTokenList
   * @request GET:/api/app/job-data-forms/download-token
   * @secure
   */
  appJobDataFormsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnList
   * @request GET:/api/app/job-data-forms-extn
   * @secure
   */
  appJobDataFormsExtnList = (
    query: AppJobDataFormsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobDataFormsJobDataFormWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnCreate
   * @request POST:/api/app/job-data-forms-extn
   * @secure
   */
  appJobDataFormsExtnCreate = (
    data: MotrJobDataFormsJobDataFormCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-data-forms-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobDataFormsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobDataFormsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnDetail
   * @request GET:/api/app/job-data-forms-extn/{id}
   * @secure
   */
  appJobDataFormsExtnDetail = (
    { id }: AppJobDataFormsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnUpdate
   * @request PUT:/api/app/job-data-forms-extn/{id}
   * @secure
   */
  appJobDataFormsExtnUpdate = (
    { id }: AppJobDataFormsExtnUpdateParams,
    data: MotrJobDataFormsJobDataFormUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobDataFormsJobDataFormDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnDelete
   * @request DELETE:/api/app/job-data-forms-extn/{id}
   * @secure
   */
  appJobDataFormsExtnDelete = (
    { id }: AppJobDataFormsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-data-forms-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnJobLookupList
   * @request GET:/api/app/job-data-forms-extn/job-lookup
   * @secure
   */
  appJobDataFormsExtnJobLookupList = (
    query: AppJobDataFormsExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnJobStepLookupList
   * @request GET:/api/app/job-data-forms-extn/job-step-lookup
   * @secure
   */
  appJobDataFormsExtnJobStepLookupList = (
    query: AppJobDataFormsExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnAsExcelFileList
   * @request GET:/api/app/job-data-forms-extn/as-excel-file
   * @secure
   */
  appJobDataFormsExtnAsExcelFileList = (
    query: AppJobDataFormsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-data-forms-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobDataFormExtn
   * @name AppJobDataFormsExtnDownloadTokenList
   * @request GET:/api/app/job-data-forms-extn/download-token
   * @secure
   */
  appJobDataFormsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-data-forms-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddCreate
   * @request POST:/api/app/jobs-ext/add
   * @secure
   */
  appJobsExtAddCreate = (
    data: MotrJobsJobExtnDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddJobWorkingDocumentsCreate
   * @request POST:/api/app/jobs-ext/add-job-working-documents
   * @secure
   */
  appJobsExtAddJobWorkingDocumentsCreate = (
    data: MotrJobsWorkingDocument[],
    query: AppJobsExtAddJobWorkingDocumentsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-job-working-documents`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateDocumentStatusCreate
   * @request POST:/api/app/jobs-ext/update-document-status
   * @secure
   */
  appJobsExtUpdateDocumentStatusCreate = (
    data: MotrJobsWorkingDocument,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-document-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddUpdateJobWorkingDocumentsCreate
   * @request POST:/api/app/jobs-ext/add-update-job-working-documents
   * @secure
   */
  appJobsExtAddUpdateJobWorkingDocumentsCreate = (
    data: MotrJobsAddUpdateWorkingDocumentsVm,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-update-job-working-documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetJobWorkingDocumentsList
   * @request GET:/api/app/jobs-ext/get-job-working-documents
   * @secure
   */
  appJobsExtGetJobWorkingDocumentsList = (
    query: AppJobsExtGetJobWorkingDocumentsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentEnvelopeViewModel[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/get-job-working-documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetAllJobTagsList
   * @request GET:/api/app/jobs-ext/get-all-job-tags
   * @secure
   */
  appJobsExtGetAllJobTagsList = (params: RequestParams = {}) =>
    this.request<string[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/get-all-job-tags`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetJobLinksCountList
   * @request GET:/api/app/jobs-ext/GetJobLinksCount
   * @secure
   */
  appJobsExtGetJobLinksCountList = (
    query: AppJobsExtGetJobLinksCountListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobLinksJobLinksVM[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/GetJobLinksCount`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetUserAllJobsList
   * @request GET:/api/app/jobs-ext/get-user-all-jobs
   * @secure
   */
  appJobsExtGetUserAllJobsList = (
    query: AppJobsExtGetUserAllJobsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsKeyValueVM[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/get-user-all-jobs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetJobLinksList
   * @request GET:/api/app/jobs-ext/get-job-links
   * @secure
   */
  appJobsExtGetJobLinksList = (
    query: AppJobsExtGetJobLinksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobLinksJobLinkDtoVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/get-job-links`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddJobLinkCreate
   * @request POST:/api/app/jobs-ext/add-job-link
   * @secure
   */
  appJobsExtAddJobLinkCreate = (
    data: MotrJobsLinkJobRequestVm,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-job-link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtRemoveJobLinkCreate
   * @request POST:/api/app/jobs-ext/remove-job-link
   * @secure
   */
  appJobsExtRemoveJobLinkCreate = (
    data: MotrJobsLinkJobRequestVm,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/remove-job-link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddUpdateCheckListGroupAndItemCreate
   * @request POST:/api/app/jobs-ext/add-update-checkListGroupAndItem
   * @secure
   */
  appJobsExtAddUpdateCheckListGroupAndItemCreate = (
    data: MotrJobsAddUpdateCheckListGroupAndItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-update-checkListGroupAndItem`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtListCreate
   * @request POST:/api/app/jobs-ext/list
   * @secure
   */
  appJobsExtListCreate = (
    data: MotrJobsGetJobsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsJobDashboardVM, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/jobs-ext/list`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtWorkgroupWorkloadByUserList
   * @request GET:/api/app/jobs-ext/workgroup-workload-by-user
   * @secure
   */
  appJobsExtWorkgroupWorkloadByUserList = (
    query: AppJobsExtWorkgroupWorkloadByUserListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkgroupWorkloadVm,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/workgroup-workload-by-user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtWorkgroupWorkloadList
   * @request GET:/api/app/jobs-ext/workgroup-workload
   * @secure
   */
  appJobsExtWorkgroupWorkloadList = (
    query: AppJobsExtWorkgroupWorkloadListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkgroupWorkloadVm,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/workgroup-workload`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetStepListList
   * @request GET:/api/app/jobs-ext/get-step-list
   * @secure
   */
  appJobsExtGetStepListList = (
    query: AppJobsExtGetStepListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobStepDetailResponse1MotrJobsJobStepVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/get-step-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtToggleStepNotificationsList
   * @request GET:/api/app/jobs-ext/toggle-step-notifications
   * @secure
   */
  appJobsExtToggleStepNotificationsList = (
    query: AppJobsExtToggleStepNotificationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/toggle-step-notifications`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtStepActionsList
   * @request GET:/api/app/jobs-ext/step-actions
   * @secure
   */
  appJobsExtStepActionsList = (
    query: AppJobsExtStepActionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobActionResponse[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/step-actions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateGuidLineCreate
   * @request POST:/api/app/jobs-ext/update-guidLine
   * @secure
   */
  appJobsExtUpdateGuidLineCreate = (
    data: MotrJobsUpdateJobGuidlineRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-guidLine`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddJobStepCheckListItemCreate
   * @request POST:/api/app/jobs-ext/add-jobStep-checkListItem
   * @secure
   */
  appJobsExtAddJobStepCheckListItemCreate = (
    data: MotrJobsAddJobCheckListItemRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-jobStep-checkListItem`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateActionCreate
   * @request POST:/api/app/jobs-ext/update-action
   * @secure
   */
  appJobsExtUpdateActionCreate = (
    data: MotrJobsUpdateJboStepActionRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsJobVm, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-action`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtRetryTaskExecutionCreate
   * @request POST:/api/app/jobs-ext/retry-task-execution
   * @secure
   */
  appJobsExtRetryTaskExecutionCreate = (
    query: AppJobsExtRetryTaskExecutionCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/retry-task-execution`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetAdhocEmailTemplateCreate
   * @request POST:/api/app/jobs-ext/get-adhoc-email-template
   * @secure
   */
  appJobsExtGetAdhocEmailTemplateCreate = (
    data: MotrJobsGetJobStepEmailTemplate,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobStepAdhocEmailTemplateRespose,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/get-adhoc-email-template`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateDueDateCreate
   * @request POST:/api/app/jobs-ext/update-dueDate
   * @secure
   */
  appJobsExtUpdateDueDateCreate = (
    data: MotrJobsUpdateJobStepDueDateRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-dueDate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateAllowClientAccessCreate
   * @request POST:/api/app/jobs-ext/update-allow-client-access
   * @secure
   */
  appJobsExtUpdateAllowClientAccessCreate = (
    data: MotrJobsUpdateJobAllowClient,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-allow-client-access`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateStepDataFormCreate
   * @request POST:/api/app/jobs-ext/update-step-data-form
   * @secure
   */
  appJobsExtUpdateStepDataFormCreate = (
    data: MotrJobsUpdateJobDataFormVm,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-step-data-form`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateStepUsersCreate
   * @request POST:/api/app/jobs-ext/update-step-users
   * @secure
   */
  appJobsExtUpdateStepUsersCreate = (
    data: MotrJobsAddRemoveStepUsers,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsOwnerDetailVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/update-step-users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtJobAllowExternalWorkgroupAccessUpdate
   * @request PUT:/api/app/jobs-ext/jobAllowExternalWorkgroupAccess
   * @secure
   */
  appJobsExtJobAllowExternalWorkgroupAccessUpdate = (
    data: MotrJobsJobDocumentAccessDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/jobAllowExternalWorkgroupAccess`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtJobDocumentReadyForSigningUpdate
   * @request PUT:/api/app/jobs-ext/jobDocumentReadyForSigning
   * @secure
   */
  appJobsExtJobDocumentReadyForSigningUpdate = (
    data: MotrJobsJobDocumentReadyForSigningDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/jobDocumentReadyForSigning`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtJobAllowClientAccessUpdate
   * @request PUT:/api/app/jobs-ext/jobAllowClientAccess
   * @secure
   */
  appJobsExtJobAllowClientAccessUpdate = (
    data: MotrJobsJobDocumentAccessDto,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/jobAllowClientAccess`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtList
   * @request GET:/api/app/jobs-ext
   * @secure
   */
  appJobsExtList = (
    query: AppJobsExtListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobsJobWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtCreate
   * @request POST:/api/app/jobs-ext
   * @secure
   */
  appJobsExtCreate = (data: MotrJobsJobCreateDto, params: RequestParams = {}) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtWithNavigationPropertiesDetail
   * @request GET:/api/app/jobs-ext/with-navigation-properties/{id}
   * @secure
   */
  appJobsExtWithNavigationPropertiesDetail = (
    { id }: AppJobsExtWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtDetail
   * @request GET:/api/app/jobs-ext/{id}
   * @secure
   */
  appJobsExtDetail = (
    { id }: AppJobsExtDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdate
   * @request PUT:/api/app/jobs-ext/{id}
   * @secure
   */
  appJobsExtUpdate = (
    { id }: AppJobsExtUpdateParams,
    data: MotrJobsJobUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobsJobDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtDelete
   * @request DELETE:/api/app/jobs-ext/{id}
   * @secure
   */
  appJobsExtDelete = (
    { id }: AppJobsExtDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtTemplateLookupList
   * @request GET:/api/app/jobs-ext/template-lookup
   * @secure
   */
  appJobsExtTemplateLookupList = (
    query: AppJobsExtTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtOrganizationUnitLookupList
   * @request GET:/api/app/jobs-ext/organization-unit-lookup
   * @secure
   */
  appJobsExtOrganizationUnitLookupList = (
    query: AppJobsExtOrganizationUnitLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/organization-unit-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtJobOutcomeLookupList
   * @request GET:/api/app/jobs-ext/job-outcome-lookup
   * @secure
   */
  appJobsExtJobOutcomeLookupList = (
    query: AppJobsExtJobOutcomeLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/job-outcome-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtTakeDocumentDecisionCreate
   * @request POST:/api/app/jobs-ext/take-document-decision
   * @secure
   */
  appJobsExtTakeDocumentDecisionCreate = (
    data: MotrJobsDocumentExceptionDecisionVM,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsDocumentExceptionDecisionResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/take-document-decision`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetStepUsersList
   * @request GET:/api/app/jobs-ext/get-step-users
   * @secure
   */
  appJobsExtGetStepUsersList = (
    query: AppJobsExtGetStepUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrSharedUserDto[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/get-step-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtAddNewJobStepCreate
   * @request POST:/api/app/jobs-ext/add-new-job-step
   * @secure
   */
  appJobsExtAddNewJobStepCreate = (
    data: MotrJobsAddJobStepViewModel,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/add-new-job-step`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateJobStepOrderUpdate
   * @request PUT:/api/app/jobs-ext/update-job-step-order
   * @secure
   */
  appJobsExtUpdateJobStepOrderUpdate = (
    data: MotrJobsJobStepOrderUpdate,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepsJobStepDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/update-job-step-order`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetCacheItemsList
   * @request GET:/api/app/jobs-ext/getCacheItems
   * @secure
   */
  appJobsExtGetCacheItemsList = (params: RequestParams = {}) =>
    this.request<string[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/getCacheItems`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtClearCacheList
   * @request GET:/api/app/jobs-ext/ClearCache
   * @secure
   */
  appJobsExtClearCacheList = (
    query: AppJobsExtClearCacheListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/ClearCache`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetCacheItemList
   * @request GET:/api/app/jobs-ext/GetCacheItem
   * @secure
   */
  appJobsExtGetCacheItemList = (
    query: AppJobsExtGetCacheItemListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/GetCacheItem`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetJobParametersList
   * @request GET:/api/app/jobs-ext/GetJobParameters
   * @secure
   */
  appJobsExtGetJobParametersList = (
    query: AppJobsExtGetJobParametersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsGenericEntity[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/jobs-ext/GetJobParameters`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtMigrateJobsDataList
   * @request GET:/api/app/jobs-ext/MigrateJobsData
   * @secure
   */
  appJobsExtMigrateJobsDataList = (params: RequestParams = {}) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/MigrateJobsData`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtUpdateJobChecklistItemsCreate
   * @request POST:/api/app/jobs-ext/update-job-checklist-items
   * @secure
   */
  appJobsExtUpdateJobChecklistItemsCreate = (
    data: MotrJobsJobStepChecklistGroupDtoVm[],
    query: AppJobsExtUpdateJobChecklistItemsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/update-job-checklist-items`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtFilterJobsForAiCreate
   * @request POST:/api/app/jobs-ext/FilterJobsForAI
   * @secure
   */
  appJobsExtFilterJobsForAiCreate = (
    data: MotrJobsGetJobsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiServicesJobsData, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/jobs-ext/FilterJobsForAI`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGetJobsForAiCreate
   * @request POST:/api/app/jobs-ext/GetJobsForAI
   * @secure
   */
  appJobsExtGetJobsForAiCreate = (
    data: MotrJobsGetJobsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiServicesJobsData, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/jobs-ext/GetJobsForAI`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtGJobsSummaryForAiCreate
   * @request POST:/api/app/jobs-ext/GJobsSummaryForAI
   * @secure
   */
  appJobsExtGJobsSummaryForAiCreate = (
    data: MotrJobsGetJobsRequest,
    params: RequestParams = {},
  ) =>
    this.request<MotrAiServicesJobsData, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/jobs-ext/GJobsSummaryForAI`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtRegenerateWorkingDocumentCreate
   * @request POST:/api/app/jobs-ext/regenerate-working-document/{documentId}
   * @secure
   */
  appJobsExtRegenerateWorkingDocumentCreate = (
    { documentId }: AppJobsExtRegenerateWorkingDocumentCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/regenerate-working-document/${documentId}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobExt
   * @name AppJobsExtCreateServiceRequestCreate
   * @request POST:/api/app/jobs-ext/createServiceRequest
   * @secure
   */
  appJobsExtCreateServiceRequestCreate = (
    data: MotrMotrQQuestionnaireResponseDto[],
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/jobs-ext/createServiceRequest`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsList
   * @request GET:/api/app/job-holds
   * @secure
   */
  appJobHoldsList = (
    query: AppJobHoldsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobHoldsJobHoldWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-holds`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsCreate
   * @request POST:/api/app/job-holds
   * @secure
   */
  appJobHoldsCreate = (
    data: MotrJobHoldsJobHoldCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobHoldsJobHoldDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-holds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-holds/with-navigation-properties/{id}
   * @secure
   */
  appJobHoldsWithNavigationPropertiesDetail = (
    { id }: AppJobHoldsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobHoldsJobHoldWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-holds/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsDetail
   * @request GET:/api/app/job-holds/{id}
   * @secure
   */
  appJobHoldsDetail = (
    { id }: AppJobHoldsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobHoldsJobHoldDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-holds/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsUpdate
   * @request PUT:/api/app/job-holds/{id}
   * @secure
   */
  appJobHoldsUpdate = (
    { id }: AppJobHoldsUpdateParams,
    data: MotrJobHoldsJobHoldUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobHoldsJobHoldDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-holds/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsDelete
   * @request DELETE:/api/app/job-holds/{id}
   * @secure
   */
  appJobHoldsDelete = (
    { id }: AppJobHoldsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-holds/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsJobLookupList
   * @request GET:/api/app/job-holds/job-lookup
   * @secure
   */
  appJobHoldsJobLookupList = (
    query: AppJobHoldsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-holds/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobHold
   * @name AppJobHoldsJobStepLookupList
   * @request GET:/api/app/job-holds/job-step-lookup
   * @secure
   */
  appJobHoldsJobStepLookupList = (
    query: AppJobHoldsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-holds/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsList
   * @request GET:/api/app/job-improvements
   * @secure
   */
  appJobImprovementsList = (
    query: AppJobImprovementsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobImprovementsJobImprovementReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsCreate
   * @request POST:/api/app/job-improvements
   * @secure
   */
  appJobImprovementsCreate = (
    data: MotrJobImprovementsCreateJobImprovementDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsExportList
   * @request GET:/api/app/job-improvements/export
   * @secure
   */
  appJobImprovementsExportList = (
    query: AppJobImprovementsExportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsDelete
   * @request DELETE:/api/app/job-improvements/{id}
   * @secure
   */
  appJobImprovementsDelete = (
    { id }: AppJobImprovementsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-improvements/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsByJobStepList
   * @request GET:/api/app/job-improvements/by-job-step
   * @secure
   */
  appJobImprovementsByJobStepList = (
    query: AppJobImprovementsByJobStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements/by-job-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsWithHistoryList
   * @request GET:/api/app/job-improvements/{id}/with-history
   * @secure
   */
  appJobImprovementsWithHistoryList = (
    { id }: AppJobImprovementsWithHistoryListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsImprovementWithHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements/${id}/with-history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementsUpdateStatusCreate
   * @request POST:/api/app/job-improvements/update-status
   * @secure
   */
  appJobImprovementsUpdateStatusCreate = (
    data: MotrJobImprovementsUpdateImprovementStatusDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsImprovementStatusHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvements/update-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementList
   * @request GET:/api/app/job-improvement
   * @secure
   */
  appJobImprovementList = (
    query: AppJobImprovementListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobImprovementsJobImprovementReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementCreate
   * @request POST:/api/app/job-improvement
   * @secure
   */
  appJobImprovementCreate = (
    data: MotrJobImprovementsCreateJobImprovementDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementForExportList
   * @request GET:/api/app/job-improvement/for-export
   * @secure
   */
  appJobImprovementForExportList = (
    query: AppJobImprovementForExportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement/for-export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementDelete
   * @request DELETE:/api/app/job-improvement/{id}
   * @secure
   */
  appJobImprovementDelete = (
    { id }: AppJobImprovementDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-improvement/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementByJobStepList
   * @request GET:/api/app/job-improvement/by-job-step
   * @secure
   */
  appJobImprovementByJobStepList = (
    query: AppJobImprovementByJobStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsJobImprovementReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement/by-job-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementWithHistoryDetail
   * @request GET:/api/app/job-improvement/with-history/{improvementId}
   * @secure
   */
  appJobImprovementWithHistoryDetail = (
    { improvementId }: AppJobImprovementWithHistoryDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsImprovementWithHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement/with-history/${improvementId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobImprovement
   * @name AppJobImprovementStatusUpdate
   * @request PUT:/api/app/job-improvement/status
   * @secure
   */
  appJobImprovementStatusUpdate = (
    data: MotrJobImprovementsUpdateImprovementStatusDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobImprovementsImprovementStatusHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-improvement/status`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksList
   * @request GET:/api/app/job-links
   * @secure
   */
  appJobLinksList = (
    query: AppJobLinksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobLinksJobLinkWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-links`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksCreate
   * @request POST:/api/app/job-links
   * @secure
   */
  appJobLinksCreate = (
    data: MotrJobLinksJobLinkCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobLinksJobLinkDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-links`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksWithNavigationPropertiesDetail
   * @request GET:/api/app/job-links/with-navigation-properties/{id}
   * @secure
   */
  appJobLinksWithNavigationPropertiesDetail = (
    { id }: AppJobLinksWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobLinksJobLinkWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-links/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksDetail
   * @request GET:/api/app/job-links/{id}
   * @secure
   */
  appJobLinksDetail = (
    { id }: AppJobLinksDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobLinksJobLinkDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-links/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksUpdate
   * @request PUT:/api/app/job-links/{id}
   * @secure
   */
  appJobLinksUpdate = (
    { id }: AppJobLinksUpdateParams,
    data: MotrJobLinksJobLinkUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobLinksJobLinkDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-links/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksDelete
   * @request DELETE:/api/app/job-links/{id}
   * @secure
   */
  appJobLinksDelete = (
    { id }: AppJobLinksDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-links/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksJobLookupList
   * @request GET:/api/app/job-links/job-lookup
   * @secure
   */
  appJobLinksJobLookupList = (
    query: AppJobLinksJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-links/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobLink
   * @name AppJobLinksJobStepLookupList
   * @request GET:/api/app/job-links/job-step-lookup
   * @secure
   */
  appJobLinksJobStepLookupList = (
    query: AppJobLinksJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-links/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesList
   * @request GET:/api/app/job-notes
   * @secure
   */
  appJobNotesList = (
    query: AppJobNotesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobNotesJobNoteWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesCreate
   * @request POST:/api/app/job-notes
   * @secure
   */
  appJobNotesCreate = (
    data: MotrJobNotesJobNoteCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesWithNavigationPropertiesDetail
   * @request GET:/api/app/job-notes/with-navigation-properties/{id}
   * @secure
   */
  appJobNotesWithNavigationPropertiesDetail = (
    { id }: AppJobNotesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobNotesJobNoteWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesDetail
   * @request GET:/api/app/job-notes/{id}
   * @secure
   */
  appJobNotesDetail = (
    { id }: AppJobNotesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesUpdate
   * @request PUT:/api/app/job-notes/{id}
   * @secure
   */
  appJobNotesUpdate = (
    { id }: AppJobNotesUpdateParams,
    data: MotrJobNotesJobNoteUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesDelete
   * @request DELETE:/api/app/job-notes/{id}
   * @secure
   */
  appJobNotesDelete = (
    { id }: AppJobNotesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-notes/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesJobLookupList
   * @request GET:/api/app/job-notes/job-lookup
   * @secure
   */
  appJobNotesJobLookupList = (
    query: AppJobNotesJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNote
   * @name AppJobNotesJobStepLookupList
   * @request GET:/api/app/job-notes/job-step-lookup
   * @secure
   */
  appJobNotesJobStepLookupList = (
    query: AppJobNotesJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnList
   * @request GET:/api/app/job-notes-extn
   * @secure
   */
  appJobNotesExtnList = (
    query: AppJobNotesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobNotesJobNoteWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnCreate
   * @request POST:/api/app/job-notes-extn
   * @secure
   */
  appJobNotesExtnCreate = (
    data: MotrJobNotesJobNoteCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-notes-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobNotesExtnWithNavigationPropertiesDetail = (
    { id }: AppJobNotesExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobNotesJobNoteWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnDetail
   * @request GET:/api/app/job-notes-extn/{id}
   * @secure
   */
  appJobNotesExtnDetail = (
    { id }: AppJobNotesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnUpdate
   * @request PUT:/api/app/job-notes-extn/{id}
   * @secure
   */
  appJobNotesExtnUpdate = (
    { id }: AppJobNotesExtnUpdateParams,
    data: MotrJobNotesJobNoteUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobNotesJobNoteDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-notes-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnDelete
   * @request DELETE:/api/app/job-notes-extn/{id}
   * @secure
   */
  appJobNotesExtnDelete = (
    { id }: AppJobNotesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-notes-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnJobLookupList
   * @request GET:/api/app/job-notes-extn/job-lookup
   * @secure
   */
  appJobNotesExtnJobLookupList = (
    query: AppJobNotesExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobNoteExtn
   * @name AppJobNotesExtnJobStepLookupList
   * @request GET:/api/app/job-notes-extn/job-step-lookup
   * @secure
   */
  appJobNotesExtnJobStepLookupList = (
    query: AppJobNotesExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-notes-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcome
   * @name AppJobOutcomesList
   * @request GET:/api/app/job-outcomes
   * @secure
   */
  appJobOutcomesList = (
    query: AppJobOutcomesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobOutcomesJobOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcome
   * @name AppJobOutcomesCreate
   * @request POST:/api/app/job-outcomes
   * @secure
   */
  appJobOutcomesCreate = (
    data: MotrJobOutcomesJobOutcomeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcome
   * @name AppJobOutcomesDetail
   * @request GET:/api/app/job-outcomes/{id}
   * @secure
   */
  appJobOutcomesDetail = (
    { id }: AppJobOutcomesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcome
   * @name AppJobOutcomesUpdate
   * @request PUT:/api/app/job-outcomes/{id}
   * @secure
   */
  appJobOutcomesUpdate = (
    { id }: AppJobOutcomesUpdateParams,
    data: MotrJobOutcomesJobOutcomeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcome
   * @name AppJobOutcomesDelete
   * @request DELETE:/api/app/job-outcomes/{id}
   * @secure
   */
  appJobOutcomesDelete = (
    { id }: AppJobOutcomesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-outcomes/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcomeExtn
   * @name AppJobOutcomesExtnList
   * @request GET:/api/app/job-outcomes-extn
   * @secure
   */
  appJobOutcomesExtnList = (
    query: AppJobOutcomesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobOutcomesJobOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcomeExtn
   * @name AppJobOutcomesExtnCreate
   * @request POST:/api/app/job-outcomes-extn
   * @secure
   */
  appJobOutcomesExtnCreate = (
    data: MotrJobOutcomesJobOutcomeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcomeExtn
   * @name AppJobOutcomesExtnDetail
   * @request GET:/api/app/job-outcomes-extn/{id}
   * @secure
   */
  appJobOutcomesExtnDetail = (
    { id }: AppJobOutcomesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcomeExtn
   * @name AppJobOutcomesExtnUpdate
   * @request PUT:/api/app/job-outcomes-extn/{id}
   * @secure
   */
  appJobOutcomesExtnUpdate = (
    { id }: AppJobOutcomesExtnUpdateParams,
    data: MotrJobOutcomesJobOutcomeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobOutcomesJobOutcomeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-outcomes-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobOutcomeExtn
   * @name AppJobOutcomesExtnDelete
   * @request DELETE:/api/app/job-outcomes-extn/{id}
   * @secure
   */
  appJobOutcomesExtnDelete = (
    { id }: AppJobOutcomesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-outcomes-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksList
   * @request GET:/api/app/job-risks
   * @secure
   */
  appJobRisksList = (
    query: AppJobRisksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobRisksJobRiskReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksCreate
   * @request POST:/api/app/job-risks
   * @secure
   */
  appJobRisksCreate = (
    data: MotrJobRisksCreateJobRiskDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobRisksJobRiskDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-risks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksExportList
   * @request GET:/api/app/job-risks/export
   * @secure
   */
  appJobRisksExportList = (
    query: AppJobRisksExportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksJobRiskReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risks/export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksDelete
   * @request DELETE:/api/app/job-risks/{id}
   * @secure
   */
  appJobRisksDelete = (
    { id }: AppJobRisksDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-risks/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksByJobStepList
   * @request GET:/api/app/job-risks/by-job-step
   * @secure
   */
  appJobRisksByJobStepList = (
    query: AppJobRisksByJobStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksJobRiskDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risks/by-job-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksWithHistoryList
   * @request GET:/api/app/job-risks/{id}/with-history
   * @secure
   */
  appJobRisksWithHistoryList = (
    { id }: AppJobRisksWithHistoryListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksRiskWithHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risks/${id}/with-history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRisksUpdateControlMaturityCreate
   * @request POST:/api/app/job-risks/update-control-maturity
   * @secure
   */
  appJobRisksUpdateControlMaturityCreate = (
    data: MotrJobRisksUpdateControlMaturityDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksRiskControlMaturityHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risks/update-control-maturity`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskCreate
   * @request POST:/api/app/job-risk
   * @secure
   */
  appJobRiskCreate = (
    data: MotrJobRisksCreateJobRiskDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobRisksJobRiskDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-risk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskList
   * @request GET:/api/app/job-risk
   * @secure
   */
  appJobRiskList = (
    query: AppJobRiskListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobRisksJobRiskReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risk`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskDelete
   * @request DELETE:/api/app/job-risk/{id}
   * @secure
   */
  appJobRiskDelete = (
    { id }: AppJobRiskDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-risk/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskByJobStepList
   * @request GET:/api/app/job-risk/by-job-step
   * @secure
   */
  appJobRiskByJobStepList = (
    query: AppJobRiskByJobStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksJobRiskDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risk/by-job-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskForExportList
   * @request GET:/api/app/job-risk/for-export
   * @secure
   */
  appJobRiskForExportList = (
    query: AppJobRiskForExportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksJobRiskReportDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risk/for-export`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskWithHistoryDetail
   * @request GET:/api/app/job-risk/with-history/{riskId}
   * @secure
   */
  appJobRiskWithHistoryDetail = (
    { riskId }: AppJobRiskWithHistoryDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksRiskWithHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risk/with-history/${riskId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobRisk
   * @name AppJobRiskControlMaturityUpdate
   * @request PUT:/api/app/job-risk/control-maturity
   * @secure
   */
  appJobRiskControlMaturityUpdate = (
    data: MotrJobRisksUpdateControlMaturityDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobRisksRiskControlMaturityHistoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-risk/control-maturity`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsList
   * @request GET:/api/app/job-steps
   * @secure
   */
  appJobStepsList = (
    query: AppJobStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepsJobStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsCreate
   * @request POST:/api/app/job-steps
   * @secure
   */
  appJobStepsCreate = (
    data: MotrJobStepsJobStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-steps/with-navigation-properties/{id}
   * @secure
   */
  appJobStepsWithNavigationPropertiesDetail = (
    { id }: AppJobStepsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepsJobStepWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsDetail
   * @request GET:/api/app/job-steps/{id}
   * @secure
   */
  appJobStepsDetail = (
    { id }: AppJobStepsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsUpdate
   * @request PUT:/api/app/job-steps/{id}
   * @secure
   */
  appJobStepsUpdate = (
    { id }: AppJobStepsUpdateParams,
    data: MotrJobStepsJobStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsDelete
   * @request DELETE:/api/app/job-steps/{id}
   * @secure
   */
  appJobStepsDelete = (
    { id }: AppJobStepsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-steps/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStep
   * @name AppJobStepsJobLookupList
   * @request GET:/api/app/job-steps/job-lookup
   * @secure
   */
  appJobStepsJobLookupList = (
    query: AppJobStepsJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalApprovalsByJobStepDetail
   * @request GET:/api/app/job-step-approval/approvals-by-job-step/{jobStepId}
   * @secure
   */
  appJobStepApprovalApprovalsByJobStepDetail = (
    { jobStepId }: AppJobStepApprovalApprovalsByJobStepDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/approvals-by-job-step/${jobStepId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalApprovalsByJobDetail
   * @request GET:/api/app/job-step-approval/approvals-by-job/{jobId}
   * @secure
   */
  appJobStepApprovalApprovalsByJobDetail = (
    { jobId }: AppJobStepApprovalApprovalsByJobDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/approvals-by-job/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalSubmitApprovalCreate
   * @request POST:/api/app/job-step-approval/submit-approval
   * @secure
   */
  appJobStepApprovalSubmitApprovalCreate = (
    data: MotrJobStepApprovalsSubmitApprovalDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/submit-approval`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalAddApproverCreate
   * @request POST:/api/app/job-step-approval/add-approver
   * @secure
   */
  appJobStepApprovalAddApproverCreate = (
    data: MotrJobStepApprovalsAddJobStepApproverDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/add-approver`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalAddApproversCreate
   * @request POST:/api/app/job-step-approval/add-approvers
   * @secure
   */
  appJobStepApprovalAddApproversCreate = (
    data: MotrJobStepApprovalsAddJobStepApproversDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/add-approvers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalSendApprovalEmailsCreate
   * @request POST:/api/app/job-step-approval/send-approval-emails
   * @secure
   */
  appJobStepApprovalSendApprovalEmailsCreate = (
    data: MotrJobStepApprovalsSendApprovalEmailsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-approval/send-approval-emails`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalRemoveApproverDelete
   * @request DELETE:/api/app/job-step-approval/{approvalId}/remove-approver
   * @secure
   */
  appJobStepApprovalRemoveApproverDelete = (
    { approvalId }: AppJobStepApprovalRemoveApproverDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-approval/${approvalId}/remove-approver`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalDelegateApprovalCreate
   * @request POST:/api/app/job-step-approval/delegate-approval
   * @secure
   */
  appJobStepApprovalDelegateApprovalCreate = (
    data: MotrJobStepApprovalsDelegateApprovalDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsJobStepApprovalDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/delegate-approval`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalMyPendingApprovalsList
   * @request GET:/api/app/job-step-approval/my-pending-approvals
   * @secure
   */
  appJobStepApprovalMyPendingApprovalsList = (
    query: AppJobStepApprovalMyPendingApprovalsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepApprovalsMyPendingApprovalDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approval/my-pending-approvals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApproval
   * @name AppJobStepApprovalMyPendingApprovalsCountList
   * @request GET:/api/app/job-step-approval/my-pending-approvals-count
   * @secure
   */
  appJobStepApprovalMyPendingApprovalsCountList = (
    params: RequestParams = {},
  ) =>
    this.request<number, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-approval/my-pending-approvals-count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApprovalsReport
   * @name AppJobStepApprovalsReportDetailsList
   * @request GET:/api/app/job-step-approvals-report/details
   * @secure
   */
  appJobStepApprovalsReportDetailsList = (
    query: AppJobStepApprovalsReportDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrReportsJobStepApprovalsJobStepApprovalsStepDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approvals-report/details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepApprovalsReport
   * @name AppJobStepApprovalsReportFilterOptionsList
   * @request GET:/api/app/job-step-approvals-report/filter-options
   * @secure
   */
  appJobStepApprovalsReportFilterOptionsList = (params: RequestParams = {}) =>
    this.request<
      MotrReportsJobStepApprovalsJobStepApprovalsFilterOptionsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-approvals-report/filter-options`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepBasedApprovalReport
   * @name AppJobStepBasedApprovalReportReportList
   * @request GET:/api/app/job-step-based-approval-report/report
   * @secure
   */
  appJobStepBasedApprovalReportReportList = (
    query: AppJobStepBasedApprovalReportReportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrReportsJobStepBasedApprovalJobStepBasedApprovalRowDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-based-approval-report/report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepBasedApprovalReport
   * @name AppJobStepBasedApprovalReportInternalPeopleOptionsList
   * @request GET:/api/app/job-step-based-approval-report/internal-people-options
   * @secure
   */
  appJobStepBasedApprovalReportInternalPeopleOptionsList = (
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsJobStepBasedApprovalJobStepBasedApprovalPersonDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-based-approval-report/internal-people-options`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsList
   * @request GET:/api/app/job-step-checklists
   * @secure
   */
  appJobStepChecklistsList = (
    query: AppJobStepChecklistsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsCreate
   * @request POST:/api/app/job-step-checklists
   * @secure
   */
  appJobStepChecklistsCreate = (
    data: MotrJobStepChecklistsJobStepChecklistCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-checklists/with-navigation-properties/{id}
   * @secure
   */
  appJobStepChecklistsWithNavigationPropertiesDetail = (
    { id }: AppJobStepChecklistsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsDetail
   * @request GET:/api/app/job-step-checklists/{id}
   * @secure
   */
  appJobStepChecklistsDetail = (
    { id }: AppJobStepChecklistsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsUpdate
   * @request PUT:/api/app/job-step-checklists/{id}
   * @secure
   */
  appJobStepChecklistsUpdate = (
    { id }: AppJobStepChecklistsUpdateParams,
    data: MotrJobStepChecklistsJobStepChecklistUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsDelete
   * @request DELETE:/api/app/job-step-checklists/{id}
   * @secure
   */
  appJobStepChecklistsDelete = (
    { id }: AppJobStepChecklistsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklists/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklist
   * @name AppJobStepChecklistsJobStepChecklistGroupLookupList
   * @request GET:/api/app/job-step-checklists/job-step-checklist-group-lookup
   * @secure
   */
  appJobStepChecklistsJobStepChecklistGroupLookupList = (
    query: AppJobStepChecklistsJobStepChecklistGroupLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists/job-step-checklist-group-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnList
   * @request GET:/api/app/job-step-checklists-extn
   * @secure
   */
  appJobStepChecklistsExtnList = (
    query: AppJobStepChecklistsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-checklists-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobStepChecklistsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobStepChecklistsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnDetail
   * @request GET:/api/app/job-step-checklists-extn/{id}
   * @secure
   */
  appJobStepChecklistsExtnDetail = (
    { id }: AppJobStepChecklistsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnUpdate
   * @request PUT:/api/app/job-step-checklists-extn/{id}
   * @secure
   */
  appJobStepChecklistsExtnUpdate = (
    { id }: AppJobStepChecklistsExtnUpdateParams,
    data: MotrJobStepChecklistsJobStepChecklistUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnDelete
   * @request DELETE:/api/app/job-step-checklists-extn/{id}
   * @secure
   */
  appJobStepChecklistsExtnDelete = (
    { id }: AppJobStepChecklistsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklists-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnJobStepChecklistGroupLookupList
   * @request GET:/api/app/job-step-checklists-extn/job-step-checklist-group-lookup
   * @secure
   */
  appJobStepChecklistsExtnJobStepChecklistGroupLookupList = (
    query: AppJobStepChecklistsExtnJobStepChecklistGroupLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/job-step-checklist-group-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnSaveJobStepChecklistCreate
   * @request POST:/api/app/job-step-checklists-extn/save-job-step-checklist
   * @secure
   */
  appJobStepChecklistsExtnSaveJobStepChecklistCreate = (
    data: MotrJobStepChecklistsJobStepChecklistCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/save-job-step-checklist`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnSaveJobStepChecklistAndLogCreate
   * @request POST:/api/app/job-step-checklists-extn/save-job-step-checklist-and-log
   * @secure
   */
  appJobStepChecklistsExtnSaveJobStepChecklistAndLogCreate = (
    data: MotrJobStepChecklistsJobStepChecklistCreateAndLogDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/save-job-step-checklist-and-log`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnChecklistGroupAndItemDetail
   * @request GET:/api/app/job-step-checklists-extn/checklist-group-and-item/{id}
   * @secure
   */
  appJobStepChecklistsExtnChecklistGroupAndItemDetail = (
    { id }: AppJobStepChecklistsExtnChecklistGroupAndItemDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistsJobStepCheckListGroupAndItems[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/checklist-group-and-item/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnAssignChecklistItemsCreate
   * @request POST:/api/app/job-step-checklists-extn/assign-checklist-items
   * @secure
   */
  appJobStepChecklistsExtnAssignChecklistItemsCreate = (
    data: MotrJobStepChecklistsAssignChecklistItemsInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklists-extn/assign-checklist-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnTransferChecklistItemsCreate
   * @request POST:/api/app/job-step-checklists-extn/transfer-checklist-items
   * @secure
   */
  appJobStepChecklistsExtnTransferChecklistItemsCreate = (
    data: MotrJobStepChecklistsTransferChecklistItemsInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklists-extn/transfer-checklist-items`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnUpdateChecklistDueDateCreate
   * @request POST:/api/app/job-step-checklists-extn/update-checklist-due-date
   * @secure
   */
  appJobStepChecklistsExtnUpdateChecklistDueDateCreate = (
    data: MotrJobStepChecklistsUpdateChecklistDueDateInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklists-extn/update-checklist-due-date`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistExtn
   * @name AppJobStepChecklistsExtnMyChecklistsList
   * @request GET:/api/app/job-step-checklists-extn/my-checklists
   * @secure
   */
  appJobStepChecklistsExtnMyChecklistsList = (params: RequestParams = {}) =>
    this.request<
      MotrJobStepChecklistsMyAssignedChecklistItemDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklists-extn/my-checklists`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsList
   * @request GET:/api/app/job-step-checklist-groups
   * @secure
   */
  appJobStepChecklistGroupsList = (
    query: AppJobStepChecklistGroupsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsCreate
   * @request POST:/api/app/job-step-checklist-groups
   * @secure
   */
  appJobStepChecklistGroupsCreate = (
    data: MotrJobStepChecklistGroupsJobStepChecklistGroupCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-checklist-groups/with-navigation-properties/{id}
   * @secure
   */
  appJobStepChecklistGroupsWithNavigationPropertiesDetail = (
    { id }: AppJobStepChecklistGroupsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsDetail
   * @request GET:/api/app/job-step-checklist-groups/{id}
   * @secure
   */
  appJobStepChecklistGroupsDetail = (
    { id }: AppJobStepChecklistGroupsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsUpdate
   * @request PUT:/api/app/job-step-checklist-groups/{id}
   * @secure
   */
  appJobStepChecklistGroupsUpdate = (
    { id }: AppJobStepChecklistGroupsUpdateParams,
    data: MotrJobStepChecklistGroupsJobStepChecklistGroupUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsDelete
   * @request DELETE:/api/app/job-step-checklist-groups/{id}
   * @secure
   */
  appJobStepChecklistGroupsDelete = (
    { id }: AppJobStepChecklistGroupsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklist-groups/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroup
   * @name AppJobStepChecklistGroupsJobStepLookupList
   * @request GET:/api/app/job-step-checklist-groups/job-step-lookup
   * @secure
   */
  appJobStepChecklistGroupsJobStepLookupList = (
    query: AppJobStepChecklistGroupsJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnList
   * @request GET:/api/app/job-step-checklist-groups-extn
   * @secure
   */
  appJobStepChecklistGroupsExtnList = (
    query: AppJobStepChecklistGroupsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnCreate
   * @request POST:/api/app/job-step-checklist-groups-extn
   * @secure
   */
  appJobStepChecklistGroupsExtnCreate = (
    data: MotrJobStepChecklistGroupsJobStepChecklistGroupCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-checklist-groups-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobStepChecklistGroupsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobStepChecklistGroupsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnDetail
   * @request GET:/api/app/job-step-checklist-groups-extn/{id}
   * @secure
   */
  appJobStepChecklistGroupsExtnDetail = (
    { id }: AppJobStepChecklistGroupsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnUpdate
   * @request PUT:/api/app/job-step-checklist-groups-extn/{id}
   * @secure
   */
  appJobStepChecklistGroupsExtnUpdate = (
    { id }: AppJobStepChecklistGroupsExtnUpdateParams,
    data: MotrJobStepChecklistGroupsJobStepChecklistGroupUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepChecklistGroupsJobStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnDelete
   * @request DELETE:/api/app/job-step-checklist-groups-extn/{id}
   * @secure
   */
  appJobStepChecklistGroupsExtnDelete = (
    { id }: AppJobStepChecklistGroupsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-checklist-groups-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepChecklistGroupExtn
   * @name AppJobStepChecklistGroupsExtnJobStepLookupList
   * @request GET:/api/app/job-step-checklist-groups-extn/job-step-lookup
   * @secure
   */
  appJobStepChecklistGroupsExtnJobStepLookupList = (
    query: AppJobStepChecklistGroupsExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-checklist-groups-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnList
   * @request GET:/api/app/job-steps-extn
   * @secure
   */
  appJobStepsExtnList = (
    query: AppJobStepsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepsJobStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnCreate
   * @request POST:/api/app/job-steps-extn
   * @secure
   */
  appJobStepsExtnCreate = (
    data: MotrJobStepsJobStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-steps-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobStepsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobStepsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepsJobStepWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnDetail
   * @request GET:/api/app/job-steps-extn/{id}
   * @secure
   */
  appJobStepsExtnDetail = (
    { id }: AppJobStepsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnUpdate
   * @request PUT:/api/app/job-steps-extn/{id}
   * @secure
   */
  appJobStepsExtnUpdate = (
    { id }: AppJobStepsExtnUpdateParams,
    data: MotrJobStepsJobStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrJobStepsJobStepDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/job-steps-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnDelete
   * @request DELETE:/api/app/job-steps-extn/{id}
   * @secure
   */
  appJobStepsExtnDelete = (
    { id }: AppJobStepsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-steps-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepExtn
   * @name AppJobStepsExtnJobLookupList
   * @request GET:/api/app/job-steps-extn/job-lookup
   * @secure
   */
  appJobStepsExtnJobLookupList = (
    query: AppJobStepsExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-steps-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersList
   * @request GET:/api/app/job-step-users
   * @secure
   */
  appJobStepUsersList = (
    query: AppJobStepUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepUsersJobStepUserWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersCreate
   * @request POST:/api/app/job-step-users
   * @secure
   */
  appJobStepUsersCreate = (
    data: MotrJobStepUsersJobStepUserCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-users/with-navigation-properties/{id}
   * @secure
   */
  appJobStepUsersWithNavigationPropertiesDetail = (
    { id }: AppJobStepUsersWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersDetail
   * @request GET:/api/app/job-step-users/{id}
   * @secure
   */
  appJobStepUsersDetail = (
    { id }: AppJobStepUsersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersUpdate
   * @request PUT:/api/app/job-step-users/{id}
   * @secure
   */
  appJobStepUsersUpdate = (
    { id }: AppJobStepUsersUpdateParams,
    data: MotrJobStepUsersJobStepUserUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersDelete
   * @request DELETE:/api/app/job-step-users/{id}
   * @secure
   */
  appJobStepUsersDelete = (
    { id }: AppJobStepUsersDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-users/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersIdentityUserLookupList
   * @request GET:/api/app/job-step-users/identity-user-lookup
   * @secure
   */
  appJobStepUsersIdentityUserLookupList = (
    query: AppJobStepUsersIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUser
   * @name AppJobStepUsersJobStepLookupList
   * @request GET:/api/app/job-step-users/job-step-lookup
   * @secure
   */
  appJobStepUsersJobStepLookupList = (
    query: AppJobStepUsersJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnList
   * @request GET:/api/app/job-step-users-extn
   * @secure
   */
  appJobStepUsersExtnList = (
    query: AppJobStepUsersExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobStepUsersJobStepUserWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnCreate
   * @request POST:/api/app/job-step-users-extn
   * @secure
   */
  appJobStepUsersExtnCreate = (
    data: MotrJobStepUsersJobStepUserCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-step-users-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobStepUsersExtnWithNavigationPropertiesDetail = (
    { id }: AppJobStepUsersExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnDetail
   * @request GET:/api/app/job-step-users-extn/{id}
   * @secure
   */
  appJobStepUsersExtnDetail = (
    { id }: AppJobStepUsersExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnUpdate
   * @request PUT:/api/app/job-step-users-extn/{id}
   * @secure
   */
  appJobStepUsersExtnUpdate = (
    { id }: AppJobStepUsersExtnUpdateParams,
    data: MotrJobStepUsersJobStepUserUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepUsersJobStepUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnDelete
   * @request DELETE:/api/app/job-step-users-extn/{id}
   * @secure
   */
  appJobStepUsersExtnDelete = (
    { id }: AppJobStepUsersExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-step-users-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnIdentityUserLookupList
   * @request GET:/api/app/job-step-users-extn/identity-user-lookup
   * @secure
   */
  appJobStepUsersExtnIdentityUserLookupList = (
    query: AppJobStepUsersExtnIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobStepUserExtn
   * @name AppJobStepUsersExtnJobStepLookupList
   * @request GET:/api/app/job-step-users-extn/job-step-lookup
   * @secure
   */
  appJobStepUsersExtnJobStepLookupList = (
    query: AppJobStepUsersExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-step-users-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTaskUpdateTool
   * @name AppJobTaskUpdateToolExecuteCreate
   * @request POST:/api/app/job-task-update-tool/execute
   * @secure
   */
  appJobTaskUpdateToolExecuteCreate = (
    data: Record<string, any>,
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-task-update-tool/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsList
   * @request GET:/api/app/job-time-logs
   * @secure
   */
  appJobTimeLogsList = (
    query: AppJobTimeLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsCreate
   * @request POST:/api/app/job-time-logs
   * @secure
   */
  appJobTimeLogsCreate = (
    data: MotrJobTimeLogsJobTimeLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsDelete
   * @request DELETE:/api/app/job-time-logs
   * @secure
   */
  appJobTimeLogsDelete = (
    query: AppJobTimeLogsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsWithNavigationPropertiesDetail
   * @request GET:/api/app/job-time-logs/with-navigation-properties/{id}
   * @secure
   */
  appJobTimeLogsWithNavigationPropertiesDetail = (
    { id }: AppJobTimeLogsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsDetail
   * @request GET:/api/app/job-time-logs/{id}
   * @secure
   */
  appJobTimeLogsDetail = (
    { id }: AppJobTimeLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsUpdate
   * @request PUT:/api/app/job-time-logs/{id}
   * @secure
   */
  appJobTimeLogsUpdate = (
    { id }: AppJobTimeLogsUpdateParams,
    data: MotrJobTimeLogsJobTimeLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsDelete2
   * @request DELETE:/api/app/job-time-logs/{id}
   * @originalName appJobTimeLogsDelete
   * @duplicate
   * @secure
   */
  appJobTimeLogsDelete2 = (
    { id }: AppJobTimeLogsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsIdentityUserLookupList
   * @request GET:/api/app/job-time-logs/identity-user-lookup
   * @secure
   */
  appJobTimeLogsIdentityUserLookupList = (
    query: AppJobTimeLogsIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsAsExcelFileList
   * @request GET:/api/app/job-time-logs/as-excel-file
   * @secure
   */
  appJobTimeLogsAsExcelFileList = (
    query: AppJobTimeLogsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsDownloadTokenList
   * @request GET:/api/app/job-time-logs/download-token
   * @secure
   */
  appJobTimeLogsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLog
   * @name AppJobTimeLogsAllDelete
   * @request DELETE:/api/app/job-time-logs/all
   * @secure
   */
  appJobTimeLogsAllDelete = (
    query: AppJobTimeLogsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnList
   * @request GET:/api/app/job-time-logs-extn
   * @secure
   */
  appJobTimeLogsExtnList = (
    query: AppJobTimeLogsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnCreate
   * @request POST:/api/app/job-time-logs-extn
   * @secure
   */
  appJobTimeLogsExtnCreate = (
    data: MotrJobTimeLogsJobTimeLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnDelete
   * @request DELETE:/api/app/job-time-logs-extn
   * @secure
   */
  appJobTimeLogsExtnDelete = (
    query: AppJobTimeLogsExtnDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs-extn`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/job-time-logs-extn/with-navigation-properties/{id}
   * @secure
   */
  appJobTimeLogsExtnWithNavigationPropertiesDetail = (
    { id }: AppJobTimeLogsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnDetail
   * @request GET:/api/app/job-time-logs-extn/{id}
   * @secure
   */
  appJobTimeLogsExtnDetail = (
    { id }: AppJobTimeLogsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnUpdate
   * @request PUT:/api/app/job-time-logs-extn/{id}
   * @secure
   */
  appJobTimeLogsExtnUpdate = (
    { id }: AppJobTimeLogsExtnUpdateParams,
    data: MotrJobTimeLogsJobTimeLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobTimeLogsJobTimeLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnDelete2
   * @request DELETE:/api/app/job-time-logs-extn/{id}
   * @originalName appJobTimeLogsExtnDelete
   * @duplicate
   * @secure
   */
  appJobTimeLogsExtnDelete2 = (
    { id }: AppJobTimeLogsExtnDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnIdentityUserLookupList
   * @request GET:/api/app/job-time-logs-extn/identity-user-lookup
   * @secure
   */
  appJobTimeLogsExtnIdentityUserLookupList = (
    query: AppJobTimeLogsExtnIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnAsExcelFileList
   * @request GET:/api/app/job-time-logs-extn/as-excel-file
   * @secure
   */
  appJobTimeLogsExtnAsExcelFileList = (
    query: AppJobTimeLogsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnDownloadTokenList
   * @request GET:/api/app/job-time-logs-extn/download-token
   * @secure
   */
  appJobTimeLogsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/job-time-logs-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags JobTimeLogExtn
   * @name AppJobTimeLogsExtnAllDelete
   * @request DELETE:/api/app/job-time-logs-extn/all
   * @secure
   */
  appJobTimeLogsExtnAllDelete = (
    query: AppJobTimeLogsExtnAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/job-time-logs-extn/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMap
   * @name AppKeyMapsList
   * @request GET:/api/app/key-maps
   * @secure
   */
  appKeyMapsList = (
    query: AppKeyMapsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrKeyMapsKeyMapDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/key-maps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMap
   * @name AppKeyMapsCreate
   * @request POST:/api/app/key-maps
   * @secure
   */
  appKeyMapsCreate = (
    data: MotrKeyMapsKeyMapCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMap
   * @name AppKeyMapsDetail
   * @request GET:/api/app/key-maps/{id}
   * @secure
   */
  appKeyMapsDetail = (
    { id }: AppKeyMapsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMap
   * @name AppKeyMapsUpdate
   * @request PUT:/api/app/key-maps/{id}
   * @secure
   */
  appKeyMapsUpdate = (
    { id }: AppKeyMapsUpdateParams,
    data: MotrKeyMapsKeyMapUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMap
   * @name AppKeyMapsDelete
   * @request DELETE:/api/app/key-maps/{id}
   * @secure
   */
  appKeyMapsDelete = (
    { id }: AppKeyMapsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMapExtn
   * @name AppKeyMapsExtnList
   * @request GET:/api/app/key-maps-extn
   * @secure
   */
  appKeyMapsExtnList = (
    query: AppKeyMapsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrKeyMapsKeyMapDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/key-maps-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMapExtn
   * @name AppKeyMapsExtnCreate
   * @request POST:/api/app/key-maps-extn
   * @secure
   */
  appKeyMapsExtnCreate = (
    data: MotrKeyMapsKeyMapCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMapExtn
   * @name AppKeyMapsExtnDetail
   * @request GET:/api/app/key-maps-extn/{id}
   * @secure
   */
  appKeyMapsExtnDetail = (
    { id }: AppKeyMapsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMapExtn
   * @name AppKeyMapsExtnUpdate
   * @request PUT:/api/app/key-maps-extn/{id}
   * @secure
   */
  appKeyMapsExtnUpdate = (
    { id }: AppKeyMapsExtnUpdateParams,
    data: MotrKeyMapsKeyMapUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrKeyMapsKeyMapDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KeyMapExtn
   * @name AppKeyMapsExtnDelete
   * @request DELETE:/api/app/key-maps-extn/{id}
   * @secure
   */
  appKeyMapsExtnDelete = (
    { id }: AppKeyMapsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/key-maps-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags KnowledgeBase
   * @name AppKnowledgeBaseDocumentsCreate
   * @request POST:/api/app/knowledge-base/documents
   * @secure
   */
  appKnowledgeBaseDocumentsCreate = (
    data: {
      /** @format binary */
      file?: File;
      title?: string;
      description?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrKnowledgeBaseKnowledgeDocumentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/knowledge-base/documents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KnowledgeBase
   * @name AppKnowledgeBaseDocumentsList
   * @request GET:/api/app/knowledge-base/documents
   * @secure
   */
  appKnowledgeBaseDocumentsList = (
    query: AppKnowledgeBaseDocumentsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrKnowledgeBaseKnowledgeDocumentDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/knowledge-base/documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags KnowledgeBase
   * @name AppKnowledgeBaseDocumentsDelete
   * @request DELETE:/api/app/knowledge-base/documents/{id}
   * @secure
   */
  appKnowledgeBaseDocumentsDelete = (
    { id }: AppKnowledgeBaseDocumentsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/knowledge-base/documents/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags KnowledgeBase
   * @name AppKnowledgeBaseDocumentsReprocessCreate
   * @request POST:/api/app/knowledge-base/documents/{id}/reprocess
   * @secure
   */
  appKnowledgeBaseDocumentsReprocessCreate = (
    { id }: AppKnowledgeBaseDocumentsReprocessCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/knowledge-base/documents/${id}/reprocess`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags KnowledgeBase
   * @name AppKnowledgeBaseSearchList
   * @request GET:/api/app/knowledge-base/search
   * @secure
   */
  appKnowledgeBaseSearchList = (
    query: AppKnowledgeBaseSearchListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrKnowledgeBaseKnowledgeSearchResultDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/knowledge-base/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesAllList
   * @request GET:/api/language-management/languages/all
   * @secure
   */
  languageManagementLanguagesAllList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpLanguageManagementDtoLanguageDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesList
   * @request GET:/api/language-management/languages
   * @secure
   */
  languageManagementLanguagesList = (
    query: LanguageManagementLanguagesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpLanguageManagementDtoLanguageDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesCreate
   * @request POST:/api/language-management/languages
   * @secure
   */
  languageManagementLanguagesCreate = (
    data: VoloAbpLanguageManagementDtoCreateLanguageDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpLanguageManagementDtoLanguageDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesDetail
   * @request GET:/api/language-management/languages/{id}
   * @secure
   */
  languageManagementLanguagesDetail = (
    { id }: LanguageManagementLanguagesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpLanguageManagementDtoLanguageDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesUpdate
   * @request PUT:/api/language-management/languages/{id}
   * @secure
   */
  languageManagementLanguagesUpdate = (
    { id }: LanguageManagementLanguagesUpdateParams,
    data: VoloAbpLanguageManagementDtoUpdateLanguageDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpLanguageManagementDtoLanguageDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesDelete
   * @request DELETE:/api/language-management/languages/{id}
   * @secure
   */
  languageManagementLanguagesDelete = (
    { id }: LanguageManagementLanguagesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/language-management/languages/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesSetAsDefaultUpdate
   * @request PUT:/api/language-management/languages/{id}/set-as-default
   * @secure
   */
  languageManagementLanguagesSetAsDefaultUpdate = (
    { id }: LanguageManagementLanguagesSetAsDefaultUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/language-management/languages/${id}/set-as-default`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesResourcesList
   * @request GET:/api/language-management/languages/resources
   * @secure
   */
  languageManagementLanguagesResourcesList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpLanguageManagementDtoLanguageResourceDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages/resources`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesCultureListList
   * @request GET:/api/language-management/languages/culture-list
   * @secure
   */
  languageManagementLanguagesCultureListList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpLanguageManagementDtoCultureInfoDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/languages/culture-list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Languages
   * @name LanguageManagementLanguagesFlagListList
   * @request GET:/api/language-management/languages/flag-list
   * @secure
   */
  languageManagementLanguagesFlagListList = (params: RequestParams = {}) =>
    this.request<string[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/language-management/languages/flag-list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTextBulk
   * @name AppLanguageTextsBulkUpdateCreate
   * @request POST:/api/app/language-texts/bulk-update
   * @secure
   */
  appLanguageTextsBulkUpdateCreate = (
    data: MotrLanguageTextsBulkUpdateLanguageTextDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrLanguageTextsBulkUpdateLanguageTextResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/language-texts/bulk-update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTextBulk
   * @name AppLanguageTextBulkBulkUpdateCreate
   * @request POST:/api/app/language-text-bulk/bulk-update
   * @secure
   */
  appLanguageTextBulkBulkUpdateCreate = (
    data: MotrLanguageTextsBulkUpdateLanguageTextDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrLanguageTextsBulkUpdateLanguageTextResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/language-text-bulk/bulk-update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTexts
   * @name LanguageManagementLanguageTextsList
   * @request GET:/api/language-management/language-texts
   * @secure
   */
  languageManagementLanguageTextsList = (
    query: LanguageManagementLanguageTextsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpLanguageManagementDtoLanguageTextDtoVoloAbpLanguageManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/language-texts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTexts
   * @name LanguageManagementLanguageTextsDetail
   * @request GET:/api/language-management/language-texts/{resourceName}/{cultureName}/{name}
   * @secure
   */
  languageManagementLanguageTextsDetail = (
    {
      resourceName,
      cultureName,
      name,
      ...query
    }: LanguageManagementLanguageTextsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpLanguageManagementDtoLanguageTextDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/language-management/language-texts/${resourceName}/${cultureName}/${name}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTexts
   * @name LanguageManagementLanguageTextsUpdate
   * @request PUT:/api/language-management/language-texts/{resourceName}/{cultureName}/{name}
   * @secure
   */
  languageManagementLanguageTextsUpdate = (
    {
      resourceName,
      cultureName,
      name,
      ...query
    }: LanguageManagementLanguageTextsUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/language-management/language-texts/${resourceName}/${cultureName}/${name}`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LanguageTexts
   * @name LanguageManagementLanguageTextsRestoreUpdate
   * @request PUT:/api/language-management/language-texts/{resourceName}/{cultureName}/{name}/restore
   * @secure
   */
  languageManagementLanguageTextsRestoreUpdate = (
    {
      resourceName,
      cultureName,
      name,
    }: LanguageManagementLanguageTextsRestoreUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/language-management/language-texts/${resourceName}/${cultureName}/${name}/restore`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Login
   * @name AccountLoginCreate
   * @request POST:/api/account/login
   * @secure
   */
  accountLoginCreate = (
    data: VoloAbpAccountPublicWebAreasAccountControllersModelsUserLoginInfo,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountPublicWebAreasAccountControllersModelsAbpLoginResult,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Login
   * @name AccountLinkLoginCreate
   * @request POST:/api/account/linkLogin
   * @secure
   */
  accountLinkLoginCreate = (
    data: VoloAbpAccountPublicWebAreasAccountControllersModelsLinkUserLoginInfo,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountPublicWebAreasAccountControllersModelsAbpLoginResult,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/linkLogin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Login
   * @name AccountLogoutList
   * @request GET:/api/account/logout
   * @secure
   */
  accountLogoutList = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/logout`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Login
   * @name AccountCheckPasswordCreate
   * @request POST:/api/account/checkPassword
   * @secure
   */
  accountCheckPasswordCreate = (
    data: VoloAbpAccountPublicWebAreasAccountControllersModelsUserLoginInfo,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountPublicWebAreasAccountControllersModelsAbpLoginResult,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/checkPassword`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LogoUpload
   * @name AppBrandingLogoUploadCreate
   * @request POST:/api/app/branding/logo/upload
   * @secure
   */
  appBrandingLogoUploadCreate = (
    data: {
      /** @format binary */
      file?: File;
      variant?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrBrandingLogoUploadResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/branding/logo/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LogoUpload
   * @name AppBrandingLogoBackgroundUploadCreate
   * @request POST:/api/app/branding/logo/background/upload
   * @secure
   */
  appBrandingLogoBackgroundUploadCreate = (
    data: {
      /** @format binary */
      file?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrBrandingLogoUploadResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/branding/logo/background/upload`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LogoUpload
   * @name AppBrandingLogoUrlsList
   * @request GET:/api/app/branding/logo/urls
   * @secure
   */
  appBrandingLogoUrlsList = (params: RequestParams = {}) =>
    this.request<
      MotrBrandingLogoUrlsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/branding/logo/urls`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags LogoUpload
   * @name AppBrandingLogoDelete
   * @request DELETE:/api/app/branding/logo/{variant}
   * @secure
   */
  appBrandingLogoDelete = (
    { variant }: AppBrandingLogoDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/branding/logo/${variant}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags LogoUpload
   * @name AppBrandingLogoBackgroundDelete
   * @request DELETE:/api/app/branding/logo/background
   * @secure
   */
  appBrandingLogoBackgroundDelete = (params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/branding/logo/background`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersRefreshToolsCreate
   * @request POST:/api/app/mcp-servers/{id}/refresh-tools
   * @secure
   */
  appMcpServersRefreshToolsCreate = (
    { id }: AppMcpServersRefreshToolsCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsRefreshMcpToolsResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-servers/${id}/refresh-tools`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersTestCallCreate
   * @request POST:/api/app/mcp-servers/{id}/test-call
   * @secure
   */
  appMcpServersTestCallCreate = (
    { id }: AppMcpServersTestCallCreateParams,
    data: MotrSkillsTestMcpToolCallInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpToolCallResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-servers/${id}/test-call`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersList
   * @request GET:/api/app/mcp-servers
   * @secure
   */
  appMcpServersList = (
    query: AppMcpServersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-servers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersCreate
   * @request POST:/api/app/mcp-servers
   * @secure
   */
  appMcpServersCreate = (
    data: MotrSkillsMcpServerCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsMcpServerDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/mcp-servers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersDelete
   * @request DELETE:/api/app/mcp-servers
   * @secure
   */
  appMcpServersDelete = (
    query: AppMcpServersDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/mcp-servers`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersDetail
   * @request GET:/api/app/mcp-servers/{id}
   * @secure
   */
  appMcpServersDetail = (
    { id }: AppMcpServersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsMcpServerDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/mcp-servers/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersUpdate
   * @request PUT:/api/app/mcp-servers/{id}
   * @secure
   */
  appMcpServersUpdate = (
    { id }: AppMcpServersUpdateParams,
    data: MotrSkillsMcpServerUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsMcpServerDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/mcp-servers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersDelete2
   * @request DELETE:/api/app/mcp-servers/{id}
   * @originalName appMcpServersDelete
   * @duplicate
   * @secure
   */
  appMcpServersDelete2 = (
    { id }: AppMcpServersDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/mcp-servers/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServer
   * @name AppMcpServersAllDelete
   * @request DELETE:/api/app/mcp-servers/all
   * @secure
   */
  appMcpServersAllDelete = (
    query: AppMcpServersAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/mcp-servers/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsList
   * @request GET:/api/app/mcp-server-audit-logs
   * @secure
   */
  appMcpServerAuditLogsList = (
    query: AppMcpServerAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerAuditLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsCreate
   * @request POST:/api/app/mcp-server-audit-logs
   * @secure
   */
  appMcpServerAuditLogsCreate = (
    data: MotrSkillsMcpServerAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsWithNavigationPropertiesDetail
   * @request GET:/api/app/mcp-server-audit-logs/with-navigation-properties/{id}
   * @secure
   */
  appMcpServerAuditLogsWithNavigationPropertiesDetail = (
    { id }: AppMcpServerAuditLogsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerAuditLogWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsDetail
   * @request GET:/api/app/mcp-server-audit-logs/{id}
   * @secure
   */
  appMcpServerAuditLogsDetail = (
    { id }: AppMcpServerAuditLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsUpdate
   * @request PUT:/api/app/mcp-server-audit-logs/{id}
   * @secure
   */
  appMcpServerAuditLogsUpdate = (
    { id }: AppMcpServerAuditLogsUpdateParams,
    data: MotrSkillsMcpServerAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsDelete
   * @request DELETE:/api/app/mcp-server-audit-logs/{id}
   * @secure
   */
  appMcpServerAuditLogsDelete = (
    { id }: AppMcpServerAuditLogsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/mcp-server-audit-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerAuditLog
   * @name AppMcpServerAuditLogsMcpServerLookupList
   * @request GET:/api/app/mcp-server-audit-logs/mcp-server-lookup
   * @secure
   */
  appMcpServerAuditLogsMcpServerLookupList = (
    query: AppMcpServerAuditLogsMcpServerLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-audit-logs/mcp-server-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsByMcpServerList
   * @request GET:/api/app/mcp-server-tools/by-mcp-server
   * @secure
   */
  appMcpServerToolsByMcpServerList = (
    query: AppMcpServerToolsByMcpServerListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerToolDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/by-mcp-server`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsDetailedByMcpServerList
   * @request GET:/api/app/mcp-server-tools/detailed/by-mcp-server
   * @secure
   */
  appMcpServerToolsDetailedByMcpServerList = (
    query: AppMcpServerToolsDetailedByMcpServerListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerToolWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/detailed/by-mcp-server`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsList
   * @request GET:/api/app/mcp-server-tools
   * @secure
   */
  appMcpServerToolsList = (
    query: AppMcpServerToolsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsMcpServerToolWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsCreate
   * @request POST:/api/app/mcp-server-tools
   * @secure
   */
  appMcpServerToolsCreate = (
    data: MotrSkillsMcpServerToolCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerToolDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsWithNavigationPropertiesDetail
   * @request GET:/api/app/mcp-server-tools/with-navigation-properties/{id}
   * @secure
   */
  appMcpServerToolsWithNavigationPropertiesDetail = (
    { id }: AppMcpServerToolsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerToolWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsDetail
   * @request GET:/api/app/mcp-server-tools/{id}
   * @secure
   */
  appMcpServerToolsDetail = (
    { id }: AppMcpServerToolsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerToolDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsUpdate
   * @request PUT:/api/app/mcp-server-tools/{id}
   * @secure
   */
  appMcpServerToolsUpdate = (
    { id }: AppMcpServerToolsUpdateParams,
    data: MotrSkillsMcpServerToolUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsMcpServerToolDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsDelete
   * @request DELETE:/api/app/mcp-server-tools/{id}
   * @secure
   */
  appMcpServerToolsDelete = (
    { id }: AppMcpServerToolsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/mcp-server-tools/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags McpServerTool
   * @name AppMcpServerToolsMcpServerLookupList
   * @request GET:/api/app/mcp-server-tools/mcp-server-lookup
   * @secure
   */
  appMcpServerToolsMcpServerLookupList = (
    query: AppMcpServerToolsMcpServerLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/mcp-server-tools/mcp-server-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesList
   * @request GET:/api/app/messages
   * @secure
   */
  appMessagesList = (
    query: AppMessagesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesCreate
   * @request POST:/api/app/messages
   * @secure
   */
  appMessagesCreate = (
    data: MotrMessagesMessageCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesWithNavigationPropertiesDetail
   * @request GET:/api/app/messages/with-navigation-properties/{id}
   * @secure
   */
  appMessagesWithNavigationPropertiesDetail = (
    { id }: AppMessagesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMessagesMessageWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesDetail
   * @request GET:/api/app/messages/{id}
   * @secure
   */
  appMessagesDetail = (
    { id }: AppMessagesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesUpdate
   * @request PUT:/api/app/messages/{id}
   * @secure
   */
  appMessagesUpdate = (
    { id }: AppMessagesUpdateParams,
    data: MotrMessagesMessageUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesDelete
   * @request DELETE:/api/app/messages/{id}
   * @secure
   */
  appMessagesDelete = (
    { id }: AppMessagesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesJobLookupList
   * @request GET:/api/app/messages/job-lookup
   * @secure
   */
  appMessagesJobLookupList = (
    query: AppMessagesJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesJobStepLookupList
   * @request GET:/api/app/messages/job-step-lookup
   * @secure
   */
  appMessagesJobStepLookupList = (
    query: AppMessagesJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesIdentityUserLookupList
   * @request GET:/api/app/messages/identity-user-lookup
   * @secure
   */
  appMessagesIdentityUserLookupList = (
    query: AppMessagesIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Message
   * @name AppMessagesBroadcastMessageCreate
   * @request POST:/api/app/messages/broadcast-message
   * @secure
   */
  appMessagesBroadcastMessageCreate = (
    data: MotrMessagesSendBroadcastMessageViewModel,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages/broadcast-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnGetMessagesList
   * @request GET:/api/app/messages-extn/get-messages
   * @secure
   */
  appMessagesExtnGetMessagesList = (
    query: AppMessagesExtnGetMessagesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/get-messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/messages-extn/with-navigation-properties/{id}
   * @secure
   */
  appMessagesExtnWithNavigationPropertiesDetail = (
    { id }: AppMessagesExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMessagesMessageWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnDetail
   * @request GET:/api/app/messages-extn/{id}
   * @secure
   */
  appMessagesExtnDetail = (
    { id }: AppMessagesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnUpdate
   * @request PUT:/api/app/messages-extn/{id}
   * @secure
   */
  appMessagesExtnUpdate = (
    { id }: AppMessagesExtnUpdateParams,
    data: MotrMessagesMessageUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnDelete
   * @request DELETE:/api/app/messages-extn/{id}
   * @secure
   */
  appMessagesExtnDelete = (
    { id }: AppMessagesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnJobLookupList
   * @request GET:/api/app/messages-extn/job-lookup
   * @secure
   */
  appMessagesExtnJobLookupList = (
    query: AppMessagesExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnJobStepLookupList
   * @request GET:/api/app/messages-extn/job-step-lookup
   * @secure
   */
  appMessagesExtnJobStepLookupList = (
    query: AppMessagesExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnIdentityUserLookupList
   * @request GET:/api/app/messages-extn/identity-user-lookup
   * @secure
   */
  appMessagesExtnIdentityUserLookupList = (
    query: AppMessagesExtnIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnCreate
   * @request POST:/api/app/messages-extn
   * @secure
   */
  appMessagesExtnCreate = (
    data: MotrMessagesMessageCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/messages-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnBroadcastMessageCreate
   * @request POST:/api/app/messages-extn/broadcast-message
   * @secure
   */
  appMessagesExtnBroadcastMessageCreate = (
    data: MotrMessagesSendBroadcastMessageViewModel,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages-extn/broadcast-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnDeliverSecureLinksCreate
   * @request POST:/api/app/messages-extn/deliver-secure-links
   * @secure
   */
  appMessagesExtnDeliverSecureLinksCreate = (
    data: MotrMessagesDeliverSecureLink,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/deliver-secure-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnGetCountsList
   * @request GET:/api/app/messages-extn/get-counts
   * @secure
   */
  appMessagesExtnGetCountsList = (
    query: AppMessagesExtnGetCountsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<number, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages-extn/get-counts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnMessageMarkAsReadList
   * @request GET:/api/app/messages-extn/message-mark-as-read
   * @secure
   */
  appMessagesExtnMessageMarkAsReadList = (
    query: AppMessagesExtnMessageMarkAsReadListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages-extn/message-mark-as-read`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnMessagesDeleteDelete
   * @request DELETE:/api/app/messages-extn/messages-delete
   * @secure
   */
  appMessagesExtnMessagesDeleteDelete = (
    query: AppMessagesExtnMessagesDeleteDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/messages-extn/messages-delete`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnGetPublicMessagesList
   * @request GET:/api/app/messages-extn/get-public-messages
   * @secure
   */
  appMessagesExtnGetPublicMessagesList = (params: RequestParams = {}) =>
    this.request<
      MotrMessagesMessageDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/get-public-messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessagesExtnGetCommunicationsList
   * @request GET:/api/app/messages-extn/get-communications
   * @secure
   */
  appMessagesExtnGetCommunicationsList = (
    query: AppMessagesExtnGetCommunicationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/messages-extn/get-communications`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnPublicMessagesList
   * @request GET:/api/app/message-extn/public-messages
   * @secure
   */
  appMessageExtnPublicMessagesList = (params: RequestParams = {}) =>
    this.request<
      MotrMessagesMessageDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/public-messages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnCountList
   * @request GET:/api/app/message-extn/count
   * @secure
   */
  appMessageExtnCountList = (
    query: AppMessageExtnCountListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<number, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/message-extn/count`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnDeliverSecureLinksCreate
   * @request POST:/api/app/message-extn/deliver-secure-links
   * @secure
   */
  appMessageExtnDeliverSecureLinksCreate = (
    data: MotrMessagesDeliverSecureLink,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseVM,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/deliver-secure-links`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnBroadcastMessageCreate
   * @request POST:/api/app/message-extn/broadcast-message
   * @secure
   */
  appMessageExtnBroadcastMessageCreate = (
    data: MotrMessagesSendBroadcastMessageViewModel,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/message-extn/broadcast-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnMarkMessagesReadCreate
   * @request POST:/api/app/message-extn/mark-messages-read
   * @secure
   */
  appMessageExtnMarkMessagesReadCreate = (
    query: AppMessageExtnMarkMessagesReadCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/message-extn/mark-messages-read`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnMessagesDelete
   * @request DELETE:/api/app/message-extn/messages
   * @secure
   */
  appMessageExtnMessagesDelete = (
    query: AppMessageExtnMessagesDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/message-extn/messages`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnList
   * @request GET:/api/app/message-extn
   * @secure
   */
  appMessageExtnList = (
    query: AppMessageExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnCreate
   * @request POST:/api/app/message-extn
   * @secure
   */
  appMessageExtnCreate = (
    data: MotrMessagesMessageCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/message-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnPagedListList
   * @request GET:/api/app/message-extn/paged-list
   * @secure
   */
  appMessageExtnPagedListList = (
    query: AppMessageExtnPagedListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMessagesMessageWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/paged-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnWithNavigationPropertiesList
   * @request GET:/api/app/message-extn/{id}/with-navigation-properties
   * @secure
   */
  appMessageExtnWithNavigationPropertiesList = (
    { id }: AppMessageExtnWithNavigationPropertiesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMessagesMessageWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/${id}/with-navigation-properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnDetail
   * @request GET:/api/app/message-extn/{id}
   * @secure
   */
  appMessageExtnDetail = (
    { id }: AppMessageExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/message-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnDelete
   * @request DELETE:/api/app/message-extn/{id}
   * @secure
   */
  appMessageExtnDelete = (
    { id }: AppMessageExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/message-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnUpdate
   * @request PUT:/api/app/message-extn/{id}
   * @secure
   */
  appMessageExtnUpdate = (
    { id }: AppMessageExtnUpdateParams,
    data: MotrMessagesMessageUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrMessagesMessageDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/message-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnJobLookupList
   * @request GET:/api/app/message-extn/job-lookup
   * @secure
   */
  appMessageExtnJobLookupList = (
    query: AppMessageExtnJobLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/job-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnJobStepLookupList
   * @request GET:/api/app/message-extn/job-step-lookup
   * @secure
   */
  appMessageExtnJobStepLookupList = (
    query: AppMessageExtnJobStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/job-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MessageExtn
   * @name AppMessageExtnIdentityUserLookupList
   * @request GET:/api/app/message-extn/identity-user-lookup
   * @secure
   */
  appMessageExtnIdentityUserLookupList = (
    query: AppMessageExtnIdentityUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemNullable1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798ESystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/message-extn/identity-user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MetadataSchema
   * @name AppCabinetsExtnMetadataSchemaList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/metadata-schema
   * @secure
   */
  appCabinetsExtnMetadataSchemaList = (
    { cabinetId }: AppCabinetsExtnMetadataSchemaListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrCabinetMetadataSchemasCabinetMetadataSchemaDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/metadata-schema`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MetadataSchema
   * @name AppCabinetsExtnMetadataSchemaUpdate
   * @request PUT:/api/app/cabinets-extn/{cabinetId}/metadata-schema/{attributeId}
   * @secure
   */
  appCabinetsExtnMetadataSchemaUpdate = (
    { cabinetId, attributeId }: AppCabinetsExtnMetadataSchemaUpdateParams,
    data: MotrCabinetMetadataSchemasUpdateMetadataSchemaInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrCabinetMetadataSchemasCabinetMetadataSchemaDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/metadata-schema/${attributeId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqTemplatesList
   * @request GET:/api/motrq/templates
   * @secure
   */
  motrqTemplatesList = (params: RequestParams = {}) =>
    this.request<MotrMotrQMotrQTemplateDto[], any>({
      path: `/api/motrq/templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqQuestionnairesList
   * @request GET:/api/motrq/questionnaires
   * @secure
   */
  motrqQuestionnairesList = (params: RequestParams = {}) =>
    this.request<MotrMotrQMotrQQuestionnaireDto[], any>({
      path: `/api/motrq/questionnaires`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqTemplatesPlaceholdersList
   * @request GET:/api/motrq/templates/{templateId}/placeholders
   * @secure
   */
  motrqTemplatesPlaceholdersList = (
    { templateId }: MotrqTemplatesPlaceholdersListParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMotrQMotrQDocumentPlaceholderDto[], any>({
      path: `/api/motrq/templates/${templateId}/placeholders`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqGetServiceRequestParametersDetail
   * @request GET:/api/motrq/get-service-request-parameters/{templateId}
   * @secure
   */
  motrqGetServiceRequestParametersDetail = (
    { templateId, ...query }: MotrqGetServiceRequestParametersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMotrQServiceRequestParameterDto[], any>({
      path: `/api/motrq/get-service-request-parameters/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqServiceRequestClientsDetail
   * @request GET:/api/motrq/service-request-clients/{templateId}
   * @secure
   */
  motrqServiceRequestClientsDetail = (
    { templateId, ...query }: MotrqServiceRequestClientsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMotrQLookupItemDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      any
    >({
      path: `/api/motrq/service-request-clients/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqServiceRequestMattersDetail
   * @request GET:/api/motrq/service-request-matters/{templateId}
   * @secure
   */
  motrqServiceRequestMattersDetail = (
    { templateId, ...query }: MotrqServiceRequestMattersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMotrQLookupItemDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      any
    >({
      path: `/api/motrq/service-request-matters/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name MotrqServiceRequestPrefillDetail
   * @request GET:/api/motrq/service-request-prefill/{templateId}
   * @secure
   */
  motrqServiceRequestPrefillDetail = (
    { templateId, ...query }: MotrqServiceRequestPrefillDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrMotrQServiceRequestPrefillItemDto[], any>({
      path: `/api/motrq/service-request-prefill/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQAvailableQuestionnairesList
   * @request GET:/api/app/motr-q/available-questionnaires
   * @secure
   */
  appMotrQAvailableQuestionnairesList = (params: RequestParams = {}) =>
    this.request<
      MotrMotrQMotrQQuestionnaireDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/available-questionnaires`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQPublishedTemplatesList
   * @request GET:/api/app/motr-q/published-templates
   * @secure
   */
  appMotrQPublishedTemplatesList = (params: RequestParams = {}) =>
    this.request<
      MotrMotrQMotrQTemplateDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/published-templates`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQDocumentPlaceholdersByTemplateIdDetail
   * @request GET:/api/app/motr-q/document-placeholders-by-template-id/{templateId}
   * @secure
   */
  appMotrQDocumentPlaceholdersByTemplateIdDetail = (
    { templateId }: AppMotrQDocumentPlaceholdersByTemplateIdDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMotrQMotrQDocumentPlaceholderDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/document-placeholders-by-template-id/${templateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQServiceRequestParametersDetail
   * @request GET:/api/app/motr-q/service-request-parameters/{templateId}
   * @secure
   */
  appMotrQServiceRequestParametersDetail = (
    { templateId, ...query }: AppMotrQServiceRequestParametersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMotrQServiceRequestParameterDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/service-request-parameters/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQServiceRequestClientsDetail
   * @request GET:/api/app/motr-q/service-request-clients/{templateId}
   * @secure
   */
  appMotrQServiceRequestClientsDetail = (
    { templateId, ...query }: AppMotrQServiceRequestClientsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMotrQLookupItemDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/service-request-clients/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQServiceRequestMattersDetail
   * @request GET:/api/app/motr-q/service-request-matters/{templateId}
   * @secure
   */
  appMotrQServiceRequestMattersDetail = (
    { templateId, ...query }: AppMotrQServiceRequestMattersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrMotrQLookupItemDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/service-request-matters/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MotrQ
   * @name AppMotrQServiceRequestPrefillDetail
   * @request GET:/api/app/motr-q/service-request-prefill/{templateId}
   * @secure
   */
  appMotrQServiceRequestPrefillDetail = (
    { templateId, ...query }: AppMotrQServiceRequestPrefillDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrMotrQServiceRequestPrefillItemDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/motr-q/service-request-prefill/${templateId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLog
   * @name AppNdAuditLogsList
   * @request GET:/api/app/nd-audit-logs
   * @secure
   */
  appNdAuditLogsList = (
    query: AppNdAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrNdAuditLogsNdAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLog
   * @name AppNdAuditLogsCreate
   * @request POST:/api/app/nd-audit-logs
   * @secure
   */
  appNdAuditLogsCreate = (
    data: MotrNdAuditLogsNdAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLog
   * @name AppNdAuditLogsDetail
   * @request GET:/api/app/nd-audit-logs/{id}
   * @secure
   */
  appNdAuditLogsDetail = (
    { id }: AppNdAuditLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLog
   * @name AppNdAuditLogsUpdate
   * @request PUT:/api/app/nd-audit-logs/{id}
   * @secure
   */
  appNdAuditLogsUpdate = (
    { id }: AppNdAuditLogsUpdateParams,
    data: MotrNdAuditLogsNdAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLog
   * @name AppNdAuditLogsDelete
   * @request DELETE:/api/app/nd-audit-logs/{id}
   * @secure
   */
  appNdAuditLogsDelete = (
    { id }: AppNdAuditLogsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/nd-audit-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLogExtn
   * @name AppNdAuditLogsExtnList
   * @request GET:/api/app/nd-audit-logs-extn
   * @secure
   */
  appNdAuditLogsExtnList = (
    query: AppNdAuditLogsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrNdAuditLogsNdAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLogExtn
   * @name AppNdAuditLogsExtnCreate
   * @request POST:/api/app/nd-audit-logs-extn
   * @secure
   */
  appNdAuditLogsExtnCreate = (
    data: MotrNdAuditLogsNdAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLogExtn
   * @name AppNdAuditLogsExtnDetail
   * @request GET:/api/app/nd-audit-logs-extn/{id}
   * @secure
   */
  appNdAuditLogsExtnDetail = (
    { id }: AppNdAuditLogsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLogExtn
   * @name AppNdAuditLogsExtnUpdate
   * @request PUT:/api/app/nd-audit-logs-extn/{id}
   * @secure
   */
  appNdAuditLogsExtnUpdate = (
    { id }: AppNdAuditLogsExtnUpdateParams,
    data: MotrNdAuditLogsNdAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/nd-audit-logs-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NdAuditLogExtn
   * @name AppNdAuditLogsExtnDelete
   * @request DELETE:/api/app/nd-audit-logs-extn/{id}
   * @secure
   */
  appNdAuditLogsExtnDelete = (
    { id }: AppNdAuditLogsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/nd-audit-logs-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsList
   * @request GET:/api/app/notifications
   * @secure
   */
  appNotificationsList = (
    query: AppNotificationsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrNotificationsNotificationWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsCreate
   * @request POST:/api/app/notifications
   * @secure
   */
  appNotificationsCreate = (
    data: MotrNotificationsNotificationCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsWithNavigationPropertiesDetail
   * @request GET:/api/app/notifications/with-navigation-properties/{id}
   * @secure
   */
  appNotificationsWithNavigationPropertiesDetail = (
    { id }: AppNotificationsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsDetail
   * @request GET:/api/app/notifications/{id}
   * @secure
   */
  appNotificationsDetail = (
    { id }: AppNotificationsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsUpdate
   * @request PUT:/api/app/notifications/{id}
   * @secure
   */
  appNotificationsUpdate = (
    { id }: AppNotificationsUpdateParams,
    data: MotrNotificationsNotificationUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsDelete
   * @request DELETE:/api/app/notifications/{id}
   * @secure
   */
  appNotificationsDelete = (
    { id }: AppNotificationsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/notifications/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notification
   * @name AppNotificationsTemplateLookupList
   * @request GET:/api/app/notifications/template-lookup
   * @secure
   */
  appNotificationsTemplateLookupList = (
    query: AppNotificationsTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnList
   * @request GET:/api/app/notifications-extn
   * @secure
   */
  appNotificationsExtnList = (
    query: AppNotificationsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrNotificationsNotificationWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnCreate
   * @request POST:/api/app/notifications-extn
   * @secure
   */
  appNotificationsExtnCreate = (
    data: MotrNotificationsNotificationCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/notifications-extn/with-navigation-properties/{id}
   * @secure
   */
  appNotificationsExtnWithNavigationPropertiesDetail = (
    { id }: AppNotificationsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnDetail
   * @request GET:/api/app/notifications-extn/{id}
   * @secure
   */
  appNotificationsExtnDetail = (
    { id }: AppNotificationsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnUpdate
   * @request PUT:/api/app/notifications-extn/{id}
   * @secure
   */
  appNotificationsExtnUpdate = (
    { id }: AppNotificationsExtnUpdateParams,
    data: MotrNotificationsNotificationUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNotificationsNotificationDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnDelete
   * @request DELETE:/api/app/notifications-extn/{id}
   * @secure
   */
  appNotificationsExtnDelete = (
    { id }: AppNotificationsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/notifications-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationExtn
   * @name AppNotificationsExtnTemplateLookupList
   * @request GET:/api/app/notifications-extn/template-lookup
   * @secure
   */
  appNotificationsExtnTemplateLookupList = (
    query: AppNotificationsExtnTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/notifications-extn/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsRolesUpdate
   * @request PUT:/api/identity/organization-units/{id}/roles
   * @secure
   */
  identityOrganizationUnitsRolesUpdate = (
    { id }: IdentityOrganizationUnitsRolesUpdateParams,
    data: VoloAbpIdentityOrganizationUnitRoleInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/roles`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsRolesList
   * @request GET:/api/identity/organization-units/{id}/roles
   * @secure
   */
  identityOrganizationUnitsRolesList = (
    { id, ...query }: IdentityOrganizationUnitsRolesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/${id}/roles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsMembersUpdate
   * @request PUT:/api/identity/organization-units/{id}/members
   * @secure
   */
  identityOrganizationUnitsMembersUpdate = (
    { id }: IdentityOrganizationUnitsMembersUpdateParams,
    data: VoloAbpIdentityOrganizationUnitUserInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/members`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsMembersList
   * @request GET:/api/identity/organization-units/{id}/members
   * @secure
   */
  identityOrganizationUnitsMembersList = (
    { id, ...query }: IdentityOrganizationUnitsMembersListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/${id}/members`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsCreate
   * @request POST:/api/identity/organization-units
   * @secure
   */
  identityOrganizationUnitsCreate = (
    data: VoloAbpIdentityOrganizationUnitCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsDelete
   * @request DELETE:/api/identity/organization-units
   * @secure
   */
  identityOrganizationUnitsDelete = (
    query: IdentityOrganizationUnitsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsList
   * @request GET:/api/identity/organization-units
   * @secure
   */
  identityOrganizationUnitsList = (
    query: IdentityOrganizationUnitsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsDetail
   * @request GET:/api/identity/organization-units/{id}
   * @secure
   */
  identityOrganizationUnitsDetail = (
    { id }: IdentityOrganizationUnitsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsUpdate
   * @request PUT:/api/identity/organization-units/{id}
   * @secure
   */
  identityOrganizationUnitsUpdate = (
    { id }: IdentityOrganizationUnitsUpdateParams,
    data: VoloAbpIdentityOrganizationUnitUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsAllList
   * @request GET:/api/identity/organization-units/all
   * @secure
   */
  identityOrganizationUnitsAllList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsMoveUpdate
   * @request PUT:/api/identity/organization-units/{id}/move
   * @secure
   */
  identityOrganizationUnitsMoveUpdate = (
    { id }: IdentityOrganizationUnitsMoveUpdateParams,
    data: VoloAbpIdentityOrganizationUnitMoveInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/move`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsAvailableUsersList
   * @request GET:/api/identity/organization-units/available-users
   * @secure
   */
  identityOrganizationUnitsAvailableUsersList = (
    query: IdentityOrganizationUnitsAvailableUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/available-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsAvailableRolesList
   * @request GET:/api/identity/organization-units/available-roles
   * @secure
   */
  identityOrganizationUnitsAvailableRolesList = (
    query: IdentityOrganizationUnitsAvailableRolesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/organization-units/available-roles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsMoveAllUsersUpdate
   * @request PUT:/api/identity/organization-units/{id}/move-all-users
   * @secure
   */
  identityOrganizationUnitsMoveAllUsersUpdate = (
    { id, ...query }: IdentityOrganizationUnitsMoveAllUsersUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/move-all-users`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsMembersDelete
   * @request DELETE:/api/identity/organization-units/{id}/members/{memberId}
   * @secure
   */
  identityOrganizationUnitsMembersDelete = (
    { id, memberId }: IdentityOrganizationUnitsMembersDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/members/${memberId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnit
   * @name IdentityOrganizationUnitsRolesDelete
   * @request DELETE:/api/identity/organization-units/{id}/roles/{roleId}
   * @secure
   */
  identityOrganizationUnitsRolesDelete = (
    { id, roleId }: IdentityOrganizationUnitsRolesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/organization-units/${id}/roles/${roleId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnAddMemberCreate
   * @request POST:/api/app/organization-unit-extn/add-member
   * @secure
   */
  appOrganizationUnitExtnAddMemberCreate = (
    data: VoloAbpIdentityOrganizationUnitUserInput,
    query: AppOrganizationUnitExtnAddMemberCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/add-member`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnAddRoleCreate
   * @request POST:/api/app/organization-unit-extn/add-role
   * @secure
   */
  appOrganizationUnitExtnAddRoleCreate = (
    data: VoloAbpIdentityOrganizationUnitRoleInput,
    query: AppOrganizationUnitExtnAddRoleCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/add-role`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnCreateCreate
   * @request POST:/api/app/organization-unit-extn/create
   * @secure
   */
  appOrganizationUnitExtnCreateCreate = (
    data: VoloAbpIdentityOrganizationUnitCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnDeleteDelete
   * @request DELETE:/api/app/organization-unit-extn/delete
   * @secure
   */
  appOrganizationUnitExtnDeleteDelete = (
    query: AppOrganizationUnitExtnDeleteDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/delete`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnBulkDeleteDelete
   * @request DELETE:/api/app/organization-unit-extn/bulk-delete
   * @secure
   */
  appOrganizationUnitExtnBulkDeleteDelete = (
    query: AppOrganizationUnitExtnBulkDeleteDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/bulk-delete`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnCreateClientWorkgroupAsyncCreate
   * @request POST:/api/app/organization-unit-extn/CreateClientWorkgroupAsync
   * @secure
   */
  appOrganizationUnitExtnCreateClientWorkgroupAsyncCreate = (
    data: MotrOrganizationsAddClientWorkGroupWithUsers,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrOrganizationsAddClientWorkGroupWithUsers,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/CreateClientWorkgroupAsync`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetByIdList
   * @request GET:/api/app/organization-unit-extn/get-by-id
   * @secure
   */
  appOrganizationUnitExtnGetByIdList = (
    query: AppOrganizationUnitExtnGetByIdListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/get-by-id`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetAvailableRolesList
   * @request GET:/api/app/organization-unit-extn/get-available-roles
   * @secure
   */
  appOrganizationUnitExtnGetAvailableRolesList = (
    query: AppOrganizationUnitExtnGetAvailableRolesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/get-available-roles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetAvailableUsersList
   * @request GET:/api/app/organization-unit-extn/get-available-users
   * @secure
   */
  appOrganizationUnitExtnGetAvailableUsersList = (
    query: AppOrganizationUnitExtnGetAvailableUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/get-available-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnResolveOrgUnitsCreate
   * @request POST:/api/app/organization-unit-extn/resolve-org-units
   * @secure
   */
  appOrganizationUnitExtnResolveOrgUnitsCreate = (
    data: MotrOrganizationsResolveOrganizationUnitsInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1MotrOrganizationsResolvedOrganizationUnitDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/resolve-org-units`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetAllOrgListList
   * @request GET:/api/app/organization-unit-extn/get-all-org-list
   * @secure
   */
  appOrganizationUnitExtnGetAllOrgListList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/get-all-org-list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetListAsyncList
   * @request GET:/api/app/organization-unit-extn/GetListAsync
   * @secure
   */
  appOrganizationUnitExtnGetListAsyncList = (
    query: AppOrganizationUnitExtnGetListAsyncListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/GetListAsync`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetMembersAsyncList
   * @request GET:/api/app/organization-unit-extn/GetMembersAsync
   * @secure
   */
  appOrganizationUnitExtnGetMembersAsyncList = (
    query: AppOrganizationUnitExtnGetMembersAsyncListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/GetMembersAsync`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnGetRolesAsyncList
   * @request GET:/api/app/organization-unit-extn/GetRolesAsync
   * @secure
   */
  appOrganizationUnitExtnGetRolesAsyncList = (
    query: AppOrganizationUnitExtnGetRolesAsyncListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/GetRolesAsync`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnMoveAllUsersAsyncUpdate
   * @request PUT:/api/app/organization-unit-extn/MoveAllUsersAsync
   * @secure
   */
  appOrganizationUnitExtnMoveAllUsersAsyncUpdate = (
    query: AppOrganizationUnitExtnMoveAllUsersAsyncUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/MoveAllUsersAsync`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnMoveAsyncUpdate
   * @request PUT:/api/app/organization-unit-extn/MoveAsync
   * @secure
   */
  appOrganizationUnitExtnMoveAsyncUpdate = (
    data: VoloAbpIdentityOrganizationUnitMoveInput,
    query: AppOrganizationUnitExtnMoveAsyncUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/MoveAsync`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnRemoveMemberAsyncDelete
   * @request DELETE:/api/app/organization-unit-extn/RemoveMemberAsync
   * @secure
   */
  appOrganizationUnitExtnRemoveMemberAsyncDelete = (
    query: AppOrganizationUnitExtnRemoveMemberAsyncDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/RemoveMemberAsync`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnRemoveRoleAsyncDelete
   * @request DELETE:/api/app/organization-unit-extn/RemoveRoleAsync
   * @secure
   */
  appOrganizationUnitExtnRemoveRoleAsyncDelete = (
    query: AppOrganizationUnitExtnRemoveRoleAsyncDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/organization-unit-extn/RemoveRoleAsync`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OrganizationUnitExtn
   * @name AppOrganizationUnitExtnUpdateAsyncUpdate
   * @request PUT:/api/app/organization-unit-extn/UpdateAsync
   * @secure
   */
  appOrganizationUnitExtnUpdateAsyncUpdate = (
    data: VoloAbpIdentityOrganizationUnitUpdateDto,
    query: AppOrganizationUnitExtnUpdateAsyncUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitWithDetailsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/organization-unit-extn/UpdateAsync`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outcome
   * @name AppOutcomesList
   * @request GET:/api/app/outcomes
   * @secure
   */
  appOutcomesList = (
    query: AppOutcomesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrOutcomesOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/outcomes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Outcome
   * @name AppOutcomesCreate
   * @request POST:/api/app/outcomes
   * @secure
   */
  appOutcomesCreate = (
    data: MotrOutcomesOutcomeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Outcome
   * @name AppOutcomesDetail
   * @request GET:/api/app/outcomes/{id}
   * @secure
   */
  appOutcomesDetail = (
    { id }: AppOutcomesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Outcome
   * @name AppOutcomesUpdate
   * @request PUT:/api/app/outcomes/{id}
   * @secure
   */
  appOutcomesUpdate = (
    { id }: AppOutcomesUpdateParams,
    data: MotrOutcomesOutcomeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Outcome
   * @name AppOutcomesDelete
   * @request DELETE:/api/app/outcomes/{id}
   * @secure
   */
  appOutcomesDelete = (
    { id }: AppOutcomesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/outcomes/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OutcomeExtn
   * @name AppOutcomesExtnList
   * @request GET:/api/app/outcomes-extn
   * @secure
   */
  appOutcomesExtnList = (
    query: AppOutcomesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrOutcomesOutcomeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/outcomes-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags OutcomeExtn
   * @name AppOutcomesExtnCreate
   * @request POST:/api/app/outcomes-extn
   * @secure
   */
  appOutcomesExtnCreate = (
    data: MotrOutcomesOutcomeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags OutcomeExtn
   * @name AppOutcomesExtnDetail
   * @request GET:/api/app/outcomes-extn/{id}
   * @secure
   */
  appOutcomesExtnDetail = (
    { id }: AppOutcomesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags OutcomeExtn
   * @name AppOutcomesExtnUpdate
   * @request PUT:/api/app/outcomes-extn/{id}
   * @secure
   */
  appOutcomesExtnUpdate = (
    { id }: AppOutcomesExtnUpdateParams,
    data: MotrOutcomesOutcomeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrOutcomesOutcomeDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/outcomes-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags OutcomeExtn
   * @name AppOutcomesExtnDelete
   * @request DELETE:/api/app/outcomes-extn/{id}
   * @secure
   */
  appOutcomesExtnDelete = (
    { id }: AppOutcomesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/outcomes-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksPublishCreate
   * @request POST:/api/app/packs/{id}/publish
   * @secure
   */
  appPacksPublishCreate = (
    { id }: AppPacksPublishCreateParams,
    data: MotrSkillsPublishPackInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/packs/${id}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksRollbackCreate
   * @request POST:/api/app/packs/{id}/rollback
   * @secure
   */
  appPacksRollbackCreate = (
    { id }: AppPacksRollbackCreateParams,
    data: MotrSkillsRollbackPackInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/packs/${id}/rollback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksList
   * @request GET:/api/app/packs
   * @secure
   */
  appPacksList = (query: AppPacksListParams = {}, params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/packs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksCreate
   * @request POST:/api/app/packs
   * @secure
   */
  appPacksCreate = (
    data: MotrSkillsPackCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksDelete
   * @request DELETE:/api/app/packs
   * @secure
   */
  appPacksDelete = (
    query: AppPacksDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksWithNavigationPropertiesDetail
   * @request GET:/api/app/packs/with-navigation-properties/{id}
   * @secure
   */
  appPacksWithNavigationPropertiesDetail = (
    { id }: AppPacksWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/packs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksDetail
   * @request GET:/api/app/packs/{id}
   * @secure
   */
  appPacksDetail = ({ id }: AppPacksDetailParams, params: RequestParams = {}) =>
    this.request<MotrSkillsPackDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksUpdate
   * @request PUT:/api/app/packs/{id}
   * @secure
   */
  appPacksUpdate = (
    { id }: AppPacksUpdateParams,
    data: MotrSkillsPackUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksDelete2
   * @request DELETE:/api/app/packs/{id}
   * @originalName appPacksDelete
   * @duplicate
   * @secure
   */
  appPacksDelete2 = (
    { id }: AppPacksDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksAiModelLookupList
   * @request GET:/api/app/packs/ai-model-lookup
   * @secure
   */
  appPacksAiModelLookupList = (
    query: AppPacksAiModelLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/packs/ai-model-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksAllDelete
   * @request DELETE:/api/app/packs/all
   * @secure
   */
  appPacksAllDelete = (
    query: AppPacksAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pack
   * @name AppPacksSetListedCreate
   * @request POST:/api/app/packs/{id}/set-listed
   * @secure
   */
  appPacksSetListedCreate = (
    { id, ...query }: AppPacksSetListedCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/packs/${id}/set-listed`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersByPackList
   * @request GET:/api/app/pack-mcp-servers/by-pack
   * @secure
   */
  appPackMcpServersByPackList = (
    query: AppPackMcpServersByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackMcpServerDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersDetailedByPackList
   * @request GET:/api/app/pack-mcp-servers/detailed/by-pack
   * @secure
   */
  appPackMcpServersDetailedByPackList = (
    query: AppPackMcpServersDetailedByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackMcpServerWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/detailed/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersList
   * @request GET:/api/app/pack-mcp-servers
   * @secure
   */
  appPackMcpServersList = (
    query: AppPackMcpServersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackMcpServerWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersCreate
   * @request POST:/api/app/pack-mcp-servers
   * @secure
   */
  appPackMcpServersCreate = (
    data: MotrSkillsPackMcpServerCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackMcpServerDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersWithNavigationPropertiesDetail
   * @request GET:/api/app/pack-mcp-servers/with-navigation-properties/{id}
   * @secure
   */
  appPackMcpServersWithNavigationPropertiesDetail = (
    { id }: AppPackMcpServersWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackMcpServerWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersDetail
   * @request GET:/api/app/pack-mcp-servers/{id}
   * @secure
   */
  appPackMcpServersDetail = (
    { id }: AppPackMcpServersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackMcpServerDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersUpdate
   * @request PUT:/api/app/pack-mcp-servers/{id}
   * @secure
   */
  appPackMcpServersUpdate = (
    { id }: AppPackMcpServersUpdateParams,
    data: MotrSkillsPackMcpServerUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackMcpServerDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersDelete
   * @request DELETE:/api/app/pack-mcp-servers/{id}
   * @secure
   */
  appPackMcpServersDelete = (
    { id }: AppPackMcpServersDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/pack-mcp-servers/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersPackLookupList
   * @request GET:/api/app/pack-mcp-servers/pack-lookup
   * @secure
   */
  appPackMcpServersPackLookupList = (
    query: AppPackMcpServersPackLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/pack-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackMcpServer
   * @name AppPackMcpServersMcpServerLookupList
   * @request GET:/api/app/pack-mcp-servers/mcp-server-lookup
   * @secure
   */
  appPackMcpServersMcpServerLookupList = (
    query: AppPackMcpServersMcpServerLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-mcp-servers/mcp-server-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsByPackList
   * @request GET:/api/app/pack-skills/by-pack
   * @secure
   */
  appPackSkillsByPackList = (
    query: AppPackSkillsByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackSkillDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsDetailedByPackList
   * @request GET:/api/app/pack-skills/detailed/by-pack
   * @secure
   */
  appPackSkillsDetailedByPackList = (
    query: AppPackSkillsDetailedByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackSkillWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills/detailed/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsList
   * @request GET:/api/app/pack-skills
   * @secure
   */
  appPackSkillsList = (
    query: AppPackSkillsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackSkillWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsCreate
   * @request POST:/api/app/pack-skills
   * @secure
   */
  appPackSkillsCreate = (
    data: MotrSkillsPackSkillCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackSkillDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/pack-skills`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsWithNavigationPropertiesDetail
   * @request GET:/api/app/pack-skills/with-navigation-properties/{id}
   * @secure
   */
  appPackSkillsWithNavigationPropertiesDetail = (
    { id }: AppPackSkillsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackSkillWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsDetail
   * @request GET:/api/app/pack-skills/{id}
   * @secure
   */
  appPackSkillsDetail = (
    { id }: AppPackSkillsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackSkillDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/pack-skills/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsUpdate
   * @request PUT:/api/app/pack-skills/{id}
   * @secure
   */
  appPackSkillsUpdate = (
    { id }: AppPackSkillsUpdateParams,
    data: MotrSkillsPackSkillUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsPackSkillDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/pack-skills/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsDelete
   * @request DELETE:/api/app/pack-skills/{id}
   * @secure
   */
  appPackSkillsDelete = (
    { id }: AppPackSkillsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/pack-skills/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsPackLookupList
   * @request GET:/api/app/pack-skills/pack-lookup
   * @secure
   */
  appPackSkillsPackLookupList = (
    query: AppPackSkillsPackLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills/pack-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackSkill
   * @name AppPackSkillsSkillLookupList
   * @request GET:/api/app/pack-skills/skill-lookup
   * @secure
   */
  appPackSkillsSkillLookupList = (
    query: AppPackSkillsSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-skills/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsList
   * @request GET:/api/app/pack-versions
   * @secure
   */
  appPackVersionsList = (
    query: AppPackVersionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsPackVersionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsCreate
   * @request POST:/api/app/pack-versions
   * @secure
   */
  appPackVersionsCreate = (
    data: MotrSkillsPackVersionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsWithNavigationPropertiesDetail
   * @request GET:/api/app/pack-versions/with-navigation-properties/{id}
   * @secure
   */
  appPackVersionsWithNavigationPropertiesDetail = (
    { id }: AppPackVersionsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsDetail
   * @request GET:/api/app/pack-versions/{id}
   * @secure
   */
  appPackVersionsDetail = (
    { id }: AppPackVersionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsUpdate
   * @request PUT:/api/app/pack-versions/{id}
   * @secure
   */
  appPackVersionsUpdate = (
    { id }: AppPackVersionsUpdateParams,
    data: MotrSkillsPackVersionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsPackVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsDelete
   * @request DELETE:/api/app/pack-versions/{id}
   * @secure
   */
  appPackVersionsDelete = (
    { id }: AppPackVersionsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/pack-versions/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsPackLookupList
   * @request GET:/api/app/pack-versions/pack-lookup
   * @secure
   */
  appPackVersionsPackLookupList = (
    query: AppPackVersionsPackLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions/pack-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PackVersion
   * @name AppPackVersionsAiModelLookupList
   * @request GET:/api/app/pack-versions/ai-model-lookup
   * @secure
   */
  appPackVersionsAiModelLookupList = (
    query: AppPackVersionsAiModelLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/pack-versions/ai-model-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PasswordRequirements
   * @name AppPasswordRequirementsPasswordRequirementsList
   * @request GET:/api/app/password-requirements/password-requirements
   * @secure
   */
  appPasswordRequirementsPasswordRequirementsList = (
    params: RequestParams = {},
  ) =>
    this.request<
      MotrIdentityPasswordRequirementsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/password-requirements/password-requirements`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PasswordRequirements
   * @name AppPasswordRequirementsValidatePasswordCreate
   * @request POST:/api/app/password-requirements/validate-password
   * @secure
   */
  appPasswordRequirementsValidatePasswordCreate = (
    query: AppPasswordRequirementsValidatePasswordCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrIdentityPasswordRequirementsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/password-requirements/validate-password`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PeopleChangesV2
   * @name V2AppPeopleChangesHistoryList
   * @request GET:/api/v2/app/people-changes/history
   * @secure
   */
  v2AppPeopleChangesHistoryList = (
    query: V2AppPeopleChangesHistoryListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrUserEnrollmentLogsV2PeopleChangeHistoryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/v2/app/people-changes/history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PeopleChangesV2
   * @name V2AppPeopleChangesHistoryDetail
   * @request GET:/api/v2/app/people-changes/history/{id}
   * @secure
   */
  v2AppPeopleChangesHistoryDetail = (
    { id }: V2AppPeopleChangesHistoryDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsV2PeopleChangeHistoryDetailDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/v2/app/people-changes/history/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PeopleChangesV2
   * @name V2AppPeopleChangesWizardScopeCreate
   * @request POST:/api/v2/app/people-changes/wizard-scope
   * @secure
   */
  v2AppPeopleChangesWizardScopeCreate = (
    data: MotrUserEnrollmentLogsV2GetWizardScopeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsV2WizardScopeDataDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/v2/app/people-changes/wizard-scope`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PeopleChangesV2
   * @name V2AppPeopleChangesExecuteCreate
   * @request POST:/api/v2/app/people-changes/execute
   * @secure
   */
  v2AppPeopleChangesExecuteCreate = (
    data: MotrUserEnrollmentLogsV2ExecutePeopleChangeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsV2PeopleChangeResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/v2/app/people-changes/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionManagementPermissionsList
   * @request GET:/api/permission-management/permissions
   * @secure
   */
  permissionManagementPermissionsList = (
    query: PermissionManagementPermissionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpPermissionManagementGetPermissionListResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/permission-management/permissions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Permissions
   * @name PermissionManagementPermissionsUpdate
   * @request PUT:/api/permission-management/permissions
   * @secure
   */
  permissionManagementPermissionsUpdate = (
    data: VoloAbpPermissionManagementUpdatePermissionsDto,
    query: PermissionManagementPermissionsUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/permission-management/permissions`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsList
   * @request GET:/api/app/power-reports
   * @secure
   */
  appPowerReportsList = (
    query: AppPowerReportsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrPowerReportsPowerReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsCreate
   * @request POST:/api/app/power-reports
   * @secure
   */
  appPowerReportsCreate = (
    data: MotrPowerReportsPowerReportCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsDetail
   * @request GET:/api/app/power-reports/{id}
   * @secure
   */
  appPowerReportsDetail = (
    { id }: AppPowerReportsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsUpdate
   * @request PUT:/api/app/power-reports/{id}
   * @secure
   */
  appPowerReportsUpdate = (
    { id }: AppPowerReportsUpdateParams,
    data: MotrPowerReportsPowerReportUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsDelete
   * @request DELETE:/api/app/power-reports/{id}
   * @secure
   */
  appPowerReportsDelete = (
    { id }: AppPowerReportsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/power-reports/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsAsExcelFileList
   * @request GET:/api/app/power-reports/as-excel-file
   * @secure
   */
  appPowerReportsAsExcelFileList = (
    query: AppPowerReportsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/power-reports/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReport
   * @name AppPowerReportsDownloadTokenList
   * @request GET:/api/app/power-reports/download-token
   * @secure
   */
  appPowerReportsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnList
   * @request GET:/api/app/power-reports-extn
   * @secure
   */
  appPowerReportsExtnList = (
    query: AppPowerReportsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrPowerReportsPowerReportDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnCreate
   * @request POST:/api/app/power-reports-extn
   * @secure
   */
  appPowerReportsExtnCreate = (
    data: MotrPowerReportsPowerReportCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnDetail
   * @request GET:/api/app/power-reports-extn/{id}
   * @secure
   */
  appPowerReportsExtnDetail = (
    { id }: AppPowerReportsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnUpdate
   * @request PUT:/api/app/power-reports-extn/{id}
   * @secure
   */
  appPowerReportsExtnUpdate = (
    { id }: AppPowerReportsExtnUpdateParams,
    data: MotrPowerReportsPowerReportUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrPowerReportsPowerReportDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnDelete
   * @request DELETE:/api/app/power-reports-extn/{id}
   * @secure
   */
  appPowerReportsExtnDelete = (
    { id }: AppPowerReportsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/power-reports-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnAsExcelFileList
   * @request GET:/api/app/power-reports-extn/as-excel-file
   * @secure
   */
  appPowerReportsExtnAsExcelFileList = (
    query: AppPowerReportsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/power-reports-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnDownloadTokenList
   * @request GET:/api/app/power-reports-extn/download-token
   * @secure
   */
  appPowerReportsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags PowerReportExtn
   * @name AppPowerReportsExtnGetEmbedInfoList
   * @request GET:/api/app/power-reports-extn/GetEmbedInfo
   * @secure
   */
  appPowerReportsExtnGetEmbedInfoList = (
    query: AppPowerReportsExtnGetEmbedInfoListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrPowerReportsPowerBIReportResponseVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/power-reports-extn/GetEmbedInfo`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileList
   * @request GET:/api/account/my-profile
   * @secure
   */
  accountMyProfileList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpAccountProfileDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/my-profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileUpdate
   * @request PUT:/api/account/my-profile
   * @secure
   */
  accountMyProfileUpdate = (
    data: VoloAbpAccountUpdateProfileDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpAccountProfileDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/my-profile`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileChangePasswordCreate
   * @request POST:/api/account/my-profile/change-password
   * @secure
   */
  accountMyProfileChangePasswordCreate = (
    data: VoloAbpAccountChangePasswordInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/my-profile/change-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileTwoFactorEnabledList
   * @request GET:/api/account/my-profile/two-factor-enabled
   * @secure
   */
  accountMyProfileTwoFactorEnabledList = (params: RequestParams = {}) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/my-profile/two-factor-enabled`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileSetTwoFactorEnabledCreate
   * @request POST:/api/account/my-profile/set-two-factor-enabled
   * @secure
   */
  accountMyProfileSetTwoFactorEnabledCreate = (
    query: AccountMyProfileSetTwoFactorEnabledCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/my-profile/set-two-factor-enabled`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileCanEnableTwoFactorList
   * @request GET:/api/account/my-profile/can-enable-two-factor
   * @secure
   */
  accountMyProfileCanEnableTwoFactorList = (params: RequestParams = {}) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/my-profile/can-enable-two-factor`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Profile
   * @name AccountMyProfileTimezonesList
   * @request GET:/api/account/my-profile/timezones
   * @secure
   */
  accountMyProfileTimezonesList = (params: RequestParams = {}) =>
    this.request<VoloAbpNameValue[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/my-profile/timezones`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtGetJobHistoryList
   * @request GET:/api/app/report-ext/get-job-history
   * @secure
   */
  appReportExtGetJobHistoryList = (
    query: AppReportExtGetJobHistoryListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsGetJobHistoryResponse,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/get-job-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtGetJobTimelogsList
   * @request GET:/api/app/report-ext/get-job-timelogs
   * @secure
   */
  appReportExtGetJobTimelogsList = (
    query: AppReportExtGetJobTimelogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsGetJobTimeLogReportResponse[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/get-job-timelogs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtGetJobHistoryFiltersList
   * @request GET:/api/app/report-ext/get-job-history-filters
   * @secure
   */
  appReportExtGetJobHistoryFiltersList = (params: RequestParams = {}) =>
    this.request<
      MotrJobsJobHistoryFilters,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/get-job-history-filters`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtMatterTypesList
   * @request GET:/api/app/report-ext/matter-types
   * @secure
   */
  appReportExtMatterTypesList = (params: RequestParams = {}) =>
    this.request<
      MotrReportsMatterTypeFilterOptionDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/matter-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtPipelineReportCreate
   * @request POST:/api/app/report-ext/pipeline-report
   * @secure
   */
  appReportExtPipelineReportCreate = (
    data: MotrJobsPipelineRepotRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsPipelineRepotResponse,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/pipeline-report`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtJobOutcomeReportList
   * @request GET:/api/app/report-ext/job-outcome-report
   * @secure
   */
  appReportExtJobOutcomeReportList = (
    query: AppReportExtJobOutcomeReportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobOutputEntity[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/job-outcome-report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtNdAuditLogsList
   * @request GET:/api/app/report-ext/ndAuditLogs
   * @secure
   */
  appReportExtNdAuditLogsList = (
    query: AppReportExtNdAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsNdAuditLogResponseModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/ndAuditLogs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtNdAuditLogDetailsList
   * @request GET:/api/app/report-ext/ndAuditLogDetails
   * @secure
   */
  appReportExtNdAuditLogDetailsList = (
    query: AppReportExtNdAuditLogDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrNdAuditLogsNdAuditLogDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/ndAuditLogDetails`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtPerformanceDetailsList
   * @request GET:/api/app/report-ext/performance-details
   * @secure
   */
  appReportExtPerformanceDetailsList = (
    query: AppReportExtPerformanceDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsPerformaceReportResponseViewModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/performance-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtSystemPerformanceDetailsList
   * @request GET:/api/app/report-ext/system-performance-details
   * @secure
   */
  appReportExtSystemPerformanceDetailsList = (
    query: AppReportExtSystemPerformanceDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsPerformaceReportResponseViewModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/system-performance-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtSystemTagsPerformanceDetailsList
   * @request GET:/api/app/report-ext/system-tags-performance-details
   * @secure
   */
  appReportExtSystemTagsPerformanceDetailsList = (
    query: AppReportExtSystemTagsPerformanceDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsTagsPerformaceReportResponseViewModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/system-tags-performance-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtGetUserHistoryList
   * @request GET:/api/app/report-ext/get-user-history
   * @secure
   */
  appReportExtGetUserHistoryList = (
    query: AppReportExtGetUserHistoryListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsGetJobHistoryResponse[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/get-user-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtUserDashboardDetailsList
   * @request GET:/api/app/report-ext/user-dashboard-details
   * @secure
   */
  appReportExtUserDashboardDetailsList = (
    query: AppReportExtUserDashboardDetailsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsUserDashboardGraphResponseModel,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/user-dashboard-details`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtDashboardSummaryCreate
   * @request POST:/api/app/report-ext/dashboard-summary
   * @secure
   */
  appReportExtDashboardSummaryCreate = (
    data: MotrReportsDashboardSummaryRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrReportsDashboardSummaryResponse,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/dashboard-summary`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtWorkgroupPipelineReportCreate
   * @request POST:/api/app/report-ext/workgroup-pipeline-report
   * @secure
   */
  appReportExtWorkgroupPipelineReportCreate = (
    data: MotrJobsWorkgroupPipelineRepotRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkgroupPipelineRepotResponse,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/workgroup-pipeline-report`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtDurationReportList
   * @request GET:/api/app/report-ext/duration-report
   * @secure
   */
  appReportExtDurationReportList = (
    query: AppReportExtDurationReportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsDurationReportDataModel[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/duration-report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtDurationReportForStepsList
   * @request GET:/api/app/report-ext/duration-report-for-steps
   * @secure
   */
  appReportExtDurationReportForStepsList = (
    query: AppReportExtDurationReportForStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsDurationReportDataModel[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/duration-report-for-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ReportExtController
   * @name AppReportExtTagsReportList
   * @request GET:/api/app/report-ext/tags-report
   * @secure
   */
  appReportExtTagsReportList = (
    query: AppReportExtTagsReportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsDurationReportDataModel[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/report-ext/tags-report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RepoSyncHistory
   * @name AppRepoSyncHistoryList
   * @request GET:/api/app/repo-sync-history
   * @secure
   */
  appRepoSyncHistoryList = (
    query: AppRepoSyncHistoryListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSyncHistoryRepoSyncHistorySummaryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/repo-sync-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags RepoSyncHistory
   * @name AppRepoSyncHistoryDetail
   * @request GET:/api/app/repo-sync-history/{id}
   * @secure
   */
  appRepoSyncHistoryDetail = (
    { id }: AppRepoSyncHistoryDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncHistoryRepoSyncHistoryDetailDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/repo-sync-history/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesDetail
   * @request GET:/api/identity/roles/{id}
   * @secure
   */
  identityRolesDetail = (
    { id }: IdentityRolesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityRoleDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesUpdate
   * @request PUT:/api/identity/roles/{id}
   * @secure
   */
  identityRolesUpdate = (
    { id }: IdentityRolesUpdateParams,
    data: VoloAbpIdentityIdentityRoleUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityRoleDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesDelete
   * @request DELETE:/api/identity/roles/{id}
   * @secure
   */
  identityRolesDelete = (
    { id }: IdentityRolesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/roles/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesCreate
   * @request POST:/api/identity/roles
   * @secure
   */
  identityRolesCreate = (
    data: VoloAbpIdentityIdentityRoleCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityRoleDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesList
   * @request GET:/api/identity/roles
   * @secure
   */
  identityRolesList = (
    query: IdentityRolesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesAllList
   * @request GET:/api/identity/roles/all
   * @secure
   */
  identityRolesAllList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesClaimsUpdate
   * @request PUT:/api/identity/roles/{id}/claims
   * @secure
   */
  identityRolesClaimsUpdate = (
    { id }: IdentityRolesClaimsUpdateParams,
    data: VoloAbpIdentityIdentityRoleClaimDto[],
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/roles/${id}/claims`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesClaimsList
   * @request GET:/api/identity/roles/{id}/claims
   * @secure
   */
  identityRolesClaimsList = (
    { id }: IdentityRolesClaimsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityRoleClaimDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles/${id}/claims`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesMoveAllUsersUpdate
   * @request PUT:/api/identity/roles/{id}/move-all-users
   * @secure
   */
  identityRolesMoveAllUsersUpdate = (
    { id, ...query }: IdentityRolesMoveAllUsersUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/roles/${id}/move-all-users`,
      method: "PUT",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Role
   * @name IdentityRolesAllClaimTypesList
   * @request GET:/api/identity/roles/all-claim-types
   * @secure
   */
  identityRolesAllClaimTypesList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityClaimTypeDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/roles/all-claim-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesDetail
   * @request GET:/api/openiddict/scopes/{id}
   * @secure
   */
  openiddictScopesDetail = (
    { id }: OpeniddictScopesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictScopesDtosScopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/scopes/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesUpdate
   * @request PUT:/api/openiddict/scopes/{id}
   * @secure
   */
  openiddictScopesUpdate = (
    { id }: OpeniddictScopesUpdateParams,
    data: VoloAbpOpenIddictScopesDtosUpdateScopeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictScopesDtosScopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/scopes/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesList
   * @request GET:/api/openiddict/scopes
   * @secure
   */
  openiddictScopesList = (
    query: OpeniddictScopesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpOpenIddictScopesDtosScopeDtoVoloAbpOpenIddictProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/scopes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesCreate
   * @request POST:/api/openiddict/scopes
   * @secure
   */
  openiddictScopesCreate = (
    data: VoloAbpOpenIddictScopesDtosCreateScopeInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpOpenIddictScopesDtosScopeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/scopes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesDelete
   * @request DELETE:/api/openiddict/scopes
   * @secure
   */
  openiddictScopesDelete = (
    query: OpeniddictScopesDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/openiddict/scopes`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Scopes
   * @name OpeniddictScopesAllList
   * @request GET:/api/openiddict/scopes/all
   * @secure
   */
  openiddictScopesAllList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpOpenIddictScopesDtosScopeDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/openiddict/scopes/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SecurityLog
   * @name IdentitySecurityLogsList
   * @request GET:/api/identity/security-logs
   * @secure
   */
  identitySecurityLogsList = (
    query: IdentitySecurityLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentitySecurityLogDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/security-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SecurityLog
   * @name IdentitySecurityLogsDetail
   * @request GET:/api/identity/security-logs/{id}
   * @secure
   */
  identitySecurityLogsDetail = (
    { id }: IdentitySecurityLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentitySecurityLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/security-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SecurityLog
   * @name IdentitySecurityLogsMyList
   * @request GET:/api/identity/security-logs/my
   * @secure
   */
  identitySecurityLogsMyList = (
    query: IdentitySecurityLogsMyListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentitySecurityLogDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/security-logs/my`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SecurityLog
   * @name IdentitySecurityLogsMyDetail
   * @request GET:/api/identity/security-logs/my/{id}
   * @secure
   */
  identitySecurityLogsMyDetail = (
    { id }: IdentitySecurityLogsMyDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentitySecurityLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/security-logs/my/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsList
   * @request GET:/api/identity/settings
   * @secure
   */
  identitySettingsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityIdentitySettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsUpdate
   * @request PUT:/api/identity/settings
   * @secure
   */
  identitySettingsUpdate = (
    data: VoloAbpIdentityIdentitySettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/settings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsLdapList
   * @request GET:/api/identity/settings/ldap
   * @secure
   */
  identitySettingsLdapList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityIdentityLdapSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/settings/ldap`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsLdapUpdate
   * @request PUT:/api/identity/settings/ldap
   * @secure
   */
  identitySettingsLdapUpdate = (
    data: VoloAbpIdentityIdentityLdapSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/settings/ldap`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsOauthList
   * @request GET:/api/identity/settings/oauth
   * @secure
   */
  identitySettingsOauthList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityIdentityOAuthSettingsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/settings/oauth`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name IdentitySettingsOauthUpdate
   * @request PUT:/api/identity/settings/oauth
   * @secure
   */
  identitySettingsOauthUpdate = (
    data: VoloAbpIdentityIdentityOAuthSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/settings/oauth`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsMotrSettingsList
   * @request GET:/api/app/settings/motr-settings
   * @secure
   */
  appSettingsMotrSettingsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpSettingsSettingValue[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/settings/motr-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsSettingsList
   * @request GET:/api/app/settings/settings
   * @secure
   */
  appSettingsSettingsList = (
    query: AppSettingsSettingsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpSettingsSettingValue[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/settings/settings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsUserSettingsList
   * @request GET:/api/app/settings/user-settings
   * @secure
   */
  appSettingsUserSettingsList = (
    query: AppSettingsUserSettingsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpSettingsSettingValue[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/settings/user-settings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsLanguagesList
   * @request GET:/api/app/settings/languages
   * @secure
   */
  appSettingsLanguagesList = (params: RequestParams = {}) =>
    this.request<
      MotrSettingsLanguageListViewModel[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/settings/languages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsSyncLanguageTextCreate
   * @request POST:/api/app/settings/sync-language-text
   * @secure
   */
  appSettingsSyncLanguageTextCreate = (
    data: MotrSettingsLanguageSyncViewModel,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/settings/sync-language-text`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsResetRolePermissionsCreate
   * @request POST:/api/app/settings/reset-role-permissions
   * @secure
   */
  appSettingsResetRolePermissionsCreate = (
    query: AppSettingsResetRolePermissionsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/settings/reset-role-permissions`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsSyncLanguageTextsCreate
   * @request POST:/api/app/settings/sync-language-texts
   * @secure
   */
  appSettingsSyncLanguageTextsCreate = (
    data: string[],
    query: AppSettingsSyncLanguageTextsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/settings/sync-language-texts`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsSetSettingsCreate
   * @request POST:/api/app/settings/set-settings
   * @secure
   */
  appSettingsSetSettingsCreate = (
    data: VoloAbpSettingsSettingValue[],
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpSettingsSettingValue[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/settings/set-settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Settings
   * @name AppSettingsClearCacheCreate
   * @request POST:/api/app/settings/clear-cache
   * @secure
   */
  appSettingsClearCacheCreate = (
    query: AppSettingsClearCacheCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/settings/clear-cache`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsPublishCreate
   * @request POST:/api/app/skills/{id}/publish
   * @secure
   */
  appSkillsPublishCreate = (
    { id }: AppSkillsPublishCreateParams,
    data: MotrSkillsPublishSkillInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skills/${id}/publish`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsRollbackCreate
   * @request POST:/api/app/skills/{id}/rollback
   * @secure
   */
  appSkillsRollbackCreate = (
    { id }: AppSkillsRollbackCreateParams,
    data: MotrSkillsRollbackSkillInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skills/${id}/rollback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsDeprecateCreate
   * @request POST:/api/app/skills/{id}/deprecate
   * @secure
   */
  appSkillsDeprecateCreate = (
    { id }: AppSkillsDeprecateCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/${id}/deprecate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsRestoreCreate
   * @request POST:/api/app/skills/{id}/restore
   * @secure
   */
  appSkillsRestoreCreate = (
    { id }: AppSkillsRestoreCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/${id}/restore`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsList
   * @request GET:/api/app/skills
   * @secure
   */
  appSkillsList = (
    query: AppSkillsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skills`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsCreate
   * @request POST:/api/app/skills
   * @secure
   */
  appSkillsCreate = (
    data: MotrSkillsSkillCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsDelete
   * @request DELETE:/api/app/skills
   * @secure
   */
  appSkillsDelete = (
    query: AppSkillsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsDetail
   * @request GET:/api/app/skills/{id}
   * @secure
   */
  appSkillsDetail = (
    { id }: AppSkillsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsUpdate
   * @request PUT:/api/app/skills/{id}
   * @secure
   */
  appSkillsUpdate = (
    { id }: AppSkillsUpdateParams,
    data: MotrSkillsSkillUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSkillsSkillDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsDelete2
   * @request DELETE:/api/app/skills/{id}
   * @originalName appSkillsDelete
   * @duplicate
   * @secure
   */
  appSkillsDelete2 = (
    { id }: AppSkillsDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Skill
   * @name AppSkillsAllDelete
   * @request DELETE:/api/app/skills/all
   * @secure
   */
  appSkillsAllDelete = (
    query: AppSkillsAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skills/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsList
   * @request GET:/api/app/skill-audit-logs
   * @secure
   */
  appSkillAuditLogsList = (
    query: AppSkillAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillAuditLogWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsCreate
   * @request POST:/api/app/skill-audit-logs
   * @secure
   */
  appSkillAuditLogsCreate = (
    data: MotrSkillsSkillAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsWithNavigationPropertiesDetail
   * @request GET:/api/app/skill-audit-logs/with-navigation-properties/{id}
   * @secure
   */
  appSkillAuditLogsWithNavigationPropertiesDetail = (
    { id }: AppSkillAuditLogsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillAuditLogWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsDetail
   * @request GET:/api/app/skill-audit-logs/{id}
   * @secure
   */
  appSkillAuditLogsDetail = (
    { id }: AppSkillAuditLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsUpdate
   * @request PUT:/api/app/skill-audit-logs/{id}
   * @secure
   */
  appSkillAuditLogsUpdate = (
    { id }: AppSkillAuditLogsUpdateParams,
    data: MotrSkillsSkillAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsDelete
   * @request DELETE:/api/app/skill-audit-logs/{id}
   * @secure
   */
  appSkillAuditLogsDelete = (
    { id }: AppSkillAuditLogsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skill-audit-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillAuditLog
   * @name AppSkillAuditLogsSkillLookupList
   * @request GET:/api/app/skill-audit-logs/skill-lookup
   * @secure
   */
  appSkillAuditLogsSkillLookupList = (
    query: AppSkillAuditLogsSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-audit-logs/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesBySkillList
   * @request GET:/api/app/skill-resources/by-skill
   * @secure
   */
  appSkillResourcesBySkillList = (
    query: AppSkillResourcesBySkillListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillResourceDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/by-skill`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesDetailedBySkillList
   * @request GET:/api/app/skill-resources/detailed/by-skill
   * @secure
   */
  appSkillResourcesDetailedBySkillList = (
    query: AppSkillResourcesDetailedBySkillListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillResourceWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/detailed/by-skill`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesList
   * @request GET:/api/app/skill-resources
   * @secure
   */
  appSkillResourcesList = (
    query: AppSkillResourcesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillResourceWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesCreate
   * @request POST:/api/app/skill-resources
   * @secure
   */
  appSkillResourcesCreate = (
    data: MotrSkillsSkillResourceCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillResourceDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesWithNavigationPropertiesDetail
   * @request GET:/api/app/skill-resources/with-navigation-properties/{id}
   * @secure
   */
  appSkillResourcesWithNavigationPropertiesDetail = (
    { id }: AppSkillResourcesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillResourceWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesDetail
   * @request GET:/api/app/skill-resources/{id}
   * @secure
   */
  appSkillResourcesDetail = (
    { id }: AppSkillResourcesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillResourceDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesUpdate
   * @request PUT:/api/app/skill-resources/{id}
   * @secure
   */
  appSkillResourcesUpdate = (
    { id }: AppSkillResourcesUpdateParams,
    data: MotrSkillsSkillResourceUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillResourceDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesDelete
   * @request DELETE:/api/app/skill-resources/{id}
   * @secure
   */
  appSkillResourcesDelete = (
    { id }: AppSkillResourcesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skill-resources/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillResource
   * @name AppSkillResourcesSkillLookupList
   * @request GET:/api/app/skill-resources/skill-lookup
   * @secure
   */
  appSkillResourcesSkillLookupList = (
    query: AppSkillResourcesSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-resources/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillTest
   * @name AppSkillTestRunCreate
   * @request POST:/api/app/skill-test/run
   * @secure
   */
  appSkillTestRunCreate = (
    data: MotrAiServicesSkillsSkillTestRunInputDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skill-test/run`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsBySkillList
   * @request GET:/api/app/skill-tool-bindings/by-skill
   * @secure
   */
  appSkillToolBindingsBySkillList = (
    query: AppSkillToolBindingsBySkillListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillToolBindingDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/by-skill`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsDetailedBySkillList
   * @request GET:/api/app/skill-tool-bindings/detailed/by-skill
   * @secure
   */
  appSkillToolBindingsDetailedBySkillList = (
    query: AppSkillToolBindingsDetailedBySkillListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillToolBindingWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/detailed/by-skill`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsList
   * @request GET:/api/app/skill-tool-bindings
   * @secure
   */
  appSkillToolBindingsList = (
    query: AppSkillToolBindingsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillToolBindingWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsCreate
   * @request POST:/api/app/skill-tool-bindings
   * @secure
   */
  appSkillToolBindingsCreate = (
    data: MotrSkillsSkillToolBindingCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillToolBindingDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsWithNavigationPropertiesDetail
   * @request GET:/api/app/skill-tool-bindings/with-navigation-properties/{id}
   * @secure
   */
  appSkillToolBindingsWithNavigationPropertiesDetail = (
    { id }: AppSkillToolBindingsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillToolBindingWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsDetail
   * @request GET:/api/app/skill-tool-bindings/{id}
   * @secure
   */
  appSkillToolBindingsDetail = (
    { id }: AppSkillToolBindingsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillToolBindingDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsUpdate
   * @request PUT:/api/app/skill-tool-bindings/{id}
   * @secure
   */
  appSkillToolBindingsUpdate = (
    { id }: AppSkillToolBindingsUpdateParams,
    data: MotrSkillsSkillToolBindingUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillToolBindingDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsDelete
   * @request DELETE:/api/app/skill-tool-bindings/{id}
   * @secure
   */
  appSkillToolBindingsDelete = (
    { id }: AppSkillToolBindingsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skill-tool-bindings/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsSkillLookupList
   * @request GET:/api/app/skill-tool-bindings/skill-lookup
   * @secure
   */
  appSkillToolBindingsSkillLookupList = (
    query: AppSkillToolBindingsSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillToolBinding
   * @name AppSkillToolBindingsMcpServerLookupList
   * @request GET:/api/app/skill-tool-bindings/mcp-server-lookup
   * @secure
   */
  appSkillToolBindingsMcpServerLookupList = (
    query: AppSkillToolBindingsMcpServerLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-tool-bindings/mcp-server-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsList
   * @request GET:/api/app/skill-versions
   * @secure
   */
  appSkillVersionsList = (
    query: AppSkillVersionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsSkillVersionWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsCreate
   * @request POST:/api/app/skill-versions
   * @secure
   */
  appSkillVersionsCreate = (
    data: MotrSkillsSkillVersionCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsWithNavigationPropertiesDetail
   * @request GET:/api/app/skill-versions/with-navigation-properties/{id}
   * @secure
   */
  appSkillVersionsWithNavigationPropertiesDetail = (
    { id }: AppSkillVersionsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsDetail
   * @request GET:/api/app/skill-versions/{id}
   * @secure
   */
  appSkillVersionsDetail = (
    { id }: AppSkillVersionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsUpdate
   * @request PUT:/api/app/skill-versions/{id}
   * @secure
   */
  appSkillVersionsUpdate = (
    { id }: AppSkillVersionsUpdateParams,
    data: MotrSkillsSkillVersionUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsSkillVersionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsDelete
   * @request DELETE:/api/app/skill-versions/{id}
   * @secure
   */
  appSkillVersionsDelete = (
    { id }: AppSkillVersionsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/skill-versions/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SkillVersion
   * @name AppSkillVersionsSkillLookupList
   * @request GET:/api/app/skill-versions/skill-lookup
   * @secure
   */
  appSkillVersionsSkillLookupList = (
    query: AppSkillVersionsSkillLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/skill-versions/skill-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Snippet
   * @name AppSnippetsList
   * @request GET:/api/app/snippets
   * @secure
   */
  appSnippetsList = (
    query: AppSnippetsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSnippetsSnippetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/snippets`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Snippet
   * @name AppSnippetsCreate
   * @request POST:/api/app/snippets
   * @secure
   */
  appSnippetsCreate = (
    data: MotrSnippetsSnippetCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Snippet
   * @name AppSnippetsDetail
   * @request GET:/api/app/snippets/{id}
   * @secure
   */
  appSnippetsDetail = (
    { id }: AppSnippetsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Snippet
   * @name AppSnippetsUpdate
   * @request PUT:/api/app/snippets/{id}
   * @secure
   */
  appSnippetsUpdate = (
    { id }: AppSnippetsUpdateParams,
    data: MotrSnippetsSnippetUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Snippet
   * @name AppSnippetsDelete
   * @request DELETE:/api/app/snippets/{id}
   * @secure
   */
  appSnippetsDelete = (
    { id }: AppSnippetsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/snippets/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SnippetExtn
   * @name AppSnippetsExtnList
   * @request GET:/api/app/snippets-extn
   * @secure
   */
  appSnippetsExtnList = (
    query: AppSnippetsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSnippetsSnippetDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/snippets-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SnippetExtn
   * @name AppSnippetsExtnCreate
   * @request POST:/api/app/snippets-extn
   * @secure
   */
  appSnippetsExtnCreate = (
    data: MotrSnippetsSnippetCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets-extn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags SnippetExtn
   * @name AppSnippetsExtnDetail
   * @request GET:/api/app/snippets-extn/{id}
   * @secure
   */
  appSnippetsExtnDetail = (
    { id }: AppSnippetsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets-extn/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags SnippetExtn
   * @name AppSnippetsExtnUpdate
   * @request PUT:/api/app/snippets-extn/{id}
   * @secure
   */
  appSnippetsExtnUpdate = (
    { id }: AppSnippetsExtnUpdateParams,
    data: MotrSnippetsSnippetUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrSnippetsSnippetDto, VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/snippets-extn/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags SnippetExtn
   * @name AppSnippetsExtnDelete
   * @request DELETE:/api/app/snippets-extn/{id}
   * @secure
   */
  appSnippetsExtnDelete = (
    { id }: AppSnippetsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/snippets-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags StepResponsibilitySegment
   * @name AppStepResponsibilityToggleCreate
   * @request POST:/api/app/step-responsibility/toggle
   * @secure
   */
  appStepResponsibilityToggleCreate = (
    data: MotrStepResponsibilitySegmentsToggleResponsibilityInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrStepResponsibilitySegmentsStepResponsibilitySummaryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/step-responsibility/toggle`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StepResponsibilitySegment
   * @name AppStepResponsibilityStepDetail
   * @request GET:/api/app/step-responsibility/step/{jobStepId}
   * @secure
   */
  appStepResponsibilityStepDetail = (
    { jobStepId }: AppStepResponsibilityStepDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrStepResponsibilitySegmentsStepResponsibilitySummaryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/step-responsibility/step/${jobStepId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StepResponsibilitySegment
   * @name AppStepResponsibilityJobDetail
   * @request GET:/api/app/step-responsibility/job/{jobId}
   * @secure
   */
  appStepResponsibilityJobDetail = (
    { jobId }: AppStepResponsibilityJobDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrStepResponsibilitySegmentsJobResponsibilitySummaryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/step-responsibility/job/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags StepResponsibilitySegment
   * @name AppStepResponsibilityTimeBreakdownReportList
   * @request GET:/api/app/step-responsibility/time-breakdown-report
   * @secure
   */
  appStepResponsibilityTimeBreakdownReportList = (
    query: AppStepResponsibilityTimeBreakdownReportListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrStepResponsibilitySegmentsTimeBreakdownReportResponseDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/step-responsibility/time-breakdown-report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data
   * @secure
   */
  appCabinetsExtnSyncedDataList = (
    { cabinetId, ...query }: AppCabinetsExtnSyncedDataListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedDataTreeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataCreate
   * @request POST:/api/app/cabinets-extn/{cabinetId}/synced-data
   * @secure
   */
  appCabinetsExtnSyncedDataCreate = (
    { cabinetId }: AppCabinetsExtnSyncedDataCreateParams,
    data: MotrSyncedDataCreateSyncedEntityInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataDirtyPreviewList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data/dirty-preview
   * @secure
   */
  appCabinetsExtnSyncedDataDirtyPreviewList = (
    { cabinetId }: AppCabinetsExtnSyncedDataDirtyPreviewListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataDirtyPreviewDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/dirty-preview`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataChildrenList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data/children
   * @secure
   */
  appCabinetsExtnSyncedDataChildrenList = (
    { cabinetId, ...query }: AppCabinetsExtnSyncedDataChildrenListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/children`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataByKeyList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data/by-key
   * @secure
   */
  appCabinetsExtnSyncedDataByKeyList = (
    { cabinetId, ...query }: AppCabinetsExtnSyncedDataByKeyListParams,
    params: RequestParams = {},
  ) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/by-key`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataDetail
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}
   * @secure
   */
  appCabinetsExtnSyncedDataDetail = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataUpdate
   * @request PUT:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}
   * @secure
   */
  appCabinetsExtnSyncedDataUpdate = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataUpdateParams,
    data: MotrSyncedDataUpdateSyncedEntityInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataDelete
   * @request DELETE:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}
   * @secure
   */
  appCabinetsExtnSyncedDataDelete = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataPushCreate
   * @request POST:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}/push
   * @secure
   */
  appCabinetsExtnSyncedDataPushCreate = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataPushCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}/push`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataResolveConflictCreate
   * @request POST:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}/resolve-conflict
   * @secure
   */
  appCabinetsExtnSyncedDataResolveConflictCreate = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataResolveConflictCreateParams,
    data: MotrSyncedDataResolveConflictInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}/resolve-conflict`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataMetadataUpdate
   * @request PUT:/api/app/cabinets-extn/{cabinetId}/synced-data/{id}/metadata
   * @secure
   */
  appCabinetsExtnSyncedDataMetadataUpdate = (
    { cabinetId, id }: AppCabinetsExtnSyncedDataMetadataUpdateParams,
    data: MotrSyncedDataUpdateMetadataOnlyInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/${id}/metadata`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataKeysList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/synced-data/keys
   * @secure
   */
  appCabinetsExtnSyncedDataKeysList = (
    { cabinetId }: AppCabinetsExtnSyncedDataKeysListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      Record<string, MotrSyncedDataKeyIdPairDto[]>,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/keys`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncedData
   * @name AppCabinetsExtnSyncedDataLocalOnlyCreate
   * @request POST:/api/app/cabinets-extn/{cabinetId}/synced-data/local-only
   * @secure
   */
  appCabinetsExtnSyncedDataLocalOnlyCreate = (
    { cabinetId }: AppCabinetsExtnSyncedDataLocalOnlyCreateParams,
    data: MotrSyncedDataCreateSyncedEntityInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncedDataSyncedEntityNodeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/synced-data/local-only`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncHistory
   * @name AppCabinetsExtnSyncHistoryList
   * @request GET:/api/app/cabinets-extn/{cabinetId}/sync-history
   * @secure
   */
  appCabinetsExtnSyncHistoryList = (
    { cabinetId, ...query }: AppCabinetsExtnSyncHistoryListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSyncHistoryRepoSyncHistorySummaryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/cabinets-extn/${cabinetId}/sync-history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SyncHistory
   * @name AppSyncHistoryDetail
   * @request GET:/api/app/sync-history/{id}
   * @secure
   */
  appSyncHistoryDetail = (
    { id }: AppSyncHistoryDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSyncHistoryRepoSyncHistoryDetailDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/sync-history/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsList
   * @request GET:/api/app/tags
   * @secure
   */
  appTagsList = (query: AppTagsListParams = {}, params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTagsTagWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsCreate
   * @request POST:/api/app/tags
   * @secure
   */
  appTagsCreate = (data: MotrTagsTagCreateDto, params: RequestParams = {}) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsWithNavigationPropertiesDetail
   * @request GET:/api/app/tags/with-navigation-properties/{id}
   * @secure
   */
  appTagsWithNavigationPropertiesDetail = (
    { id }: AppTagsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagsTagWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsDetail
   * @request GET:/api/app/tags/{id}
   * @secure
   */
  appTagsDetail = ({ id }: AppTagsDetailParams, params: RequestParams = {}) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsUpdate
   * @request PUT:/api/app/tags/{id}
   * @secure
   */
  appTagsUpdate = (
    { id }: AppTagsUpdateParams,
    data: MotrTagsTagUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsDelete
   * @request DELETE:/api/app/tags/{id}
   * @secure
   */
  appTagsDelete = ({ id }: AppTagsDeleteParams, params: RequestParams = {}) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsTagCategoryLookupList
   * @request GET:/api/app/tags/tag-category-lookup
   * @secure
   */
  appTagsTagCategoryLookupList = (
    query: AppTagsTagCategoryLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags/tag-category-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsAsExcelFileList
   * @request GET:/api/app/tags/as-excel-file
   * @secure
   */
  appTagsAsExcelFileList = (
    query: AppTagsAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsDownloadTokenList
   * @request GET:/api/app/tags/download-token
   * @secure
   */
  appTagsDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnList
   * @request GET:/api/app/tags-extn
   * @secure
   */
  appTagsExtnList = (
    query: AppTagsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTagsTagWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnCreate
   * @request POST:/api/app/tags-extn
   * @secure
   */
  appTagsExtnCreate = (
    data: MotrTagsTagCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/tags-extn/with-navigation-properties/{id}
   * @secure
   */
  appTagsExtnWithNavigationPropertiesDetail = (
    { id }: AppTagsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagsTagWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnDetail
   * @request GET:/api/app/tags-extn/{id}
   * @secure
   */
  appTagsExtnDetail = (
    { id }: AppTagsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnUpdate
   * @request PUT:/api/app/tags-extn/{id}
   * @secure
   */
  appTagsExtnUpdate = (
    { id }: AppTagsExtnUpdateParams,
    data: MotrTagsTagUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<MotrTagsTagDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnDelete
   * @request DELETE:/api/app/tags-extn/{id}
   * @secure
   */
  appTagsExtnDelete = (
    { id }: AppTagsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnTagCategoryLookupList
   * @request GET:/api/app/tags-extn/tag-category-lookup
   * @secure
   */
  appTagsExtnTagCategoryLookupList = (
    query: AppTagsExtnTagCategoryLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags-extn/tag-category-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnAsExcelFileList
   * @request GET:/api/app/tags-extn/as-excel-file
   * @secure
   */
  appTagsExtnAsExcelFileList = (
    query: AppTagsExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tags-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnDownloadTokenList
   * @request GET:/api/app/tags-extn/download-token
   * @secure
   */
  appTagsExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tag
   * @name AppTagsExtnTagsAndCategoriesList
   * @request GET:/api/app/tags-extn/tags-and-categories
   * @secure
   */
  appTagsExtnTagsAndCategoriesList = (params: RequestParams = {}) =>
    this.request<
      MotrTagsTagAndCategoriesDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tags-extn/tags-and-categories`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesList
   * @request GET:/api/app/tag-categories
   * @secure
   */
  appTagCategoriesList = (
    query: AppTagCategoriesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTagCategoriesTagCategoryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesCreate
   * @request POST:/api/app/tag-categories
   * @secure
   */
  appTagCategoriesCreate = (
    data: MotrTagCategoriesTagCategoryCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesDetail
   * @request GET:/api/app/tag-categories/{id}
   * @secure
   */
  appTagCategoriesDetail = (
    { id }: AppTagCategoriesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesUpdate
   * @request PUT:/api/app/tag-categories/{id}
   * @secure
   */
  appTagCategoriesUpdate = (
    { id }: AppTagCategoriesUpdateParams,
    data: MotrTagCategoriesTagCategoryUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesDelete
   * @request DELETE:/api/app/tag-categories/{id}
   * @secure
   */
  appTagCategoriesDelete = (
    { id }: AppTagCategoriesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tag-categories/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesAsExcelFileList
   * @request GET:/api/app/tag-categories/as-excel-file
   * @secure
   */
  appTagCategoriesAsExcelFileList = (
    query: AppTagCategoriesAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tag-categories/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesDownloadTokenList
   * @request GET:/api/app/tag-categories/download-token
   * @secure
   */
  appTagCategoriesDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnList
   * @request GET:/api/app/tag-categories-extn
   * @secure
   */
  appTagCategoriesExtnList = (
    query: AppTagCategoriesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTagCategoriesTagCategoryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnCreate
   * @request POST:/api/app/tag-categories-extn
   * @secure
   */
  appTagCategoriesExtnCreate = (
    data: MotrTagCategoriesTagCategoryCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnDetail
   * @request GET:/api/app/tag-categories-extn/{id}
   * @secure
   */
  appTagCategoriesExtnDetail = (
    { id }: AppTagCategoriesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnUpdate
   * @request PUT:/api/app/tag-categories-extn/{id}
   * @secure
   */
  appTagCategoriesExtnUpdate = (
    { id }: AppTagCategoriesExtnUpdateParams,
    data: MotrTagCategoriesTagCategoryUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTagCategoriesTagCategoryDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnDelete
   * @request DELETE:/api/app/tag-categories-extn/{id}
   * @secure
   */
  appTagCategoriesExtnDelete = (
    { id }: AppTagCategoriesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tag-categories-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnAsExcelFileList
   * @request GET:/api/app/tag-categories-extn/as-excel-file
   * @secure
   */
  appTagCategoriesExtnAsExcelFileList = (
    query: AppTagCategoriesExtnAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tag-categories-extn/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TagCategory
   * @name AppTagCategoriesExtnDownloadTokenList
   * @request GET:/api/app/tag-categories-extn/download-token
   * @secure
   */
  appTagCategoriesExtnDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tag-categories-extn/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesList
   * @request GET:/api/app/templates
   * @secure
   */
  appTemplatesList = (
    query: AppTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesCreate
   * @request POST:/api/app/templates
   * @secure
   */
  appTemplatesCreate = (
    data: MotrTemplatesTemplateCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesWithNavigationPropertiesDetail
   * @request GET:/api/app/templates/with-navigation-properties/{id}
   * @secure
   */
  appTemplatesWithNavigationPropertiesDetail = (
    { id }: AppTemplatesWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesDetail
   * @request GET:/api/app/templates/{id}
   * @secure
   */
  appTemplatesDetail = (
    { id }: AppTemplatesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesUpdate
   * @request PUT:/api/app/templates/{id}
   * @secure
   */
  appTemplatesUpdate = (
    { id }: AppTemplatesUpdateParams,
    data: MotrTemplatesTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesDelete
   * @request DELETE:/api/app/templates/{id}
   * @secure
   */
  appTemplatesDelete = (
    { id }: AppTemplatesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/templates/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesTemplateTypeLookupList
   * @request GET:/api/app/templates/template-type-lookup
   * @secure
   */
  appTemplatesTemplateTypeLookupList = (
    query: AppTemplatesTemplateTypeLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates/template-type-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Template
   * @name AppTemplatesGetServiceRequestTemplatesList
   * @request GET:/api/app/templates/get-service-request-templates
   * @secure
   */
  appTemplatesGetServiceRequestTemplatesList = (
    query: AppTemplatesGetServiceRequestTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates/get-service-request-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLog
   * @name AppTemplateAuditLogsList
   * @request GET:/api/app/template-audit-logs
   * @secure
   */
  appTemplateAuditLogsList = (
    query: AppTemplateAuditLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateAuditLogsTemplateAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLog
   * @name AppTemplateAuditLogsCreate
   * @request POST:/api/app/template-audit-logs
   * @secure
   */
  appTemplateAuditLogsCreate = (
    data: MotrTemplateAuditLogsTemplateAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLog
   * @name AppTemplateAuditLogsDetail
   * @request GET:/api/app/template-audit-logs/{id}
   * @secure
   */
  appTemplateAuditLogsDetail = (
    { id }: AppTemplateAuditLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLog
   * @name AppTemplateAuditLogsUpdate
   * @request PUT:/api/app/template-audit-logs/{id}
   * @secure
   */
  appTemplateAuditLogsUpdate = (
    { id }: AppTemplateAuditLogsUpdateParams,
    data: MotrTemplateAuditLogsTemplateAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLog
   * @name AppTemplateAuditLogsDelete
   * @request DELETE:/api/app/template-audit-logs/{id}
   * @secure
   */
  appTemplateAuditLogsDelete = (
    { id }: AppTemplateAuditLogsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-audit-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLogExtn
   * @name AppTemplateAuditLogsExtnList
   * @request GET:/api/app/template-audit-logs-extn
   * @secure
   */
  appTemplateAuditLogsExtnList = (
    query: AppTemplateAuditLogsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateAuditLogsTemplateAuditLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLogExtn
   * @name AppTemplateAuditLogsExtnCreate
   * @request POST:/api/app/template-audit-logs-extn
   * @secure
   */
  appTemplateAuditLogsExtnCreate = (
    data: MotrTemplateAuditLogsTemplateAuditLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLogExtn
   * @name AppTemplateAuditLogsExtnDetail
   * @request GET:/api/app/template-audit-logs-extn/{id}
   * @secure
   */
  appTemplateAuditLogsExtnDetail = (
    { id }: AppTemplateAuditLogsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLogExtn
   * @name AppTemplateAuditLogsExtnUpdate
   * @request PUT:/api/app/template-audit-logs-extn/{id}
   * @secure
   */
  appTemplateAuditLogsExtnUpdate = (
    { id }: AppTemplateAuditLogsExtnUpdateParams,
    data: MotrTemplateAuditLogsTemplateAuditLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateAuditLogsTemplateAuditLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-audit-logs-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateAuditLogExtn
   * @name AppTemplateAuditLogsExtnDelete
   * @request DELETE:/api/app/template-audit-logs-extn/{id}
   * @secure
   */
  appTemplateAuditLogsExtnDelete = (
    { id }: AppTemplateAuditLogsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-audit-logs-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraft
   * @name AppTemplateDraftsList
   * @request GET:/api/app/template-drafts
   * @secure
   */
  appTemplateDraftsList = (
    query: AppTemplateDraftsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateDraftsTemplateDraftDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraft
   * @name AppTemplateDraftsCreate
   * @request POST:/api/app/template-drafts
   * @secure
   */
  appTemplateDraftsCreate = (
    data: MotrTemplateDraftsTemplateDraftCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraft
   * @name AppTemplateDraftsDetail
   * @request GET:/api/app/template-drafts/{id}
   * @secure
   */
  appTemplateDraftsDetail = (
    { id }: AppTemplateDraftsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraft
   * @name AppTemplateDraftsUpdate
   * @request PUT:/api/app/template-drafts/{id}
   * @secure
   */
  appTemplateDraftsUpdate = (
    { id }: AppTemplateDraftsUpdateParams,
    data: MotrTemplateDraftsTemplateDraftUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraft
   * @name AppTemplateDraftsDelete
   * @request DELETE:/api/app/template-drafts/{id}
   * @secure
   */
  appTemplateDraftsDelete = (
    { id }: AppTemplateDraftsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnList
   * @request GET:/api/app/template-drafts-extn
   * @secure
   */
  appTemplateDraftsExtnList = (
    query: AppTemplateDraftsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateDraftsTemplateDraftDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnCreate
   * @request POST:/api/app/template-drafts-extn
   * @secure
   */
  appTemplateDraftsExtnCreate = (
    data: MotrTemplateDraftsTemplateDraftCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDetail
   * @request GET:/api/app/template-drafts-extn/{id}
   * @secure
   */
  appTemplateDraftsExtnDetail = (
    { id }: AppTemplateDraftsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdate
   * @request PUT:/api/app/template-drafts-extn/{id}
   * @secure
   */
  appTemplateDraftsExtnUpdate = (
    { id }: AppTemplateDraftsExtnUpdateParams,
    data: MotrTemplateDraftsTemplateDraftUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateDraftsTemplateDraftDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDelete
   * @request DELETE:/api/app/template-drafts-extn/{id}
   * @secure
   */
  appTemplateDraftsExtnDelete = (
    { id }: AppTemplateDraftsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnCreateDraftCreate
   * @request POST:/api/app/template-drafts-extn/create-draft
   * @secure
   */
  appTemplateDraftsExtnCreateDraftCreate = (
    data: MotrTemplateDraftsTemplateDraftCreateVm,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/create-draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftTemplateCreate
   * @request POST:/api/app/template-drafts-extn/update-draft-template
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftTemplateCreate = (
    data: MotrTemplatesTemplateDto,
    query: AppTemplateDraftsExtnUpdateDraftTemplateCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-draft-template`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftTemplateStepCreate
   * @request POST:/api/app/template-drafts-extn/update-draft-template-step
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftTemplateStepCreate = (
    data: MotrTemplateStepsTemplateStepDto,
    query: AppTemplateDraftsExtnUpdateDraftTemplateStepCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-draft-template-step`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftTemplateStepPositionsCreate
   * @request POST:/api/app/template-drafts-extn/update-draft-template-step-positions
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftTemplateStepPositionsCreate = (
    data: MotrTemplateStepsTemplateStepPositionDto[],
    query: AppTemplateDraftsExtnUpdateDraftTemplateStepPositionsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/update-draft-template-step-positions`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDeleteDraftTemplateCreate
   * @request POST:/api/app/template-drafts-extn/delete-draft-template
   * @secure
   */
  appTemplateDraftsExtnDeleteDraftTemplateCreate = (
    query: AppTemplateDraftsExtnDeleteDraftTemplateCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/delete-draft-template`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnGetDraftTemplateCreate
   * @request POST:/api/app/template-drafts-extn/get-draft-template
   * @secure
   */
  appTemplateDraftsExtnGetDraftTemplateCreate = (
    query: AppTemplateDraftsExtnGetDraftTemplateCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/get-draft-template`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnGetDraftTemplateStepsList
   * @request GET:/api/app/template-drafts-extn/get-draft-template-steps
   * @secure
   */
  appTemplateDraftsExtnGetDraftTemplateStepsList = (
    query: AppTemplateDraftsExtnGetDraftTemplateStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/get-draft-template-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnGetDraftTemplateChecklistItemsList
   * @request GET:/api/app/template-drafts-extn/get-draft-template-checklist-items
   * @secure
   */
  appTemplateDraftsExtnGetDraftTemplateChecklistItemsList = (
    query: AppTemplateDraftsExtnGetDraftTemplateChecklistItemsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepCheckListGroupAndItems[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/get-draft-template-checklist-items`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDeleteDraftTemplateChecklistItemsDelete
   * @request DELETE:/api/app/template-drafts-extn/delete-draft-template-checklist-items
   * @secure
   */
  appTemplateDraftsExtnDeleteDraftTemplateChecklistItemsDelete = (
    query: AppTemplateDraftsExtnDeleteDraftTemplateChecklistItemsDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/delete-draft-template-checklist-items`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDeleteDraftTemplateChecklistGroupDelete
   * @request DELETE:/api/app/template-drafts-extn/delete-draft-template-checklist-group
   * @secure
   */
  appTemplateDraftsExtnDeleteDraftTemplateChecklistGroupDelete = (
    query: AppTemplateDraftsExtnDeleteDraftTemplateChecklistGroupDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/delete-draft-template-checklist-group`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateChecklistItemsCreate
   * @request POST:/api/app/template-drafts-extn/update-checklist-items
   * @secure
   */
  appTemplateDraftsExtnUpdateChecklistItemsCreate = (
    data: MotrTemplatesTemplateStepChecklistGroupDtoVM[],
    query: AppTemplateDraftsExtnUpdateChecklistItemsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-checklist-items`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftStepDocumentsCreate
   * @request POST:/api/app/template-drafts-extn/update-draft-step-documents
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftStepDocumentsCreate = (
    data: MotrDocumentsDocumentDto[],
    query: AppTemplateDraftsExtnUpdateDraftStepDocumentsCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-draft-step-documents`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftStepAiStepActionCreate
   * @request POST:/api/app/template-drafts-extn/update-draft-step-ai-step-action
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftStepAiStepActionCreate = (
    data: MotrJobsKeyValueSequenceVm[],
    query: AppTemplateDraftsExtnUpdateDraftStepAiStepActionCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-draft-step-ai-step-action`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnGetDraftStepDocumentsList
   * @request GET:/api/app/template-drafts-extn/get-draft-step-documents
   * @secure
   */
  appTemplateDraftsExtnGetDraftStepDocumentsList = (
    query: AppTemplateDraftsExtnGetDraftStepDocumentsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentsDocumentDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/get-draft-step-documents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDeleteDraftStepDelete
   * @request DELETE:/api/app/template-drafts-extn/delete-draft-step
   * @secure
   */
  appTemplateDraftsExtnDeleteDraftStepDelete = (
    query: AppTemplateDraftsExtnDeleteDraftStepDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/delete-draft-step`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnGetDraftDocumentPlaceholdersList
   * @request GET:/api/app/template-drafts-extn/get-draft-document-placeholders
   * @secure
   */
  appTemplateDraftsExtnGetDraftDocumentPlaceholdersList = (
    query: AppTemplateDraftsExtnGetDraftDocumentPlaceholdersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/get-draft-document-placeholders`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnUpdateDraftDocumentPlaceholderUpdate
   * @request PUT:/api/app/template-drafts-extn/update-draft-document-placeholder
   * @secure
   */
  appTemplateDraftsExtnUpdateDraftDocumentPlaceholderUpdate = (
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
    query: AppTemplateDraftsExtnUpdateDraftDocumentPlaceholderUpdateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/update-draft-document-placeholder`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnCreateDraftDocumentPlaceholderCreate
   * @request POST:/api/app/template-drafts-extn/create-draft-document-placeholder
   * @secure
   */
  appTemplateDraftsExtnCreateDraftDocumentPlaceholderCreate = (
    data: MotrDocumentPlaceHoldersDocumentPlaceHolderCreateDto,
    query: AppTemplateDraftsExtnCreateDraftDocumentPlaceholderCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrDocumentPlaceHoldersDocumentPlaceHolderDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-drafts-extn/create-draft-document-placeholder`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateDraftExtn
   * @name AppTemplateDraftsExtnDeleteDraftDocumentPlaceholderDelete
   * @request DELETE:/api/app/template-drafts-extn/delete-draft-document-placeholder
   * @secure
   */
  appTemplateDraftsExtnDeleteDraftDocumentPlaceholderDelete = (
    query: AppTemplateDraftsExtnDeleteDraftDocumentPlaceholderDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-drafts-extn/delete-draft-document-placeholder`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnCloneCreate
   * @request POST:/api/app/templates-extn/clone
   * @secure
   */
  appTemplatesExtnCloneCreate = (
    query: AppTemplatesExtnCloneCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/clone`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetTemplateDetailsDetail
   * @request GET:/api/app/templates-extn/get-template-details/{id}
   * @secure
   */
  appTemplatesExtnGetTemplateDetailsDetail = (
    { id, ...query }: AppTemplatesExtnGetTemplateDetailsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateVm,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-template-details/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnSetAsServiceRequestDetail
   * @request GET:/api/app/templates-extn/set-as-service-request/{id}
   * @secure
   */
  appTemplatesExtnSetAsServiceRequestDetail = (
    { id, ...query }: AppTemplatesExtnSetAsServiceRequestDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/set-as-service-request/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnSetAsServiceRequestV2Create
   * @request POST:/api/app/templates-extn/set-as-service-request-v2/{id}
   * @secure
   */
  appTemplatesExtnSetAsServiceRequestV2Create = (
    { id }: AppTemplatesExtnSetAsServiceRequestV2CreateParams,
    data: MotrTemplatesTemplateServiceDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/set-as-service-request-v2/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnServiceRequestWorkgroupsDetail
   * @request GET:/api/app/templates-extn/service-request-workgroups/{id}
   * @secure
   */
  appTemplatesExtnServiceRequestWorkgroupsDetail = (
    { id }: AppTemplatesExtnServiceRequestWorkgroupsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateServiceRequestWorkgroupDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/service-request-workgroups/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnServiceRequestFieldsDetail
   * @request GET:/api/app/templates-extn/service-request-fields/{id}
   * @secure
   */
  appTemplatesExtnServiceRequestFieldsDetail = (
    { id }: AppTemplatesExtnServiceRequestFieldsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesServiceRequestFieldDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/service-request-fields/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnServiceRequestFieldsUpdate
   * @request PUT:/api/app/templates-extn/service-request-fields/{id}
   * @secure
   */
  appTemplatesExtnServiceRequestFieldsUpdate = (
    { id }: AppTemplatesExtnServiceRequestFieldsUpdateParams,
    data: MotrTemplatesUpdateServiceRequestFieldsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesServiceRequestFieldDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/service-request-fields/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnRemoveServiceRequestDetail
   * @request GET:/api/app/templates-extn/remove-service-request/{id}
   * @secure
   */
  appTemplatesExtnRemoveServiceRequestDetail = (
    { id }: AppTemplatesExtnRemoveServiceRequestDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/remove-service-request/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnList
   * @request GET:/api/app/templates-extn
   * @secure
   */
  appTemplatesExtnList = (
    query: AppTemplatesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnCreate
   * @request POST:/api/app/templates-extn
   * @secure
   */
  appTemplatesExtnCreate = (
    data: MotrTemplatesTemplateCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetServiceRequestTemplatesList
   * @request GET:/api/app/templates-extn/get-service-request-templates
   * @secure
   */
  appTemplatesExtnGetServiceRequestTemplatesList = (
    query: AppTemplatesExtnGetServiceRequestTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-service-request-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetTemplateWithStepsList
   * @request GET:/api/app/templates-extn/get-template-with-steps
   * @secure
   */
  appTemplatesExtnGetTemplateWithStepsList = (
    query: AppTemplatesExtnGetTemplateWithStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-template-with-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/templates-extn/with-navigation-properties/{id}
   * @secure
   */
  appTemplatesExtnWithNavigationPropertiesDetail = (
    { id }: AppTemplatesExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnDetail
   * @request GET:/api/app/templates-extn/{id}
   * @secure
   */
  appTemplatesExtnDetail = (
    { id }: AppTemplatesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnUpdate
   * @request PUT:/api/app/templates-extn/{id}
   * @secure
   */
  appTemplatesExtnUpdate = (
    { id }: AppTemplatesExtnUpdateParams,
    data: MotrTemplatesTemplateUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnDelete
   * @request DELETE:/api/app/templates-extn/{id}
   * @secure
   */
  appTemplatesExtnDelete = (
    { id }: AppTemplatesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/templates-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnTemplateTypeLookupList
   * @request GET:/api/app/templates-extn/template-type-lookup
   * @secure
   */
  appTemplatesExtnTemplateTypeLookupList = (
    query: AppTemplatesExtnTemplateTypeLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/template-type-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnUpdateDraftCreate
   * @request POST:/api/app/templates-extn/update-draft
   * @secure
   */
  appTemplatesExtnUpdateDraftCreate = (
    query: AppTemplatesExtnUpdateDraftCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/templates-extn/update-draft`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetTemplatesForOrganizationCreate
   * @request POST:/api/app/templates-extn/get-templates-for-organization
   * @secure
   */
  appTemplatesExtnGetTemplatesForOrganizationCreate = (
    data: MotrTemplatesOrganizationTemplatesRequestModel,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateWithNavigationPropertiesDtoVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-templates-for-organization`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetAllTemplateWithStepsList
   * @request GET:/api/app/templates-extn/get-all-template-with-steps
   * @secure
   */
  appTemplatesExtnGetAllTemplateWithStepsList = (
    query: AppTemplatesExtnGetAllTemplateWithStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-all-template-with-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnPublishTemplateCreate
   * @request POST:/api/app/templates-extn/publish-template
   * @secure
   */
  appTemplatesExtnPublishTemplateCreate = (
    query: AppTemplatesExtnPublishTemplateCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedModelsGenericResponseDataVM1MotrTemplatesTemplateDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/publish-template`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetAllTemplatesList
   * @request GET:/api/app/templates-extn/get-all-templates
   * @secure
   */
  appTemplatesExtnGetAllTemplatesList = (
    query: AppTemplatesExtnGetAllTemplatesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplatesTemplateWithNavPropVmMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-all-templates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetAllTemplatesListList
   * @request GET:/api/app/templates-extn/get-all-templates-list
   * @secure
   */
  appTemplatesExtnGetAllTemplatesListList = (params: RequestParams = {}) =>
    this.request<
      MotrTemplatesTemplateInfoDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-all-templates-list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateExtn
   * @name AppTemplatesExtnGetAllTemplatesListWithJobCountsList
   * @request GET:/api/app/templates-extn/get-all-templates-list-with-job-counts
   * @secure
   */
  appTemplatesExtnGetAllTemplatesListWithJobCountsList = (
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateInfoDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/templates-extn/get-all-templates-list-with-job-counts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateImport
   * @name AppTemplateImportDownloadTemplateCreate
   * @request POST:/api/app/template-import/download-template
   * @secure
   */
  appTemplateImportDownloadTemplateCreate = (params: RequestParams = {}) =>
    this.request<Blob, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-import/download-template`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateImport
   * @name AppTemplateImportValidateCreate
   * @request POST:/api/app/template-import/validate
   * @secure
   */
  appTemplateImportValidateCreate = (
    data: {
      /** @format binary */
      file?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplatesTemplateImportTemplateImportValidationResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-import/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateImport
   * @name AppTemplateImportProcessCreate
   * @request POST:/api/app/template-import/process
   * @secure
   */
  appTemplateImportProcessCreate = (
    data: {
      /** @format binary */
      file?: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-import/process`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsList
   * @request GET:/api/app/template-steps
   * @secure
   */
  appTemplateStepsList = (
    query: AppTemplateStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsCreate
   * @request POST:/api/app/template-steps
   * @secure
   */
  appTemplateStepsCreate = (
    data: MotrTemplateStepsTemplateStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsWithNavigationPropertiesDetail
   * @request GET:/api/app/template-steps/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepsWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsDetail
   * @request GET:/api/app/template-steps/{id}
   * @secure
   */
  appTemplateStepsDetail = (
    { id }: AppTemplateStepsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsUpdate
   * @request PUT:/api/app/template-steps/{id}
   * @secure
   */
  appTemplateStepsUpdate = (
    { id }: AppTemplateStepsUpdateParams,
    data: MotrTemplateStepsTemplateStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsDelete
   * @request DELETE:/api/app/template-steps/{id}
   * @secure
   */
  appTemplateStepsDelete = (
    { id }: AppTemplateStepsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-steps/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStep
   * @name AppTemplateStepsTemplateLookupList
   * @request GET:/api/app/template-steps/template-lookup
   * @secure
   */
  appTemplateStepsTemplateLookupList = (
    query: AppTemplateStepsTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksList
   * @request GET:/api/app/template-step-ai-tasks
   * @secure
   */
  appTemplateStepAiTasksList = (
    query: AppTemplateStepAiTasksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepAiTasksTemplateStepAiTaskWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksCreate
   * @request POST:/api/app/template-step-ai-tasks
   * @secure
   */
  appTemplateStepAiTasksCreate = (
    data: MotrTemplateStepAiTasksTemplateStepAiTaskCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepAiTasksTemplateStepAiTaskDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksDelete
   * @request DELETE:/api/app/template-step-ai-tasks
   * @secure
   */
  appTemplateStepAiTasksDelete = (
    query: AppTemplateStepAiTasksDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-ai-tasks`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksWithNavigationPropertiesDetail
   * @request GET:/api/app/template-step-ai-tasks/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepAiTasksWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepAiTasksWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepAiTasksTemplateStepAiTaskWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksDetail
   * @request GET:/api/app/template-step-ai-tasks/{id}
   * @secure
   */
  appTemplateStepAiTasksDetail = (
    { id }: AppTemplateStepAiTasksDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepAiTasksTemplateStepAiTaskDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksUpdate
   * @request PUT:/api/app/template-step-ai-tasks/{id}
   * @secure
   */
  appTemplateStepAiTasksUpdate = (
    { id }: AppTemplateStepAiTasksUpdateParams,
    data: MotrTemplateStepAiTasksTemplateStepAiTaskUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepAiTasksTemplateStepAiTaskDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksDelete2
   * @request DELETE:/api/app/template-step-ai-tasks/{id}
   * @originalName appTemplateStepAiTasksDelete
   * @duplicate
   * @secure
   */
  appTemplateStepAiTasksDelete2 = (
    { id }: AppTemplateStepAiTasksDelete2Params,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-ai-tasks/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksTemplateStepLookupList
   * @request GET:/api/app/template-step-ai-tasks/template-step-lookup
   * @secure
   */
  appTemplateStepAiTasksTemplateStepLookupList = (
    query: AppTemplateStepAiTasksTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksAiTaskLookupList
   * @request GET:/api/app/template-step-ai-tasks/ai-task-lookup
   * @secure
   */
  appTemplateStepAiTasksAiTaskLookupList = (
    query: AppTemplateStepAiTasksAiTaskLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/ai-task-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksAsExcelFileList
   * @request GET:/api/app/template-step-ai-tasks/as-excel-file
   * @secure
   */
  appTemplateStepAiTasksAsExcelFileList = (
    query: AppTemplateStepAiTasksAsExcelFileListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-ai-tasks/as-excel-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksDownloadTokenList
   * @request GET:/api/app/template-step-ai-tasks/download-token
   * @secure
   */
  appTemplateStepAiTasksDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-ai-tasks/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepAiTask
   * @name AppTemplateStepAiTasksAllDelete
   * @request DELETE:/api/app/template-step-ai-tasks/all
   * @secure
   */
  appTemplateStepAiTasksAllDelete = (
    query: AppTemplateStepAiTasksAllDeleteParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-ai-tasks/all`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsList
   * @request GET:/api/app/template-step-checklists
   * @secure
   */
  appTemplateStepChecklistsList = (
    query: AppTemplateStepChecklistsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsCreate
   * @request POST:/api/app/template-step-checklists
   * @secure
   */
  appTemplateStepChecklistsCreate = (
    data: MotrTemplateStepChecklistsTemplateStepChecklistCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsWithNavigationPropertiesDetail
   * @request GET:/api/app/template-step-checklists/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepChecklistsWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepChecklistsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsDetail
   * @request GET:/api/app/template-step-checklists/{id}
   * @secure
   */
  appTemplateStepChecklistsDetail = (
    { id }: AppTemplateStepChecklistsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsUpdate
   * @request PUT:/api/app/template-step-checklists/{id}
   * @secure
   */
  appTemplateStepChecklistsUpdate = (
    { id }: AppTemplateStepChecklistsUpdateParams,
    data: MotrTemplateStepChecklistsTemplateStepChecklistUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsDelete
   * @request DELETE:/api/app/template-step-checklists/{id}
   * @secure
   */
  appTemplateStepChecklistsDelete = (
    { id }: AppTemplateStepChecklistsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklists/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklist
   * @name AppTemplateStepChecklistsTemplateStepChecklistGroupLookupList
   * @request GET:/api/app/template-step-checklists/template-step-checklist-group-lookup
   * @secure
   */
  appTemplateStepChecklistsTemplateStepChecklistGroupLookupList = (
    query: AppTemplateStepChecklistsTemplateStepChecklistGroupLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists/template-step-checklist-group-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnList
   * @request GET:/api/app/template-step-checklists-extn
   * @secure
   */
  appTemplateStepChecklistsExtnList = (
    query: AppTemplateStepChecklistsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnCreate
   * @request POST:/api/app/template-step-checklists-extn
   * @secure
   */
  appTemplateStepChecklistsExtnCreate = (
    data: MotrTemplateStepChecklistsTemplateStepChecklistCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/template-step-checklists-extn/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepChecklistsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnDetail
   * @request GET:/api/app/template-step-checklists-extn/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnDetail = (
    { id }: AppTemplateStepChecklistsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnUpdate
   * @request PUT:/api/app/template-step-checklists-extn/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnUpdate = (
    { id }: AppTemplateStepChecklistsExtnUpdateParams,
    data: MotrTemplateStepChecklistsTemplateStepChecklistUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepChecklistDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnDelete
   * @request DELETE:/api/app/template-step-checklists-extn/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnDelete = (
    { id }: AppTemplateStepChecklistsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklists-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnTemplateStepChecklistGroupLookupList
   * @request GET:/api/app/template-step-checklists-extn/template-step-checklist-group-lookup
   * @secure
   */
  appTemplateStepChecklistsExtnTemplateStepChecklistGroupLookupList = (
    query: AppTemplateStepChecklistsExtnTemplateStepChecklistGroupLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn/template-step-checklist-group-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnGetTemplateStepGroupAndItemsDetail
   * @request GET:/api/app/template-step-checklists-extn/get-template-step-group-and-items/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnGetTemplateStepGroupAndItemsDetail = (
    {
      id,
      ...query
    }: AppTemplateStepChecklistsExtnGetTemplateStepGroupAndItemsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistsTemplateStepCheckListGroupAndItems[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklists-extn/get-template-step-group-and-items/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistExtn
   * @name AppTemplateStepChecklistsExtnDeleteChecklistItemDelete
   * @request DELETE:/api/app/template-step-checklists-extn/delete-checklist-item/{id}
   * @secure
   */
  appTemplateStepChecklistsExtnDeleteChecklistItemDelete = (
    {
      id,
      ...query
    }: AppTemplateStepChecklistsExtnDeleteChecklistItemDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklists-extn/delete-checklist-item/${id}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsList
   * @request GET:/api/app/template-step-checklist-groups
   * @secure
   */
  appTemplateStepChecklistGroupsList = (
    query: AppTemplateStepChecklistGroupsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsCreate
   * @request POST:/api/app/template-step-checklist-groups
   * @secure
   */
  appTemplateStepChecklistGroupsCreate = (
    data: MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsWithNavigationPropertiesDetail
   * @request GET:/api/app/template-step-checklist-groups/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepChecklistGroupsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsDetail
   * @request GET:/api/app/template-step-checklist-groups/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsDetail = (
    { id }: AppTemplateStepChecklistGroupsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsUpdate
   * @request PUT:/api/app/template-step-checklist-groups/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsUpdate = (
    { id }: AppTemplateStepChecklistGroupsUpdateParams,
    data: MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsDelete
   * @request DELETE:/api/app/template-step-checklist-groups/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsDelete = (
    { id }: AppTemplateStepChecklistGroupsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklist-groups/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup
   * @name AppTemplateStepChecklistGroupsTemplateStepLookupList
   * @request GET:/api/app/template-step-checklist-groups/template-step-lookup
   * @secure
   */
  appTemplateStepChecklistGroupsTemplateStepLookupList = (
    query: AppTemplateStepChecklistGroupsTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnList
   * @request GET:/api/app/template-step-checklist-groups-extn
   * @secure
   */
  appTemplateStepChecklistGroupsExtnList = (
    query: AppTemplateStepChecklistGroupsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnCreate
   * @request POST:/api/app/template-step-checklist-groups-extn
   * @secure
   */
  appTemplateStepChecklistGroupsExtnCreate = (
    data: MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/template-step-checklist-groups-extn/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsExtnWithNavigationPropertiesDetail = (
    {
      id,
    }: AppTemplateStepChecklistGroupsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnDetail
   * @request GET:/api/app/template-step-checklist-groups-extn/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsExtnDetail = (
    { id }: AppTemplateStepChecklistGroupsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnUpdate
   * @request PUT:/api/app/template-step-checklist-groups-extn/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsExtnUpdate = (
    { id }: AppTemplateStepChecklistGroupsExtnUpdateParams,
    data: MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepChecklistGroupsTemplateStepChecklistGroupDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnDelete
   * @request DELETE:/api/app/template-step-checklist-groups-extn/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsExtnDelete = (
    { id }: AppTemplateStepChecklistGroupsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklist-groups-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnTemplateStepLookupList
   * @request GET:/api/app/template-step-checklist-groups-extn/template-step-lookup
   * @secure
   */
  appTemplateStepChecklistGroupsExtnTemplateStepLookupList = (
    query: AppTemplateStepChecklistGroupsExtnTemplateStepLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-checklist-groups-extn/template-step-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepChecklistGroup-extn
   * @name AppTemplateStepChecklistGroupsExtnDeleteChecklistGroupDelete
   * @request DELETE:/api/app/template-step-checklist-groups-extn/delete-checklist-group/{id}
   * @secure
   */
  appTemplateStepChecklistGroupsExtnDeleteChecklistGroupDelete = (
    {
      id,
      ...query
    }: AppTemplateStepChecklistGroupsExtnDeleteChecklistGroupDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-checklist-groups-extn/delete-checklist-group/${id}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnAiTaskLookupList
   * @request GET:/api/app/template-steps-extn/ai-task-lookup
   * @secure
   */
  appTemplateStepsExtnAiTaskLookupList = (
    query: AppTemplateStepsExtnAiTaskLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/ai-task-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnGetTemplateListList
   * @request GET:/api/app/template-steps-extn/get-template-list
   * @secure
   */
  appTemplateStepsExtnGetTemplateListList = (
    query: AppTemplateStepsExtnGetTemplateListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/get-template-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnWithNavigationPropertiesDetail
   * @request GET:/api/app/template-steps-extn/with-navigation-properties/{id}
   * @secure
   */
  appTemplateStepsExtnWithNavigationPropertiesDetail = (
    { id }: AppTemplateStepsExtnWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnDetail
   * @request GET:/api/app/template-steps-extn/{id}
   * @secure
   */
  appTemplateStepsExtnDetail = (
    { id }: AppTemplateStepsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnUpdate
   * @request PUT:/api/app/template-steps-extn/{id}
   * @secure
   */
  appTemplateStepsExtnUpdate = (
    { id }: AppTemplateStepsExtnUpdateParams,
    data: MotrTemplateStepsTemplateStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnDelete
   * @request DELETE:/api/app/template-steps-extn/{id}
   * @secure
   */
  appTemplateStepsExtnDelete = (
    { id }: AppTemplateStepsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-steps-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnGetTemplateStepList
   * @request GET:/api/app/template-steps-extn/get-template-step
   * @secure
   */
  appTemplateStepsExtnGetTemplateStepList = (
    query: AppTemplateStepsExtnGetTemplateStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/get-template-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnTemplateLookupList
   * @request GET:/api/app/template-steps-extn/template-lookup
   * @secure
   */
  appTemplateStepsExtnTemplateLookupList = (
    query: AppTemplateStepsExtnTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnCreate
   * @request POST:/api/app/template-steps-extn
   * @secure
   */
  appTemplateStepsExtnCreate = (
    data: MotrTemplateStepsTemplateStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnGetOrgMemebersList
   * @request GET:/api/app/template-steps-extn/get-org-memebers
   * @secure
   */
  appTemplateStepsExtnGetOrgMemebersList = (
    query: AppTemplateStepsExtnGetOrgMemebersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepOrgUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/get-org-memebers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnGetAllStepsList
   * @request GET:/api/app/template-steps-extn/get-all-steps
   * @secure
   */
  appTemplateStepsExtnGetAllStepsList = (
    query: AppTemplateStepsExtnGetAllStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/get-all-steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnStepApproversDetail
   * @request GET:/api/app/template-steps-extn/step-approvers/{templateStepId}
   * @secure
   */
  appTemplateStepsExtnStepApproversDetail = (
    { templateStepId }: AppTemplateStepsExtnStepApproversDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsTemplateStepApproverDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/step-approvers/${templateStepId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnStepApproversCreate
   * @request POST:/api/app/template-steps-extn/step-approvers/{templateStepId}
   * @secure
   */
  appTemplateStepsExtnStepApproversCreate = (
    { templateStepId }: AppTemplateStepsExtnStepApproversCreateParams,
    data: MotrJobStepApprovalsCreateTemplateStepApproverDto[],
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsTemplateStepApproverDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-steps-extn/step-approvers/${templateStepId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepsExtnStepApprovalSettingsUpdate
   * @request PUT:/api/app/template-steps-extn/step-approval-settings/{templateStepId}
   * @secure
   */
  appTemplateStepsExtnStepApprovalSettingsUpdate = (
    { templateStepId }: AppTemplateStepsExtnStepApprovalSettingsUpdateParams,
    data: MotrJobStepApprovalsUpdateStepApprovalSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-steps-extn/step-approval-settings/${templateStepId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnAiTaskLookupList
   * @request GET:/api/app/template-step-extn/ai-task-lookup
   * @secure
   */
  appTemplateStepExtnAiTaskLookupList = (
    query: AppTemplateStepExtnAiTaskLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/ai-task-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnOrgUnitAndMembersList
   * @request GET:/api/app/template-step-extn/org-unit-and-members
   * @secure
   */
  appTemplateStepExtnOrgUnitAndMembersList = (
    query: AppTemplateStepExtnOrgUnitAndMembersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepOrgUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/org-unit-and-members`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnList
   * @request GET:/api/app/template-step-extn
   * @secure
   */
  appTemplateStepExtnList = (
    query: AppTemplateStepExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnCreate
   * @request POST:/api/app/template-step-extn
   * @secure
   */
  appTemplateStepExtnCreate = (
    data: MotrTemplateStepsTemplateStepCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnStepsList
   * @request GET:/api/app/template-step-extn/steps
   * @secure
   */
  appTemplateStepExtnStepsList = (
    query: AppTemplateStepExtnStepsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateStepsTemplateStepWithNavigationPropertiesDtoVMMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/steps`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnWithNavigationPropertiesList
   * @request GET:/api/app/template-step-extn/{id}/with-navigation-properties
   * @secure
   */
  appTemplateStepExtnWithNavigationPropertiesList = (
    { id }: AppTemplateStepExtnWithNavigationPropertiesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/${id}/with-navigation-properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnDetail
   * @request GET:/api/app/template-step-extn/{id}
   * @secure
   */
  appTemplateStepExtnDetail = (
    { id }: AppTemplateStepExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnDelete
   * @request DELETE:/api/app/template-step-extn/{id}
   * @secure
   */
  appTemplateStepExtnDelete = (
    { id }: AppTemplateStepExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnUpdate
   * @request PUT:/api/app/template-step-extn/{id}
   * @secure
   */
  appTemplateStepExtnUpdate = (
    { id }: AppTemplateStepExtnUpdateParams,
    data: MotrTemplateStepsTemplateStepUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnTemplateStepList
   * @request GET:/api/app/template-step-extn/template-step
   * @secure
   */
  appTemplateStepExtnTemplateStepList = (
    query: AppTemplateStepExtnTemplateStepListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateStepsTemplateStepDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/template-step`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnTemplateLookupList
   * @request GET:/api/app/template-step-extn/template-lookup
   * @secure
   */
  appTemplateStepExtnTemplateLookupList = (
    query: AppTemplateStepExtnTemplateLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/template-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnStepApproversDetail
   * @request GET:/api/app/template-step-extn/step-approvers/{templateStepId}
   * @secure
   */
  appTemplateStepExtnStepApproversDetail = (
    { templateStepId }: AppTemplateStepExtnStepApproversDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsTemplateStepApproverDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/step-approvers/${templateStepId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnSetStepApproversCreate
   * @request POST:/api/app/template-step-extn/set-step-approvers/{templateStepId}
   * @secure
   */
  appTemplateStepExtnSetStepApproversCreate = (
    { templateStepId }: AppTemplateStepExtnSetStepApproversCreateParams,
    data: MotrJobStepApprovalsCreateTemplateStepApproverDto[],
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobStepApprovalsTemplateStepApproverDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-step-extn/set-step-approvers/${templateStepId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateStepExtn
   * @name AppTemplateStepExtnStepApprovalSettingsUpdate
   * @request PUT:/api/app/template-step-extn/step-approval-settings/{templateStepId}
   * @secure
   */
  appTemplateStepExtnStepApprovalSettingsUpdate = (
    { templateStepId }: AppTemplateStepExtnStepApprovalSettingsUpdateParams,
    data: MotrJobStepApprovalsUpdateStepApprovalSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-step-extn/step-approval-settings/${templateStepId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateType
   * @name AppTemplateTypesList
   * @request GET:/api/app/template-types
   * @secure
   */
  appTemplateTypesList = (
    query: AppTemplateTypesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateTypesTemplateTypeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateType
   * @name AppTemplateTypesCreate
   * @request POST:/api/app/template-types
   * @secure
   */
  appTemplateTypesCreate = (
    data: MotrTemplateTypesTemplateTypeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateType
   * @name AppTemplateTypesDetail
   * @request GET:/api/app/template-types/{id}
   * @secure
   */
  appTemplateTypesDetail = (
    { id }: AppTemplateTypesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateType
   * @name AppTemplateTypesUpdate
   * @request PUT:/api/app/template-types/{id}
   * @secure
   */
  appTemplateTypesUpdate = (
    { id }: AppTemplateTypesUpdateParams,
    data: MotrTemplateTypesTemplateTypeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateType
   * @name AppTemplateTypesDelete
   * @request DELETE:/api/app/template-types/{id}
   * @secure
   */
  appTemplateTypesDelete = (
    { id }: AppTemplateTypesDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-types/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateTypeExtn
   * @name AppTemplateTypesExtnList
   * @request GET:/api/app/template-types-extn
   * @secure
   */
  appTemplateTypesExtnList = (
    query: AppTemplateTypesExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrTemplateTypesTemplateTypeDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateTypeExtn
   * @name AppTemplateTypesExtnCreate
   * @request POST:/api/app/template-types-extn
   * @secure
   */
  appTemplateTypesExtnCreate = (
    data: MotrTemplateTypesTemplateTypeCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateTypeExtn
   * @name AppTemplateTypesExtnDetail
   * @request GET:/api/app/template-types-extn/{id}
   * @secure
   */
  appTemplateTypesExtnDetail = (
    { id }: AppTemplateTypesExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateTypeExtn
   * @name AppTemplateTypesExtnUpdate
   * @request PUT:/api/app/template-types-extn/{id}
   * @secure
   */
  appTemplateTypesExtnUpdate = (
    { id }: AppTemplateTypesExtnUpdateParams,
    data: MotrTemplateTypesTemplateTypeUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrTemplateTypesTemplateTypeDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/template-types-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TemplateTypeExtn
   * @name AppTemplateTypesExtnDelete
   * @request DELETE:/api/app/template-types-extn/{id}
   * @secure
   */
  appTemplateTypesExtnDelete = (
    { id }: AppTemplateTypesExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/template-types-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsDetail
   * @request GET:/api/saas/tenants/{id}
   * @secure
   */
  saasTenantsDetail = (
    { id }: SaasTenantsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosSaasTenantDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsUpdate
   * @request PUT:/api/saas/tenants/{id}
   * @secure
   */
  saasTenantsUpdate = (
    { id }: SaasTenantsUpdateParams,
    data: VoloSaasHostDtosSaasTenantUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosSaasTenantDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsDelete
   * @request DELETE:/api/saas/tenants/{id}
   * @secure
   */
  saasTenantsDelete = (
    { id }: SaasTenantsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/tenants/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsList
   * @request GET:/api/saas/tenants
   * @secure
   */
  saasTenantsList = (
    query: SaasTenantsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloSaasHostDtosSaasTenantDtoVoloSaasHostApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsCreate
   * @request POST:/api/saas/tenants
   * @secure
   */
  saasTenantsCreate = (
    data: VoloSaasHostDtosSaasTenantCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosSaasTenantDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsDatabasesList
   * @request GET:/api/saas/tenants/databases
   * @secure
   */
  saasTenantsDatabasesList = (params: RequestParams = {}) =>
    this.request<
      VoloSaasHostDtosSaasTenantDatabasesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants/databases`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsConnectionStringsList
   * @request GET:/api/saas/tenants/{id}/connection-strings
   * @secure
   */
  saasTenantsConnectionStringsList = (
    { id }: SaasTenantsConnectionStringsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloSaasHostDtosSaasTenantConnectionStringsDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants/${id}/connection-strings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsConnectionStringsUpdate
   * @request PUT:/api/saas/tenants/{id}/connection-strings
   * @secure
   */
  saasTenantsConnectionStringsUpdate = (
    { id }: SaasTenantsConnectionStringsUpdateParams,
    data: VoloSaasHostDtosSaasTenantConnectionStringsDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/tenants/${id}/connection-strings`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsApplyDatabaseMigrationsCreate
   * @request POST:/api/saas/tenants/{id}/apply-database-migrations
   * @secure
   */
  saasTenantsApplyDatabaseMigrationsCreate = (
    { id }: SaasTenantsApplyDatabaseMigrationsCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/tenants/${id}/apply-database-migrations`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsLookupEditionsList
   * @request GET:/api/saas/tenants/lookup/editions
   * @secure
   */
  saasTenantsLookupEditionsList = (params: RequestParams = {}) =>
    this.request<
      VoloSaasHostDtosEditionLookupDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/saas/tenants/lookup/editions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsCheckConnectionStringList
   * @request GET:/api/saas/tenants/check-connection-string
   * @secure
   */
  saasTenantsCheckConnectionStringList = (
    query: SaasTenantsCheckConnectionStringListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/tenants/check-connection-string`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name SaasTenantsSetPasswordUpdate
   * @request PUT:/api/saas/tenants/{id}/set-password
   * @secure
   */
  saasTenantsSetPasswordUpdate = (
    { id }: SaasTenantsSetPasswordUpdateParams,
    data: VoloSaasHostDtosSaasTenantSetPasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/saas/tenants/${id}/set-password`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsAvailableHostPacksList
   * @request GET:/api/app/tenant-pack-enablements/available-host-packs
   * @secure
   */
  appTenantPackEnablementsAvailableHostPacksList = (
    query: AppTenantPackEnablementsAvailableHostPacksListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsHostPackSummaryDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/available-host-packs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsEnableCreate
   * @request POST:/api/app/tenant-pack-enablements/{packId}/enable
   * @secure
   */
  appTenantPackEnablementsEnableCreate = (
    { packId }: AppTenantPackEnablementsEnableCreateParams,
    data: MotrSkillsEnablePackInputDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/${packId}/enable`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsUpdateToLatestCreate
   * @request POST:/api/app/tenant-pack-enablements/{packId}/update-to-latest
   * @secure
   */
  appTenantPackEnablementsUpdateToLatestCreate = (
    { packId }: AppTenantPackEnablementsUpdateToLatestCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/${packId}/update-to-latest`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsDisableCreate
   * @request POST:/api/app/tenant-pack-enablements/{packId}/disable
   * @secure
   */
  appTenantPackEnablementsDisableCreate = (
    { packId }: AppTenantPackEnablementsDisableCreateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tenant-pack-enablements/${packId}/disable`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsByPackList
   * @request GET:/api/app/tenant-pack-enablements/by-pack
   * @secure
   */
  appTenantPackEnablementsByPackList = (
    query: AppTenantPackEnablementsByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsTenantPackEnablementDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsDetailedByPackList
   * @request GET:/api/app/tenant-pack-enablements/detailed/by-pack
   * @secure
   */
  appTenantPackEnablementsDetailedByPackList = (
    query: AppTenantPackEnablementsDetailedByPackListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsTenantPackEnablementWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/detailed/by-pack`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsList
   * @request GET:/api/app/tenant-pack-enablements
   * @secure
   */
  appTenantPackEnablementsList = (
    query: AppTenantPackEnablementsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSkillsTenantPackEnablementWithNavigationPropertiesDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsCreate
   * @request POST:/api/app/tenant-pack-enablements
   * @secure
   */
  appTenantPackEnablementsCreate = (
    data: MotrSkillsTenantPackEnablementCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsWithNavigationPropertiesDetail
   * @request GET:/api/app/tenant-pack-enablements/with-navigation-properties/{id}
   * @secure
   */
  appTenantPackEnablementsWithNavigationPropertiesDetail = (
    { id }: AppTenantPackEnablementsWithNavigationPropertiesDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementWithNavigationPropertiesDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/with-navigation-properties/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsDetail
   * @request GET:/api/app/tenant-pack-enablements/{id}
   * @secure
   */
  appTenantPackEnablementsDetail = (
    { id }: AppTenantPackEnablementsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsUpdate
   * @request PUT:/api/app/tenant-pack-enablements/{id}
   * @secure
   */
  appTenantPackEnablementsUpdate = (
    { id }: AppTenantPackEnablementsUpdateParams,
    data: MotrSkillsTenantPackEnablementUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSkillsTenantPackEnablementDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsDelete
   * @request DELETE:/api/app/tenant-pack-enablements/{id}
   * @secure
   */
  appTenantPackEnablementsDelete = (
    { id }: AppTenantPackEnablementsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/tenant-pack-enablements/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsPackLookupList
   * @request GET:/api/app/tenant-pack-enablements/pack-lookup
   * @secure
   */
  appTenantPackEnablementsPackLookupList = (
    query: AppTenantPackEnablementsPackLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/pack-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TenantPackEnablement
   * @name AppTenantPackEnablementsPackVersionLookupList
   * @request GET:/api/app/tenant-pack-enablements/pack-version-lookup
   * @secure
   */
  appTenantPackEnablementsPackVersionLookupList = (
    query: AppTenantPackEnablementsPackVersionLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedLookupDto1SystemGuidSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798EMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/tenant-pack-enablements/pack-version-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TextTemplateContents
   * @name TextTemplateManagementTemplateContentsList
   * @request GET:/api/text-template-management/template-contents
   * @secure
   */
  textTemplateManagementTemplateContentsList = (
    query: TextTemplateManagementTemplateContentsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpTextTemplateManagementTextTemplatesTextTemplateContentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/text-template-management/template-contents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TextTemplateContents
   * @name TextTemplateManagementTemplateContentsUpdate
   * @request PUT:/api/text-template-management/template-contents
   * @secure
   */
  textTemplateManagementTemplateContentsUpdate = (
    data: VoloAbpTextTemplateManagementTextTemplatesUpdateTemplateContentInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpTextTemplateManagementTextTemplatesTextTemplateContentDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/text-template-management/template-contents`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TextTemplateContents
   * @name TextTemplateManagementTemplateContentsRestoreToDefaultUpdate
   * @request PUT:/api/text-template-management/template-contents/restore-to-default
   * @secure
   */
  textTemplateManagementTemplateContentsRestoreToDefaultUpdate = (
    data: VoloAbpTextTemplateManagementTextTemplatesRestoreTemplateContentInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/text-template-management/template-contents/restore-to-default`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags TextTemplateDefinitions
   * @name TextTemplateManagementTemplateDefinitionsList
   * @request GET:/api/text-template-management/template-definitions
   * @secure
   */
  textTemplateManagementTemplateDefinitionsList = (
    query: TextTemplateManagementTemplateDefinitionsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpTextTemplateManagementTextTemplatesTemplateDefinitionDtoVoloAbpTextTemplateManagementApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/text-template-management/template-definitions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TextTemplateDefinitions
   * @name TextTemplateManagementTemplateDefinitionsDetail
   * @request GET:/api/text-template-management/template-definitions/{name}
   * @secure
   */
  textTemplateManagementTemplateDefinitionsDetail = (
    { name }: TextTemplateManagementTemplateDefinitionsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpTextTemplateManagementTextTemplatesTemplateDefinitionDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/text-template-management/template-definitions/${name}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeZoneSettings
   * @name SettingManagementTimezoneList
   * @request GET:/api/setting-management/timezone
   * @secure
   */
  settingManagementTimezoneList = (params: RequestParams = {}) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/setting-management/timezone`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeZoneSettings
   * @name SettingManagementTimezoneCreate
   * @request POST:/api/setting-management/timezone
   * @secure
   */
  settingManagementTimezoneCreate = (
    query: SettingManagementTimezoneCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/setting-management/timezone`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags TimeZoneSettings
   * @name SettingManagementTimezoneTimezonesList
   * @request GET:/api/setting-management/timezone/timezones
   * @secure
   */
  settingManagementTimezoneTimezonesList = (params: RequestParams = {}) =>
    this.request<VoloAbpNameValue[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/setting-management/timezone/timezones`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersDetail
   * @request GET:/api/identity/users/{id}
   * @secure
   */
  identityUsersDetail = (
    { id }: IdentityUsersDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersUpdate
   * @request PUT:/api/identity/users/{id}
   * @secure
   */
  identityUsersUpdate = (
    { id }: IdentityUsersUpdateParams,
    data: VoloAbpIdentityIdentityUserUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersDelete
   * @request DELETE:/api/identity/users/{id}
   * @secure
   */
  identityUsersDelete = (
    { id }: IdentityUsersDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersList
   * @request GET:/api/identity/users
   * @secure
   */
  identityUsersList = (
    query: IdentityUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1VoloAbpIdentityIdentityUserDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersCreate
   * @request POST:/api/identity/users
   * @secure
   */
  identityUsersCreate = (
    data: VoloAbpIdentityIdentityUserCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersByIdDetail
   * @request GET:/api/identity/users/by-id/{id}
   * @secure
   */
  identityUsersByIdDetail = (
    { id }: IdentityUsersByIdDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/by-id/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersRolesList
   * @request GET:/api/identity/users/{id}/roles
   * @secure
   */
  identityUsersRolesList = (
    { id }: IdentityUsersRolesListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/${id}/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersRolesUpdate
   * @request PUT:/api/identity/users/{id}/roles
   * @secure
   */
  identityUsersRolesUpdate = (
    { id }: IdentityUsersRolesUpdateParams,
    data: VoloAbpIdentityIdentityUserUpdateRolesDto,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/roles`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersAssignableRolesList
   * @request GET:/api/identity/users/assignable-roles
   * @secure
   */
  identityUsersAssignableRolesList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityIdentityRoleDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/assignable-roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersAvailableOrganizationUnitsList
   * @request GET:/api/identity/users/available-organization-units
   * @secure
   */
  identityUsersAvailableOrganizationUnitsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpIdentityOrganizationUnitWithDetailsDtoVoloAbpIdentityProApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/available-organization-units`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersAllClaimTypesList
   * @request GET:/api/identity/users/all-claim-types
   * @secure
   */
  identityUsersAllClaimTypesList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityClaimTypeDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/all-claim-types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersClaimsList
   * @request GET:/api/identity/users/{id}/claims
   * @secure
   */
  identityUsersClaimsList = (
    { id }: IdentityUsersClaimsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserClaimDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/${id}/claims`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersClaimsUpdate
   * @request PUT:/api/identity/users/{id}/claims
   * @secure
   */
  identityUsersClaimsUpdate = (
    { id }: IdentityUsersClaimsUpdateParams,
    data: VoloAbpIdentityIdentityUserClaimDto[],
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/claims`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersOrganizationUnitsList
   * @request GET:/api/identity/users/{id}/organization-units
   * @secure
   */
  identityUsersOrganizationUnitsList = (
    { id }: IdentityUsersOrganizationUnitsListParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/${id}/organization-units`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersLockUpdate
   * @request PUT:/api/identity/users/{id}/lock/{lockoutEnd}
   * @secure
   */
  identityUsersLockUpdate = (
    { id, lockoutEnd }: IdentityUsersLockUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/lock/${lockoutEnd}`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersUnlockUpdate
   * @request PUT:/api/identity/users/{id}/unlock
   * @secure
   */
  identityUsersUnlockUpdate = (
    { id }: IdentityUsersUnlockUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/unlock`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersByUsernameDetail
   * @request GET:/api/identity/users/by-username/{username}
   * @secure
   */
  identityUsersByUsernameDetail = (
    { username }: IdentityUsersByUsernameDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/by-username/${username}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersByEmailDetail
   * @request GET:/api/identity/users/by-email/{email}
   * @secure
   */
  identityUsersByEmailDetail = (
    { email }: IdentityUsersByEmailDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/by-email/${email}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersTwoFactorEnabledList
   * @request GET:/api/identity/users/{id}/two-factor-enabled
   * @secure
   */
  identityUsersTwoFactorEnabledList = (
    { id }: IdentityUsersTwoFactorEnabledListParams,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/two-factor-enabled`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersTwoFactorUpdate
   * @request PUT:/api/identity/users/{id}/two-factor/{enabled}
   * @secure
   */
  identityUsersTwoFactorUpdate = (
    { id, enabled }: IdentityUsersTwoFactorUpdateParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/two-factor/${enabled}`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersChangePasswordUpdate
   * @request PUT:/api/identity/users/{id}/change-password
   * @secure
   */
  identityUsersChangePasswordUpdate = (
    { id }: IdentityUsersChangePasswordUpdateParams,
    data: VoloAbpIdentityIdentityUserUpdatePasswordInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/${id}/change-password`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersLookupRolesList
   * @request GET:/api/identity/users/lookup/roles
   * @secure
   */
  identityUsersLookupRolesList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityIdentityRoleLookupDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/lookup/roles`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersLookupOrganizationUnitsList
   * @request GET:/api/identity/users/lookup/organization-units
   * @secure
   */
  identityUsersLookupOrganizationUnitsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityOrganizationUnitLookupDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/lookup/organization-units`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersExternalLoginProvidersList
   * @request GET:/api/identity/users/external-login-Providers
   * @secure
   */
  identityUsersExternalLoginProvidersList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityExternalLoginProviderDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/external-login-Providers`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersImportExternalUserCreate
   * @request POST:/api/identity/users/import-external-user
   * @secure
   */
  identityUsersImportExternalUserCreate = (
    data: VoloAbpIdentityImportExternalUserInput,
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/import-external-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersExportAsExcelList
   * @request GET:/api/identity/users/export-as-excel
   * @secure
   */
  identityUsersExportAsExcelList = (
    query: IdentityUsersExportAsExcelListParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/export-as-excel`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersExportAsCsvList
   * @request GET:/api/identity/users/export-as-csv
   * @secure
   */
  identityUsersExportAsCsvList = (
    query: IdentityUsersExportAsCsvListParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/export-as-csv`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersDownloadTokenList
   * @request GET:/api/identity/users/download-token
   * @secure
   */
  identityUsersDownloadTokenList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityDownloadTokenResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/download-token`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersImportUsersSampleFileList
   * @request GET:/api/identity/users/import-users-sample-file
   * @secure
   */
  identityUsersImportUsersSampleFileList = (
    query: IdentityUsersImportUsersSampleFileListParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/import-users-sample-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersImportUsersFromFileCreate
   * @request POST:/api/identity/users/import-users-from-file
   * @secure
   */
  identityUsersImportUsersFromFileCreate = (
    data: {
      /** @format binary */
      File?: File;
    },
    query: IdentityUsersImportUsersFromFileCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityImportUsersFromFileOutput,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/import-users-from-file`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name IdentityUsersDownloadImportInvalidUsersFileList
   * @request GET:/api/identity/users/download-import-invalid-users-file
   * @secure
   */
  identityUsersDownloadImportInvalidUsersFileList = (
    query: IdentityUsersDownloadImportInvalidUsersFileListParams,
    params: RequestParams = {},
  ) =>
    this.request<File, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/download-import-invalid-users-file`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserLinkCreate
   * @request POST:/api/account/link-user/link
   * @secure
   */
  accountLinkUserLinkCreate = (
    data: VoloAbpAccountLinkUserInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/link`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserUnlinkCreate
   * @request POST:/api/account/link-user/unlink
   * @secure
   */
  accountLinkUserUnlinkCreate = (
    data: VoloAbpAccountUnLinkUserInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/unlink`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserIsLinkedCreate
   * @request POST:/api/account/link-user/is-linked
   * @secure
   */
  accountLinkUserIsLinkedCreate = (
    data: VoloAbpAccountIsLinkedInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/is-linked`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserGenerateLinkTokenCreate
   * @request POST:/api/account/link-user/generate-link-token
   * @secure
   */
  accountLinkUserGenerateLinkTokenCreate = (params: RequestParams = {}) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/generate-link-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserVerifyLinkTokenCreate
   * @request POST:/api/account/link-user/verify-link-token
   * @secure
   */
  accountLinkUserVerifyLinkTokenCreate = (
    data: VoloAbpAccountVerifyLinkTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/verify-link-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserGenerateLinkLoginTokenCreate
   * @request POST:/api/account/link-user/generate-link-login-token
   * @secure
   */
  accountLinkUserGenerateLinkLoginTokenCreate = (params: RequestParams = {}) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/generate-link-login-token`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserVerifyLinkLoginTokenCreate
   * @request POST:/api/account/link-user/verify-link-login-token
   * @secure
   */
  accountLinkUserVerifyLinkLoginTokenCreate = (
    data: VoloAbpAccountVerifyLinkLoginTokenInput,
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/link-user/verify-link-login-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountLinkUserList
   * @request GET:/api/account/link-user
   * @secure
   */
  accountLinkUserList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpAccountLinkUserDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/link-user`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationDelegatedUsersList
   * @request GET:/api/account/user-delegation/delegated-users
   * @secure
   */
  accountUserDelegationDelegatedUsersList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserDelegationDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/user-delegation/delegated-users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationMyDelegatedUsersList
   * @request GET:/api/account/user-delegation/my-delegated-users
   * @secure
   */
  accountUserDelegationMyDelegatedUsersList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserDelegationDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/user-delegation/my-delegated-users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationActiveDelegationsList
   * @request GET:/api/account/user-delegation/active-delegations
   * @secure
   */
  accountUserDelegationActiveDelegationsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserDelegationDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/user-delegation/active-delegations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationUserLookupList
   * @request GET:/api/account/user-delegation/user-lookup
   * @secure
   */
  accountUserDelegationUserLookupList = (
    query: AccountUserDelegationUserLookupListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpAccountUserLookupDtoVoloAbpAccountProPublicApplicationContractsVersion8140CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/account/user-delegation/user-lookup`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationDelegateNewUserCreate
   * @request POST:/api/account/user-delegation/delegate-new-user
   * @secure
   */
  accountUserDelegationDelegateNewUserCreate = (
    data: VoloAbpAccountDelegateNewUserInput,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/user-delegation/delegate-new-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AccountUserDelegationDeleteDelegationCreate
   * @request POST:/api/account/user-delegation/delete-delegation
   * @secure
   */
  accountUserDelegationDeleteDelegationCreate = (
    query: AccountUserDelegationDeleteDelegationCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/account/user-delegation/delete-delegation`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLog
   * @name AppUserEnrollmentLogsList
   * @request GET:/api/app/user-enrollment-logs
   * @secure
   */
  appUserEnrollmentLogsList = (
    query: AppUserEnrollmentLogsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrUserEnrollmentLogsUserEnrollmentLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLog
   * @name AppUserEnrollmentLogsCreate
   * @request POST:/api/app/user-enrollment-logs
   * @secure
   */
  appUserEnrollmentLogsCreate = (
    data: MotrUserEnrollmentLogsUserEnrollmentLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLog
   * @name AppUserEnrollmentLogsDetail
   * @request GET:/api/app/user-enrollment-logs/{id}
   * @secure
   */
  appUserEnrollmentLogsDetail = (
    { id }: AppUserEnrollmentLogsDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLog
   * @name AppUserEnrollmentLogsUpdate
   * @request PUT:/api/app/user-enrollment-logs/{id}
   * @secure
   */
  appUserEnrollmentLogsUpdate = (
    { id }: AppUserEnrollmentLogsUpdateParams,
    data: MotrUserEnrollmentLogsUserEnrollmentLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLog
   * @name AppUserEnrollmentLogsDelete
   * @request DELETE:/api/app/user-enrollment-logs/{id}
   * @secure
   */
  appUserEnrollmentLogsDelete = (
    { id }: AppUserEnrollmentLogsDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-enrollment-logs/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnList
   * @request GET:/api/app/user-enrollment-logs-extn
   * @secure
   */
  appUserEnrollmentLogsExtnList = (
    query: AppUserEnrollmentLogsExtnListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrUserEnrollmentLogsUserEnrollmentLogDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs-extn`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnCreate
   * @request POST:/api/app/user-enrollment-logs-extn
   * @secure
   */
  appUserEnrollmentLogsExtnCreate = (
    data: MotrUserEnrollmentLogsUserEnrollmentLogCreateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs-extn`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnDetail
   * @request GET:/api/app/user-enrollment-logs-extn/{id}
   * @secure
   */
  appUserEnrollmentLogsExtnDetail = (
    { id }: AppUserEnrollmentLogsExtnDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs-extn/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnUpdate
   * @request PUT:/api/app/user-enrollment-logs-extn/{id}
   * @secure
   */
  appUserEnrollmentLogsExtnUpdate = (
    { id }: AppUserEnrollmentLogsExtnUpdateParams,
    data: MotrUserEnrollmentLogsUserEnrollmentLogUpdateDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUserEnrollmentLogsUserEnrollmentLogDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs-extn/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnDelete
   * @request DELETE:/api/app/user-enrollment-logs-extn/{id}
   * @secure
   */
  appUserEnrollmentLogsExtnDelete = (
    { id }: AppUserEnrollmentLogsExtnDeleteParams,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-enrollment-logs-extn/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnEnrollUserCreate
   * @request POST:/api/app/user-enrollment-logs-extn/enroll-user
   * @secure
   */
  appUserEnrollmentLogsExtnEnrollUserCreate = (
    data: MotrJobsEnrollUserRequestVm,
    params: RequestParams = {},
  ) =>
    this.request<MotrResponseMessage, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-enrollment-logs-extn/enroll-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserEnrollmentLogExtn
   * @name AppUserEnrollmentLogsExtnGetJobAndTemplatesCreate
   * @request POST:/api/app/user-enrollment-logs-extn/get-job-and-templates
   * @secure
   */
  appUserEnrollmentLogsExtnGetJobAndTemplatesCreate = (
    data: MotrJobsGetJobsWithNavigationPropertiesRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsJobWithNavigationPropertiesVm,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-enrollment-logs-extn/get-job-and-templates`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserAccountExtVerifyUserAccountList
   * @request GET:/api/app/user-account-ext/verify-user-account
   * @secure
   */
  appUserAccountExtVerifyUserAccountList = (
    query: AppUserAccountExtVerifyUserAccountListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<boolean, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-account-ext/verify-user-account`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetListAsyncList
   * @request GET:/api/app/user-ext/GetListAsync
   * @secure
   */
  appUserExtGetListAsyncList = (
    query: AppUserExtGetListAsyncListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosPagedResultDto1MotrSharedUserExtDtoMotrApplicationContractsVersion1000CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/GetListAsync`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtUsersListList
   * @request GET:/api/app/user-ext/users-list
   * @secure
   */
  appUserExtUsersListList = (
    query: AppUserExtUsersListListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrSharedUserDto[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/users-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtAllUsersList
   * @request GET:/api/app/user-ext/all-users
   * @secure
   */
  appUserExtAllUsersList = (params: RequestParams = {}) =>
    this.request<MotrSharedUserExtDto[], VoloAbpHttpRemoteServiceErrorResponse>(
      {
        path: `/api/app/user-ext/all-users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetAllOrgunitsList
   * @request GET:/api/app/user-ext/get-all-orgunits
   * @secure
   */
  appUserExtGetAllOrgunitsList = (params: RequestParams = {}) =>
    this.request<
      VoloAbpIdentityOrganizationUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-all-orgunits`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetWorkgroupUsersList
   * @request GET:/api/app/user-ext/get-workgroup-users
   * @secure
   */
  appUserExtGetWorkgroupUsersList = (
    query: AppUserExtGetWorkgroupUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkGroupUserResponseVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-workgroup-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetWorkgroupChildUsersList
   * @request GET:/api/app/user-ext/get-workgroup-child-users
   * @secure
   */
  appUserExtGetWorkgroupChildUsersList = (
    query: AppUserExtGetWorkgroupChildUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkGroupUserResponseVm[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-workgroup-child-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetProfilePicsList
   * @request GET:/api/app/user-ext/get-profile-pics
   * @secure
   */
  appUserExtGetProfilePicsList = (
    query: AppUserExtGetProfilePicsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<Blob[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/get-profile-pics`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUsernamesList
   * @request GET:/api/app/user-ext/get-usernames
   * @secure
   */
  appUserExtGetUsernamesList = (
    query: AppUserExtGetUsernamesListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityIdentityUserDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-usernames`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUserList
   * @request GET:/api/app/user-ext/get-user
   * @secure
   */
  appUserExtGetUserList = (
    query: AppUserExtGetUserListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrSharedUserDto, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/get-user`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUserOrgunitsList
   * @request GET:/api/app/user-ext/get-user-orgunits
   * @secure
   */
  appUserExtGetUserOrgunitsList = (
    query: AppUserExtGetUserOrgunitsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-user-orgunits`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetMyJobsList
   * @request GET:/api/app/user-ext/get-my-jobs
   * @secure
   */
  appUserExtGetMyJobsList = (params: RequestParams = {}) =>
    this.request<MotrJobsMyJobDto[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/get-my-jobs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetOrgunitUsersList
   * @request GET:/api/app/user-ext/get-orgunit-users
   * @secure
   */
  appUserExtGetOrgunitUsersList = (
    query: AppUserExtGetOrgunitUsersListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsWorkGroupUserDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-orgunit-users`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetOrgunitsList
   * @request GET:/api/app/user-ext/get-orgunits
   * @secure
   */
  appUserExtGetOrgunitsList = (
    query: AppUserExtGetOrgunitsListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpIdentityOrganizationUnitDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/get-orgunits`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUsersByRoleList
   * @request GET:/api/app/user-ext/get-users-by-role
   * @secure
   */
  appUserExtGetUsersByRoleList = (
    query: AppUserExtGetUsersByRoleListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrSharedUserDto[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/get-users-by-role`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetOrgUnitsAndUsersAsyncList
   * @request GET:/api/app/user-ext/GetOrgUnitsAndUsersAsync
   * @secure
   */
  appUserExtGetOrgUnitsAndUsersAsyncList = (params: RequestParams = {}) =>
    this.request<
      MotrSharedOrganizationUnitAndUserDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/GetOrgUnitsAndUsersAsync`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtImportTemplateList
   * @request GET:/api/app/user-ext/import-template
   * @secure
   */
  appUserExtImportTemplateList = (params: RequestParams = {}) =>
    this.request<any, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/import-template`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtValidateImportCreate
   * @request POST:/api/app/user-ext/validate-import
   * @secure
   */
  appUserExtValidateImportCreate = (
    data: MotrUsersValidateUserImportInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUsersUserImportValidationResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/validate-import`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtImportUsersCreate
   * @request POST:/api/app/user-ext/import-users
   * @secure
   */
  appUserExtImportUsersCreate = (
    data: MotrUsersExecuteUserImportInput,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrUsersUserImportResultDto,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/import-users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUsersByEmailsAsyncList
   * @request GET:/api/app/user-ext/GetUsersByEmailsAsync
   * @secure
   */
  appUserExtGetUsersByEmailsAsyncList = (
    query: AppUserExtGetUsersByEmailsAsyncListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<MotrSharedUserDto[], VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-ext/GetUsersByEmailsAsync`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtBulkImportCreate
   * @request POST:/api/app/user-ext/BulkImport
   * @secure
   */
  appUserExtBulkImportCreate = (
    data: MotrJobsBulkImportRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      MotrJobsBulkImportRequest,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/BulkImport`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserExt
   * @name AppUserExtGetUsersBasicDetailsAsyncCreate
   * @request POST:/api/app/user-ext/GetUsersBasicDetailsAsync
   * @secure
   */
  appUserExtGetUsersBasicDetailsAsyncCreate = (
    query: AppUserExtGetUsersBasicDetailsAsyncCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      MotrSharedUserBasicInfoDto[],
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/app/user-ext/GetUsersBasicDetailsAsync`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserLookup
   * @name IdentityUsersLookupDetail
   * @request GET:/api/identity/users/lookup/{id}
   * @secure
   */
  identityUsersLookupDetail = (
    { id }: IdentityUsersLookupDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<VoloAbpUsersUserData, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/lookup/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserLookup
   * @name IdentityUsersLookupByUsernameDetail
   * @request GET:/api/identity/users/lookup/by-username/{userName}
   * @secure
   */
  identityUsersLookupByUsernameDetail = (
    { userName }: IdentityUsersLookupByUsernameDetailParams,
    params: RequestParams = {},
  ) =>
    this.request<VoloAbpUsersUserData, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/lookup/by-username/${userName}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserLookup
   * @name IdentityUsersLookupSearchList
   * @request GET:/api/identity/users/lookup/search
   * @secure
   */
  identityUsersLookupSearchList = (
    query: IdentityUsersLookupSearchListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<
      VoloAbpApplicationDtosListResultDto1VoloAbpUsersUserDataVoloAbpUsersAbstractionsVersion8200CultureNeutralPublicKeyTokenNull,
      VoloAbpHttpRemoteServiceErrorResponse
    >({
      path: `/api/identity/users/lookup/search`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserLookup
   * @name IdentityUsersLookupCountList
   * @request GET:/api/identity/users/lookup/count
   * @secure
   */
  identityUsersLookupCountList = (
    query: IdentityUsersLookupCountListParams = {},
    params: RequestParams = {},
  ) =>
    this.request<number, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/identity/users/lookup/count`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserToken
   * @name AppUserTokenPropertiesList
   * @request GET:/api/app/user-token/properties
   * @secure
   */
  appUserTokenPropertiesList = (params: RequestParams = {}) =>
    this.request<MotrUsersUserToken, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-token/properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UserToken
   * @name AppUserTokenSetPropertiesCreate
   * @request POST:/api/app/user-token/set-properties
   * @secure
   */
  appUserTokenSetPropertiesCreate = (
    data: MotrUsersUserToken,
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/user-token/set-properties`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestSetupCreate
   * @request POST:/api/app/web-request/setup
   * @secure
   */
  appWebRequestSetupCreate = (
    query: AppWebRequestSetupCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RestSharpRestRequest, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/setup`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestHeaderCreate
   * @request POST:/api/app/web-request/header
   * @secure
   */
  appWebRequestHeaderCreate = (
    query: AppWebRequestHeaderCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/header`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestParameterCreate
   * @request POST:/api/app/web-request/parameter
   * @secure
   */
  appWebRequestParameterCreate = (
    query: AppWebRequestParameterCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<void, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/parameter`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestExecuteCreate
   * @request POST:/api/app/web-request/execute
   * @secure
   */
  appWebRequestExecuteCreate = (
    data: RestSharpRestRequest,
    params: RequestParams = {},
  ) =>
    this.request<RestSharpRestResponse, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestExecuteRequestCreate
   * @request POST:/api/app/web-request/execute-request
   * @secure
   */
  appWebRequestExecuteRequestCreate = (
    data: RestSharpRestRequest,
    query: AppWebRequestExecuteRequestCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RestSharpRestResponse, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/execute-request`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestFormRequestCreate
   * @request POST:/api/app/web-request/form-request
   * @secure
   */
  appWebRequestFormRequestCreate = (
    data: any,
    query: AppWebRequestFormRequestCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<RestSharpRestRequest, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/form-request`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WebRequest
   * @name AppWebRequestBase64EncodeCreate
   * @request POST:/api/app/web-request/base64Encode
   * @secure
   */
  appWebRequestBase64EncodeCreate = (
    query: AppWebRequestBase64EncodeCreateParams = {},
    params: RequestParams = {},
  ) =>
    this.request<string, VoloAbpHttpRemoteServiceErrorResponse>({
      path: `/api/app/web-request/base64Encode`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
}
